//eslint-disable qoutes
import React from "react";
import { FacebookIcon, InstagramIcon, LinkedInIcon, TwitterIcon, YoutubePlayIcon } from "../components/Icons/icons.component";

export const useDynamicEntityColors = true;

export const FEEDS_API_RETRY_LIMIT = 4;
export const FEEDS_API_INITIAL_TIME_INTERVAL = 1; // minutes

export const HOTSTAR_ID = 3798;

export const GACODE = 'G-GM0B8HVJ2C';

export const CLIENT_NAME = {
  cil: "CIL",
};

export const LOGO = {
  biuLogoBase:
    "data:image/png;base64,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",
};
export const VERTICALS = {
  V_ONLINE: 1,
  V_PRINT: 2,
  V_PRINT_AND_ONLINE: -1,
  V_SOCIAL: 4,
  V_BLOG: 5,
  V_TV: 13,
  V_FORUM: 6,
  V_BLOGS_AND_FORUMS: 56,
  TWITTER_INSIGHTS: 7,
  LINKEDIN_INSIGHTS: 8,
  FACEBOOK_INSIGHTS: 9,
  INSTAGRAM_INSIGHTS: 10,
  V_PRINT_AND_ONLINE_OLD: 0,
};

export const VERTICAL_NAMES = {
  1: "Online",
  2: "Print",
  0: "Print and Online",
  4: "Social",
  5: "Blog",
  6: "Forum",
  56: "Blogs and Forum",
  7: "X Insights ",
};

const { V_PRINT, V_ONLINE, V_PRINT_AND_ONLINE, V_SOCIAL, V_BLOG, V_FORUM ,V_TV} = VERTICALS;

export const [THEME_LABEL, TONE_LABEL, UNSET_THEME_LABEL, UNSET_TONE_LABEL] = [
  "Theme",
  "Sentiment",
  "Unset Theme",
  "Unset Sentiment",
];
export const GRAPH_DATATYPE = {
  SOVRankingNOAPrint: "SovClientCompetitorsPrint",
  SOVRankingNOAOnline: "SovClientCompetitorOnline",
  SOVCCMPrint: "SovClientCompetitorsCCMPrint",
  SOVMAVPrint: "SovClientCompetitorsMAVPrint",
  SOVWordCountOnline: "SOVWordCount",
  TopPublicationOnline: "TopPublicationOnline",
  TopPublicationPrint: "TopPublicationPrint",
  TopPublicationCCMPrint: "TopPublicationCCMPrint",
  TopPublicationMAVPrint: "TopPublicationMAVPrint",
  TopJournalistDataOnline: "TopJournalistDataOnline",
  TopJournalistDataPrint: "TopJournalistDataPrint",
  TopJournalistCCMDataPrint: "TopJournalistCCMDataPrint",
  TopJournalistMAVDataPrint: "TopJournalistMAVDataPrint",
  TopJournalistWordCountDataOnline: "TopJournalistWordCountDataOnline",
  TonalityByPublication: "TonalityByPublication",
  TonalityDataOnline: "TonalityDataOnline",
  TonalityDataPrint: "TonalityDataPrint",
  TonalityWordCount: "TonalityWordCount",
  //CityWiseWCRanking: "CityWiseWCRanking",
  MediaWiseNOARanking: "MediaWiseNOARanking",
  CityWiseNOARanking: "CityWisePrint",
  CityWiseCCMRanking: "CityWiseCCMPrint",
  CityWiseMAVRanking: "CityWiseMAVPrint",
  // CityWiseWCTrend: "CityWiseWCTrend",

  MediaExposureReportPrint: "MediaExposureReportPrint",
  TrendAnalysisPrint: "TrendAnalysisPrint",
  EditionWiseNOATrend: "EditionWiseNOATrend",
  TrendAnalysisOnline: "TrendAnalysisOnline",
  JournalistAnalysisPrint: "JournalistAnalysisPrint",
  ThematicAnalysisEntity: "ThematicAnalysisEntity",
  ThematicAnalysisTag: "ThematicAnalysisTag",
  TrendAnalysisMAVPrint: "TrendAnalysisMAVPrint",
  TrendAnalysisCCMPrint: "TrendAnalysisCCMPrint",
  MavDataPrint: "MavDataPrint",
  CcmDataPrint: "CcmDataPrint",
  TonalityMAVPrint: "TonalityMAVPrint",
  TonalityCCMPrint: "TonalityCCMPrint",
  WordCountDateWise: "WordCountDateWise",
  KeywordCloud: "KeywordCloud",
  TopLanguages: "TopLanguages",
  PrintLanguageWise: "PrintLanguageWise",
  OnlineLanguageWise: "OnlineLanguageWise",
  TopPublicationWordCountOnline: "TopPublicationWordCountOnline",
  Influencers: "Influencers",
  Reach: "Reach",
  WorldMap: "WorldMap",
  TopPosters: "TopPosters",

  //NEW QUALITATIVE
  SOVEntityRankingPrint: "SOVEntityRankingPrint",
  SOVEntityRankingOnline: "SOVEntityRankingOnline",
  SOVEntityTrendPrint: "SOVEntityTrendPrint",
  SOVEntityTrendOnline: "SOVEntityTrendOnline",
  SOVEntityTonalityPrint: "SOVEntityTonalityPrint",
  SOVEntityTonalityOnline: "SOVEntityTonalityOnline",
  SOVPublicationRankingPrint: "SOVPublicationRankingPrint",
  SOVPublicationRankingOnline: "SOVPublicationRankingOnline",
  SOVPublicationTrendPrint: "SOVPublicationTrendPrint",
  SOVPublicationTrendOnline: "SOVPublicationTrendOnline",
  SOVPublicationTonalityPrint: "SOVPublicationTonalityPrint",
  SOVPublicationTonalityOnline: "SOVPublicationTonalityOnline",
  SOVJournalistRankingPrint: "SOVJournalistRankingPrint",
  SOVJournalistRankingOnline: "SOVJournalistRankingOnline",
  SOVJournalistTrendPrint: "SOVJournalistTrendPrint",
  SOVJournalistTrendOnline: "SOVJournalistTrendOnline",
  SOVJournalistTonalityPrint: "SOVJournalistTonalityPrint",
  SOVJournalistTonalityOnline: "SOVJournalistTonalityOnline",
  SOVCityRankingPrint: "SOVCityRankingPrint",
  SOVCityRankingOnline: "SOVCityRankingOnline",
  SOVCityTrendPrint: "SOVCityTrendPrint",
  SOVCityTrendOnline: "SOVCityTrendOnline",
  SOVCityTonalityPrint: "SOVCityTonalityPrint",
  SOVCityTonalityOnline: "SOVCityTonalityOnline",
  SOVKeywordRankingPrint: "SOVKeywordRankingPrint",
  SOVKeywordRankingOnline: "SOVKeywordRankingOnline",
  SOVKeywordTrendPrint: "SOVKeywordTrendPrint",
  SOVKeywordTrendOnline: "SOVKeywordTrendOnline",
  SOVKeywordTonalityPrint: "SOVKeywordTonalityPrint",
  SOVKeywordTonalityOnline: "SOVKeywordTonalityOnline",


  SOVEntityRankingPrintOnline: "SOVEntityRankingPrintOnline",
  SOVEntityTrendPrintOnline: "SOVEntityTrendPrintOnline",
  SOVEntityTonalityPrintOnline: "SOVEntityTonalityPrintOnline",
  SOVPublicationRankingPrintOnline: "SOVPublicationRankingPrintOnline",
  SOVPublicationTrendPrintOnline: "SOVPublicationTrendPrintOnline",
  SOVPublicationTonalityPrintOnline: "SOVPublicationTonalityPrintOnline",
  SOVJournalistRankingPrintOnline: "SOVJournalistRankingPrintOnline",
  SOVJournalistTrendPrintOnline: "SOVJournalistTrendPrintOnline",
  SOVJournalistTonalityPrintOnline: "SOVJournalistTonalityPrintOnline",
  SOVCityRankingPrintOnline: "SOVCityRankingPrintOnline",
  SOVCityTrendPrintOnline: "SOVCityTrendPrintOnline",
  SOVCityTonalityPrintOnline: "SOVCityTonalityPrintOnline",
  SOVKeywordRankingPrintOnline: "SOVKeywordRankingPrintOnline",
  SOVKeywordTrendPrintOnline: "SOVKeywordTrendPrintOnline",
  SOVKeywordTonalityPrintOnline: "SOVKeywordTonalityPrintOnline",


  //Sentiment Graph Type Starts

  SentimentEntityTrendPrint: "SentimentEntityTrendPrint",
  SentimentEntityTrendOnline: "SentimentEntityTrendOnline",
  SentimentEntitySOVPrint: "SentimentEntitySOVPrint",
  SentimentEntitySOVOnline: "SentimentEntitySOVOnline",

  SentimentJournalistTrendPrint: "SentimentJournalistTrendPrint",
  SentimentJournalistTrendOnline: "SentimentJournalistTrendOnline",
  SentimentJournalistSOVPrint: "SentimentJournalistSOVPrint",
  SentimentJournalistSOVOnline: "SentimentJournalistSOVOnline",

  SentimentPublicationTrendPrint: "SentimentPublicationTrendPrint",
  SentimentPublicationTrendOnline: "SentimentPublicationTrendOnline",
  SentimentPublicationSOVPrint: "SentimentPublicationSOVPrint",
  SentimentPublicationSOVOnline: "SentimentPublicationSOVOnline",

  SentimentCityTrendPrint: "SentimentCityTrendPrint",
  SentimentCitySOVPrint: "SentimentCitySOVPrint",

  SentimentKeywordTrendPrint: "SentimentKeywordTrendPrint",
  SentimentKeywordTrendOnline: "SentimentKeywordTrendOnline",
  SentimentKeywordSOVPrint: "SentimentKeywordSOVPrint",
  SentimentKeywordSOVOnline: "SentimentKeywordSOVOnline",

  SentimentNewEntitySOVPrint: "SentimentNewEntitySOVPrint",
  SentimentNewEntitySOVOnline: "SentimentNewEntitySOVOnline",

  SentimentEntityTrendPrintOnline: "SentimentEntityTrendPrintOnline",
  SentimentEntitySOVPrintOnline: "SentimentEntitySOVPrintOnline",
  SentimentJournalistTrendPrintOnline: "SentimentJournalistTrendPrintOnline",
  SentimentJournalistSOVPrintOnline: "SentimentJournalistSOVPrintOnline",
  SentimentPublicationTrendPrintOnline: "SentimentPublicationTrendPrintOnline",
  SentimentPublicationSOVPrintOnline: "SentimentPublicationSOVPrintOnline",
  SentimentCityTrendPrintOnline: "SentimentCityTrendPrintOnline",
  SentimentCitySOVPrintOnline: "SentimentCitySOVPrintOnline",
  SentimentKeywordTrendPrintOnline: "SentimentKeywordTrendPrintOnline",
  SentimentKeywordSOVPrintOnline: "SentimentKeywordSOVPrintOnline",



  //Sentiment Graph Type Ends

  //Spokesperson Graph Type Starts

  SpokespersonEntityTrendPrint: "SpokespersonEntityTrendPrint",
  SpokespersonEntityTrendOnline: "SpokespersonEntityTrendOnline",
  SpokespersonEntitySOVPrint: "SpokespersonEntitySOVPrint",
  SpokespersonEntitySOVOnline: "SpokespersonEntitySOVOnline",

  SpokespersonJournalistTrendPrint: "SpokespersonJournalistTrendPrint",
  SpokespersonJournalistTrendOnline: "SpokespersonJournalistTrendOnline",
  SpokespersonJournalistSOVPrint: "SpokespersonJournalistSOVPrint",
  SpokespersonJournalistSOVOnline: "SpokespersonJournalistSOVOnline",

  SpokespersonTopicTrendPrint: "SpokespersonTopicTrendPrint",
  SpokespersonTopicTrendOnline: "SpokespersonTopicTrendOnline",
  SpokespersonTopicSOVPrint: "SpokespersonTopicSOVPrint",
  SpokespersonTopicSOVOnline: "SpokespersonTopicSOVOnline",



  SpokespersonProfileTrendPrint: "SpokespersonProfileTrendPrint",
  SpokespersonProfileTrendOnline: "SpokespersonProfileTrendOnline",
  SpokespersonProfileSOVPrint: "SpokespersonProfileSOVPrint",
  SpokespersonProfileSOVOnline: "SpokespersonProfileSOVOnline",

  SpokespersonEntityTrendPrintOnline: "SpokespersonEntityTrendPrintOnline",
  SpokespersonEntitySOVPrintOnline: "SpokespersonEntitySOVPrintOnline",
  SpokespersonJournalistTrendPrintOnline: "SpokespersonJournalistTrendPrintOnline",
  SpokespersonJournalistSOVPrintOnline: "SpokespersonJournalistSOVPrintOnline",
  SpokespersonTopicTrendPrintOnline: "SpokespersonTopicTrendPrintOnline",
  SpokespersonTopicSOVPrintOnline: "SpokespersonTopicSOVPrintOnline",
  SpokespersonProfileTrendPrintOnline: "SpokespersonProfileTrendPrintOnline",
  SpokespersonProfileSOVPrintOnline: "SpokespersonProfileSOVPrintOnline",

  //Spokesperson Graph Type Ends

  // Journalist Graph Type Starts
  JournalistEntityTrendPrint: "JournalistEntityTrendPrint",
  JournalistEntityTrendOnline: "JournalistEntityTrendOnline",
  JournalistEntitySOVPrint: "JournalistEntitySOVPrint",
  JournalistEntitySOVOnline: "JournalistEntitySOVOnline",
  JournalistEntityTonalityPrint: "JournalistEntityTonalityPrint",
  JournalistEntityTonalityOnline: "JournalistEntityTonalityOnline",

  JournalistKeywordTrendPrint: "JournalistKeywordTrendPrint",
  JournalistKeywordTrendOnline: "JournalistKeywordTrendOnline",
  JournalistKeywordSOVPrint: "JournalistKeywordSOVPrint",
  JournalistKeywordSOVOnline: "JournalistKeywordSOVOnline",
  JournalistKeywordTonalityPrint: "JournalistKeywordTonalityPrint",
  JournalistKeywordTonalityOnline: "JournalistKeywordTonalityOnline",


  JournalistEntitySOVPrintOnline: "JournalistEntitySOVPrintOnline",
  JournalistEntityTrendPrintOnline: "JournalistEntityTrendPrintOnline",
  JournalistEntityTonalityPrintOnline: "JournalistEntityTonalityPrintOnline",
  JournalistKeywordTrendPrintOnline: "JournalistKeywordTrendPrintOnline",
  JournalistKeywordSOVPrintOnline: "JournalistKeywordSOVPrintOnline",
  JournalistKeywordTonalityPrintOnline: "JournalistKeywordTonalityPrintOnline",
  // Journalist Graph Type Starts


  //Keyword Graph Type Starts
  KeywordEntityTrendPrint: "KeywordEntityTrendPrint",
  KeywordEntityTrendOnline: "KeywordEntityTrendOnline",
  KeywordEntitySOVPrint: "KeywordEntitySOVPrint",
  KeywordEntitySOVOnline: "KeywordEntitySOVOnline",
  KeywordEntityTonalityPrint: "KeywordEntityTonalityPrint",
  KeywordEntityTonalityOnline: "KeywordEntityTonalityOnline",

  KeywordPublicationTrendPrint: "KeywordPublicationTrendPrint",
  KeywordPublicationTrendOnline: "KeywordPublicationTrendOnline",
  KeywordPublicationSOVPrint: "KeywordPublicationSOVPrint",
  KeywordPublicationSOVOnline: "KeywordPublicationSOVOnline",
  KeywordPublicationTonalityPrint: "KeywordPublicationTonalityPrint",
  KeywordPublicationTonalityOnline: "KeywordPublicationTonalityOnline",

  KeywordJournalistTrendPrint: "KeywordJournalistTrendPrint",
  KeywordJournalistTrendOnline: "KeywordJournalistTrendOnline",
  KeywordJournalistSOVPrint: "KeywordJournalistSOVPrint",
  KeywordJournalistSOVOnline: "KeywordJournalistSOVOnline",
  KeywordJournalistTonalityPrint: "KeywordJournalistTonalityPrint",
  KeywordJournalistTonalityOnline: "KeywordJournalistTonalityOnline",

  KeywordCityTrendPrint: "KeywordCityTrendPrint",
  KeywordCityTrendOnline: "KeywordCityTrendOnline",
  KeywordCitySOVPrint: "KeywordCitySOVPrint",
  KeywordCitySOVOnline: "KeywordCitySOVOnline",
  KeywordCityTonalityPrint: "KeywordCityTonalityPrint",
  KeywordCityTonalityOnline: "KeywordCityTonalityOnline",

  KeywordSpokespersonTrendPrint: "KeywordSpokespersonTrendPrint",
  KeywordSpokespersonTrendOnline: "KeywordSpokespersonTrendOnline",
  KeywordSpokespersonSOVPrint: "KeywordSpokespersonSOVPrint",
  KeywordSpokespersonSOVOnline: "KeywordSpokespersonSOVOnline",
  KeywordSpokespersonTonalityPrint: "KeywordSpokespersonTonalityPrint",
  KeywordSpokespersonTonalityOnline: "KeywordSpokespersonTonalityOnline",

  KeywordEntitySOVPrintOnline: "KeywordEntitySOVPrintOnline",
  KeywordEntityTrendPrintOnline: "KeywordEntityTrendPrintOnline",
  KeywordEntityTonalityPrintOnline: "KeywordEntityTonalityPrintOnline",
  KeywordPublicationSOVPrintOnline: "KeywordPublicationSOVPrintOnline",
  KeywordPublicationTrendPrintOnline: "KeywordPublicationTrendPrintOnline",
  KeywordPublicationTonalityPrintOnline: "KeywordPublicationTonalityPrintOnline",
  KeywordJournalistSOVPrintOnline: "KeywordJournalistSOVPrintOnline",
  KeywordJournalistTrendPrintOnline: "KeywordJournalistTrendPrintOnline",
  KeywordJournalistTonalityPrintOnline: "KeywordJournalistTonalityPrintOnline",
  KeywordCitySOVPrintOnline: "KeywordCitySOVPrintOnline",
  KeywordCityTrendPrintOnline: "KeywordCityTrendPrintOnline",
  KeywordCityTonalityPrintOnline: "KeywordCityTonalityPrintOnline",
  KeywordSpokespersonSOVPrintOnline: "KeywordSpokespersonSOVPrintOnline",
  KeywordSpokespersonTrendPrintOnline: "KeywordSpokespersonTrendPrintOnline",
  KeywordSpokespersonTonalityPrintOnline: "KeywordSpokespersonTonalityPrintOnline",


  //Keyword Graph Type Ends

  //Thematic starts
  ThematicEntitySOVPrint: "ThematicEntitySOVPrint",
  ThematicEntitySOVOnline: "ThematicEntitySOVOnline",
  ThematicEntityTrendPrint: "ThematicEntityTrendPrint",
  ThematicEntityTrendOnline: "ThematicEntityTrendOnline",
  ThematicEntityTonalityPrint: "ThematicEntityTonalityPrint",
  ThematicEntityTonalityOnline: "ThematicEntityTonalityOnline",
  ThematicPublicationSOVPrint: "ThematicPublicationSOVPrint",
  ThematicPublicationSOVOnline: "ThematicPublicationSOVOnline",
  ThematicPublicationTrendPrint: "ThematicPublicationTrendPrint",
  ThematicPublicationTrendOnline: "ThematicPublicationTrendOnline",
  ThematicPublicationTonalityPrint: "ThematicPublicationTonalityPrint",
  ThematicPublicationTonalityOnline: "ThematicPublicationTonalityOnline",
  ThematicJournalistSOVPrint: "ThematicJournalistSOVPrint",
  ThematicJournalistSOVOnline: "ThematicJournalistSOVOnline",
  ThematicJournalistTrendPrint: "ThematicJournalistTrendPrint",
  ThematicJournalistTrendOnline: "ThematicJournalistTrendOnline",
  ThematicJournalistTonalityPrint: "ThematicJournalistTonalityPrint",
  ThematicJournalistTonalityOnline: "ThematicJournalistTonalityOnline",
  ThematicCitySOVPrint: "ThematicCitySOVPrint",
  ThematicCitySOVOnline: "ThematicCitySOVOnline",
  ThematicCityTrendPrint: "ThematicCityTrendPrint",
  ThematicCityTrendOnline: "ThematicCityTrendOnline",
  ThematicCityTonalityPrint: "ThematicCityTonalityPrint",
  ThematicCityTonalityOnline: "ThematicCityTonalityOnline",
  ThematicKeywordSOVPrint: "ThematicKeywordSOVPrint",
  ThematicKeywordSOVOnline: "ThematicKeywordSOVOnline",
  ThematicKeywordTrendPrint: "ThematicKeywordTrendPrint",
  ThematicKeywordTrendOnline: "ThematicKeywordTrendOnline",
  ThematicKeywordTonalityPrint: "ThematicKeywordTonalityPrint",
  ThematicKeywordTonalityOnline: "ThematicKeywordTonalityOnline",
  ThematicNewEntitySOVPrint: "ThematicNewEntitySOVPrint",
  ThematicNewEntitySOVOnline: "ThematicNewEntitySOVOnline",


  ThematicEntitySOVPrintOnline: "ThematicEntitySOVPrintOnline",
  ThematicEntityTrendPrintOnline: "ThematicEntityTrendPrintOnline",
  ThematicEntityTonalityPrintOnline: "ThematicEntityTonalityPrintOnline",
  ThematicPublicationSOVPrintOnline: "ThematicPublicationSOVPrintOnline",
  ThematicPublicationTrendPrintOnline: "ThematicPublicationTrendPrintOnline",
  ThematicPublicationTonalityPrintOnline: "ThematicPublicationTonalityPrintOnline",
  ThematicJournalistSOVPrintOnline: "ThematicJournalistSOVPrintOnline",
  ThematicJournalistTrendPrintOnline: "ThematicJournalistTrendPrintOnline",
  ThematicJournalistTonalityPrintOnline: "ThematicJournalistTonalityPrintOnline",
  ThematicCitySOVPrintOnline: "ThematicCitySOVPrintOnline",
  ThematicCityTrendPrintOnline: "ThematicCityTrendPrintOnline",
  ThematicCityTonalityPrintOnline: "ThematicCityTonalityPrintOnline",
  ThematicKeywordSOVPrintOnline: "ThematicKeywordSOVPrintOnline",
  ThematicKeywordTrendPrintOnline: "ThematicKeywordTrendPrintOnline",
  ThematicKeywordTonalityPrintOnline: "ThematicKeywordTonalityPrintOnline",
  //Thematic Ends
  //Geolocation Starts
  GeolocationEntitySOVPrint: "GeolocationEntitySOVPrint",
  GeolocationEntitySOVOnline: "GeolocationEntitySOVOnline",
  GeolocationEntityTrendPrint: "GeolocationEntityTrendPrint",
  GeolocationEntityTrendOnline: "GeolocationEntityTrendOnline",
  GeolocationEntityTonalityPrint: "GeolocationEntityTonalityPrint",
  GeolocationEntityTonalityOnline: "GeolocationEntityTonalityOnline",
  GeolocationPublicationSOVPrint: "GeolocationPublicationSOVPrint",
  GeolocationPublicationSOVOnline: "GeolocationPublicationSOVOnline",
  GeolocationPublicationTrendPrint: "GeolocationPublicationTrendPrint",
  GeolocationPublicationTrendOnline: "GeolocationPublicationTrendOnline",
  GeolocationPublicationTonalityPrint: "GeolocationPublicationTonalityPrint",
  GeolocationPublicationTonalityOnline: "GeolocationPublicationTonalityOnline",
  GeolocationKeywordSOVPrint: "GeolocationKeywordSOVPrint",
  GeolocationKeywordSOVOnline: "GeolocationKeywordSOVOnline",
  GeolocationKeywordTrendPrint: "GeolocationKeywordTrendPrint",
  GeolocationKeywordTrendOnline: "GeolocationKeywordTrendOnline",
  GeolocationKeywordTonalityPrint: "GeolocationKeywordTonalityPrint",
  GeolocationKeywordTonalityOnline: "GeolocationKeywordTonalityOnline",

  GeolocationNewEntitySOVPrint: "GeolocationNewEntitySOVPrint",
  GeolocationNewEntitySOVOnline: "GeolocationNewEntitySOVOnline",

  GeolocationEntitySOVPrintOnline: "GeolocationEntitySOVPrintOnline",
  GeolocationEntityTrendPrintOnline: "GeolocationEntityTrendPrintOnline",
  GeolocationEntityTonalityPrintOnline: "GeolocationEntityTonalityPrintOnline",
  GeolocationPublicationSOVPrintOnline: "GeolocationPublicationSOVPrintOnline",
  GeolocationPublicationTrendPrintOnline: "GeolocationPublicationTrendPrintOnline",
  GeolocationPublicationTonalityPrintOnline: "GeolocationPublicationTonalityPrintOnline",
  GeolocationKeywordSOVPrintOnline: "GeolocationKeywordSOVPrintOnline",
  GeolocationKeywordTrendPrintOnline: "GeolocationKeywordTrendPrintOnline",
  GeolocationKeywordTonalityPrintOnline: "GeolocationKeywordTonalityPrintOnline",
  //Geolocation Ends
  //Publication Starts
  PublicationEntitySOVPrint: "PublicationEntitySOVPrint",
  PublicationEntitySOVOnline: "PublicationEntitySOVOnline",
  PublicationEntityTrendPrint: "PublicationEntityTrendPrint",
  PublicationEntityTrendOnline: "PublicationEntityTrendOnline",
  PublicationEntityTonalityPrint: "PublicationEntityTonalityPrint",
  PublicationEntityTonalityOnline: "PublicationEntityTonalityOnline",
  PublicationJournalistSOVPrint: "PublicationJournalistSOVPrint",
  PublicationJournalistSOVOnline: "PublicationJournalistSOVOnline",
  PublicationJournalistTrendPrint: "PublicationJournalistTrendPrint",
  PublicationJournalistTrendOnline: "PublicationJournalistTrendOnline",
  PublicationJournalistTonalityPrint: "PublicationJournalistTonalityPrint",
  PublicationJournalistTonalityOnline: "PublicationJournalistTonalityOnline",
  PublicationKeywordSOVPrint: "PublicationKeywordSOVPrint",
  PublicationKeywordSOVOnline: "PublicationKeywordSOVOnline",
  PublicationKeywordTrendPrint: "PublicationKeywordTrendPrint",
  PublicationKeywordTrendOnline: "PublicationKeywordTrendOnline",
  PublicationKeywordTonalityPrint: "PublicationKeywordTonalityPrint",
  PublicationKeywordTonalityOnline: "PublicationKeywordTonalityOnline",

  PublicationNewEntitySOVPrint: "PublicationNewEntitySOVPrint",
  PublicationNewEntitySOVOnline: "PublicationNewEntitySOVOnline",

  PublicationEntitySOVPrintOnline: "PublicationEntitySOVPrintOnline",
  PublicationEntityTrendPrintOnline: "PublicationEntityTrendPrintOnline",
  PublicationEntityTonalityPrintOnline: "PublicationEntityTonalityPrintOnline",
  PublicationJournalistSOVPrintOnline: "PublicationJournalistSOVPrintOnline",
  PublicationJournalistTrendPrintOnline: "PublicationJournalistTrendPrintOnline",
  PublicationJournalistTonalityPrintOnline: "PublicationJournalistTonalityPrintOnline",
  PublicationKeywordSOVPrintOnline: "PublicationKeywordSOVPrintOnline",
  PublicationKeywordTrendPrintOnline: "PublicationKeywordTrendPrintOnline",
  PublicationKeywordTonalityPrintOnline: "PublicationKeywordTonalityPrintOnline",
  //Publication Ends
  //PREV QUALITATIVE
  Snapshot: "Snapshot",
  StoryTable: "StoryTable",
  StoryPaticipate: "StoryPaticipate",
  ThematicReportThemeWisePrint: "ThematicReportThemeWisePrint",
  ThematicReportThemeWiseOnline: "ThematicReportThemeWiseOnline",
  ThematicReportEntitySOVPrint: "ThematicReportEntitySOVPrint",
  ThematicReportEntitySOVOnline: "ThematicReportEntitySOVOnline",
  ThematicReportEntityTrendPrint: "ThematicReportEntityTrendPrint",
  ThematicReportEntityTrendOnline: "ThematicReportEntityTrendOnline",
  ThematicReportEntityTonalityPrint: "ThematicReportEntityTonalityPrint",
  ThematicReportEntityTonalityOnline: "ThematicReportEntityTonalityOnline",
  ThematicReportWithTopicPrint: "ThematicReportWithTopicPrint",
  ThematicReportWithTopicOnline: "ThematicReportWithTopicOnline",
  ThematicReportThemeWiseSpreadPrint: "ThematicReportThemeWiseSpreadPrint",
  ThematicReportThemeWiseSpreadOnline: "ThematicReportThemeWiseSpreadOnline",
  ThematicReportEntityWiseSpreadPrint: "ThematicReportEntityWiseSpreadPrint",
  ThematicReportEntityWiseSpreadOnline: "ThematicReportEntityWiseSpreadOnline",
  GeolocationZonalSpread: "GeolocationZonalSpread",
  GeolocationZonalSpreadIndex: "GeolocationZonalSpreadIndex",
  GeolocationZonalSpreadIndexEntityWise: "GeolocationZonalSpreadIndexEntityWise",
  GeolocationZoneWiseArticle: "GeolocationZoneWiseArticle",
  JournalistReportIndexPrint: "JournalistReportIndexPrint",
  JournalistReportIndexOnline: "JournalistReportIndexOnline",
  JournalistReportArticlePrint: "JournalistReportArticlePrint",
  JournalistReportArticleOnline: "JournalistReportArticleOnline",
  JournalistSentiment: "JournalistSentiment",
  SentimentReportIndexPrint: "SentimentReportIndexPrint",
  SentimentReportIndexOnline: "SentimentReportIndexOnline",
  SentimentReportArticlePrint: "SentimentReportArticlePrint",
  SentimentReportArticleOnline: "SentimentReportArticleOnline",
  GeolocationZoneWiseTopPublication: "GeolocationZoneWiseTopPublication",
  GeolocationZoneWiseSOVIndex: "GeolocationZoneWiseSOVIndex",
  GeolocationMarketSpread: "GeolocationMarketSpread",
  GeolocationCityWiseArticle: "GeolocationCityWiseArticle",
  SentimentGenreIndexOnline: "SentimentGenreIndexOnline",
  GeolocationCityWiseSOVIndex: "GeolocationCityWiseSOVIndex",
  SentimentGenreIndexPrint: "SentimentGenreIndexPrint",
  SentimentGenreArticleOnline: "SentimentGenreArticleOnline",
  SentimentGenreArticlePrint: "SentimentGenreArticlePrint",
  KeywordReportIndexPrint: "KeywordReportIndexPrint",
  KeywordReportIndexOnline: "KeywordReportIndexOnline",
  KeywordReportTrendPrint: "KeywordReportTrendPrint",
  KeywordReportTrendOnline: "KeywordReportTrendOnline",
  KeywordReportSentimentPrint: "KeywordReportSentimentPrint",
  KeywordReportSentimentOnline: "KeywordReportSentimentOnline",
  SentimentTableIndex: "SentimentTableIndex",
  SentimentTableArticle: "SentimentTableArticle",
  SpokesPersonReportIndex: "SpokesPersonReportIndex",
  SpokesPersonReportArticle: "SpokesPersonReportArticle",
  TonalityDataTV : "TonalityDataTV"
};

export const HTTP_CODES = {
  SUCCESS: 200,
  NOT_FOUND: 404,
  INTERNAL_SERVER_ERROR: 500,
  INCORRECT_INPUT: 400,
  UNAUTHORIZED: 401,
  CREATED: 201,
  FORBIDDEN: 403,
  DELETED: 204,
};

export const ERROR_RESPONSE_CODE = {
  INVALID_TOKEN: "authorization.token.invalid",
};

export const INVALID_SESSION_KEY = "isInValidSession";

export const FILTER_NAMES = {
  RANGE: "range",
  TONALITY: "SENTIMENT",
  CHANNELS: "PLATFORM",
  PUBLICATION_TYPE: "PUBLICATION_TYPE",
  PUBLICATION: "PUBLICATION",
  EDITION: "EDITION",
  ZONE: "ZONE",
  SOURCE_TYPE: "SOURCE_TYPE",
  CATEGORY: "CATEGORY",
  ENTITY: "ENTITY",
  HEADLINE: "HEADLINE",
  PUBLICATION_IDS: "PUBLICATION_IDS",
  CLIENT: "CLIENT",
  VERTICAL: "MEDIA_TYPE",
  TYPED_PUBLICATION_TEXT: "TYPED_PUBLICATION_TEXT",
  REMOVE_PUBLICATION_TEXT: "REMOVE_PUBLICATION_TEXT",
  REPORTER: "REPORTER",
  TYPED_REPORTER_TEXT: "TYPED_REPORTER_TEXT",
  REMOVE_REPORTER_TEXT: "REMOVE_REPORTER_TEXT",
  PRESS_RELEASE: "PRESS_RELEASE",
  KEYWORDS_SEARCH: "KEYWORDS",
  CITY: "CITY",
  CHANNEL: "CHANNEL",
  REACTIONS: "REACTIONS",
  COMMENTS: "COMMENTS",
  SOCIAL_ENTITY: "SOCIAL_ENTITY",
  REPORTS_ENTITY: "REPORTS_ENTITY",
  LANGUAGES: "LANGUAGES",
  COUNTRY: "COUNTRY",
  PLATFORM: "PLATFORM",
  VERTICALS_FOR_BLOG_AND_FORUMS: "VERTICAL",
  TONALITY_MULT: "TONALITY_MULT",
  CHANNELS_LIST: "CHANNEL_NAME",
  REPORT_LIST: "REPORT_LIST",
  LANGUAGE_LIST: "LANGUAGE_LIST",
  COUNTRY_LIST: "COUNTRY_LIST",
  TAGS: "TAGS",
  CHART_TYPE: "CHART_TYPE",
};
export const HOVER_CONTENT = {
  ESTIMATED_ARTICLE:
    "We calculate the Potential Readership of an article by multiplying the number of Monthly Unique Visitors to the website with our own unique Readership Factor. The Readership Factor considers the number of Monthly Visits per Unique Visitor and the Average Article Lifespan on the individual site. A website with high loyalty and long article lifespan has a higher Readership Factor, whereas low loyalty and short article lifespan bring down the value",
  ESTIMATED_PREDICTED:
    "Expected final readership probability, based on the article’s expected lifetime.",
  WEBSITE_READRSHIP:
    "The Monthly Visits metric shows the average sum of all non-unique visits per month, during the selected time frame.",
  WEBSITE_COUNTRY_AND_GLOBAL:
    "Rank is a website traffic scoring method developed by SimilarWeb to determine a website’s rank. It calculates the number of monthly unique visitors together with the number of page views across desktop and mobile traffic.",
};

export const GRAPH_TYPES = {
  PIE: "1",
  BAR_VERTICAL: "2",
  BAR_HORIZONTAL: "3",
  LINE: "4",
  AREA: "5",
  BAR_STACKED: "6",
  BAR_STACKED_EQUAL_HEIGHT: "61",
  TABLE: "7",
  WORD_CLOUD: "8",
  GENDER: "9",
  CHOROPLETH: "11",
  DOUGHNUT: "10",
  INFLUENCERS: "16",
  //new qualitative
  SNAPSHOT: "32",
  SOVStory: "33",
  STORYTABLE: "34",
  JournalistSentiment: "37",
  SENTIMENTTABLEINDEX: "50",
  SENTIMENTTABLEARTICLE: "51"
};

const {
  PIE,
  BAR_HORIZONTAL,
  BAR_STACKED,
  BAR_VERTICAL,
  AREA,
  LINE,
  TABLE,
  WORD_CLOUD,
  GENDER,
  CHOROPLETH,
  DOUGHNUT,
  INFLUENCERS,
  BAR_STACKED_EQUAL_HEIGHT,
} = GRAPH_TYPES;

export const WORD_CLOUD_TYPE = [
  // {
  //   label: "Word cloud by theme",
  //   value: "5",
  // },
  // {
  //   label: "Word cloud by celebrity",
  //   value: "2",
  // },
  // {
  //   label: "Word cloud by brand",
  //   value: "3",
  // },
  {
    label: "Word cloud by emoji",
    value: "4",
  },
  {
    label: "Word cloud by hashtag",
    value: "1",
  },
];

export const QUALITATIVE_REPORT_LEVELS = {
  ENTITY: "ENTITY",
  CITY: "CITY",
  JOURNALIST: "JOURNALIST",
  KEYWORD: "KEYWORD",
  PUBLICATION: "PUBLICATION",
  VISIBILITY: "VISIBILITY",
  PROFILING: "PROFILING",
  SPOKESPERSON: "SPOKESPERSON",
  TOPIC: "TOPIC",
  HEADLINE: "HEADLINE",
  PROMINANCE: "PROMINANCE",
  KEY_MESSAGE: "KEY_MESSAGE",
  RECOMMENDATIOM: "RECOMMENDATION",
  PHOTO: "PHOTO",
  SPOKESPERSON: "SPOKESPERSON"
}

export const REPORT_TYPES = {
  SOVNOARanking: "6",
  SOVCCMRanking: "sovCCMRanking",
  SOVMAVRanking: "sovMAVRanking",
  SOVWC: "sovWCRanking",
  SOV_CCM_TREND: "sovCCMTrend",
  SOV_MAV_TREND: "sovMAVTrend",
  SOV_NOA_TREND: "1",
  SOV_WC_TREND: "sovWCTrend",
  JournalistNOARanking: "JournalistNOARanking",
  JournalistCCMRanking: "JournalistCCMRanking",
  JournalistMAVRanking: "JournalistMAVRanking",
  JournalistWCRanking: "JournalistWCRanking",
  JournalistNOATrend: "JournalistNOATrend",
  JournalistAnalysisPrint: "JournalistAnalysisPrint",
  ThematicAnalysisEntity: "ThematicAnalysisEntity",
  ThematicAnalysisTag: "ThematicAnalysisTag",
  JournalistCCMTrend: "JournalistCCMTrend",
  JournalistMAVTrend: "JournalistMAVTrend",
  JournalistWCTrend: "JournalistWCTrend",
  JournalistTonalityNOATrend: "JournalistTonalityNOATrend",
  JournalistTonalityCCMTrend: "JournalistTonalityCCMTrend",
  JournalistTonalityMAVTrend: "JournalistTonalityMAVTrend",
  JournalistTonalityNOARanking: "JournalistTonalityNOARanking",
  JournalistTonalityCCMRanking: "JournalistTonalityCCMRanking",
  JournalistTonalityMAVRanking: "JournalistTonalityMAVRanking",
  JournalistTonalityWCRanking: "JournalistTonalityWCRanking",
  TonalityNAORanking: "5",
  TonalityCCMRanking: "TonalityCCMRanking",
  TonalityMAVRanking: "TonalityMAVRanking",
  TonalityWordCount: "TonalityWordCount",
  TonalityNAOTrend: "TonalityNAOTrend",
  TonalityCCMTrend: "TonalityCCMTrend",
  TonalityMAVTrend: "TonalityMAVTrend",
  TonalityWCTrend: "TonalityWCTrend",
  PublicationNOARanking: "PublicationNOARanking",
  PublicationCCMRanking: "PublicationCCMRanking",
  PublicationMAVRanking: "PublicationMAVRanking",
  PublicationNOATrend: "PublicationNOATrend",
  PublicationCCMTrend: "PublicationCCMTrend",
  PublicationMAVTrend: "PublicationMAVTrend",
  PublicationTonalityNOARanking: "PublicationTonalityNOARanking",
  PublicationTonalityCCMRanking: "PublicationTonalityCCMRanking",
  PublicationTonalityMAVRanking: "PublicationTonalityMAVRanking",
  PublicationTonalityWCRanking: "PublicationTonalityWCRanking",
  TopPublicationWordCount: "TopPublicationWordCount",
  TopPublicationTrendWordCount: "TopPublicationTrendWordCount",

  KeywordCloudNOA: "20",
  CityWiseWCRanking: "CityWiseWCRanking",
  MediaWiseNOARanking: "MediaWiseNOARanking",
  CityWiseNOARanking: "4",
  CityWiseCCMRanking: "CityWiseCCMRanking",
  CityWiseMAVRanking: "CityWiseMAVRanking",
  CityWiseWCTrend: "CityWiseWCTrend",
  EditionWiseNOATrend: "EditionWiseNOATrend",
  CityWiseNOATrend: "CityWiseNOATrend",
  CityWiseCCMTrend: "CityWiseCCMTrend",
  CityWiseMAVTrend: "CityWiseMAVTrend",
  CityWiseTonality: "CityWiseTonality",
  StateWiseTonality: "StateWiseTonality",
  StateWiseTrend: "StateWiseTrend",
  CityWiseCCMTonality: "CityWiseCCMTonality",
  CityWiseMAVTonality: "CityWiseMAVTonality",
  MediaExposureReport: "MediaExposureReport",
  SOVCity: "4",
  SOVTonality: "5",
  SOVRanking: "6",
  TotalMediaExposure: "7",
  SOVTrend: "8",
  SOVMAVTrend: "9",
  SOVMAV: "10",
  SOVCCMTrend: "11",
  SOVCCM: "12",
  SOVTonalityCCM: "13",
  SOVTonalityMAV: "14",
  Reach: "15",
  INFLUENCERS: "16",
  KEYINFLUENCERS: "27",
  TopPosters: "17",
  TopPostersTrend: "57",
  TopPostersWithDetail: "58",
  InfluencerWithDetail: "59",
  TopLanguages: "18",
  ShareRetweet: "43",
  ReplyComment: "45",
  Attachment: "46",
  Like: "44",
  AuthorLike: "50",
  MemberType: "48",
  TypeOfPost: "49",
  AuthorFollowing: "51",
  AuthorTweetCount: "52",
  AuthorListed: "53",
  AuthorCreated: "54",
  WorldMap: "19",
  citywisenew: "55",
  CitySpecificReport: "21",
  PLATFORM_RANK: "22",
  PLATFORM_TREND: "23",
  PLATFORM_TONALITY: "24",
  TagBasedTagAnalysis: "25",
  EntityBasedTagAnalysis: "26",
  TWITTER: "TWITTER INSIGHTS",
  LINKEDIN: "LINKEDIN INSIGHTS",
  LINKEDIN_METRICS: "LINKEDIN MATRICS",
  FACEBOOK_METRICS: "FACEBOOK MATRICS",
  INSTAGRAM_METRICS: "INSTAGRAM MATRICS",
  FACEBOOK: "FACEBOOK INSIGHTS",
  INSTAGRAM: "INSTAGRAM INSIGHTS",
  //new qualitative
  /*** IMPORTANT TO FOLLOW THE NAMING CONVENTION BELOW ***/
  //SOV starts
  // // // Entity Level starts
  SOVEntityRankingNOA: "SOVEntityRankingNOA",
  SOVEntityRankingCCM: "SOVEntityRankingCCM",
  SOVEntityRankingMAV: "SOVEntityRankingMAV",
  SOVEntityRankingIndex: "SOVEntityRankingIndex",
  SOVEntityRankingReach: "SOVEntityRankingReach",
  SOVEntityRankingWordCount: "SOVEntityRankingWordCount",
  SOVEntityTrendWordCount: "SOVEntityTrendWordCount",
  SOVEntityTrendNOA: "SOVEntityTrendNOA",
  SOVEntityTrendCCM: "SOVEntityTrendCCM",
  SOVEntityTrendMAV: "SOVEntityTrendMAV",
  SOVEntityTrendIndex: "SOVEntityTrendIndex",
  SOVEntityTrendReach: "SOVEntityTrendReach",
  SOVEntityTrendWordCount: "SOVEntityTrendWordCount",
  SOVEntityTonalityNOA: "SOVEntityTonalityNOA",
  SOVEntityTonalityCCM: "SOVEntityTonalityCCM",
  SOVEntityTonalityMAV: "SOVEntityTonalityMAV",
  SOVEntityTonalityIndex: "SOVEntityTonalityIndex",
  SOVEntityTonalityReach: "SOVEntityTonalityReach",
  SOVEntityTonalityWordCount: "SOVEntityTonalityWordCount",
  // // // Entity Level ends
  // // // Journalist Level starts
  SOVJournalistRankingNOA: "SOVJournalistRankingNOA",
  SOVJournalistRankingCCM: "SOVJournalistRankingCCM",
  SOVJournalistRankingMAV: "SOVJournalistRankingMAV",
  SOVJournalistRankingIndex: "SOVJournalistRankingIndex",
  SOVJournalistRankingReach: "SOVJournalistRankingReach",
  SOVJournalistRankingWordCount: "SOVJournalistRankingWordCount",
  SOVJournalistTrendNOA: "SOVJournalistTrendNOA",
  SOVJournalistTrendCCM: "SOVJournalistTrendCCM",
  SOVJournalistTrendMAV: "SOVJournalistTrendMAV",
  SOVJournalistTrendIndex: "SOVJournalistTrendIndex",
  SOVJournalistTrendReach: "SOVJournalistTrendReach",
  SOVJournalistTrendWordCount: "SOVJournalistTrendWordCount",
  SOVJournalistTonalityNOA: "SOVJournalistTonalityNOA",
  SOVJournalistTonalityCCM: "SOVJournalistTonalityCCM",
  SOVJournalistTonalityMAV: "SOVJournalistTonalityMAV",
  SOVJournalistTonalityIndex: "SOVJournalistTonalityIndex",
  SOVJournalistTonalityReach: "SOVJournalistTonalityReach",
  SOVJournalistTonalityWordCount: "SOVJournalistTonalityWordCount",
  // // // Journalist Level Ends
  // // // Publication Level Starts
  SOVPublicationRankingNOA: "SOVPublicationRankingNOA",
  SOVPublicationRankingCCM: "SOVPublicationRankingCCM",
  SOVPublicationRankingMAV: "SOVPublicationRankingMAV",
  SOVPublicationRankingIndex: "SOVPublicationRankingIndex",
  SOVPublicationRankingReach: "SOVPublicationRankingReach",
  SOVPublicationRankingWordCount: "SOVPublicationRankingWordCount",
  SOVPublicationTrendNOA: "SOVPublicationTrendNOA",
  SOVPublicationTrendCCM: "SOVPublicationTrendCCM",
  SOVPublicationTrendMAV: "SOVPublicationTrendMAV",
  SOVPublicationTrendIndex: "SOVPublicationTrendIndex",
  SOVPublicationTrendReach: "SOVPublicationTrendReach",
  SOVPublicationTrendWordCount: "SOVPublicationTrendWordCount",
  SOVPublicationTonalityNOA: "SOVPublicationTonalityNOA",
  SOVPublicationTonalityCCM: "SOVPublicationTonalityCCM",
  SOVPublicationTonalityMAV: "SOVPublicationTonalityMAV",
  SOVPublicationTonalityIndex: "SOVPublicationTonalityIndex",
  SOVPublicationTonalityReach: "SOVPublicationTonalityReach",
  SOVPublicationTonalityWordCount: "SOVPublicationTonalityWordCount",
  // // // Publication Level Ends
  // // // City Level Starts
  SOVCityRankingNOA: "SOVCityRankingNOA",
  SOVCityRankingCCM: "SOVCityRankingCCM",
  SOVCityRankingMAV: "SOVCityRankingMAV",
  SOVCityRankingIndex: "SOVCityRankingIndex",
  SOVCityRankingReach: "SOVCityRankingReach",
  SOVCityRankingWordCount: "SOVCityRankingWordCount",
  SOVCityTrendNOA: "SOVCityTrendNOA",
  SOVCityTrendCCM: "SOVCityTrendCCM",
  SOVCityTrendMAV: "SOVCityTrendMAV",
  SOVCityTrendIndex: "SOVCityTrendIndex",
  SOVCityTrendReach: "SOVCityTrendReach",
  SOVCityTrendWordCount: "SOVCityTrendWordCount",
  SOVCityTonalityNOA: "SOVCityTonalityNOA",
  SOVCityTonalityCCM: "SOVCityTonalityCCM",
  SOVCityTonalityMAV: "SOVCityTonalityMAV",
  SOVCityTonalityIndex: "SOVCityTonalityIndex",
  SOVCityTonalityReach: "SOVCityTonalityReach",
  SOVCityTonalityWordCount: "SOVCityTonalityWordCount",
  // // // City Level Ends
  // // // Keyword Level Starts
  SOVKeywordRankingNOA: "SOVKeywordRankingNOA",
  SOVKeywordRankingCCM: "SOVKeywordRankingCCM",
  SOVKeywordRankingMAV: "SOVKeywordRankingMAV",
  SOVKeywordRankingIndex: "SOVKeywordRankingIndex",
  SOVKeywordRankingReach: "SOVKeywordRankingReach",
  SOVKeywordRankingWordCount: "SOVKeywordRankingWordCount",
  SOVKeywordTrendNOA: "SOVKeywordTrendNOA",
  SOVKeywordTrendCCM: "SOVKeywordTrendCCM",
  SOVKeywordTrendMAV: "SOVKeywordTrendMAV",
  SOVKeywordTrendIndex: "SOVKeywordTrendIndex",
  SOVKeywordTrendReach: "SOVKeywordTrendReach",
  SOVKeywordTrendWordCount: "SOVKeywordTrendWordCount",
  SOVKeywordTonalityNOA: "SOVKeywordTonalityNOA",
  SOVKeywordTonalityCCM: "SOVKeywordTonalityCCM",
  SOVKeywordTonalityMAV: "SOVKeywordTonalityMAV",
  SOVKeywordTonalityIndex: "SOVKeywordTonalityIndex",
  SOVKeywordTonalityReach: "SOVKeywordTonalityReach",
  SOVKeywordTonalityWordCount: "SOVKeywordTonalityWordCount",
  // // // Keyword Level Ends
  //SOV Ends

  // sentiment Starts

  // // // Entity Level starts

  SentimentEntityTrendWordCount: "SentimentEntityTrendWordCount",
  SentimentEntityTrendNOA: "SentimentEntityTrendNOA",
  SentimentEntityTrendCCM: "SentimentEntityTrendCCM",
  SentimentEntityTrendMAV: "SentimentEntityTrendMAV",
  SentimentEntityTrendIndex: "SentimentEntityTrendIndex",
  SentimentEntityTrendReach: "SentimentEntityTrendReach",
  SentimentEntitySOVNOA: "SentimentEntitySOVNOA",
  SentimentEntitySOVCCM: "SentimentEntitySOVCCM",
  SentimentEntitySOVMAV: "SentimentEntitySOVMAV",
  SentimentEntitySOVIndex: "SentimentEntitySOVIndex",
  SentimentEntitySOVReach: "SentimentEntitySOVReach",
  SentimentEntitySOVWordCount: "SentimentEntitySOVWordCount",

  // // // Publication Level starts

  SentimentPublicationTrendWordCount: "SentimentPublicationTrendWordCount",
  SentimentPublicationTrendNOA: "SentimentPublicationTrendNOA",
  SentimentPublicationTrendCCM: "SentimentPublicationTrendCCM",
  SentimentPublicationTrendMAV: "SentimentPublicationTrendMAV",
  SentimentPublicationTrendIndex: "SentimentPublicationTrendIndex",
  SentimentPublicationTrendReach: "SentimentPublicationTrendReach",
  SentimentPublicationSOVNOA: "SentimentPublicationSOVNOA",
  SentimentPublicationSOVCCM: "SentimentPublicationSOVCCM",
  SentimentPublicationSOVMAV: "SentimentPublicationSOVMAV",
  SentimentPublicationSOVIndex: "SentimentPublicationSOVIndex",
  SentimentPublicationSOVReach: "SentimentPublicationSOVReach",
  SentimentPublicationSOVWordCount: "SentimentPublicationSOVWordCount",

  // // // Journalist Level starts

  SentimentJournalistTrendWordCount: "SentimentJournalistTrendWordCount",
  SentimentJournalistTrendNOA: "SentimentJournalistTrendNOA",
  SentimentJournalistTrendCCM: "SentimentJournalistTrendCCM",
  SentimentJournalistTrendMAV: "SentimentJournalistTrendMAV",
  SentimentJournalistTrendIndex: "SentimentJournalistTrendIndex",
  SentimentJournalistTrendReach: "SentimentJournalistTrendReach",
  SentimentJournalistSOVNOA: "SentimentJournalistSOVNOA",
  SentimentJournalistSOVCCM: "SentimentJournalistSOVCCM",
  SentimentJournalistSOVMAV: "SentimentJournalistSOVMAV",
  SentimentJournalistSOVIndex: "SentimentJournalistSOVIndex",
  SentimentJournalistSOVReach: "SentimentJournalistSOVReach",
  SentimentJournalistSOVWordCount: "SentimentJournalistSOVWordCount",

  // // // City Level starts

  SentimentCityTrendNOA: "SentimentCityTrendNOA",
  SentimentCityTrendCCM: "SentimentCityTrendCCM",
  SentimentCityTrendMAV: "SentimentCityTrendMAV",
  SentimentCityTrendIndex: "SentimentCityTrendIndex",
  SentimentCityTrendReach: "SentimentCityTrendReach",
  SentimentCitySOVNOA: "SentimentCitySOVNOA",
  SentimentCitySOVCCM: "SentimentCitySOVCCM",
  SentimentCitySOVMAV: "SentimentCitySOVMAV",
  SentimentCitySOVIndex: "SentimentCitySOVIndex",
  SentimentCitySOVReach: "SentimentCitySOVReach",

  // // // Keyword Level starts

  SentimentKeywordTrendWordCount: "SentimentKeywordTrendWordCount",
  SentimentKeywordTrendNOA: "SentimentKeywordTrendNOA",
  SentimentKeywordTrendCCM: "SentimentKeywordTrendCCM",
  SentimentKeywordTrendMAV: "SentimentKeywordTrendMAV",
  SentimentKeywordTrendIndex: "SentimentKeywordTrendIndex",
  SentimentKeywordTrendReach: "SentimentKeywordTrendReach",
  SentimentKeywordSOVNOA: "SentimentKeywordSOVNOA",
  SentimentKeywordSOVCCM: "SentimentKeywordSOVCCM",
  SentimentKeywordSOVMAV: "SentimentKeywordSOVMAV",
  SentimentKeywordSOVIndex: "SentimentKeywordSOVIndex",
  SentimentKeywordSOVReach: "SentimentKeywordSOVReach",
  SentimentKeywordSOVWordCount: "SentimentKeywordSOVWordCount",


  //new entitty for all starts

  SentimentNewEntitySOVNOA: "SentimentNewEntitySOVNOA",
  SentimentNewEntitySOVCCM: "SentimentNewEntitySOVCCM",
  SentimentNewEntitySOVMAV: "SentimentNewEntitySOVMAV",
  SentimentNewEntitySOVIndex: "SentimentNewEntitySOVIndex",
  SentimentNewEntitySOVReach: "SentimentNewEntitySOVReach",
  SentimentNewEntitySOVWordCount: "SentimentNewEntitySOVWordCount",
  ///new entity for all ends
  // // // Entity Level ends

  // sentiment Ends


  // Spokesperson Starts

  // // // Entity Level starts

  SpokespersonEntityTrendWordCount: "SpokespersonEntityTrendWordCount",
  SpokespersonEntityTrendNOA: "SpokespersonEntityTrendNOA",
  SpokespersonEntityTrendCCM: "SpokespersonEntityTrendCCM",
  SpokespersonEntityTrendMAV: "SpokespersonEntityTrendMAV",
  SpokespersonEntityTrendIndex: "SpokespersonEntityTrendIndex",
  SpokespersonEntityTrendReach: "SpokespersonEntityTrendReach",
  SpokespersonEntitySOVNOA: "SpokespersonEntitySOVNOA",
  SpokespersonEntitySOVCCM: "SpokespersonEntitySOVCCM",
  SpokespersonEntitySOVMAV: "SpokespersonEntitySOVMAV",
  SpokespersonEntitySOVIndex: "SpokespersonEntitySOVIndex",
  SpokespersonEntitySOVReach: "SpokespersonEntitySOVReach",
  SpokespersonEntitySOVWordCount: "SpokespersonEntitySOVWordCount",

  // // // Topic Level starts

  SpokespersonTopicTrendWordCount: "SpokespersonTopicTrendWordCount",
  SpokespersonTopicTrendNOA: "SpokespersonTopicTrendNOA",
  SpokespersonTopicTrendCCM: "SpokespersonTopicTrendCCM",
  SpokespersonTopicTrendMAV: "SpokespersonTopicTrendMAV",
  SpokespersonTopicTrendIndex: "SpokespersonTopicTrendIndex",
  SpokespersonTopicTrendReach: "SpokespersonTopicTrendReach",
  SpokespersonTopicSOVNOA: "SpokespersonTopicSOVNOA",
  SpokespersonTopicSOVCCM: "SpokespersonTopicSOVCCM",
  SpokespersonTopicSOVMAV: "SpokespersonTopicSOVMAV",
  SpokespersonTopicSOVIndex: "SpokespersonTopicSOVIndex",
  SpokespersonTopicSOVReach: "SpokespersonTopicSOVReach",
  SpokespersonTopicSOVWordCount: "SpokespersonTopicSOVWordCount",

  // // // Journalist Level starts

  SpokespersonJournalistTrendWordCount: "SpokespersonJournalistTrendWordCount",
  SpokespersonJournalistTrendNOA: "SpokespersonJournalistTrendNOA",
  SpokespersonJournalistTrendCCM: "SpokespersonJournalistTrendCCM",
  SpokespersonJournalistTrendMAV: "SpokespersonJournalistTrendMAV",
  SpokespersonJournalistTrendIndex: "SpokespersonJournalistTrendIndex",
  SpokespersonJournalistTrendReach: "SpokespersonJournalistTrendReach",
  SpokespersonJournalistSOVNOA: "SpokespersonJournalistSOVNOA",
  SpokespersonJournalistSOVCCM: "SpokespersonJournalistSOVCCM",
  SpokespersonJournalistSOVMAV: "SpokespersonJournalistSOVMAV",
  SpokespersonJournalistSOVIndex: "SpokespersonJournalistSOVIndex",
  SpokespersonJournalistSOVReach: "SpokespersonJournalistSOVReach",
  SpokespersonJournalistSOVWordCount: "SpokespersonJournalistSOVWordCount",



  // // // Profile Level starts

  SpokespersonProfileTrendWordCount: "SpokespersonProfileTrendWordCount",
  SpokespersonProfileTrendNOA: "SpokespersonProfileTrendNOA",
  SpokespersonProfileTrendCCM: "SpokespersonProfileTrendCCM",
  SpokespersonProfileTrendMAV: "SpokespersonProfileTrendMAV",
  SpokespersonProfileTrendIndex: "SpokespersonProfileTrendIndex",
  SpokespersonProfileTrendReach: "SpokespersonProfileTrendReach",
  SpokespersonProfileSOVNOA: "SpokespersonProfileSOVNOA",
  SpokespersonProfileSOVCCM: "SpokespersonProfileSOVCCM",
  SpokespersonProfileSOVMAV: "SpokespersonProfileSOVMAV",
  SpokespersonProfileSOVIndex: "SpokespersonProfileSOVIndex",
  SpokespersonProfileSOVReach: "SpokespersonProfileSOVReach",
  SpokespersonProfileSOVWordCount: "SpokespersonProfileSOVWordCount",

  // // // Entity Level ends

  // Spokesperson ends

  // Journalist Starts

  // Entity level starts

  JournalistEntitySOVNOA: "JournalistEntitySOVNOA",
  JournalistEntitySOVCCM: "JournalistEntitySOVCCM",
  JournalistEntitySOVMAV: "JournalistEntitySOVMAV",
  JournalistEntitySOVIndex: "JournalistEntitySOVIndex",
  JournalistEntitySOVReach: "JournalistEntitySOVReach",
  JournalistEntitySOVWordCount: "JournalistEntitySOVWordCount",
  JournalistEntityTrendWordCount: "JournalistEntityTrendWordCount",
  JournalistEntityTrendNOA: "JournalistEntityTrendNOA",
  JournalistEntityTrendCCM: "JournalistEntityTrendCCM",
  JournalistEntityTrendMAV: "JournalistEntityTrendMAV",
  JournalistEntityTrendIndex: "JournalistEntityTrendIndex",
  JournalistEntityTrendReach: "JournalistEntityTrendReach",
  JournalistEntityTrendWordCount: "JournalistEntityTrendWordCount",
  JournalistEntityTonalityNOA: "JournalistEntityTonalityNOA",
  JournalistEntityTonalityCCM: "JournalistEntityTonalityCCM",
  JournalistEntityTonalityMAV: "JournalistEntityTonalityMAV",
  JournalistEntityTonalityIndex: "JournalistEntityTonalityIndex",
  JournalistEntityTonalityReach: "JournalistEntityTonalityReach",
  JournalistEntityTonalityWordCount: "JournalistEntityTonalityWordCount",

  // Keyword level starts

  JournalistKeywordSOVNOA: "JournalistKeywordSOVNOA",
  JournalistKeywordSOVCCM: "JournalistKeywordSOVCCM",
  JournalistKeywordSOVMAV: "JournalistKeywordSOVMAV",
  JournalistKeywordSOVIndex: "JournalistKeywordSOVIndex",
  JournalistKeywordSOVReach: "JournalistKeywordSOVReach",
  JournalistKeywordSOVWordCount: "JournalistKeywordSOVWordCount",
  JournalistKeywordTrendWordCount: "JournalistKeywordTrendWordCount",
  JournalistKeywordTrendNOA: "JournalistKeywordTrendNOA",
  JournalistKeywordTrendCCM: "JournalistKeywordTrendCCM",
  JournalistKeywordTrendMAV: "JournalistKeywordTrendMAV",
  JournalistKeywordTrendIndex: "JournalistKeywordTrendIndex",
  JournalistKeywordTrendReach: "JournalistKeywordTrendReach",
  JournalistKeywordTrendWordCount: "JournalistKeywordTrendWordCount",
  JournalistKeywordTonalityNOA: "JournalistKeywordTonalityNOA",
  JournalistKeywordTonalityCCM: "JournalistKeywordTonalityCCM",
  JournalistKeywordTonalityMAV: "JournalistKeywordTonalityMAV",
  JournalistKeywordTonalityIndex: "JournalistKeywordTonalityIndex",
  JournalistKeywordTonalityReach: "JournalistKeywordTonalityReach",
  JournalistKeywordTonalityWordCount: "JournalistKeywordTonalityWordCount",


  //Journalist Ends


  // Keyword Starts

  // Entity level starts

  KeywordEntitySOVNOA: "KeywordEntitySOVNOA",
  KeywordEntitySOVCCM: "KeywordEntitySOVCCM",
  KeywordEntitySOVMAV: "KeywordEntitySOVMAV",
  KeywordEntitySOVIndex: "KeywordEntitySOVIndex",
  KeywordEntitySOVReach: "KeywordEntitySOVReach",
  KeywordEntitySOVWordCount: "KeywordEntitySOVWordCount",
  KeywordEntityTrendWordCount: "KeywordEntityTrendWordCount",
  KeywordEntityTrendNOA: "KeywordEntityTrendNOA",
  KeywordEntityTrendCCM: "KeywordEntityTrendCCM",
  KeywordEntityTrendMAV: "KeywordEntityTrendMAV",
  KeywordEntityTrendIndex: "KeywordEntityTrendIndex",
  KeywordEntityTrendReach: "KeywordEntityTrendReach",
  KeywordEntityTrendWordCount: "KeywordEntityTrendWordCount",
  KeywordEntityTonalityNOA: "KeywordEntityTonalityNOA",
  KeywordEntityTonalityCCM: "KeywordEntityTonalityCCM",
  KeywordEntityTonalityMAV: "KeywordEntityTonalityMAV",
  KeywordEntityTonalityIndex: "KeywordEntityTonalityIndex",
  KeywordEntityTonalityReach: "KeywordEntityTonalityReach",
  KeywordEntityTonalityWordCount: "KeywordEntityTonalityWordCount",

  //Publication level
  KeywordPublicationSOVNOA: "KeywordPublicationSOVNOA",
  KeywordPublicationSOVCCM: "KeywordPublicationSOVCCM",
  KeywordPublicationSOVMAV: "KeywordPublicationSOVMAV",
  KeywordPublicationSOVIndex: "KeywordPublicationSOVIndex",
  KeywordPublicationSOVReach: "KeywordPublicationSOVReach",
  KeywordPublicationSOVWordCount: "KeywordPublicationSOVWordCount",
  KeywordPublicationTrendWordCount: "KeywordPublicationTrendWordCount",
  KeywordPublicationTrendNOA: "KeywordPublicationTrendNOA",
  KeywordPublicationTrendCCM: "KeywordPublicationTrendCCM",
  KeywordPublicationTrendMAV: "KeywordPublicationTrendMAV",
  KeywordPublicationTrendIndex: "KeywordPublicationTrendIndex",
  KeywordPublicationTrendReach: "KeywordPublicationTrendReach",
  KeywordPublicationTrendWordCount: "KeywordPublicationTrendWordCount",
  KeywordPublicationTonalityNOA: "KeywordPublicationTonalityNOA",
  KeywordPublicationTonalityCCM: "KeywordPublicationTonalityCCM",
  KeywordPublicationTonalityMAV: "KeywordPublicationTonalityMAV",
  KeywordPublicationTonalityIndex: "KeywordPublicationTonalityIndex",
  KeywordPublicationTonalityReach: "KeywordPublicationTonalityReach",
  KeywordPublicationTonalityWordCount: "KeywordPublicationTonalityWordCount",

  //Journalist level

  KeywordJournalistSOVNOA: "KeywordJournalistSOVNOA",
  KeywordJournalistSOVCCM: "KeywordJournalistSOVCCM",
  KeywordJournalistSOVMAV: "KeywordJournalistSOVMAV",
  KeywordJournalistSOVIndex: "KeywordJournalistSOVIndex",
  KeywordJournalistSOVReach: "KeywordJournalistSOVReach",
  KeywordJournalistSOVWordCount: "KeywordJournalistSOVWordCount",
  KeywordJournalistTrendWordCount: "KeywordJournalistTrendWordCount",
  KeywordJournalistTrendNOA: "KeywordJournalistTrendNOA",
  KeywordJournalistTrendCCM: "KeywordJournalistTrendCCM",
  KeywordJournalistTrendMAV: "KeywordJournalistTrendMAV",
  KeywordJournalistTrendIndex: "KeywordJournalistTrendIndex",
  KeywordJournalistTrendReach: "KeywordJournalistTrendReach",
  KeywordJournalistTrendWordCount: "KeywordJournalistTrendWordCount",
  KeywordJournalistTonalityNOA: "KeywordJournalistTonalityNOA",
  KeywordJournalistTonalityCCM: "KeywordJournalistTonalityCCM",
  KeywordJournalistTonalityMAV: "KeywordJournalistTonalityMAV",
  KeywordJournalistTonalityIndex: "KeywordJournalistTonalityIndex",
  KeywordJournalistTonalityReach: "KeywordJournalistTonalityReach",
  KeywordJournalistTonalityWordCount: "KeywordJournalistTonalityWordCount",

  //City level

  KeywordCitySOVNOA: "KeywordCitySOVNOA",
  KeywordCitySOVCCM: "KeywordCitySOVCCM",
  KeywordCitySOVMAV: "KeywordCitySOVMAV",
  KeywordCitySOVIndex: "KeywordCitySOVIndex",
  KeywordCitySOVReach: "KeywordCitySOVReach",
  KeywordCitySOVWordCount: "KeywordCitySOVWordCount",
  KeywordCityTrendWordCount: "KeywordCityTrendWordCount",
  KeywordCityTrendNOA: "KeywordCityTrendNOA",
  KeywordCityTrendCCM: "KeywordCityTrendCCM",
  KeywordCityTrendMAV: "KeywordCityTrendMAV",
  KeywordCityTrendIndex: "KeywordCityTrendIndex",
  KeywordCityTrendReach: "KeywordCityTrendReach",
  KeywordCityTrendWordCount: "KeywordCityTrendWordCount",
  KeywordCityTonalityNOA: "KeywordCityTonalityNOA",
  KeywordCityTonalityCCM: "KeywordCityTonalityCCM",
  KeywordCityTonalityMAV: "KeywordCityTonalityMAV",
  KeywordCityTonalityIndex: "KeywordCityTonalityIndex",
  KeywordCityTonalityReach: "KeywordCityTonalityReach",
  KeywordCityTonalityWordCount: "KeywordCityTonalityWordCount",

  //Spokesperson level

  KeywordSpokespersonSOVNOA: "KeywordSpokespersonSOVNOA",
  KeywordSpokespersonSOVCCM: "KeywordSpokespersonSOVCCM",
  KeywordSpokespersonSOVMAV: "KeywordSpokespersonSOVMAV",
  KeywordSpokespersonSOVIndex: "KeywordSpokespersonSOVIndex",
  KeywordSpokespersonSOVReach: "KeywordSpokespersonSOVReach",
  KeywordSpokespersonSOVWordCount: "KeywordSpokespersonSOVWordCount",
  KeywordSpokespersonTrendWordCount: "KeywordSpokespersonTrendWordCount",
  KeywordSpokespersonTrendNOA: "KeywordSpokespersonTrendNOA",
  KeywordSpokespersonTrendCCM: "KeywordSpokespersonTrendCCM",
  KeywordSpokespersonTrendMAV: "KeywordSpokespersonTrendMAV",
  KeywordSpokespersonTrendIndex: "KeywordSpokespersonTrendIndex",
  KeywordSpokespersonTrendReach: "KeywordSpokespersonTrendReach",
  KeywordSpokespersonTrendWordCount: "KeywordSpokespersonTrendWordCount",
  KeywordSpokespersonTonalityNOA: "KeywordSpokespersonTonalityNOA",
  KeywordSpokespersonTonalityCCM: "KeywordSpokespersonTonalityCCM",
  KeywordSpokespersonTonalityMAV: "KeywordSpokespersonTonalityMAV",
  KeywordSpokespersonTonalityIndex: "KeywordSpokespersonTonalityIndex",
  KeywordSpokespersonTonalityReach: "KeywordSpokespersonTonalityReach",
  KeywordSpokespersonTonalityWordCount: "KeywordSpokespersonTonalityWordCount",


  //Thematic starts
  // // // Entity Level starts
  ThematicEntitySOVNOA: "ThematicEntitySOVNOA",
  ThematicEntitySOVCCM: "ThematicEntitySOVCCM",
  ThematicEntitySOVMAV: "ThematicEntitySOVMAV",
  ThematicEntitySOVIndex: "ThematicEntitySOVIndex",
  ThematicEntitySOVReach: "ThematicEntitySOVReach",
  ThematicEntitySOVWordCount: "ThematicEntitySOVWordCount",
  ThematicEntityTrendWordCount: "ThematicEntityTrendWordCount",
  ThematicEntityTrendNOA: "ThematicEntityTrendNOA",
  ThematicEntityTrendCCM: "ThematicEntityTrendCCM",
  ThematicEntityTrendMAV: "ThematicEntityTrendMAV",
  ThematicEntityTrendIndex: "ThematicEntityTrendIndex",
  ThematicEntityTrendReach: "ThematicEntityTrendReach",
  ThematicEntityTrendWordCount: "ThematicEntityTrendWordCount",
  ThematicEntityTonalityNOA: "ThematicEntityTonalityNOA",
  ThematicEntityTonalityCCM: "ThematicEntityTonalityCCM",
  ThematicEntityTonalityMAV: "ThematicEntityTonalityMAV",
  ThematicEntityTonalityIndex: "ThematicEntityTonalityIndex",
  ThematicEntityTonalityReach: "ThematicEntityTonalityReach",
  ThematicEntityTonalityWordCount: "ThematicEntityTonalityWordCount",
  // // // Entity Level ends
  // // // Journalist Level starts
  ThematicJournalistSOVNOA: "ThematicJournalistSOVNOA",
  ThematicJournalistSOVCCM: "ThematicJournalistSOVCCM",
  ThematicJournalistSOVMAV: "ThematicJournalistSOVMAV",
  ThematicJournalistSOVIndex: "ThematicJournalistSOVIndex",
  ThematicJournalistSOVReach: "ThematicJournalistSOVReach",
  ThematicJournalistSOVWordCount: "ThematicJournalistSOVWordCount",
  ThematicJournalistTrendNOA: "ThematicJournalistTrendNOA",
  ThematicJournalistTrendCCM: "ThematicJournalistTrendCCM",
  ThematicJournalistTrendMAV: "ThematicJournalistTrendMAV",
  ThematicJournalistTrendIndex: "ThematicJournalistTrendIndex",
  ThematicJournalistTrendReach: "ThematicJournalistTrendReach",
  ThematicJournalistTrendWordCount: "ThematicJournalistTrendWordCount",
  ThematicJournalistTonalityNOA: "ThematicJournalistTonalityNOA",
  ThematicJournalistTonalityCCM: "ThematicJournalistTonalityCCM",
  ThematicJournalistTonalityMAV: "ThematicJournalistTonalityMAV",
  ThematicJournalistTonalityIndex: "ThematicJournalistTonalityIndex",
  ThematicJournalistTonalityReach: "ThematicJournalistTonalityReach",
  ThematicJournalistTonalityWordCount: "ThematicJournalistTonalityWordCount",
  // // // Journalist Level Ends
  // // // Publication Level Starts
  ThematicPublicationSOVNOA: "ThematicPublicationSOVNOA",
  ThematicPublicationSOVCCM: "ThematicPublicationSOVCCM",
  ThematicPublicationSOVMAV: "ThematicPublicationSOVMAV",
  ThematicPublicationSOVIndex: "ThematicPublicationSOVIndex",
  ThematicPublicationSOVReach: "ThematicPublicationSOVReach",
  ThematicPublicationSOVWordCount: "ThematicPublicationSOVWordCount",
  ThematicPublicationTrendNOA: "ThematicPublicationTrendNOA",
  ThematicPublicationTrendCCM: "ThematicPublicationTrendCCM",
  ThematicPublicationTrendMAV: "ThematicPublicationTrendMAV",
  ThematicPublicationTrendIndex: "ThematicPublicationTrendIndex",
  ThematicPublicationTrendReach: "ThematicPublicationTrendReach",
  ThematicPublicationTrendWordCount: "ThematicPublicationTrendWordCount",
  ThematicPublicationTonalityNOA: "ThematicPublicationTonalityNOA",
  ThematicPublicationTonalityCCM: "ThematicPublicationTonalityCCM",
  ThematicPublicationTonalityMAV: "ThematicPublicationTonalityMAV",
  ThematicPublicationTonalityIndex: "ThematicPublicationTonalityIndex",
  ThematicPublicationTonalityReach: "ThematicPublicationTonalityReach",
  ThematicPublicationTonalityWordCount: "ThematicPublicationTonalityWordCount",
  // // // Publication Level Ends
  // // // City Level Starts
  ThematicCitySOVNOA: "ThematicCitySOVNOA",
  ThematicCitySOVCCM: "ThematicCitySOVCCM",
  ThematicCitySOVMAV: "ThematicCitySOVMAV",
  ThematicCitySOVIndex: "ThematicCitySOVIndex",
  ThematicCitySOVReach: "ThematicCitySOVReach",
  ThematicCitySOVWordCount: "ThematicCitySOVWordCount",
  ThematicCityTrendNOA: "ThematicCityTrendNOA",
  ThematicCityTrendCCM: "ThematicCityTrendCCM",
  ThematicCityTrendMAV: "ThematicCityTrendMAV",
  ThematicCityTrendIndex: "ThematicCityTrendIndex",
  ThematicCityTrendReach: "ThematicCityTrendReach",
  ThematicCityTrendWordCount: "ThematicCityTrendWordCount",
  ThematicCityTonalityNOA: "ThematicCityTonalityNOA",
  ThematicCityTonalityCCM: "ThematicCityTonalityCCM",
  ThematicCityTonalityMAV: "ThematicCityTonalityMAV",
  ThematicCityTonalityIndex: "ThematicCityTonalityIndex",
  ThematicCityTonalityReach: "ThematicCityTonalityReach",
  ThematicCityTonalityWordCount: "ThematicCityTonalityWordCount",
  // // // City Level Ends
  // // // Keyword Level Starts
  ThematicKeywordSOVNOA: "ThematicKeywordSOVNOA",
  ThematicKeywordSOVCCM: "ThematicKeywordSOVCCM",
  ThematicKeywordSOVMAV: "ThematicKeywordSOVMAV",
  ThematicKeywordSOVIndex: "ThematicKeywordSOVIndex",
  ThematicKeywordSOVReach: "ThematicKeywordSOVReach",
  ThematicKeywordSOVWordCount: "ThematicKeywordSOVWordCount",
  ThematicKeywordTrendNOA: "ThematicKeywordTrendNOA",
  ThematicKeywordTrendCCM: "ThematicKeywordTrendCCM",
  ThematicKeywordTrendMAV: "ThematicKeywordTrendMAV",
  ThematicKeywordTrendIndex: "ThematicKeywordTrendIndex",
  ThematicKeywordTrendReach: "ThematicKeywordTrendReach",
  ThematicKeywordTrendWordCount: "ThematicKeywordTrendWordCount",
  ThematicKeywordTonalityNOA: "ThematicKeywordTonalityNOA",
  ThematicKeywordTonalityCCM: "ThematicKeywordTonalityCCM",
  ThematicKeywordTonalityMAV: "ThematicKeywordTonalityMAV",
  ThematicKeywordTonalityIndex: "ThematicKeywordTonalityIndex",
  ThematicKeywordTonalityReach: "ThematicKeywordTonalityReach",
  ThematicKeywordTonalityWordCount: "ThematicKeywordTonalityWordCount",
  // // // Keyword Level Ends

  // New entity starts

  ThematicNewEntitySOVNOA: "ThematicNewEntitySOVNOA",
  ThematicNewEntitySOVCCM: "ThematicNewEntitySOVCCM",
  ThematicNewEntitySOVMAV: "ThematicNewEntitySOVMAV",
  ThematicNewEntitySOVIndex: "ThematicNewEntitySOVIndex",
  ThematicNewEntitySOVReach: "ThematicNewEntitySOVReach",
  ThematicNewEntitySOVWordCount: "ThematicNewEntitySOVWordCount",

  //new entity ends
  //Thematic Ends
  //Geolocation starts
  // // // Entity Level starts
  GeolocationEntitySOVNOA: "GeolocationEntitySOVNOA",
  GeolocationEntitySOVCCM: "GeolocationEntitySOVCCM",
  GeolocationEntitySOVMAV: "GeolocationEntitySOVMAV",
  GeolocationEntitySOVIndex: "GeolocationEntitySOVIndex",
  GeolocationEntitySOVReach: "GeolocationEntitySOVReach",
  GeolocationEntitySOVWordCount: "GeolocationEntitySOVWordCount",
  GeolocationEntityTrendWordCount: "GeolocationEntityTrendWordCount",
  GeolocationEntityTrendNOA: "GeolocationEntityTrendNOA",
  GeolocationEntityTrendCCM: "GeolocationEntityTrendCCM",
  GeolocationEntityTrendMAV: "GeolocationEntityTrendMAV",
  GeolocationEntityTrendIndex: "GeolocationEntityTrendIndex",
  GeolocationEntityTrendReach: "GeolocationEntityTrendReach",
  GeolocationEntityTrendWordCount: "GeolocationEntityTrendWordCount",
  GeolocationEntityTonalityNOA: "GeolocationEntityTonalityNOA",
  GeolocationEntityTonalityCCM: "GeolocationEntityTonalityCCM",
  GeolocationEntityTonalityMAV: "GeolocationEntityTonalityMAV",
  GeolocationEntityTonalityIndex: "GeolocationEntityTonalityIndex",
  GeolocationEntityTonalityReach: "GeolocationEntityTonalityReach",
  GeolocationEntityTonalityWordCount: "GeolocationEntityTonalityWordCount",
  // // // Entity Level ends
  // // // Keyword Level Starts
  GeolocationKeywordSOVNOA: "GeolocationKeywordSOVNOA",
  GeolocationKeywordSOVCCM: "GeolocationKeywordSOVCCM",
  GeolocationKeywordSOVMAV: "GeolocationKeywordSOVMAV",
  GeolocationKeywordSOVIndex: "GeolocationKeywordSOVIndex",
  GeolocationKeywordSOVReach: "GeolocationKeywordSOVReach",
  GeolocationKeywordSOVWordCount: "GeolocationKeywordSOVWordCount",
  GeolocationKeywordTrendNOA: "GeolocationKeywordTrendNOA",
  GeolocationKeywordTrendCCM: "GeolocationKeywordTrendCCM",
  GeolocationKeywordTrendMAV: "GeolocationKeywordTrendMAV",
  GeolocationKeywordTrendIndex: "GeolocationKeywordTrendIndex",
  GeolocationKeywordTrendReach: "GeolocationKeywordTrendReach",
  GeolocationKeywordTrendWordCount: "GeolocationKeywordTrendWordCount",
  GeolocationKeywordTonalityNOA: "GeolocationKeywordTonalityNOA",
  GeolocationKeywordTonalityCCM: "GeolocationKeywordTonalityCCM",
  GeolocationKeywordTonalityMAV: "GeolocationKeywordTonalityMAV",
  GeolocationKeywordTonalityIndex: "GeolocationKeywordTonalityIndex",
  GeolocationKeywordTonalityReach: "GeolocationKeywordTonalityReach",
  GeolocationKeywordTonalityWordCount: "GeolocationKeywordTonalityWordCount",
  // // // Keyword Level Ends
  // // // Publication Level Starts
  GeolocationPublicationSOVNOA: "GeolocationPublicationSOVNOA",
  GeolocationPublicationSOVCCM: "GeolocationPublicationSOVCCM",
  GeolocationPublicationSOVMAV: "GeolocationPublicationSOVMAV",
  GeolocationPublicationSOVIndex: "GeolocationPublicationSOVIndex",
  GeolocationPublicationSOVReach: "GeolocationPublicationSOVReach",
  GeolocationPublicationSOVWordCount: "GeolocationPublicationSOVWordCount",
  GeolocationPublicationTrendNOA: "GeolocationPublicationTrendNOA",
  GeolocationPublicationTrendCCM: "GeolocationPublicationTrendCCM",
  GeolocationPublicationTrendMAV: "GeolocationPublicationTrendMAV",
  GeolocationPublicationTrendIndex: "GeolocationPublicationTrendIndex",
  GeolocationPublicationTrendReach: "GeolocationPublicationTrendReach",
  GeolocationPublicationTrendWordCount: "GeolocationPublicationTrendWordCount",
  GeolocationPublicationTonalityNOA: "GeolocationPublicationTonalityNOA",
  GeolocationPublicationTonalityCCM: "GeolocationPublicationTonalityCCM",
  GeolocationPublicationTonalityMAV: "GeolocationPublicationTonalityMAV",
  GeolocationPublicationTonalityIndex: "GeolocationPublicationTonalityIndex",
  GeolocationPublicationTonalityReach: "GeolocationPublicationTonalityReach",
  GeolocationPublicationTonalityWordCount: "GeolocationPublicationTonalityWordCount",
  // // // Publication Level Ends

  //New Entity All editons starts
  GeolocationNewEntitySOVNOA: "GeolocationNewEntitySOVNOA",
  GeolocationNewEntitySOVCCM: "GeolocationNewEntitySOVCCM",
  GeolocationNewEntitySOVMAV: "GeolocationNewEntitySOVMAV",
  GeolocationNewEntitySOVIndex: "GeolocationNewEntitySOVIndex",
  GeolocationNewEntitySOVReach: "GeolocationNewEntitySOVReach",
  GeolocationNewEntitySOVWordCount: "GeolocationNewEntitySOVWordCount",
  //New entity all editions ends
  //Geolocation
  //Publication starts
  // // // Entity Level starts
  PublicationEntitySOVNOA: "PublicationEntitySOVNOA",
  PublicationEntitySOVCCM: "PublicationEntitySOVCCM",
  PublicationEntitySOVMAV: "PublicationEntitySOVMAV",
  PublicationEntitySOVIndex: "PublicationEntitySOVIndex",
  PublicationEntitySOVReach: "PublicationEntitySOVReach",
  PublicationEntitySOVWordCount: "PublicationEntitySOVWordCount",
  PublicationEntityTrendWordCount: "PublicationEntityTrendWordCount",
  PublicationEntityTrendNOA: "PublicationEntityTrendNOA",
  PublicationEntityTrendCCM: "PublicationEntityTrendCCM",
  PublicationEntityTrendMAV: "PublicationEntityTrendMAV",
  PublicationEntityTrendIndex: "PublicationEntityTrendIndex",
  PublicationEntityTrendReach: "PublicationEntityTrendReach",
  PublicationEntityTrendWordCount: "PublicationEntityTrendWordCount",
  PublicationEntityTonalityNOA: "PublicationEntityTonalityNOA",
  PublicationEntityTonalityCCM: "PublicationEntityTonalityCCM",
  PublicationEntityTonalityMAV: "PublicationEntityTonalityMAV",
  PublicationEntityTonalityIndex: "PublicationEntityTonalityIndex",
  PublicationEntityTonalityReach: "PublicationEntityTonalityReach",
  PublicationEntityTonalityWordCount: "PublicationEntityTonalityWordCount",
  // // // Entity Level ends
  // // // Keyword Level Starts
  PublicationKeywordSOVNOA: "PublicationKeywordSOVNOA",
  PublicationKeywordSOVCCM: "PublicationKeywordSOVCCM",
  PublicationKeywordSOVMAV: "PublicationKeywordSOVMAV",
  PublicationKeywordSOVIndex: "PublicationKeywordSOVIndex",
  PublicationKeywordSOVReach: "PublicationKeywordSOVReach",
  PublicationKeywordSOVWordCount: "PublicationKeywordSOVWordCount",
  PublicationKeywordTrendNOA: "PublicationKeywordTrendNOA",
  PublicationKeywordTrendCCM: "PublicationKeywordTrendCCM",
  PublicationKeywordTrendMAV: "PublicationKeywordTrendMAV",
  PublicationKeywordTrendIndex: "PublicationKeywordTrendIndex",
  PublicationKeywordTrendReach: "PublicationKeywordTrendReach",
  PublicationKeywordTrendWordCount: "PublicationKeywordTrendWordCount",
  PublicationKeywordTonalityNOA: "PublicationKeywordTonalityNOA",
  PublicationKeywordTonalityCCM: "PublicationKeywordTonalityCCM",
  PublicationKeywordTonalityMAV: "PublicationKeywordTonalityMAV",
  PublicationKeywordTonalityIndex: "PublicationKeywordTonalityIndex",
  PublicationKeywordTonalityReach: "PublicationKeywordTonalityReach",
  PublicationKeywordTonalityWordCount: "PublicationKeywordTonalityWordCount",
  // // // Keyword Level Ends
  // // // Journalist Level Starts
  PublicationJournalistSOVNOA: "PublicationJournalistSOVNOA",
  PublicationJournalistSOVCCM: "PublicationJournalistSOVCCM",
  PublicationJournalistSOVMAV: "PublicationJournalistSOVMAV",
  PublicationJournalistSOVIndex: "PublicationJournalistSOVIndex",
  PublicationJournalistSOVReach: "PublicationJournalistSOVReach",
  PublicationJournalistSOVWordCount: "PublicationJournalistSOVWordCount",
  PublicationJournalistTrendNOA: "PublicationJournalistTrendNOA",
  PublicationJournalistTrendCCM: "PublicationJournalistTrendCCM",
  PublicationJournalistTrendMAV: "PublicationJournalistTrendMAV",
  PublicationJournalistTrendIndex: "PublicationJournalistTrendIndex",
  PublicationJournalistTrendReach: "PublicationJournalistTrendReach",
  PublicationJournalistTrendWordCount: "PublicationJournalistTrendWordCount",
  PublicationJournalistTonalityNOA: "PublicationJournalistTonalityNOA",
  PublicationJournalistTonalityCCM: "PublicationJournalistTonalityCCM",
  PublicationJournalistTonalityMAV: "PublicationJournalistTonalityMAV",
  PublicationJournalistTonalityIndex: "PublicationJournalistTonalityIndex",
  PublicationJournalistTonalityReach: "PublicationJournalistTonalityReach",
  PublicationJournalistTonalityWordCount: "PublicationJournalistTonalityWordCount",
  // // // Journalist Level Ends

  //New entity starts
  PublicationNewEntitySOVNOA: "PublicationNewEntitySOVNOA",
  PublicationNewEntitySOVCCM: "PublicationNewEntitySOVCCM",
  PublicationNewEntitySOVMAV: "PublicationNewEntitySOVMAV",
  PublicationNewEntitySOVIndex: "PublicationNewEntitySOVIndex",
  PublicationNewEntitySOVReach: "PublicationNewEntitySOVReach",
  PublicationNewEntitySOVWordCount: "PublicationNewEntitySOVWordCount",

  //new entity ends
  //Publication Ends
  //prev qualitative
  SOVReportIndex: "30",
  SOVReportArticle: "31",
  SNAPSHOT: "32",
  SOVStory: "33",
  STORYTABLE: "34",
  JournalistReportIndex: "35",
  JournalistReportArticle: "36",
  JournalistSentiment: "37",
  SentimentReportIndex: "38",
  SentimentReportArticle: "39",
  SentimentGenreIndex: "40",
  SentimentGenreArticle: "41",
  ThematicReportThemeWiseArticle: "42",
  ThematicReportThemeWiseIndex: "43",
  ThematicReportWithTopicArticle: "44",
  ThematicReportWithTopicIndex: "45",
  ThematicReportThemeWiseSpreadArticle: "46",
  ThematicReportThemeWiseSpreadIndex: "47",
  ThematicReportEntityWiseSpreadArticle: "ThematicReportEntityWiseSpreadArticle",
  ThematicReportEntityWiseSpreadIndex: "ThematicReportEntityWiseSpreadIndex",
  ThematicReportThemeWiseSpreadRanking: "ThemeWiseSpreadRanking",
  GeolocationZonalSpreadArticle: "48",
  GeolocationZonalSpreadIndex: "49",
  SENTIMENTTABLEINDEX: "50",
  SENTIMENTTABLEARTICLE: "51",
  SPOKESPERSONINDEX: "52",
  SPOKESPERSONARTICLE: "53",
  GeolocationZonalSpreadIndexEntityWise: "54",
  GeolocationZoneWiseArticle: "55",
  GeolocationZoneWiseTopPublication: "56",
  GeolocationMarketSpread: "57",
  GeolocationZoneWiseSOVIndex: "58",
  GeolocationCityWiseArticle: "GeolocationCityWiseArticle",
  GeolocationCityWiseTopPublication: "GeolocationCityWiseTopPublication",
  GeolocationCityWiseSOVIndex: "GeolocationCityWiseSOVIndex",
  KeywordReportIndex: "59",
  KeywordReportArticle: "60",
  KeywordReportTrendIndex: "61",
  KeywordReportTrendArticle: "62",
  KeywordReportSentimentIndex: "63",
  KeywordReportSentimentArticle: "64",
  TonalityDataTV : "TonalityDataTV"
};
export const REPORT_CATEGORIES = {
  PUBLICATION: "PUBLICATION",
  SOV: "SOV",
  JOURNALIST: "JOURNALIST",
  CITY: "CITY",
  CITYNEW: "CITYNEW",
  KEYWORD_CLOUD: "KW",
  REACH: "REACH",
  INFLUENCERS: "INFLUENCERS",
  SENTIMENT: "SENTIMENT",
  TOP_POSTERS: "TOP_POSTERS",
  TOP_LANGUAGES: "LANGUAGE",
  CITY_SPECIFIC_REPORT: "CITY_SPECIFIC_REPORT",
  PLATFORM: "PLATFORM",
  TWITTER: "TWITTER INSIGHTS",
  LINKEDIN: "LINKEDIN INSIGHTS",
  FACEBOOK: "FACEBOOK INSIGHTS",
  INSTAGRAM: "INSTAGRAM INSIGHTS",
  TWITTER_METRICS: "TWITTER METRICS",
  TAG_ANALYSIS: "TAG ANALYSIS",
  THEMATIC_ANALYSIS: "THEMATIC ANALYSIS",
  GEOLOCATION: "GEOLOCATION",
  SPOKESPERSON: "SPOKESPERSON",
  SHARE_RETWEET: "SHARE / RETWEET",
  REPLY_COMMENT: "REPLY / COMMENT",
  ATTACHMENT: "ATTACHMENT",
  LIKE: "LIKE",
  AUTHOR_LIKE: "AUTHOR LIKE",
  MEMBER_TYPE: "MEMBER TYPE",
  TYPE_OF_POST: "TYPE OF POST",
  AUTHOR_FOLLOWING: "AUTHOR FOLLOWING",
  // AUTHOR_LIKE: "AUTHOR LIKE",
  AUTHOR_TWEET_COUNT: "AUTHOR TWEET COUNT",
  AUTHOR_LISTED: "AUTHOR LISTED",
  AUTHOR_CREATION_DETAIL: "AUTHOR CREATION DETAIL",
};
export const TWITTERLEGENDS = [
  // { name: "All", color: "#E96F6F", entityname: "count" },
  { name: "Retweets", color: "#FCC023", entityname: "share_count" },
  { name: "Original Tweets", color: "#D63548", entityname: "original" },
  { name: "Replies", color: "#0979E4", entityname: "comment_count" },
  { name: "Quoted", color: "#AF8BAF", entityname: "share_count" },
];
export const INSIGHTLEGENDS = [
  // { name: "All", color: "#E96F6F", entityname: "count" },
  { name: "Comment", color: "#FCC023", entityname: "comment_count" },
  { name: "Share", color: "#D63548", entityname: "share_count" },
  { name: "Likes", color: "#0979E4", entityname: "like_count" },
];
export const INSTAINSIGHTLEGENDS = [
  // { name: "All", color: "#E96F6F", entityname: "count" },
  { name: "Comment", color: "#FCC023", entityname: "comment_count" },
  { name: "Likes", color: "#0979E4", entityname: "like_count" },
];
export const CONSTANTS = {
  ORIGINALS: "original",
  REPLIES: "comment_count",
  RETWEETS: "share_count",
  QUOTED: "share_count",
  DEFAULT_VALUE: 0,
  PUBLISHDATE: "Publish Date",
  OCTDATE: "2021-10-31",
  WEBSITE_COUNTRY_RANK: "Website Country Rank",
  WEBSITE_GLOBAL_RANK: "Website Global Rank",
  ESTIMATED_ARTICLE_READERSHIP: "Estimated Article Readership",
  MONTHLY_VISITOR: "Monthly Visitors",
  ESTIMATED_PREDICETED_ARTICLE_READERSHIP:
    "Expected Predicted Article Readership",
  WEBSITE_READERSHIP: "Website Readership",
  WEBSITE_RANK: "Website rank",
  GENRE: "Genre",
  RANK: "Rank",
  MEDIA_TYPE: "Media Type",
  COUNTRY: "Country",
  LANGUAGE: "Language",
  SUMMARY: "Summary",
  EMPTY_ARRAY: [],
  EMPTY_OBJECT: {},
  EMPTY_STRING: "",
  DATA_NOT_FOUND: "NA",
  NO_FILTER_RESULTS: "No Matching Data Found.",
  FB: {
    REAUTH: "reauthorize",
    CONNECTED: "connected",
  },
  DEFAULT_LIMIT: 10,
  RANGE: "range",
  SORT_ORDER: "sort_order",
  CHANNELS: "channels",
  TOTAL_ARTICLES: "Total Articles",
  UNIQUE_ARTICLES: "Unique Article",
  /** Names for tonality should be exactly same as we get it on the tonality graph response*/
  TONALITY: [
    {
      text: "Positive",
      tonality: "Positive",
      color: "#ADB842",
      id: 1,
      label: "Positive",
      value: "Positive",
      tonality_id: 1,
      articlecnt: "articlecnt",
    },
    {
      text: "Negative",
      color: "#D63548",
      id: 2,
      label: "Negative",
      value: "Negative",
      articlecnt: "articlecnt",
      tonality_id: 2,
      tonality: "Negative",
    },
    {
      text: "Informative",
      color: "#FCC023",
      id: 3,
      label: "Neutral",
      value: "Neutral",
      tonality_id: 3,
      articlecnt: "articlecnt",
      tonality: "Informative",
    },
  ],
  TWEETTYPE: [
    {
      text: "TwitterQuote",
      color: "#ADB842",
      id: 4,
      label: "TwitterQuote",
      value: "TwitterQuote",
      articlecnt: "articlecnt",
    },
    {
      text: "TwitterReply",
      color: "#D63548",
      id: 3,
      label: "TwitterReply",
      value: "TwitterReply",
      articlecnt: "articlecnt",
    },
    {
      text: "TwitterRetweet",
      color: "#FCC023",
      id: 2,
      label: "TwitterRetweet",
      value: "TwitterRetweet",
      articlecnt: "articlecnt",
    },
  ],
  TABS: {
    PRINT: "PRINT",
    ONLINE: "ONLINE",
    SOCIAL: "SOCIAL",
  },
  PRINT_ONLINE_COUNT_KEYS: [
    "articlecnt",
    "ccm",
    "mav",
    "wordcountsum",
    "ccmcnt",
    "mavcnt",
    "ccmsum",
    "mavsumlkh",
  ],
    REPORTS: {
    TYPES: [
      {
        id: REPORT_TYPES.SOVNOARanking,
        value: REPORT_TYPES.SOVNOARanking,
        reportCategory: "sov",
        label: "Share of Voice By Ranking (Articles)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: true,
        graphDataType: {
          online: GRAPH_DATATYPE.SOVRankingNOAOnline,
          print: GRAPH_DATATYPE.SOVRankingNOAPrint,
          social: 1,
        },
        verticalList: [V_ONLINE, V_PRINT, V_SOCIAL, V_BLOG, V_FORUM],
        groupByField: "publish_date",
        excludeGraphType: [
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          BAR_STACKED_EQUAL_HEIGHT,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity",
        countKey: "articlecnt",
        type: "quantitive"
      },
      {
        id: REPORT_TYPES.SOVCCMRanking,
        value: REPORT_TYPES.SOVCCMRanking,
        reportCategory: "sov",
        label: "Share Of Voice By Ranking (CCM)",
        enablePrint: true,
        enableOnline: false,
        enableSocial: false,
        graphDataType: {
          online: undefined,
          print: GRAPH_DATATYPE.SOVCCMPrint,
          social: undefined,
        },
        groupByField: "publish_date",
        entityKey: "entity",
        countKey: "ccm",
        excludeGraphType: [
          AREA,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          DOUGHNUT,
          CHOROPLETH,
          BAR_STACKED,
        ],
        verticalList: [],
        type: "quantitive"
      },
      {
        id: REPORT_TYPES.SOVMAVRanking,
        value: REPORT_TYPES.SOVMAVRanking,
        reportCategory: "sov",
        label: "Share Of Voice By Ranking (MAV)",
        enablePrint: true,
        enableOnline: false,
        enableSocial: false,
        graphDataType: {
          online: undefined,
          print: GRAPH_DATATYPE.SOVMAVPrint,
          social: undefined,
        },
        groupByField: "publish_date",
        excludeGraphType: [
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          DOUGHNUT,
          CHOROPLETH,
          BAR_STACKED,
        ],
        verticalList: [],
        entityKey: "entity",
        countKey: "mav",
        type: "quantitive"
      },
      {
        id: REPORT_TYPES.SOVWC,
        value: REPORT_TYPES.SOVWC,
        reportCategory: "sov",
        label: "Share Of Voice By Ranking (Word Count)",
        enablePrint: false,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SOVWordCountOnline,
          print: undefined,
          social: undefined,
        },
        groupByField: "publish_date",
        entityKey: "entity",
        countKey: "wordcountsum",
        excludeGraphType: [
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          DOUGHNUT,
          BAR_STACKED,
          CHOROPLETH,
        ],
        verticalList: [],
        type: "quantitive"
      },

      {
        id: REPORT_TYPES.SOV_NOA_TREND,
        value: REPORT_TYPES.SOV_NOA_TREND,
        reportCategory: "sov",
        label: "Share of Voice  By Trend (Articles)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: true,
        graphDataType: {
          online: GRAPH_DATATYPE.TrendAnalysisOnline,
          print: GRAPH_DATATYPE.TrendAnalysisPrint,
          social: 1,
        },
        verticalList: [V_ONLINE, V_PRINT, V_SOCIAL, V_BLOG, V_FORUM],
        groupByField: "publish_date",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          DOUGHNUT,
          BAR_STACKED,
          CHOROPLETH,
        ],
        entityKey: "entity",
        countKey: "articlecnt",
        type: "quantitive"
      },
      {
        id: REPORT_TYPES.TopPostersTrend,
        value: REPORT_TYPES.TopPostersTrend,
        reportCategory: "sov",
        label: "Contributor Trend",
        enablePrint: true,
        enableOnline: true,
        enableSocial: true,
        graphDataType: {
          online: GRAPH_DATATYPE.TrendAnalysisOnline,
          print: GRAPH_DATATYPE.TrendAnalysisPrint,
          social: 1,
        },
        verticalList: [V_ONLINE, V_PRINT, V_SOCIAL, V_BLOG, V_FORUM],
        groupByField: "publish_date",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          BAR_VERTICAL,
          BAR_STACKED_EQUAL_HEIGHT,
          AREA,
          TABLE,
          WORD_CLOUD,
          GENDER,
          DOUGHNUT,
          BAR_STACKED,
          CHOROPLETH,
        ],
        entityKey: "entity",
        countKey: "articlecnt",
        type: "quantitive"
      },
      {
        id: REPORT_TYPES.InfluencerWithDetail,
        value: REPORT_TYPES.InfluencerWithDetail,
        reportCategory: "sov",
        label: "Influencer Trend",
        enablePrint: true,
        enableOnline: true,
        enableSocial: true,
        graphDataType: {
          online: GRAPH_DATATYPE.TrendAnalysisOnline,
          print: GRAPH_DATATYPE.TrendAnalysisPrint,
          social: 1,
        },
        verticalList: [V_ONLINE, V_PRINT, V_SOCIAL, V_BLOG, V_FORUM],
        groupByField: "publish_date",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          BAR_VERTICAL,
          BAR_STACKED_EQUAL_HEIGHT,
          AREA,
          TABLE,
          WORD_CLOUD,
          GENDER,
          DOUGHNUT,
          BAR_STACKED,
          CHOROPLETH,
        ],
        entityKey: "entity",
        countKey: "articlecnt",
        type: "quantitive"
      },
      {
        id: REPORT_TYPES.SOV_CCM_TREND,
        value: REPORT_TYPES.SOV_CCM_TREND,
        label: "Share Of Voice By Trend (CCM)",
        reportCategory: "sov",
        enablePrint: true,
        enableOnline: false,
        enableSocial: false,
        graphDataType: {
          online: undefined,
          print: GRAPH_DATATYPE.TrendAnalysisCCMPrint,
          social: undefined,
        },
        groupByField: "publish_date",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          BAR_STACKED,
          CHOROPLETH,
        ],
        verticalList: [],
        entityKey: "entity",
        countKey: "ccmcnt",
        type: "quantitive"
      },
      {
        id: REPORT_TYPES.SOV_MAV_TREND,
        value: REPORT_TYPES.SOV_MAV_TREND,
        reportCategory: "sov",
        label: "Share Of Voice By Trend (MAV)",
        enablePrint: true,
        enableOnline: false,
        enableSocial: false,
        graphDataType: {
          online: undefined,
          print: GRAPH_DATATYPE.TrendAnalysisMAVPrint,
          social: undefined,
        },
        groupByField: "publish_date",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          DOUGHNUT,
          BAR_STACKED,
          CHOROPLETH,
        ],
        verticalList: [],
        entityKey: "entity",
        countKey: "mavcnt",
        type: "quantitive"
      },
      {
        id: REPORT_TYPES.SOV_WC_TREND,
        value: REPORT_TYPES.SOV_WC_TREND,
        reportCategory: "sov",
        label: "Share Of Voice By Trend (Word Count)",
        enablePrint: false,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.WordCountDateWise,
          print: undefined,
          social: undefined,
        },
        groupByField: "publish_date",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          DOUGHNUT,
          BAR_STACKED,
          CHOROPLETH,
        ],
        verticalList: [],
        entityKey: "entity",
        countKey: "wordcountsum",
        type: "quantitive"
      },

      // Jornalist report types start
      {
        id: REPORT_TYPES.JournalistNOARanking,
        value: REPORT_TYPES.JournalistNOARanking,
        reportCategory: "journalist",
        label: "Top Journalists (Articles)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.TopJournalistDataOnline,
          print: GRAPH_DATATYPE.TopJournalistDataPrint,
          social: 3,
        },
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          DOUGHNUT,
          BAR_STACKED,
          CHOROPLETH,
        ],
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity",
        entityKey: "entity",
        sourceKey: "source_name",
        sourceKeyWithPublications: "updated_source_name",
        countKey: "articlecnt",
        type: "quantitive"
      },
      {
        id: REPORT_TYPES.JournalistCCMRanking,
        value: REPORT_TYPES.JournalistCCMRanking,
        reportCategory: "journalist",
        label: "Top Journalist (CCM)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: undefined,
          print: GRAPH_DATATYPE.TopJournalistCCMDataPrint,
          social: undefined,
        },
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          DOUGHNUT,
          BAR_STACKED,
          CHOROPLETH,
        ],
        verticalList: [],
        groupByField: "entity",
        entityKey: "entity",
        sourceKey: "source_name",
        countKey: "ccmsum",
        type: "quantitive"
      },
      {
        id: REPORT_TYPES.JournalistMAVRanking,
        value: REPORT_TYPES.JournalistMAVRanking,
        reportCategory: "journalist",
        label: "Top Journalist (MAV)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: undefined,
          print: GRAPH_DATATYPE.TopJournalistMAVDataPrint,
          social: undefined,
        },
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          DOUGHNUT,
          BAR_STACKED,
          CHOROPLETH,
        ],
        verticalList: [],
        groupByField: "entity",
        entityKey: "entity",
        sourceKey: "source_name",
        countKey: "mavsumlkh",
        type: "quantitive"
      },
      {
        id: REPORT_TYPES.JournalistNOATrend,
        value: REPORT_TYPES.JournalistNOATrend,
        reportCategory: "journalist",
        label: "Journalist By Trend (Articles)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.TrendAnalysisOnline,
          print: GRAPH_DATATYPE.TrendAnalysisPrint,
          social: 3,
        },
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          DOUGHNUT,
          BAR_STACKED,
          CHOROPLETH,
        ],
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity",
        entityKey: "entity",
        sourceKey: "source_name",
        countKey: "articlecnt",
        type: "quantitive"
      },
      {
        id: REPORT_TYPES.JournalistAnalysisPrint,
        value: REPORT_TYPES.JournalistAnalysisPrint,
        reportCategory: "journalist",
        label: "Journalist By Trend (Articles)",
        enablePrint: true,
        enableOnline: false,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.JournalistAnalysisPrint,
          print: GRAPH_DATATYPE.JournalistAnalysisPrint,
          social: 3,
        },
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          DOUGHNUT,
          BAR_STACKED,
          CHOROPLETH,
        ],
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "source_name",
        entityKey: "entity",
        sourceKey: "source_name",
        countKey: "articlecnt",
        type: "quantitive"
      },
      {
        id: REPORT_TYPES.ThematicAnalysisEntity,
        value: REPORT_TYPES.ThematicAnalysisEntity,
        reportCategory: "entitytag",
        label: "Thematic Analysis Entity Wise",
        enablePrint: true,
        enableOnline: false,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.ThematicAnalysisEntity,
          print: GRAPH_DATATYPE.ThematicAnalysisEntity,
          social: 3,
        },
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          DOUGHNUT,
          BAR_STACKED,
          CHOROPLETH,
        ],
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        entityKey: "entity_name",
        countKey: "articlecount",
        type: "quantitive"
      },
      {
        id: REPORT_TYPES.ThematicAnalysisTag,
        value: REPORT_TYPES.ThematicAnalysisTag,
        reportCategory: "tagentity",
        label: "Thematic Analysis Tag Wise",
        enablePrint: true,
        enableOnline: false,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.ThematicAnalysisTag,
          print: GRAPH_DATATYPE.ThematicAnalysisTag,
          social: 3,
        },
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          DOUGHNUT,
          BAR_STACKED,
          CHOROPLETH,
        ],
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "category_name",
        entityKey: "category_name",
        countKey: "articlecount",
        type: "quantitive"
      },
      {
        id: REPORT_TYPES.JournalistCCMTrend,
        value: REPORT_TYPES.JournalistCCMTrend,
        reportCategory: "journalist",
        label: "Journalist By Trend (CCM)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: undefined,
          print: GRAPH_DATATYPE.TrendAnalysisCCMPrint,
          social: undefined,
        },
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          DOUGHNUT,
          BAR_STACKED,
          CHOROPLETH,
        ],
        verticalList: [],
        groupByField: "entity",
        entityKey: "entity",
        countKey: "ccmcnt",
        type: "quantitive"
      },
      {
        id: REPORT_TYPES.JournalistMAVTrend,
        value: REPORT_TYPES.JournalistMAVTrend,
        reportCategory: "journalist",
        label: "Journalist By Trend (MAV)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: undefined,
          print: GRAPH_DATATYPE.TrendAnalysisMAVPrint,
          social: undefined,
        },
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          DOUGHNUT,
          BAR_STACKED,
          CHOROPLETH,
        ],
        verticalList: [],
        groupByField: "entity",
        entityKey: "entity",
        countKey: "mavcnt",
        type: "quantitive"
      },
      {
        id: REPORT_TYPES.JournalistTonalityNOARanking,
        value: REPORT_TYPES.JournalistTonalityNOARanking,
        reportCategory: "journalist",
        label: "Journalist By Sentiment (Articles)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.TonalityDataOnline,
          print: GRAPH_DATATYPE.TonalityDataPrint,
          social: 3,
        },
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          DOUGHNUT,
          CHOROPLETH,
          BAR_STACKED,
          BAR_VERTICAL,
        ],
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity",
        entityKey: "entity",
        sourceKey: "source_name",
        countKey: "articlecnt",
        type: "quantitive"
      },
      {
        id: REPORT_TYPES.JournalistTonalityCCMRanking,
        value: REPORT_TYPES.JournalistTonalityCCMRanking,
        reportCategory: "journalist",
        label: "Journalist By Sentiment (CCM)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: undefined,
          print: GRAPH_DATATYPE.TonalityCCMPrint,
          social: undefined,
        },
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          DOUGHNUT,
          BAR_STACKED,
          CHOROPLETH,
        ],
        verticalList: [],
        groupByField: "entity",
        entityKey: "entity",
        sourceKey: "source_name",
        countKey: "ccmsum",
        type: "quantitive"
      },
      {
        id: REPORT_TYPES.JournalistTonalityMAVRanking,
        value: REPORT_TYPES.JournalistTonalityMAVRanking,
        reportCategory: "journalist",
        label: "Journalist By Sentiment (MAV)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: undefined,
          print: GRAPH_DATATYPE.TonalityMAVPrint,
          social: undefined,
        },
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          DOUGHNUT,
          BAR_STACKED,
          CHOROPLETH,
        ],
        verticalList: [],
        groupByField: "entity",
        entityKey: "entity",
        sourceKey: "source_name",
        countKey: "mavsumlkh",
        type: "quantitive"
      },
      {
        id: REPORT_TYPES.JournalistTonalityWCRanking,
        value: REPORT_TYPES.JournalistTonalityWCRanking,
        reportCategory: "journalist",
        label: "Journalist By Sentiment (Word Count)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.TonalityWordCount,
          print: undefined,
          social: undefined,
        },
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          DOUGHNUT,
          BAR_STACKED,
          CHOROPLETH,
        ],
        verticalList: [],
        groupByField: "entity",
        entityKey: "entity",
        sourceKey: "source_name",
        countKey: "mavsumlkh",
        type: "quantitive"
      },
      // Jornalist report types end

      // Tonality start
      {
        id: REPORT_TYPES.TonalityNAORanking,
        value: REPORT_TYPES.TonalityNAORanking,
        reportCategory: "tonality",
        label: "Sentiment Analysis (Articles)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        enableTV: true,
        graphDataType: {
          online: GRAPH_DATATYPE.TonalityDataOnline,
          print: GRAPH_DATATYPE.TonalityDataPrint,
          social: undefined,
          tv: GRAPH_DATATYPE.TonalityDataTV,
        },
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          DOUGHNUT,
          BAR_STACKED,
          CHOROPLETH,
        ],
        verticalList: [V_PRINT, V_ONLINE, V_SOCIAL, V_BLOG, V_FORUM,V_TV],
        groupByField: "entity",
        entityKey: "entity",
        sourceKey: "source_name",
        countKey: "articlecnt",
        type: "quantitive"
      },
      {
        id: REPORT_TYPES.TonalityCCMRanking,
        value: REPORT_TYPES.TonalityCCMRanking,
        reportCategory: "tonality",
        label: "Sentiment Analysis by Ranking (CCM)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: undefined,
          print: GRAPH_DATATYPE.TonalityCCMPrint,
          social: undefined,
        },
        excludeGraphType: [
          PIE,
          TABLE,
          WORD_CLOUD,
          GENDER,
          DOUGHNUT,
          BAR_STACKED,
          CHOROPLETH,
        ],
        verticalList: [],
        groupByField: "entity",
        entityKey: "entity",
        type: "quantitive"
      },
      {
        id: REPORT_TYPES.TonalityMAVRanking,
        value: REPORT_TYPES.TonalityMAVRanking,
        reportCategory: "tonality",
        label: "Sentiment Analysis by Ranking (MAV)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: undefined,
          print: GRAPH_DATATYPE.TonalityMAVPrint,
          social: undefined,
        },
        excludeGraphType: [
          PIE,
          TABLE,
          WORD_CLOUD,
          GENDER,
          DOUGHNUT,
          BAR_STACKED,
          CHOROPLETH,
        ],
        verticalList: [],
        groupByField: "entity",
        entityKey: "entity",
        type: "quantitive"
      },
      {
        id: REPORT_TYPES.TonalityWordCount,
        value: REPORT_TYPES.TonalityWordCount,
        reportCategory: "tonality",
        label: "Sentiment Analysis By Ranking (Word Count)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.TonalityWordCount,
          print: undefined,
          social: undefined,
        },
        excludeGraphType: [
          PIE,
          TABLE,
          WORD_CLOUD,
          GENDER,
          DOUGHNUT,
          BAR_STACKED,
          CHOROPLETH,
        ],
        verticalList: [],
        groupByField: "entity",
        entityKey: "entity",
        type: "quantitive"
      },
      {
        id: REPORT_TYPES.TonalityNAOTrend,
        value: REPORT_TYPES.TonalityNAOTrend,
        reportCategory: "tonality",
        label: "Sentiment Analysis By Trend (Articles)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.TrendAnalysisOnline,
          print: GRAPH_DATATYPE.TrendAnalysisPrint,
          social: undefined,
        },
        excludeGraphType: [
          PIE,
          TABLE,
          WORD_CLOUD,
          GENDER,
          DOUGHNUT,
          CHOROPLETH,
          BAR_STACKED,
          BAR_HORIZONTAL,
        ],
        verticalList: [],
        groupByField: "entity",
        entityKey: "entity",
        countKey: "articlecnt",
        type: "quantitive"
      },
      {
        id: REPORT_TYPES.TonalityCCMTrend,
        value: REPORT_TYPES.TonalityCCMTrend,
        reportCategory: "tonality",
        label: "Sentiment Analysis By Trend (CCM)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: undefined,
          print: GRAPH_DATATYPE.TrendAnalysisCCMPrint,
          social: undefined,
        },
        excludeGraphType: [
          PIE,
          TABLE,
          WORD_CLOUD,
          GENDER,
          DOUGHNUT,
          BAR_STACKED,
          CHOROPLETH,
        ],
        verticalList: [],
        groupByField: "entity",
        entityKey: "entity",
        countKey: "ccmcnt",
        type: "quantitive"
      },
      {
        id: REPORT_TYPES.TonalityMAVTrend,
        value: REPORT_TYPES.TonalityMAVTrend,
        reportCategory: "tonality",
        label: "Sentiment Analysis By Trend (MAV)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: undefined,
          print: GRAPH_DATATYPE.TrendAnalysisMAVPrint,
          social: undefined,
        },
        excludeGraphType: [
          PIE,
          TABLE,
          WORD_CLOUD,
          GENDER,
          DOUGHNUT,
          BAR_STACKED,
          CHOROPLETH,
        ],
        verticalList: [],
        groupByField: "entity",
        entityKey: "entity",
        countKey: "mavcnt",
        type: "quantitive"
      },
      {
        id: REPORT_TYPES.TonalityWCTrend,
        value: REPORT_TYPES.TonalityWCTrend,
        reportCategory: "tonality",
        label: "Sentiment Analysis By Trend (Word Count)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.WordCountDateWise,
          print: undefined,
          social: undefined,
        },
        excludeGraphType: [
          PIE,
          TABLE,
          WORD_CLOUD,
          GENDER,
          DOUGHNUT,
          BAR_STACKED,
          CHOROPLETH,
        ],
        verticalList: [],
        groupByField: "entity",
        entityKey: "entity",
        countKey: "wordcountsum",
        type: "quantitive"
      },
      // Tonality ends

      // Publication report types start
      {
        id: REPORT_TYPES.PublicationNOARanking,
        value: REPORT_TYPES.PublicationNOARanking,
        label: "Top Websites (Articles)",
        reportCategory: "publication",
        enablePrint: true,
        enableOnline: false,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.TopPublicationOnline,
          print: GRAPH_DATATYPE.TopPublicationPrint,
          social: 2,
        },
        groupByField: "publication_name",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          DOUGHNUT,
          BAR_STACKED,
          CHOROPLETH,
        ],
        verticalList: [V_PRINT, V_ONLINE],
        entityKey: "entity",
        countKey: "articlecnt",
        type: "quantitive"
      },
      {
        id: REPORT_TYPES.PublicationCCMRanking,
        value: REPORT_TYPES.PublicationCCMRanking,
        label: "Top Websites (CCM)",
        reportCategory: "publication",
        enablePrint: true,
        enableOnline: false,
        enableSocial: false,
        graphDataType: {
          online: undefined,
          print: GRAPH_DATATYPE.TopPublicationCCMPrint,
          social: 2,
        },
        groupByField: "publication_name",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          DOUGHNUT,
          BAR_STACKED,
          CHOROPLETH,
        ],
        verticalList: [],
        entityKey: "entity",
        countKey: "ccmsum",
        type: "quantitive"
      },
      {
        id: REPORT_TYPES.PublicationMAVRanking,
        value: REPORT_TYPES.PublicationMAVRanking,
        label: "Top Websites (MAV)",
        reportCategory: "publication",
        enablePrint: true,
        enableOnline: false,
        enableSocial: false,
        graphDataType: {
          online: undefined,
          print: GRAPH_DATATYPE.TopPublicationMAVPrint,
          social: 2,
        },
        groupByField: "publication_name",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          DOUGHNUT,
          BAR_STACKED,
          CHOROPLETH,
        ],
        verticalList: [],
        entityKey: "entity",
        countKey: "mavsumlkh",
        type: "quantitive"
      },
      {
        id: REPORT_TYPES.PublicationNOATrend,
        value: REPORT_TYPES.PublicationNOATrend,
        label: "Trend by Websites (Articles)",
        reportCategory: "publication",
        enablePrint: true,
        enableOnline: false,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.TrendAnalysisOnline,
          print: GRAPH_DATATYPE.TrendAnalysisPrint,
          social: 2,
        },
        groupByField: "publication_name",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          DOUGHNUT,
          BAR_STACKED,
          CHOROPLETH,
        ],
        verticalList: [V_PRINT, V_ONLINE],
        entityKey: "entity",
        countKey: "articlecnt",
        type: "quantitive"
      },
      {
        id: REPORT_TYPES.PublicationCCMTrend,
        value: REPORT_TYPES.PublicationCCMTrend,
        label: "Trend by Websites (CCM)",
        reportCategory: "publication",
        enablePrint: true,
        enableOnline: false,
        enableSocial: false,
        graphDataType: {
          online: undefined,
          print: GRAPH_DATATYPE.TrendAnalysisCCMPrint,
          social: 2,
        },
        groupByField: "publication_name",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          DOUGHNUT,
          BAR_STACKED,
          CHOROPLETH,
        ],
        verticalList: [],
        entityKey: "entity",
        countKey: "ccmcnt",
        type: "quantitive"
      },
      {
        id: REPORT_TYPES.PublicationMAVTrend,
        value: REPORT_TYPES.PublicationMAVTrend,
        label: "Trend by Websites (MAV)",
        reportCategory: "publication",
        enablePrint: true,
        enableOnline: false,
        enableSocial: false,
        graphDataType: {
          online: undefined,
          print: GRAPH_DATATYPE.TrendAnalysisMAVPrint,
          social: 2,
        },
        groupByField: "publication_name",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          DOUGHNUT,
          BAR_STACKED,
          CHOROPLETH,
        ],
        verticalList: [],
        entityKey: "entity",
        countKey: "mavcnt",
        type: "quantitive"
      },
      {
        id: REPORT_TYPES.PublicationTonalityNOARanking,
        value: REPORT_TYPES.PublicationTonalityNOARanking,
        reportCategory: "publication",
        label: "Publication By Sentiment (Articles)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.TonalityDataOnline,
          // print: GRAPH_DATATYPE.TonalityDataPrint,
          print: GRAPH_DATATYPE.TonalityByPublication,
          social: 3,
        },
        excludeGraphType: [
          BAR_VERTICAL,
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          CHOROPLETH,
          BAR_STACKED,
          DOUGHNUT,
        ],
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity",
        entityKey: "entity",
        sourceKey: "publication_name",
        countKey: "articlecnt",
        type: "quantitive"
      },
      {
        id: REPORT_TYPES.PublicationTonalityCCMRanking,
        value: REPORT_TYPES.PublicationTonalityCCMRanking,
        reportCategory: "publication",
        label: "Publication By Sentiment (CCM)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: undefined,
          print: GRAPH_DATATYPE.TonalityCCMPrint,
          social: 3,
        },
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          DOUGHNUT,
          BAR_STACKED,
          CHOROPLETH,
        ],
        verticalList: [],
        groupByField: "entity",
        entityKey: "entity",
        sourceKey: "publication_name",
        countKey: "articlecnt",
        type: "quantitive"
      },
      {
        id: REPORT_TYPES.PublicationTonalityMAVRanking,
        value: REPORT_TYPES.PublicationTonalityMAVRanking,
        reportCategory: "publication",
        label: "Publication By Sentiment (MAV)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: undefined,
          print: GRAPH_DATATYPE.TonalityMAVPrint,
          social: 3,
        },
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          DOUGHNUT,
          BAR_STACKED,
          CHOROPLETH,
        ],
        verticalList: [],
        groupByField: "entity",
        entityKey: "entity",
        sourceKey: "publication_name",
        countKey: "articlecnt",
        type: "quantitive"
      },
      {
        id: REPORT_TYPES.PublicationTonalityWCRanking,
        value: REPORT_TYPES.PublicationTonalityWCRanking,
        reportCategory: "publication",
        label: "Publication By Sentiment (Word count)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.TonalityWordCount,
          print: undefined,
          social: 3,
        },
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          DOUGHNUT,
          BAR_STACKED,
          CHOROPLETH,
        ],
        verticalList: [],
        groupByField: "entity",
        entityKey: "entity",
        sourceKey: "publication_name",
        countKey: "articlecnt",
        type: "quantitive"
      },
      // Publication report types end mavsumlkh

      // keyword cloud - start
      {
        id: REPORT_TYPES.KeywordCloudNOA,
        value: REPORT_TYPES.KeywordCloudNOA,
        reportCategory: "keyword",
        label: "Keyword cloud (Articles)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.KeywordCloud,
          print: GRAPH_DATATYPE.KeywordCloud,
          social: 3,
        },
        excludeGraphType: [
          LINE,
          AREA,
          BAR_STACKED,
          BAR_STACKED_EQUAL_HEIGHT,
          BAR_VERTICAL,
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          GENDER,
          CHOROPLETH,
          DOUGHNUT,
        ],
        verticalList: [V_PRINT, V_ONLINE, V_SOCIAL, V_BLOG, V_FORUM],
        type: "quantitive"
      },
      // keyword cloud - end

      {
        id: REPORT_TYPES.TopLanguages,
        value: REPORT_TYPES.TopLanguages,
        reportCategory: "language",
        label: "Top Languages",
        enablePrint: false,
        enableOnline: false,
        enableSocial: true,
        graphDataType: {
          online: GRAPH_DATATYPE.OnlineLanguageWise,
          print: GRAPH_DATATYPE.PrintLanguageWise,
          social: GRAPH_DATATYPE.TopLanguages,
        },
        excludeGraphType: [
          LINE,
          AREA,
          BAR_STACKED,
          BAR_STACKED_EQUAL_HEIGHT,
          BAR_VERTICAL,
          BAR_HORIZONTAL,
          TABLE,
          GENDER,
          PIE,
          WORD_CLOUD,
          CHOROPLETH,
        ],
        verticalList: [V_PRINT, V_ONLINE, V_SOCIAL, V_BLOG, V_FORUM],
        type: "quantitive"
      },
      // city start
      {
        id: REPORT_TYPES.MediaWiseNOARanking,
        value: REPORT_TYPES.MediaWiseNOARanking,
        reportCategory: "city",
        label: "City By Ranking (Articles)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: undefined,
          print: GRAPH_DATATYPE.MediaWiseNOARanking,
          social: GRAPH_DATATYPE.SOVCity,
        },
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          DOUGHNUT,
          BAR_STACKED,
          CHOROPLETH,
        ],
        verticalList: [V_PRINT],
        entityKey: "entity",
        type: "quantitive"
      },
      {
        id: REPORT_TYPES.CityWiseNOARanking,
        value: REPORT_TYPES.CityWiseNOARanking,
        reportCategory: "city",
        label: "City By Ranking (Articles)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: undefined,
          print: GRAPH_DATATYPE.CityWiseNOARanking,
          social: GRAPH_DATATYPE.SOVCity,
        },
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          DOUGHNUT,
          BAR_STACKED,
          CHOROPLETH,
        ],
        verticalList: [V_PRINT],
        entityKey: "entity",
        type: "quantitive"
      },
      {
        id: REPORT_TYPES.CityWiseCCMRanking,
        value: REPORT_TYPES.CityWiseCCMRanking,
        reportCategory: "city",
        label: "City Wise  Ranking (CCM)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: undefined,
          print: GRAPH_DATATYPE.CityWiseCCMRanking,
          social: GRAPH_DATATYPE.SOVCity,
        },
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          CHOROPLETH,
          GENDER,
          BAR_STACKED,
          DOUGHNUT,
        ],
        verticalList: [],
        entityKey: "entity",
        type: "quantitive"
      },
      {
        id: REPORT_TYPES.CityWiseMAVRanking,
        value: REPORT_TYPES.CityWiseMAVRanking,
        reportCategory: "city",
        label: "City Wise Ranking (MAV)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: undefined,
          print: GRAPH_DATATYPE.CityWiseMAVRanking,
          social: GRAPH_DATATYPE.SOVCity,
        },
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          BAR_STACKED,
          CHOROPLETH,
        ],
        verticalList: [],
        entityKey: "entity",
        type: "quantitive"
      },
      {
        id: REPORT_TYPES.EditionWiseNOATrend,
        value: REPORT_TYPES.EditionWiseNOATrend,
        reportCategory: "edition",
        label: "City By Trend (Articles)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: undefined,
          print: GRAPH_DATATYPE.EditionWiseNOATrend,
          social: undefined,
        },
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          DOUGHNUT,
          BAR_STACKED,
          CHOROPLETH,
        ],
        verticalList: [V_PRINT],
        editionName: "edition_name",
        editionId: "edition_id",
        countKey: "articlecnt",
        type: "quantitive"
      },
      {
        id: REPORT_TYPES.CityWiseNOATrend,
        value: REPORT_TYPES.CityWiseNOATrend,
        reportCategory: "city",
        label: "City By Trend (Articles)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: undefined,
          print: GRAPH_DATATYPE.TrendAnalysisPrint,
          social: undefined,
        },
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          DOUGHNUT,
          BAR_STACKED,
          CHOROPLETH,
        ],
        verticalList: [V_PRINT],
        entityKey: "entity",
        countKey: "articlecnt",
        type: "quantitive"
      },
      {
        id: REPORT_TYPES.CityWiseCCMTrend,
        value: REPORT_TYPES.CityWiseCCMTrend,
        reportCategory: "city",
        label: "City Wise Trend (CCM)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: undefined,
          print: GRAPH_DATATYPE.TrendAnalysisCCMPrint,
          social: undefined,
        },
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          BAR_STACKED,
          CHOROPLETH,
        ],
        verticalList: [],
        entityKey: "entity",
        countKey: "ccmcnt",
        type: "quantitive"
      },
      {
        id: REPORT_TYPES.CityWiseMAVTrend,
        value: REPORT_TYPES.CityWiseMAVTrend,
        reportCategory: "city",
        label: "City Wise Trend (MAV)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: undefined,
          print: GRAPH_DATATYPE.TrendAnalysisMAVPrint,
          social: undefined,
        },
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          BAR_STACKED,
          CHOROPLETH,
        ],
        verticalList: [],
        countKey: "mavcnt",
        entityKey: "entity",
        type: "quantitive"
      },

      {
        id: REPORT_TYPES.CityWiseTonality,
        value: REPORT_TYPES.CityWiseTonality,
        reportCategory: "city",
        label: "City By Sentiment",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: undefined,
          print: GRAPH_DATATYPE.TonalityDataPrint,
          social: undefined,
        },
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          DOUGHNUT,
          BAR_VERTICAL,
          BAR_STACKED,
          CHOROPLETH,
        ],
        verticalList: [V_PRINT],
        entityKey: "entity",
        type: "quantitive"
      },
      {
        id: REPORT_TYPES.StateWiseTonality,
        value: REPORT_TYPES.StateWiseTonality,
        reportCategory: "state",
        label: "State By Sentiment",
        allowed_client: [11717],
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: undefined,
          print: GRAPH_DATATYPE.TonalityDataPrint,
          social: undefined,
        },
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          DOUGHNUT,
          // BAR_VERTICAL,
          BAR_STACKED,
          CHOROPLETH,
        ],
        verticalList: [V_PRINT],
        entityKey: "entity",
        type: "quantitive"
      },
      {
        id: REPORT_TYPES.StateWiseTrend,
        value: REPORT_TYPES.StateWiseTrend,
        reportCategory: "stateTrend",
        label: "State By Sentiment Trend",
        allowed_client: [11717],
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          // online: GRAPH_DATATYPE.TrendAnalysisOnline,
          online: undefined,
          print: GRAPH_DATATYPE.TrendAnalysisPrint,
          social: undefined,
        },
        excludeGraphType: [
          PIE,
          TABLE,
          WORD_CLOUD,
          GENDER,
          DOUGHNUT,
          CHOROPLETH,
          BAR_STACKED,
          BAR_HORIZONTAL,
        ],
        verticalList: [V_PRINT],
        groupByField: "entity",
        entityKey: "entity",
        countKey: "articlecnt",
        type: "quantitive"
      },
      {
        id: REPORT_TYPES.CityWiseCCMTonality,
        value: REPORT_TYPES.CityWiseCCMTonality,
        reportCategory: "city",
        label: "City By Sentiment (CCM)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: undefined,
          print: GRAPH_DATATYPE.TonalityCCMPrint,
          social: undefined,
        },
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          BAR_STACKED,
          CHOROPLETH,
        ],
        verticalList: [],
        entityKey: "entity",
        type: "quantitive"
      },
      {
        id: REPORT_TYPES.CityWiseMAVTonality,
        value: REPORT_TYPES.CityWiseMAVTonality,
        reportCategory: "city",
        label: "City By Sentiment (MAV)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: undefined,
          print: GRAPH_DATATYPE.TonalityMAVPrint,
          social: undefined,
        },
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          BAR_STACKED,
          CHOROPLETH,
        ],
        verticalList: [],
        entityKey: "entity",
        countKey: "mavcnt",
        type: "quantitive"
      },
      // city - end
      {
        id: REPORT_TYPES.MediaExposureReport,
        value: REPORT_TYPES.MediaExposureReport,
        reportCategory: "mediaexposure",
        label: "Total Media Exposure",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: undefined,
          print: GRAPH_DATATYPE.MediaExposureReportPrint,
          social: undefined,
        },
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          WORD_CLOUD,
          GENDER,
          BAR_VERTICAL,
          BAR_STACKED,
          BAR_STACKED_EQUAL_HEIGHT,
          LINE,
          AREA,
          CHOROPLETH,
          DOUGHNUT,
        ],
        verticalList: [V_PRINT],
        type: "quantitive"
      },
      //word count - inline filters - start
      {
        id: REPORT_TYPES.TopPublicationWordCount,
        value: REPORT_TYPES.TopPublicationWordCount,
        reportCategory: "publication",
        label: "Top Publication Word Count",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        groupByField: "publication_name",
        graphDataType: {
          online: GRAPH_DATATYPE.TopPublicationWordCountOnline,
          print: undefined,
          social: undefined,
        },
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          WORD_CLOUD,
          GENDER,
          BAR_VERTICAL,
          BAR_STACKED,
          BAR_STACKED_EQUAL_HEIGHT,
          LINE,
          AREA,
          CHOROPLETH,
        ],
        verticalList: [],
        entityKey: "entity",
        countKey: "wordcountsum",
        type: "quantitive"
      },
      {
        id: REPORT_TYPES.TopPublicationTrendWordCount,
        value: REPORT_TYPES.TopPublicationTrendWordCount,
        reportCategory: "publication",
        label: "Publication By Trend (Word count)",
        enablePrint: false,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.WordCountDateWise,
          print: undefined,
          social: undefined,
        },
        groupByField: "publish_date",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          DOUGHNUT,
          BAR_STACKED,
          CHOROPLETH,
        ],
        verticalList: [],
        entityKey: "entity",
        countKey: "wordcountsum",
        type: "quantitive"
      },
      {
        id: REPORT_TYPES.JournalistWCRanking,
        value: REPORT_TYPES.JournalistWCRanking,
        reportCategory: "journalist",
        label: "Journalist By Ranking (Word count)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.TopJournalistWordCountDataOnline,
          print: undefined,
          social: undefined,
        },
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          DOUGHNUT,
          BAR_STACKED,
          CHOROPLETH,
        ],
        verticalList: [],
        groupByField: "entity",
        entityKey: "entity",
        sourceKey: "source_name",
        countKey: "wordcountsum",
        type: "quantitive"
      },
      {
        id: REPORT_TYPES.JournalistWCTrend,
        value: REPORT_TYPES.JournalistWCTrend,
        reportCategory: "journalist",
        label: "Journalist By Trend (Word count)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.WordCountDateWise,
          print: undefined,
          social: undefined,
        },
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          DOUGHNUT,
          BAR_STACKED,
          CHOROPLETH,
        ],
        verticalList: [],
        groupByField: "entity",
        entityKey: "entity",
        sourceKey: "source_name",
        countKey: "wordcountsum",
        type: "quantitive"
      },
      {
        id: REPORT_TYPES.Reach,
        value: REPORT_TYPES.Reach,
        reportCategory: "reach",
        label: "Reach",
        enablePrint: false,
        enableOnline: false,
        enableSocial: false,
        graphDataType: {
          online: undefined,
          print: undefined,
          social: GRAPH_DATATYPE.Reach,
        },
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          WORD_CLOUD,
          GENDER,
          DOUGHNUT,
          BAR_STACKED,
          CHOROPLETH,
        ],
        verticalList: [],
        type: "quantitive"
      },
      {
        id: REPORT_TYPES.TopPostersWithDetail,
        value: REPORT_TYPES.TopPostersWithDetail,
        reportCategory: "topposters",
        label: "Top Posters",
        enablePrint: false,
        enableOnline: false,
        enableSocial: false,
        graphDataType: {
          online: undefined,
          print: undefined,
          social: GRAPH_DATATYPE.TopPosters,
        },
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          WORD_CLOUD,
          GENDER,
          DOUGHNUT,
          CHOROPLETH,
          LINE,
          AREA,
        ],
        verticalList: [V_SOCIAL],
        type: "quantitive"
      },
      {
        id: REPORT_TYPES.TopPosters,
        value: REPORT_TYPES.TopPosters,
        reportCategory: "topposters",
        label: "Top Posters",
        enablePrint: false,
        enableOnline: false,
        enableSocial: false,
        graphDataType: {
          online: undefined,
          print: undefined,
          social: GRAPH_DATATYPE.TopPosters,
        },
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          WORD_CLOUD,
          GENDER,
          DOUGHNUT,
          CHOROPLETH,
          LINE,
          AREA,
        ],
        verticalList: [V_SOCIAL],
        type: "quantitive"
      },
      {
        id: REPORT_TYPES.CitySpecificReport,
        value: REPORT_TYPES.CitySpecificReport,
        reportCategory: "citySpecificReport",
        label: "Citywise Insights",
        enablePrint: false,
        enableOnline: false,
        enableSocial: false,
        graphDataType: {
          online: undefined,
          print: undefined,
          social: undefined,
        },
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          WORD_CLOUD,
          GENDER,
          DOUGHNUT,
          CHOROPLETH,
          BAR_VERTICAL,
          BAR_STACKED,
          AREA,
          LINE,
        ],
        verticalList: [V_SOCIAL],
        type: "quantitive"
      },
      {
        id: REPORT_TYPES.citywisenew,
        value: REPORT_TYPES.citywisenew,
        reportCategory: "citySpecificReport",
        label: "Citywise Insights (For India Only)",
        enablePrint: false,
        enableOnline: false,
        enableSocial: false,
        graphDataType: {
          online: undefined,
          print: undefined,
          social: undefined,
        },
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          WORD_CLOUD,
          GENDER,
          DOUGHNUT,
          CHOROPLETH,
          BAR_VERTICAL,
          BAR_STACKED,
          AREA,
          LINE,
        ],
        verticalList: [V_SOCIAL],
        type: "quantitive"
      },
      {
        id: REPORT_TYPES.TagBasedTagAnalysis,
        value: REPORT_TYPES.TagBasedTagAnalysis,
        reportCategory: "TagBasedTagAnalysis",
        label: "Tag Analysis",
        enablePrint: false,
        enableOnline: false,
        enableSocial: false,
        graphDataType: {
          online: undefined,
          print: undefined,
          social: undefined,
        },
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          WORD_CLOUD,
          GENDER,
          DOUGHNUT,
          CHOROPLETH,
          BAR_VERTICAL,
          AREA,
          LINE,
          TABLE,
          BAR_STACKED,
          BAR_VERTICAL,
        ],
        verticalList: [V_SOCIAL],
        type: "quantitive"
      },
      {
        id: REPORT_TYPES.EntityBasedTagAnalysis,
        value: REPORT_TYPES.EntityBasedTagAnalysis,
        reportCategory: "EntityBasedTagAnalysis",
        label: "Tag Analysis By Entity",
        enablePrint: false,
        enableOnline: false,
        enableSocial: false,
        graphDataType: {
          online: undefined,
          print: undefined,
          social: undefined,
        },
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          WORD_CLOUD,
          GENDER,
          DOUGHNUT,
          CHOROPLETH,
          BAR_VERTICAL,
          AREA,
          LINE,
          TABLE,
          BAR_STACKED,
          BAR_VERTICAL,
        ],
        verticalList: [V_SOCIAL],
        type: "quantitive"
      },
      {
        id: REPORT_TYPES.INFLUENCERS,
        value: REPORT_TYPES.INFLUENCERS,
        reportCategory: "influencers",
        label: "Influencers",
        enablePrint: false,
        enableOnline: false,
        enableSocial: true,
        graphDataType: {
          online: undefined,
          print: undefined,
          social: GRAPH_DATATYPE.Influencers,
        },
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          WORD_CLOUD,
          GENDER,
          DOUGHNUT,
          BAR_STACKED,
          CHOROPLETH,
        ],
        verticalList: [],
        type: "quantitive"
      },
      {
        id: REPORT_TYPES.WorldMap,
        value: REPORT_TYPES.WorldMap,
        reportCategory: "worldmap",
        label: "World Map",
        enablePrint: false,
        enableOnline: false,
        enableSocial: true,
        graphDataType: {
          online: undefined,
          print: undefined,
          social: GRAPH_DATATYPE.WorldMap,
        },
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          WORD_CLOUD,
          GENDER,
          DOUGHNUT,
          LINE,
          AREA,
          BAR_STACKED,
          BAR_STACKED_EQUAL_HEIGHT,
          TABLE,
          BAR_VERTICAL,
        ],
        verticalList: [V_SOCIAL, V_BLOG, V_FORUM],
        type: "quantitive"
      },
      // Platform wise reports
      {
        id: REPORT_TYPES.ShareRetweet,
        value: REPORT_TYPES.ShareRetweet,
        label: "Share / Retweet",
        reportCategory: "platform",
        enablePrint: true,
        enableOnline: false,
        enableSocial: false,
        graphDataType: {
          online: undefined,
          print: undefined,
          social: undefined,
        },
        groupByField: "",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          DOUGHNUT,
          BAR_STACKED,
          CHOROPLETH,
        ],
        verticalList: [V_SOCIAL],
        entityKey: "entity",
        countKey: "articlecnt",
        type: "quantitive"
      },
      {
        id: REPORT_TYPES.ReplyComment,
        value: REPORT_TYPES.ReplyComment,
        label: "Reply / Comment",
        reportCategory: "platform",
        enablePrint: true,
        enableOnline: false,
        enableSocial: false,
        graphDataType: {
          online: undefined,
          print: undefined,
          social: undefined,
        },
        groupByField: "",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          DOUGHNUT,
          BAR_STACKED,
          CHOROPLETH,
        ],
        verticalList: [V_SOCIAL],
        entityKey: "entity",
        countKey: "articlecnt",
        type: "quantitive"
      },
      {
        id: REPORT_TYPES.Attachment,
        value: REPORT_TYPES.Attachment,
        label: "Attachment",
        reportCategory: "platform",
        enablePrint: true,
        enableOnline: false,
        enableSocial: false,
        graphDataType: {
          online: undefined,
          print: undefined,
          social: undefined,
        },
        groupByField: "",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          DOUGHNUT,
          BAR_STACKED,
          CHOROPLETH,
        ],
        verticalList: [V_SOCIAL],
        entityKey: "entity",
        countKey: "articlecnt",
        type: "quantitive"
      },
      {
        id: REPORT_TYPES.Like,
        value: REPORT_TYPES.Like,
        label: "Like",
        reportCategory: "platform",
        enablePrint: true,
        enableOnline: false,
        enableSocial: false,
        graphDataType: {
          online: undefined,
          print: undefined,
          social: undefined,
        },
        groupByField: "",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          DOUGHNUT,
          BAR_STACKED,
          CHOROPLETH,
        ],
        verticalList: [V_SOCIAL],
        entityKey: "entity",
        countKey: "articlecnt",
        type: "quantitive"
      },
      {
        id: REPORT_TYPES.AuthorLike,
        value: REPORT_TYPES.AuthorLike,
        label: "Author Like",
        reportCategory: "platform",
        enablePrint: true,
        enableOnline: false,
        enableSocial: false,
        graphDataType: {
          online: undefined,
          print: undefined,
          social: undefined,
        },
        groupByField: "",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          DOUGHNUT,
          BAR_STACKED,
          CHOROPLETH,
        ],
        verticalList: [V_SOCIAL],
        entityKey: "entity",
        countKey: "articlecnt",
        type: "quantitive"
      },
      {
        id: REPORT_TYPES.MemberType,
        value: REPORT_TYPES.MemberType,
        label: "Member Type",
        reportCategory: "platform",
        enablePrint: true,
        enableOnline: false,
        enableSocial: false,
        graphDataType: {
          online: undefined,
          print: undefined,
          social: undefined,
        },
        groupByField: "",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          DOUGHNUT,
          BAR_STACKED,
          CHOROPLETH,
        ],
        verticalList: [V_SOCIAL],
        entityKey: "entity",
        countKey: "articlecnt",
        type: "quantitive"
      },
      {
        id: REPORT_TYPES.AuthorCreated,
        value: REPORT_TYPES.AuthorCreated,
        label: "Author Created",
        reportCategory: "platform",
        enablePrint: true,
        enableOnline: false,
        enableSocial: false,
        graphDataType: {
          online: undefined,
          print: undefined,
          social: undefined,
        },
        groupByField: "",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          DOUGHNUT,
          BAR_STACKED,
          CHOROPLETH,
        ],
        verticalList: [V_SOCIAL],
        entityKey: "entity",
        countKey: "articlecnt",
        type: "quantitive"
      },
      {
        id: REPORT_TYPES.TypeOfPost,
        value: REPORT_TYPES.TypeOfPost,
        label: "Type of Post",
        reportCategory: "tweettype",
        enablePrint: true,
        enableOnline: false,
        enableSocial: false,
        graphDataType: {
          online: undefined,
          print: undefined,
          social: undefined,
        },
        groupByField: "",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          DOUGHNUT,
          BAR_STACKED,
          CHOROPLETH,
        ],
        verticalList: [V_SOCIAL],
        entityKey: "entity",
        countKey: "articlecnt",
        type: "quantitive"
      },
      {
        id: REPORT_TYPES.AuthorFollowing,
        value: REPORT_TYPES.AuthorFollowing,
        label: "Author Following",
        reportCategory: "AuthorFollowing",
        enablePrint: true,
        enableOnline: false,
        enableSocial: false,
        graphDataType: {
          online: undefined,
          print: undefined,
          social: undefined,
        },
        groupByField: "",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          DOUGHNUT,
          BAR_STACKED,
          CHOROPLETH,
        ],
        verticalList: [V_SOCIAL],
        entityKey: "entity",
        countKey: "articlecnt",
        type: "quantitive"
      },
      {
        id: REPORT_TYPES.AuthorTweetCount,
        value: REPORT_TYPES.AuthorTweetCount,
        label: "Author Tweet Count",
        reportCategory: "AuthorTweetCount",
        enablePrint: true,
        enableOnline: false,
        enableSocial: false,
        graphDataType: {
          online: undefined,
          print: undefined,
          social: undefined,
        },
        groupByField: "",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          DOUGHNUT,
          BAR_STACKED,
          CHOROPLETH,
        ],
        verticalList: [V_SOCIAL],
        entityKey: "entity",
        countKey: "articlecnt",
        type: "quantitive"
      },
      {
        id: REPORT_TYPES.PLATFORM_RANK,
        value: REPORT_TYPES.PLATFORM_RANK,
        label: "Platform By Ranking",
        reportCategory: "platform",
        enablePrint: true,
        enableOnline: false,
        enableSocial: false,
        graphDataType: {
          online: undefined,
          print: undefined,
          social: undefined,
        },
        groupByField: "",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          DOUGHNUT,
          BAR_STACKED,
          CHOROPLETH,
        ],
        verticalList: [V_SOCIAL],
        entityKey: "entity",
        countKey: "articlecnt",
        type: "quantitive"
      },
      {
        id: REPORT_TYPES.PLATFORM_TREND,
        value: REPORT_TYPES.PLATFORM_TREND,
        label: "Platform By Trend",
        reportCategory: "platform",
        enablePrint: true,
        enableOnline: false,
        enableSocial: false,
        graphDataType: {
          online: undefined,
          print: undefined,
          social: undefined,
        },
        groupByField: "",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          DOUGHNUT,
          BAR_STACKED,
          CHOROPLETH,
        ],
        verticalList: [V_SOCIAL],
        entityKey: "",
        countKey: "",
        type: "quantitive"
      },
      {
        id: REPORT_TYPES.PLATFORM_TONALITY,
        value: REPORT_TYPES.PLATFORM_TONALITY,
        reportCategory: "platform",
        label: "Platform By Sentiment",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: undefined,
          print: undefined,
          social: undefined,
        },
        excludeGraphType: [
          BAR_VERTICAL,
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          CHOROPLETH,
          BAR_STACKED,
          DOUGHNUT,
        ],
        verticalList: [V_SOCIAL],
        groupByField: "",
        entityKey: "",
        sourceKey: "",
        countKey: "",
        type: "quantitive"
      },
      {
        id: REPORT_TYPES.TWITTER,
        value: REPORT_TYPES.TWITTER,
        reportCategory: "twitter",
        label: "Tweet Type Breakdown",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: undefined,
          print: undefined,
          social: undefined,
        },
        excludeGraphType: [
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          CHOROPLETH,
          DOUGHNUT,
          AREA,
          BAR_STACKED,
          TABLE,
        ],
        verticalList: [V_SOCIAL],
        groupByField: "",
        entityKey: "",
        sourceKey: "",
        countKey: "",
        type: "quantitive"
      },
      {
        id: REPORT_TYPES.LINKEDIN,
        value: REPORT_TYPES.LINKEDIN,
        reportCategory: "linkedin",
        label: "LinkedIn Type Breakdown",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: undefined,
          print: undefined,
          social: undefined,
        },
        excludeGraphType: [
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          CHOROPLETH,
          DOUGHNUT,
          AREA,
          BAR_STACKED,
          TABLE,
        ],
        verticalList: [V_SOCIAL],
        groupByField: "",
        entityKey: "",
        sourceKey: "",
        countKey: "",
        type: "quantitive"
      },
      {
        id: REPORT_TYPES.FACEBOOK,
        value: REPORT_TYPES.FACEBOOK,
        reportCategory: "linkedin",
        label: "Facebook Type Breakdown",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: undefined,
          print: undefined,
          social: undefined,
        },
        excludeGraphType: [
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          CHOROPLETH,
          DOUGHNUT,
          AREA,
          BAR_STACKED,
          TABLE,
        ],
        verticalList: [V_SOCIAL],
        groupByField: "",
        entityKey: "",
        sourceKey: "",
        countKey: "",
        type: "quantitive"
      },
      {
        id: REPORT_TYPES.INSTAGRAM,
        value: REPORT_TYPES.INSTAGRAM,
        reportCategory: "linkedin",
        label: "Instagram Type Breakdown",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: undefined,
          print: undefined,
          social: undefined,
        },
        excludeGraphType: [
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          CHOROPLETH,
          DOUGHNUT,
          AREA,
          BAR_STACKED,
          TABLE,
        ],
        verticalList: [V_SOCIAL],
        groupByField: "",
        entityKey: "",
        sourceKey: "",
        countKey: "",
        type: "quantitive"
      },
      {
        id: REPORT_TYPES.TWITTER_METRICS,
        value: REPORT_TYPES.TWITTER_METRICS,
        reportCategory: "twitterKeymetrics",
        label: "Total Users",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: undefined,
          print: undefined,
          social: undefined,
        },
        excludeGraphType: [
          BAR_VERTICAL,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          CHOROPLETH,
          DOUGHNUT,
          BAR_STACKED,
          BAR_STACKED_EQUAL_HEIGHT,
          AREA,
          PIE,
          TABLE,
        ],
        verticalList: [V_SOCIAL],
        groupByField: "",
        entityKey: "",
        sourceKey: "",
        countKey: "",
        type: "quantitive"
      },
      // {
      //   id: REPORT_TYPES.LINKEDIN_METRICS,
      //   value: REPORT_TYPES.LINKEDIN_METRICS,
      //   reportCategory: "linkedinKeymetrics",
      //   label: "Total Impressions",
      //   enablePrint: true,
      //   enableOnline: true,
      //   enableSocial: false,
      //   graphDataType: {
      //     online: undefined,
      //     print: undefined,
      //     social: undefined,
      //   },
      //   excludeGraphType: [
      //     BAR_VERTICAL,
      //     BAR_HORIZONTAL,
      //     TABLE,
      //     WORD_CLOUD,
      //     GENDER,
      //     CHOROPLETH,
      //     DOUGHNUT,
      //     BAR_STACKED,
      //     BAR_STACKED_EQUAL_HEIGHT,
      //     AREA,
      //     PIE,
      //     TABLE,
      //   ],
      //   verticalList: [V_SOCIAL],
      //   groupByField: "",
      //   entityKey: "",
      //   sourceKey: "",
      //   countKey: "",
      //   type: "quantitive"
      // },
      {
        id: REPORT_TYPES.TWITTER_METRICS,
        value: REPORT_TYPES.TWITTER_METRICS,
        reportCategory: "twitterKeymetrics",
        label: "X Metrics",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: undefined,
          print: undefined,
          social: undefined,
        },
        excludeGraphType: [
          BAR_VERTICAL,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          CHOROPLETH,
          DOUGHNUT,
          BAR_STACKED,
          BAR_STACKED_EQUAL_HEIGHT,
          AREA,
          LINE,
          PIE,
          TABLE,
        ],
        verticalList: [V_SOCIAL],
        groupByField: "",
        entityKey: "",
        sourceKey: "",
        countKey: "",
        type: "quantitive"
      },
      {
        id: REPORT_TYPES.LINKEDIN_METRICS,
        value: REPORT_TYPES.LINKEDIN_METRICS,
        reportCategory: "linkedinKeymetrics",
        label: "Total Users",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: undefined,
          print: undefined,
          social: undefined,
        },
        excludeGraphType: [
          BAR_VERTICAL,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          CHOROPLETH,
          DOUGHNUT,
          BAR_STACKED,
          BAR_STACKED_EQUAL_HEIGHT,
          AREA,
          LINE,
          PIE,
          TABLE,
        ],
        verticalList: [V_SOCIAL],
        groupByField: "",
        entityKey: "",
        sourceKey: "",
        countKey: "",
        type: "quantitive"
      },
      {
        id: REPORT_TYPES.FACEBOOK_METRICS,
        value: REPORT_TYPES.FACEBOOK_METRICS,
        reportCategory: "linkedinKeymetrics",
        label: "Total Users",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: undefined,
          print: undefined,
          social: undefined,
        },
        excludeGraphType: [
          BAR_VERTICAL,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          CHOROPLETH,
          DOUGHNUT,
          BAR_STACKED,
          BAR_STACKED_EQUAL_HEIGHT,
          AREA,
          LINE,
          PIE,
          TABLE,
        ],
        verticalList: [V_SOCIAL],
        groupByField: "",
        entityKey: "",
        sourceKey: "",
        countKey: "",
        type: "quantitive"
      },
      {
        id: REPORT_TYPES.INSTAGRAM_METRICS,
        value: REPORT_TYPES.INSTAGRAM_METRICS,
        reportCategory: "linkedinKeymetrics",
        label: "Total Users",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: undefined,
          print: undefined,
          social: undefined,
        },
        excludeGraphType: [
          BAR_VERTICAL,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          CHOROPLETH,
          DOUGHNUT,
          BAR_STACKED,
          BAR_STACKED_EQUAL_HEIGHT,
          AREA,
          LINE,
          PIE,
          TABLE,
        ],
        verticalList: [V_SOCIAL],
        groupByField: "",
        entityKey: "",
        sourceKey: "",
        countKey: "",
        type: "quantitive"
      },
      {
        id: REPORT_TYPES.LINKEDIN_METRICS,
        value: REPORT_TYPES.LINKEDIN_METRICS,
        reportCategory: "linkedinKeymetrics",
        label: "LinkedIn Metrics",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: undefined,
          print: undefined,
          social: undefined,
        },
        excludeGraphType: [
          BAR_VERTICAL,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          CHOROPLETH,
          DOUGHNUT,
          BAR_STACKED,
          BAR_STACKED_EQUAL_HEIGHT,
          AREA,
          LINE,
          PIE,
          TABLE,
        ],
        verticalList: [V_SOCIAL],
        groupByField: "",
        entityKey: "",
        sourceKey: "",
        countKey: "",
        type: "quantitive"
      },
      {
        id: REPORT_TYPES.FACEBOOK_METRICS,
        value: REPORT_TYPES.FACEBOOK_METRICS,
        reportCategory: "linkedinKeymetrics",
        label: "Facebook Metrics",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: undefined,
          print: undefined,
          social: undefined,
        },
        excludeGraphType: [
          BAR_VERTICAL,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          CHOROPLETH,
          DOUGHNUT,
          BAR_STACKED,
          BAR_STACKED_EQUAL_HEIGHT,
          AREA,
          LINE,
          PIE,
          TABLE,
        ],
        verticalList: [V_SOCIAL],
        groupByField: "",
        entityKey: "",
        sourceKey: "",
        countKey: "",
        type: "quantitive"
      },
      {
        id: REPORT_TYPES.INSTAGRAM_METRICS,
        value: REPORT_TYPES.INSTAGRAM_METRICS,
        reportCategory: "linkedinKeymetrics",
        label: "Instagram Metrics",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: undefined,
          print: undefined,
          social: undefined,
        },
        excludeGraphType: [
          BAR_VERTICAL,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          CHOROPLETH,
          DOUGHNUT,
          BAR_STACKED,
          BAR_STACKED_EQUAL_HEIGHT,
          AREA,
          LINE,
          PIE,
          TABLE,
        ],
        verticalList: [V_SOCIAL],
        groupByField: "",
        entityKey: "",
        sourceKey: "",
        countKey: "",
        type: "quantitive"
      },


      //new qualitative graph type
      //SOV - Entity - Ranking 
      {
        id: REPORT_TYPES.SOVEntityRankingIndex,
        value: REPORT_TYPES.SOVEntityRankingIndex,
        reportCategory: REPORT_CATEGORIES.SOV,
        label: "Share Of Voice By Ranking - Entity (Index)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SOVEntityRankingOnline,
          print: GRAPH_DATATYPE.SOVEntityRankingPrint,
          printandonline: GRAPH_DATATYPE.SOVEntityRankingPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT, V_PRINT_AND_ONLINE],
        groupByField: "entity_name",
        excludeGraphType: [
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          BAR_STACKED_EQUAL_HEIGHT,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SOVEntityRankingNOA,
        value: REPORT_TYPES.SOVEntityRankingNOA,
        reportCategory: REPORT_CATEGORIES.SOV,
        label: "Share Of Voice By Ranking - Entity (No. Of Article)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SOVEntityRankingOnline,
          print: GRAPH_DATATYPE.SOVEntityRankingPrint,
          printandonline: GRAPH_DATATYPE.SOVEntityRankingPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          BAR_STACKED_EQUAL_HEIGHT,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SOVEntityRankingCCM,
        value: REPORT_TYPES.SOVEntityRankingCCM,
        reportCategory: REPORT_CATEGORIES.SOV,
        label: "Share Of Voice By Ranking - Entity (CCM)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SOVEntityRankingOnline,
          print: GRAPH_DATATYPE.SOVEntityRankingPrint,
          printandonline: GRAPH_DATATYPE.SOVEntityRankingPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          BAR_STACKED_EQUAL_HEIGHT,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SOVEntityRankingMAV,
        value: REPORT_TYPES.SOVEntityRankingMAV,
        reportCategory: REPORT_CATEGORIES.SOV,
        label: "Share Of Voice By Ranking - Entity (MAV)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SOVEntityRankingOnline,
          print: GRAPH_DATATYPE.SOVEntityRankingPrint,
          printandonline: GRAPH_DATATYPE.SOVEntityRankingPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          BAR_STACKED_EQUAL_HEIGHT,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SOVEntityRankingReach,
        value: REPORT_TYPES.SOVEntityRankingReach,
        reportCategory: REPORT_CATEGORIES.SOV,
        label: "Share Of Voice By Ranking - Entity (Reach)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SOVEntityRankingOnline,
          print: GRAPH_DATATYPE.SOVEntityRankingPrint,
          printandonline: GRAPH_DATATYPE.SOVEntityRankingPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          BAR_STACKED_EQUAL_HEIGHT,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SOVEntityRankingWordCount,
        value: REPORT_TYPES.SOVEntityRankingWordCount,
        reportCategory: REPORT_CATEGORIES.SOV,
        label: "Share Of Voice By Ranking - Entity (Word Count)",
        enablePrint: false,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SOVEntityRankingOnline,
        },
        verticalList: [V_ONLINE],
        groupByField: "entity_name",
        excludeGraphType: [
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          BAR_STACKED_EQUAL_HEIGHT,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      //SOV - Entity - Trend
      {
        id: REPORT_TYPES.SOVEntityTrendIndex,
        value: REPORT_TYPES.SOVEntityTrendIndex,
        reportCategory: REPORT_CATEGORIES.SOV,
        label: "Share Of Voice By Trend - Entity (Index)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SOVEntityTrendOnline,
          print: GRAPH_DATATYPE.SOVEntityTrendPrint,
          printandonline: GRAPH_DATATYPE.SOVEntityTrendPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,
          BAR_STACKED_EQUAL_HEIGHT,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SOVEntityTrendNOA,
        value: REPORT_TYPES.SOVEntityTrendNOA,
        reportCategory: REPORT_CATEGORIES.SOV,
        label: "Share Of Voice By Trend - Entity (No. Of Article)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SOVEntityTrendOnline,
          print: GRAPH_DATATYPE.SOVEntityTrendPrint,
          printandonline: GRAPH_DATATYPE.SOVEntityTrendPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,
          BAR_STACKED_EQUAL_HEIGHT,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SOVEntityTrendCCM,
        value: REPORT_TYPES.SOVEntityTrendCCM,
        reportCategory: REPORT_CATEGORIES.SOV,
        label: "Share Of Voice By Trend - Entity (CCM)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SOVEntityTrendOnline,
          print: GRAPH_DATATYPE.SOVEntityTrendPrint,
          printandonline: GRAPH_DATATYPE.SOVEntityTrendPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,
          BAR_STACKED_EQUAL_HEIGHT,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SOVEntityTrendMAV,
        value: REPORT_TYPES.SOVEntityTrendMAV,
        reportCategory: REPORT_CATEGORIES.SOV,
        label: "Share Of Voice By Trend - Entity (MAV)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SOVEntityTrendOnline,
          print: GRAPH_DATATYPE.SOVEntityTrendPrint,
          printandonline: GRAPH_DATATYPE.SOVEntityTrendPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,
          BAR_STACKED_EQUAL_HEIGHT,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SOVEntityTrendReach,
        value: REPORT_TYPES.SOVEntityTrendReach,
        reportCategory: REPORT_CATEGORIES.SOV,
        label: "Share Of Voice By Trend - Entity (Reach)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SOVEntityTrendOnline,
          print: GRAPH_DATATYPE.SOVEntityTrendPrint,
          printandonline: GRAPH_DATATYPE.SOVEntityTrendPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,
          BAR_STACKED_EQUAL_HEIGHT,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SOVEntityTrendWordCount,
        value: REPORT_TYPES.SOVEntityTrendWordCount,
        reportCategory: REPORT_CATEGORIES.SOV,
        label: "Share Of Voice By Trend - Entity (Word Count)",
        enablePrint: false,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SOVEntityTrendOnline,
        },
        verticalList: [V_ONLINE],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,
          BAR_STACKED_EQUAL_HEIGHT,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      //SOV - Entity - Tonality
      {
        id: REPORT_TYPES.SOVEntityTonalityIndex,
        value: REPORT_TYPES.SOVEntityTonalityIndex,
        reportCategory: REPORT_CATEGORIES.SOV,
        label: "Share Of Voice By Tonality - Entity (Index)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SOVEntityTonalityOnline,
          print: GRAPH_DATATYPE.SOVEntityTonalityPrint,
          printandonline: GRAPH_DATATYPE.SOVEntityTonalityPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SOVEntityTonalityNOA,
        value: REPORT_TYPES.SOVEntityTonalityNOA,
        reportCategory: REPORT_CATEGORIES.SOV,
        label: "Share Of Voice By Tonality - Entity (No. Of Article)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SOVEntityTonalityOnline,
          print: GRAPH_DATATYPE.SOVEntityTonalityPrint,
          printandonline: GRAPH_DATATYPE.SOVEntityTonalityPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SOVEntityTonalityCCM,
        value: REPORT_TYPES.SOVEntityTonalityCCM,
        reportCategory: REPORT_CATEGORIES.SOV,
        label: "Share Of Voice By Tonality - Entity (CCM)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SOVEntityTonalityOnline,
          print: GRAPH_DATATYPE.SOVEntityTonalityPrint,
          printandonline: GRAPH_DATATYPE.SOVEntityTonalityPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SOVEntityTonalityMAV,
        value: REPORT_TYPES.SOVEntityTonalityMAV,
        reportCategory: REPORT_CATEGORIES.SOV,
        label: "Share Of Voice By Tonality - Entity (MAV)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SOVEntityTonalityOnline,
          print: GRAPH_DATATYPE.SOVEntityTonalityPrint,
          printandonline: GRAPH_DATATYPE.SOVEntityTonalityPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SOVEntityTonalityReach,
        value: REPORT_TYPES.SOVEntityTonalityReach,
        reportCategory: REPORT_CATEGORIES.SOV,
        label: "Share Of Voice By Tonality - Entity (Reach)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SOVEntityTonalityOnline,
          print: GRAPH_DATATYPE.SOVEntityTonalityPrint,
          printandonline: GRAPH_DATATYPE.SOVEntityTonalityPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SOVEntityTonalityWordCount,
        value: REPORT_TYPES.SOVEntityTonalityWordCount,
        reportCategory: REPORT_CATEGORIES.SOV,
        label: "Share Of Voice By Tonality - Entity (Word Count)",
        enablePrint: false,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SOVEntityTonalityOnline,
        },
        verticalList: [V_ONLINE],
        groupByField: "entity_name",
        excludeGraphType: [

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      //SOV - Journalist - Ranking
      {
        id: REPORT_TYPES.SOVJournalistRankingIndex,
        value: REPORT_TYPES.SOVJournalistRankingIndex,
        reportCategory: REPORT_CATEGORIES.SOV,
        label: "Share Of Voice By Ranking - Journalist (Index)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SOVJournalistRankingOnline,
          print: GRAPH_DATATYPE.SOVJournalistRankingPrint,
          printandonline: GRAPH_DATATYPE.SOVJournalistRankingPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SOVJournalistRankingNOA,
        value: REPORT_TYPES.SOVJournalistRankingNOA,
        reportCategory: REPORT_CATEGORIES.SOV,
        label: "Share Of Voice By Ranking - Journalist (No. Of Article)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SOVJournalistRankingOnline,
          print: GRAPH_DATATYPE.SOVJournalistRankingPrint,
          printandonline: GRAPH_DATATYPE.SOVJournalistRankingPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SOVJournalistRankingCCM,
        value: REPORT_TYPES.SOVJournalistRankingCCM,
        reportCategory: REPORT_CATEGORIES.SOV,
        label: "Share Of Voice By Ranking - Journalist (CCM)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SOVJournalistRankingOnline,
          print: GRAPH_DATATYPE.SOVJournalistRankingPrint,
          printandonline: GRAPH_DATATYPE.SOVJournalistRankingPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SOVJournalistRankingMAV,
        value: REPORT_TYPES.SOVJournalistRankingMAV,
        reportCategory: REPORT_CATEGORIES.SOV,
        label: "Share Of Voice By Ranking - Journalist (MAV)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SOVJournalistRankingOnline,
          print: GRAPH_DATATYPE.SOVJournalistRankingPrint,
          printandonline: GRAPH_DATATYPE.SOVJournalistRankingPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SOVJournalistRankingReach,
        value: REPORT_TYPES.SOVJournalistRankingReach,
        reportCategory: REPORT_CATEGORIES.SOV,
        label: "Share Of Voice By Ranking - Journalist (Reach)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SOVJournalistRankingOnline,
          print: GRAPH_DATATYPE.SOVJournalistRankingPrint,
          printandonline: GRAPH_DATATYPE.SOVJournalistRankingPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SOVJournalistRankingWordCount,
        value: REPORT_TYPES.SOVJournalistRankingWordCount,
        reportCategory: REPORT_CATEGORIES.SOV,
        label: "Share Of Voice By Ranking - Journalist (Word Count)",
        enablePrint: false,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SOVJournalistRankingOnline,
        },
        verticalList: [V_ONLINE],
        groupByField: "entity_name",
        excludeGraphType: [

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      //SOV - Journalist - Trend
      {
        id: REPORT_TYPES.SOVJournalistTrendIndex,
        value: REPORT_TYPES.SOVJournalistTrendIndex,
        reportCategory: REPORT_CATEGORIES.SOV,
        label: "Share Of Voice By Trend - Journalist (Index)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SOVJournalistTrendOnline,
          print: GRAPH_DATATYPE.SOVJournalistTrendPrint,
          printandonline: GRAPH_DATATYPE.SOVJournalistTrendPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,
          BAR_STACKED_EQUAL_HEIGHT,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SOVJournalistTrendNOA,
        value: REPORT_TYPES.SOVJournalistTrendNOA,
        reportCategory: REPORT_CATEGORIES.SOV,
        label: "Share Of Voice By Trend - Journalist (No. Of Article)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SOVJournalistTrendOnline,
          print: GRAPH_DATATYPE.SOVJournalistTrendPrint,
          printandonline: GRAPH_DATATYPE.SOVJournalistTrendPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,
          BAR_STACKED_EQUAL_HEIGHT,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SOVJournalistTrendCCM,
        value: REPORT_TYPES.SOVJournalistTrendCCM,
        reportCategory: REPORT_CATEGORIES.SOV,
        label: "Share Of Voice By Trend - Journalist (CCM)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SOVJournalistTrendOnline,
          print: GRAPH_DATATYPE.SOVJournalistTrendPrint,
          printandonline: GRAPH_DATATYPE.SOVJournalistTrendPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,
          BAR_STACKED_EQUAL_HEIGHT,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SOVJournalistTrendMAV,
        value: REPORT_TYPES.SOVJournalistTrendMAV,
        reportCategory: REPORT_CATEGORIES.SOV,
        label: "Share Of Voice By Trend - Journalist (MAV)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SOVJournalistTrendOnline,
          print: GRAPH_DATATYPE.SOVJournalistTrendPrint,
          printandonline: GRAPH_DATATYPE.SOVJournalistTrendPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,
          BAR_STACKED_EQUAL_HEIGHT,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SOVJournalistTrendReach,
        value: REPORT_TYPES.SOVJournalistTrendReach,
        reportCategory: REPORT_CATEGORIES.SOV,
        label: "Share Of Voice By Trend - Journalist (Reach)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SOVJournalistTrendOnline,
          print: GRAPH_DATATYPE.SOVJournalistTrendPrint,
          printandonline: GRAPH_DATATYPE.SOVJournalistTrendPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,
          BAR_STACKED_EQUAL_HEIGHT,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SOVJournalistTrendWordCount,
        value: REPORT_TYPES.SOVJournalistTrendWordCount,
        reportCategory: REPORT_CATEGORIES.SOV,
        label: "Share Of Voice By Trend - Journalist (Word Count)",
        enablePrint: false,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SOVJournalistTrendOnline,
        },
        verticalList: [V_ONLINE],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,
          BAR_STACKED_EQUAL_HEIGHT,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      //SOV - Journalist- Tonality
      {
        id: REPORT_TYPES.SOVJournalistTonalityIndex,
        value: REPORT_TYPES.SOVJournalistTonalityIndex,
        reportCategory: REPORT_CATEGORIES.SOV,
        label: "Share Of Voice By Tonality - Journalist (Index)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SOVJournalistTonalityOnline,
          print: GRAPH_DATATYPE.SOVJournalistTonalityPrint,
          printandonline: GRAPH_DATATYPE.SOVJournalistTonalityPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SOVJournalistTonalityNOA,
        value: REPORT_TYPES.SOVJournalistTonalityNOA,
        reportCategory: REPORT_CATEGORIES.SOV,
        label: "Share Of Voice By Tonality - Journalist (No. Of Article)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SOVJournalistTonalityOnline,
          print: GRAPH_DATATYPE.SOVJournalistTonalityPrint,
          printandonline: GRAPH_DATATYPE.SOVJournalistTonalityPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SOVJournalistTonalityCCM,
        value: REPORT_TYPES.SOVJournalistTonalityCCM,
        reportCategory: REPORT_CATEGORIES.SOV,
        label: "Share Of Voice By Tonality - Journalist (CCM)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SOVJournalistTonalityOnline,
          print: GRAPH_DATATYPE.SOVJournalistTonalityPrint,
          printandonline: GRAPH_DATATYPE.SOVJournalistTonalityPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SOVJournalistTonalityMAV,
        value: REPORT_TYPES.SOVJournalistTonalityMAV,
        reportCategory: REPORT_CATEGORIES.SOV,
        label: "Share Of Voice By Tonality - Journalist (MAV)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SOVJournalistTonalityOnline,
          print: GRAPH_DATATYPE.SOVJournalistTonalityPrint,
          printandonline: GRAPH_DATATYPE.SOVJournalistTonalityPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SOVJournalistTonalityReach,
        value: REPORT_TYPES.SOVJournalistTonalityReach,
        reportCategory: REPORT_CATEGORIES.SOV,
        label: "Share Of Voice By Tonality - Journalist (Reach)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SOVJournalistTonalityOnline,
          print: GRAPH_DATATYPE.SOVJournalistTonalityPrint,
          printandonline: GRAPH_DATATYPE.SOVJournalistTonalityPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SOVJournalistTonalityWordCount,
        value: REPORT_TYPES.SOVJournalistTonalityWordCount,
        reportCategory: REPORT_CATEGORIES.SOV,
        label: "Share Of Voice By Tonality - Journalist (Word Count)",
        enablePrint: false,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SOVJournalistTonalityOnline,
        },
        verticalList: [V_ONLINE],
        groupByField: "entity_name",
        excludeGraphType: [

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      //SOV - Keyword - Ranking
      {
        id: REPORT_TYPES.SOVKeywordRankingIndex,
        value: REPORT_TYPES.SOVKeywordRankingIndex,
        reportCategory: REPORT_CATEGORIES.SOV,
        label: "Share Of Voice By Ranking - Keyword (Index)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SOVKeywordRankingOnline,
          print: GRAPH_DATATYPE.SOVKeywordRankingPrint,
          printandonline: GRAPH_DATATYPE.SOVKeywordRankingPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SOVKeywordRankingNOA,
        value: REPORT_TYPES.SOVKeywordRankingNOA,
        reportCategory: REPORT_CATEGORIES.SOV,
        label: "Share Of Voice By Ranking - Keyword (No. Of Article)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SOVKeywordRankingOnline,
          print: GRAPH_DATATYPE.SOVKeywordRankingPrint,
          printandonline: GRAPH_DATATYPE.SOVKeywordRankingPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SOVKeywordRankingCCM,
        value: REPORT_TYPES.SOVKeywordRankingCCM,
        reportCategory: REPORT_CATEGORIES.SOV,
        label: "Share Of Voice By Ranking - Keyword (CCM)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SOVKeywordRankingOnline,
          print: GRAPH_DATATYPE.SOVKeywordRankingPrint,
          printandonline: GRAPH_DATATYPE.SOVKeywordRankingPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SOVKeywordRankingMAV,
        value: REPORT_TYPES.SOVKeywordRankingMAV,
        reportCategory: REPORT_CATEGORIES.SOV,
        label: "Share Of Voice By Ranking - Keyword (MAV)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SOVKeywordRankingOnline,
          print: GRAPH_DATATYPE.SOVKeywordRankingPrint,
          printandonline: GRAPH_DATATYPE.SOVKeywordRankingPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SOVKeywordRankingReach,
        value: REPORT_TYPES.SOVKeywordRankingReach,
        reportCategory: REPORT_CATEGORIES.SOV,
        label: "Share Of Voice By Ranking - Keyword (Reach)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SOVKeywordRankingOnline,
          print: GRAPH_DATATYPE.SOVKeywordRankingPrint,
          printandonline: GRAPH_DATATYPE.SOVKeywordRankingPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SOVKeywordRankingWordCount,
        value: REPORT_TYPES.SOVKeywordRankingWordCount,
        reportCategory: REPORT_CATEGORIES.SOV,
        label: "Share Of Voice By Ranking - Keyword (Word Count)",
        enablePrint: false,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SOVKeywordRankingOnline,
        },
        verticalList: [V_ONLINE],
        groupByField: "entity_name",
        excludeGraphType: [

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      //SOV - Keyword - Trend
      {
        id: REPORT_TYPES.SOVKeywordTrendIndex,
        value: REPORT_TYPES.SOVKeywordTrendIndex,
        reportCategory: REPORT_CATEGORIES.SOV,
        label: "Share Of Voice By Trend - Keyword (Index)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SOVKeywordTrendOnline,
          print: GRAPH_DATATYPE.SOVKeywordTrendPrint,
          printandonline: GRAPH_DATATYPE.SOVKeywordTrendPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,
          BAR_STACKED_EQUAL_HEIGHT,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SOVKeywordTrendNOA,
        value: REPORT_TYPES.SOVKeywordTrendNOA,
        reportCategory: REPORT_CATEGORIES.SOV,
        label: "Share Of Voice By Trend - Keyword (No. Of Article)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SOVKeywordTrendOnline,
          print: GRAPH_DATATYPE.SOVKeywordTrendPrint,
          printandonline: GRAPH_DATATYPE.SOVKeywordTrendPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,
          BAR_STACKED_EQUAL_HEIGHT,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SOVKeywordTrendCCM,
        value: REPORT_TYPES.SOVKeywordTrendCCM,
        reportCategory: REPORT_CATEGORIES.SOV,
        label: "Share Of Voice By Trend - Keyword (CCM)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SOVKeywordTrendOnline,
          print: GRAPH_DATATYPE.SOVKeywordTrendPrint,
          printandonline: GRAPH_DATATYPE.SOVKeywordTrendPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,
          BAR_STACKED_EQUAL_HEIGHT,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SOVKeywordTrendMAV,
        value: REPORT_TYPES.SOVKeywordTrendMAV,
        reportCategory: REPORT_CATEGORIES.SOV,
        label: "Share Of Voice By Trend - Keyword (MAV)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SOVKeywordTrendOnline,
          print: GRAPH_DATATYPE.SOVKeywordTrendPrint,
          printandonline: GRAPH_DATATYPE.SOVKeywordTrendPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,
          BAR_STACKED_EQUAL_HEIGHT,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SOVKeywordTrendReach,
        value: REPORT_TYPES.SOVKeywordTrendReach,
        reportCategory: REPORT_CATEGORIES.SOV,
        label: "Share Of Voice By Trend - Keyword (Reach)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SOVKeywordTrendOnline,
          print: GRAPH_DATATYPE.SOVKeywordTrendPrint,
          printandonline: GRAPH_DATATYPE.SOVKeywordTrendPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,
          BAR_STACKED_EQUAL_HEIGHT,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SOVKeywordTrendWordCount,
        value: REPORT_TYPES.SOVKeywordTrendWordCount,
        reportCategory: REPORT_CATEGORIES.SOV,
        label: "Share Of Voice By Trend - Keyword (Word Count)",
        enablePrint: false,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SOVKeywordTrendOnline,
        },
        verticalList: [V_ONLINE],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,
          BAR_STACKED_EQUAL_HEIGHT,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      //SOV - Keyword- Tonality
      {
        id: REPORT_TYPES.SOVKeywordTonalityIndex,
        value: REPORT_TYPES.SOVKeywordTonalityIndex,
        reportCategory: REPORT_CATEGORIES.SOV,
        label: "Share Of Voice By Tonality - Keyword (Index)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SOVKeywordTonalityOnline,
          print: GRAPH_DATATYPE.SOVKeywordTonalityPrint,
          printandonline: GRAPH_DATATYPE.SOVKeywordTonalityPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SOVKeywordTonalityNOA,
        value: REPORT_TYPES.SOVKeywordTonalityNOA,
        reportCategory: REPORT_CATEGORIES.SOV,
        label: "Share Of Voice By Tonality - Keyword (No. Of Article)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SOVKeywordTonalityOnline,
          print: GRAPH_DATATYPE.SOVKeywordTonalityPrint,
          printandonline: GRAPH_DATATYPE.SOVKeywordTonalityPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SOVKeywordTonalityCCM,
        value: REPORT_TYPES.SOVKeywordTonalityCCM,
        reportCategory: REPORT_CATEGORIES.SOV,
        label: "Share Of Voice By Tonality - Keyword (CCM)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SOVKeywordTonalityOnline,
          print: GRAPH_DATATYPE.SOVKeywordTonalityPrint,
          printandonline: GRAPH_DATATYPE.SOVKeywordTonalityPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SOVKeywordTonalityMAV,
        value: REPORT_TYPES.SOVKeywordTonalityMAV,
        reportCategory: REPORT_CATEGORIES.SOV,
        label: "Share Of Voice By Tonality - Keyword (MAV)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SOVKeywordTonalityOnline,
          print: GRAPH_DATATYPE.SOVKeywordTonalityPrint,
          printandonline: GRAPH_DATATYPE.SOVKeywordTonalityPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SOVKeywordTonalityReach,
        value: REPORT_TYPES.SOVKeywordTonalityReach,
        reportCategory: REPORT_CATEGORIES.SOV,
        label: "Share Of Voice By Tonality - Keyword (Reach)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SOVKeywordTonalityOnline,
          print: GRAPH_DATATYPE.SOVKeywordTonalityPrint,
          printandonline: GRAPH_DATATYPE.SOVKeywordTonalityPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SOVKeywordTonalityWordCount,
        value: REPORT_TYPES.SOVKeywordTonalityWordCount,
        reportCategory: REPORT_CATEGORIES.SOV,
        label: "Share Of Voice By Tonality - Keyword (Word Count)",
        enablePrint: false,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SOVKeywordTonalityOnline,
        },
        verticalList: [V_ONLINE],
        groupByField: "entity_name",
        excludeGraphType: [

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      //SOV - City - Ranking
      //Todo: Remove Word  Count Reports for CITY LEVEL
      {
        id: REPORT_TYPES.SOVCityRankingIndex,
        value: REPORT_TYPES.SOVCityRankingIndex,
        reportCategory: REPORT_CATEGORIES.SOV,
        label: "Share Of Voice By Ranking - City (Index)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          print: GRAPH_DATATYPE.SOVCityRankingPrint,
          printandonline: GRAPH_DATATYPE.SOVCityRankingPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SOVCityRankingNOA,
        value: REPORT_TYPES.SOVCityRankingNOA,
        reportCategory: REPORT_CATEGORIES.SOV,
        label: "Share Of Voice By Ranking - City (No. Of Article)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          print: GRAPH_DATATYPE.SOVCityRankingPrint,
          printandonline: GRAPH_DATATYPE.SOVCityRankingPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SOVCityRankingCCM,
        value: REPORT_TYPES.SOVCityRankingCCM,
        reportCategory: REPORT_CATEGORIES.SOV,
        label: "Share Of Voice By Ranking - City (CCM)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          print: GRAPH_DATATYPE.SOVCityRankingPrint,
          printandonline: GRAPH_DATATYPE.SOVCityRankingPrintOnline,
        },
        verticalList: [V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SOVCityRankingMAV,
        value: REPORT_TYPES.SOVCityRankingMAV,
        reportCategory: REPORT_CATEGORIES.SOV,
        label: "Share Of Voice By Ranking - City (MAV)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          print: GRAPH_DATATYPE.SOVCityRankingPrint,
          printandonline: GRAPH_DATATYPE.SOVCityRankingPrintOnline,
        },
        verticalList: [V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SOVCityRankingReach,
        value: REPORT_TYPES.SOVCityRankingReach,
        reportCategory: REPORT_CATEGORIES.SOV,
        label: "Share Of Voice By Ranking - City (Reach)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          print: GRAPH_DATATYPE.SOVCityRankingPrint,
          printandonline: GRAPH_DATATYPE.SOVCityRankingPrintOnline,
        },
        verticalList: [V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SOVCityRankingWordCount,
        value: REPORT_TYPES.SOVCityRankingWordCount,
        reportCategory: REPORT_CATEGORIES.SOV,
        label: "Share Of Voice By Ranking - City (Word Count)",
        enablePrint: false,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SOVCityRankingOnline,
          printandonline: GRAPH_DATATYPE.SOVCityRankingPrintOnline,
        },
        verticalList: [V_ONLINE],
        groupByField: "entity_name",
        excludeGraphType: [

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      //SOV - City - Trend
      {
        id: REPORT_TYPES.SOVCityTrendIndex,
        value: REPORT_TYPES.SOVCityTrendIndex,
        reportCategory: REPORT_CATEGORIES.SOV,
        label: "Share Of Voice By Trend - City (Index)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          print: GRAPH_DATATYPE.SOVCityTrendPrint,
          printandonline: GRAPH_DATATYPE.SOVCityTrendPrintOnline,
        },
        verticalList: [V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,
          BAR_STACKED_EQUAL_HEIGHT,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SOVCityTrendNOA,
        value: REPORT_TYPES.SOVCityTrendNOA,
        reportCategory: REPORT_CATEGORIES.SOV,
        label: "Share Of Voice By Trend - City (No. Of Article)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          print: GRAPH_DATATYPE.SOVCityTrendPrint,
          printandonline: GRAPH_DATATYPE.SOVCityTrendPrintOnline,
        },
        verticalList: [V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,
          BAR_STACKED_EQUAL_HEIGHT,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SOVCityTrendCCM,
        value: REPORT_TYPES.SOVCityTrendCCM,
        reportCategory: REPORT_CATEGORIES.SOV,
        label: "Share Of Voice By Trend - City (CCM)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          print: GRAPH_DATATYPE.SOVCityTrendPrint,
          printandonline: GRAPH_DATATYPE.SOVCityTrendPrintOnline,
        },
        verticalList: [V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,
          BAR_STACKED_EQUAL_HEIGHT,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SOVCityTrendMAV,
        value: REPORT_TYPES.SOVCityTrendMAV,
        reportCategory: REPORT_CATEGORIES.SOV,
        label: "Share Of Voice By Trend - City (MAV)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          print: GRAPH_DATATYPE.SOVCityTrendPrint,
          printandonline: GRAPH_DATATYPE.SOVCityTrendPrintOnline,
        },
        verticalList: [V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,
          BAR_STACKED_EQUAL_HEIGHT,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SOVCityTrendReach,
        value: REPORT_TYPES.SOVCityTrendReach,
        reportCategory: REPORT_CATEGORIES.SOV,
        label: "Share Of Voice By Trend - City (Reach)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          print: GRAPH_DATATYPE.SOVCityTrendPrint,
          printandonline: GRAPH_DATATYPE.SOVCityTrendPrintOnline,
        },
        verticalList: [V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,
          BAR_STACKED_EQUAL_HEIGHT,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SOVCityTrendWordCount,
        value: REPORT_TYPES.SOVCityTrendWordCount,
        reportCategory: REPORT_CATEGORIES.SOV,
        label: "Share Of Voice By Trend - City (Word Count)",
        enablePrint: false,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SOVCityTrendOnline,
          printandonline: GRAPH_DATATYPE.SOVCityTrendPrintOnline,
        },
        verticalList: [V_ONLINE],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,
          BAR_STACKED_EQUAL_HEIGHT,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      //SOV - City- Tonality
      {
        id: REPORT_TYPES.SOVCityTonalityIndex,
        value: REPORT_TYPES.SOVCityTonalityIndex,
        reportCategory: REPORT_CATEGORIES.SOV,
        label: "Share Of Voice By Tonality - City (Index)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          print: GRAPH_DATATYPE.SOVCityTonalityPrint,
          printandonline: GRAPH_DATATYPE.SOVCityTonalityPrintOnline,
        },
        verticalList: [V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SOVCityTonalityNOA,
        value: REPORT_TYPES.SOVCityTonalityNOA,
        reportCategory: REPORT_CATEGORIES.SOV,
        label: "Share Of Voice By Tonality - City (No. Of Article)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          print: GRAPH_DATATYPE.SOVCityTonalityPrint,
          printandonline: GRAPH_DATATYPE.SOVCityTonalityPrintOnline,
        },
        verticalList: [V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SOVCityTonalityCCM,
        value: REPORT_TYPES.SOVCityTonalityCCM,
        reportCategory: REPORT_CATEGORIES.SOV,
        label: "Share Of Voice By Tonality - City (CCM)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          print: GRAPH_DATATYPE.SOVCityTonalityPrint,
          printandonline: GRAPH_DATATYPE.SOVCityTonalityPrintOnline,
        },
        verticalList: [V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SOVCityTonalityMAV,
        value: REPORT_TYPES.SOVCityTonalityMAV,
        reportCategory: REPORT_CATEGORIES.SOV,
        label: "Share Of Voice By Tonality - City (MAV)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          print: GRAPH_DATATYPE.SOVCityTonalityPrint,
          printandonline: GRAPH_DATATYPE.SOVCityTonalityPrintOnline,
        },
        verticalList: [V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SOVCityTonalityReach,
        value: REPORT_TYPES.SOVCityTonalityReach,
        reportCategory: REPORT_CATEGORIES.SOV,
        label: "Share Of Voice By Tonality - City (Reach)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          print: GRAPH_DATATYPE.SOVCityTonalityPrint,
          printandonline: GRAPH_DATATYPE.SOVCityTonalityPrintOnline,
        },
        verticalList: [V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SOVCityTonalityWordCount,
        value: REPORT_TYPES.SOVCityTonalityWordCount,
        reportCategory: REPORT_CATEGORIES.SOV,
        label: "Share Of Voice By Tonality - City (Word Count)",
        enablePrint: false,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SOVCityTonalityOnline,
          printandonline: GRAPH_DATATYPE.SOVCityTonalityPrintOnline,
        },
        verticalList: [V_ONLINE],
        groupByField: "entity_name",
        excludeGraphType: [

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      //SOV - Publication - Ranking
      {
        id: REPORT_TYPES.SOVPublicationRankingIndex,
        value: REPORT_TYPES.SOVPublicationRankingIndex,
        reportCategory: REPORT_CATEGORIES.SOV,
        label: "Share Of Voice By Ranking - Publication (Index)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SOVPublicationRankingOnline,
          print: GRAPH_DATATYPE.SOVPublicationRankingPrint,
          printandonline: GRAPH_DATATYPE.SOVPublicationRankingPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT_AND_ONLINE],
        groupByField: "entity_name",
        excludeGraphType: [

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SOVPublicationRankingNOA,
        value: REPORT_TYPES.SOVPublicationRankingNOA,
        reportCategory: REPORT_CATEGORIES.SOV,
        label: "Share Of Voice By Ranking - Publication (No. Of Article)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SOVPublicationRankingOnline,
          print: GRAPH_DATATYPE.SOVPublicationRankingPrint,
          printandonline: GRAPH_DATATYPE.SOVPublicationRankingPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SOVPublicationRankingCCM,
        value: REPORT_TYPES.SOVPublicationRankingCCM,
        reportCategory: REPORT_CATEGORIES.SOV,
        label: "Share Of Voice By Ranking - Publication (CCM)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SOVPublicationRankingOnline,
          print: GRAPH_DATATYPE.SOVPublicationRankingPrint,
          printandonline: GRAPH_DATATYPE.SOVPublicationRankingPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SOVPublicationRankingMAV,
        value: REPORT_TYPES.SOVPublicationRankingMAV,
        reportCategory: REPORT_CATEGORIES.SOV,
        label: "Share Of Voice By Ranking - Publication (MAV)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SOVPublicationRankingOnline,
          print: GRAPH_DATATYPE.SOVPublicationRankingPrint,
          printandonline: GRAPH_DATATYPE.SOVPublicationRankingPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SOVPublicationRankingReach,
        value: REPORT_TYPES.SOVPublicationRankingReach,
        reportCategory: REPORT_CATEGORIES.SOV,
        label: "Share Of Voice By Ranking - Publication (Reach)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SOVPublicationRankingOnline,
          print: GRAPH_DATATYPE.SOVPublicationRankingPrint,
          printandonline: GRAPH_DATATYPE.SOVPublicationRankingPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SOVPublicationRankingWordCount,
        value: REPORT_TYPES.SOVPublicationRankingWordCount,
        reportCategory: REPORT_CATEGORIES.SOV,
        label: "Share Of Voice By Ranking - Publication (Word Count)",
        enablePrint: false,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SOVPublicationRankingOnline,
          printandonline: GRAPH_DATATYPE.SOVPublicationRankingPrintOnline,
        },
        verticalList: [V_ONLINE],
        groupByField: "entity_name",
        excludeGraphType: [

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      //SOV - Publication - Trend
      {
        id: REPORT_TYPES.SOVPublicationTrendIndex,
        value: REPORT_TYPES.SOVPublicationTrendIndex,
        reportCategory: REPORT_CATEGORIES.SOV,
        label: "Share Of Voice By Trend - Publication (Index)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SOVPublicationTrendOnline,
          print: GRAPH_DATATYPE.SOVPublicationTrendPrint,
          printandonline: GRAPH_DATATYPE.SOVPublicationTrendPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,
          BAR_STACKED_EQUAL_HEIGHT,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SOVPublicationTrendNOA,
        value: REPORT_TYPES.SOVPublicationTrendNOA,
        reportCategory: REPORT_CATEGORIES.SOV,
        label: "Share Of Voice By Trend - Publication (No. Of Article)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SOVPublicationTrendOnline,
          print: GRAPH_DATATYPE.SOVPublicationTrendPrint,
          printandonline: GRAPH_DATATYPE.SOVPublicationTrendPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,
          BAR_STACKED_EQUAL_HEIGHT,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SOVPublicationTrendCCM,
        value: REPORT_TYPES.SOVPublicationTrendCCM,
        reportCategory: REPORT_CATEGORIES.SOV,
        label: "Share Of Voice By Trend - Publication (CCM)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SOVPublicationTrendOnline,
          print: GRAPH_DATATYPE.SOVPublicationTrendPrint,
          printandonline: GRAPH_DATATYPE.SOVPublicationTrendPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,
          BAR_STACKED_EQUAL_HEIGHT,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SOVPublicationTrendMAV,
        value: REPORT_TYPES.SOVPublicationTrendMAV,
        reportCategory: REPORT_CATEGORIES.SOV,
        label: "Share Of Voice By Trend - Publication (MAV)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SOVPublicationTrendOnline,
          print: GRAPH_DATATYPE.SOVPublicationTrendPrint,
          printandonline: GRAPH_DATATYPE.SOVPublicationTrendPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,
          BAR_STACKED_EQUAL_HEIGHT,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SOVPublicationTrendReach,
        value: REPORT_TYPES.SOVPublicationTrendReach,
        reportCategory: REPORT_CATEGORIES.SOV,
        label: "Share Of Voice By Trend - Publication (Reach)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SOVPublicationTrendOnline,
          print: GRAPH_DATATYPE.SOVPublicationTrendPrint,
          printandonline: GRAPH_DATATYPE.SOVPublicationTrendPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,
          BAR_STACKED_EQUAL_HEIGHT,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SOVPublicationTrendWordCount,
        value: REPORT_TYPES.SOVPublicationTrendWordCount,
        reportCategory: REPORT_CATEGORIES.SOV,
        label: "Share Of Voice By Trend - Publication (Word Count)",
        enablePrint: false,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SOVPublicationTrendOnline,
          printandonline: GRAPH_DATATYPE.SOVPublicationTrendPrintOnline,
        },
        verticalList: [V_ONLINE],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,
          BAR_STACKED_EQUAL_HEIGHT,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      //SOV - Publication- Tonality
      {
        id: REPORT_TYPES.SOVPublicationTonalityIndex,
        value: REPORT_TYPES.SOVPublicationTonalityIndex,
        reportCategory: REPORT_CATEGORIES.SOV,
        label: "Share Of Voice By Tonality - Publication (Index)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SOVPublicationTonalityOnline,
          print: GRAPH_DATATYPE.SOVPublicationTonalityPrint,
          printandonline: GRAPH_DATATYPE.SOVPublicationTonalityPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SOVPublicationTonalityNOA,
        value: REPORT_TYPES.SOVPublicationTonalityNOA,
        reportCategory: REPORT_CATEGORIES.SOV,
        label: "Share Of Voice By Tonality - Publication (No. Of Article)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SOVPublicationTonalityOnline,
          print: GRAPH_DATATYPE.SOVPublicationTonalityPrint,
          printandonline: GRAPH_DATATYPE.SOVPublicationTonalityPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SOVPublicationTonalityCCM,
        value: REPORT_TYPES.SOVPublicationTonalityCCM,
        reportCategory: REPORT_CATEGORIES.SOV,
        label: "Share Of Voice By Tonality - Publication (CCM)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SOVPublicationTonalityOnline,
          print: GRAPH_DATATYPE.SOVPublicationTonalityPrint,
          printandonline: GRAPH_DATATYPE.SOVPublicationTonalityPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SOVPublicationTonalityMAV,
        value: REPORT_TYPES.SOVPublicationTonalityMAV,
        reportCategory: REPORT_CATEGORIES.SOV,
        label: "Share Of Voice By Tonality - Publication (MAV)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SOVPublicationTonalityOnline,
          print: GRAPH_DATATYPE.SOVPublicationTonalityPrint,
          printandonline: GRAPH_DATATYPE.SOVPublicationTonalityPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SOVPublicationTonalityReach,
        value: REPORT_TYPES.SOVPublicationTonalityReach,
        reportCategory: REPORT_CATEGORIES.SOV,
        label: "Share Of Voice By Tonality - Publication (Reach)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SOVPublicationTonalityOnline,
          print: GRAPH_DATATYPE.SOVPublicationTonalityPrint,
          printandonline: GRAPH_DATATYPE.SOVPublicationTonalityPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SOVPublicationTonalityWordCount,
        value: REPORT_TYPES.SOVPublicationTonalityWordCount,
        reportCategory: REPORT_CATEGORIES.SOV,
        label: "Share Of Voice By Tonality - Publication (Word Count)",
        enablePrint: false,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SOVPublicationTonalityOnline,
          printandonline: GRAPH_DATATYPE.SOVPublicationTonalityPrintOnline,
        },
        verticalList: [V_ONLINE],
        groupByField: "entity_name",
        excludeGraphType: [

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      //block Thematic - Entity - SOV 
      {
        id: REPORT_TYPES.ThematicEntitySOVIndex,
        value: REPORT_TYPES.ThematicEntitySOVIndex,
        reportCategory: REPORT_CATEGORIES.THEMATIC_ANALYSIS,
        label: "Thematic - SOV - Entity (Index)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.ThematicEntitySOVOnline,
          print: GRAPH_DATATYPE.ThematicEntitySOVPrint,
          printandonline: GRAPH_DATATYPE.ThematicEntitySOVPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.ThematicEntitySOVNOA,
        value: REPORT_TYPES.ThematicEntitySOVNOA,
        reportCategory: REPORT_CATEGORIES.THEMATIC_ANALYSIS,
        label: "Thematic - SOV - Entity (No. Of Article)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.ThematicEntitySOVOnline,
          print: GRAPH_DATATYPE.ThematicEntitySOVPrint,
          printandonline: GRAPH_DATATYPE.ThematicEntitySOVPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.ThematicEntitySOVCCM,
        value: REPORT_TYPES.ThematicEntitySOVCCM,
        reportCategory: REPORT_CATEGORIES.THEMATIC_ANALYSIS,
        label: "Thematic - SOV - Entity (CCM)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.ThematicEntitySOVOnline,
          print: GRAPH_DATATYPE.ThematicEntitySOVPrint,
          printandonline: GRAPH_DATATYPE.ThematicEntitySOVPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.ThematicEntitySOVMAV,
        value: REPORT_TYPES.ThematicEntitySOVMAV,
        reportCategory: REPORT_CATEGORIES.THEMATIC_ANALYSIS,
        label: "Thematic - SOV - Entity (MAV)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.ThematicEntitySOVOnline,
          print: GRAPH_DATATYPE.ThematicEntitySOVPrint,
          printandonline: GRAPH_DATATYPE.ThematicEntitySOVPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.ThematicEntitySOVReach,
        value: REPORT_TYPES.ThematicEntitySOVReach,
        reportCategory: REPORT_CATEGORIES.THEMATIC_ANALYSIS,
        label: "Thematic - SOV - Entity (Reach)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.ThematicEntitySOVOnline,
          print: GRAPH_DATATYPE.ThematicEntitySOVPrint,
          printandonline: GRAPH_DATATYPE.ThematicEntitySOVPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.ThematicEntitySOVWordCount,
        value: REPORT_TYPES.ThematicEntitySOVWordCount,
        reportCategory: REPORT_CATEGORIES.THEMATIC_ANALYSIS,
        label: "Thematic - SOV - Entity (Word Count)",
        enablePrint: false,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.ThematicEntitySOVOnline,
          printandonline: GRAPH_DATATYPE.ThematicEntitySOVPrintOnline,
        },
        verticalList: [V_ONLINE],
        groupByField: "entity_name",
        excludeGraphType: [

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      //Thematic - Entity - Trend
      {
        id: REPORT_TYPES.ThematicEntityTrendIndex,
        value: REPORT_TYPES.ThematicEntityTrendIndex,
        reportCategory: REPORT_CATEGORIES.THEMATIC_ANALYSIS,
        label: "Thematic - Trend - Entity (Index)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.ThematicEntityTrendOnline,
          print: GRAPH_DATATYPE.ThematicEntityTrendPrint,
          printandonline: GRAPH_DATATYPE.ThematicEntityTrendPrintOnlie,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [

          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.ThematicEntityTrendNOA,
        value: REPORT_TYPES.ThematicEntityTrendNOA,
        reportCategory: REPORT_CATEGORIES.THEMATIC_ANALYSIS,
        label: "Thematic - Trend - Entity (No. Of Article)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.ThematicEntityTrendOnline,
          print: GRAPH_DATATYPE.ThematicEntityTrendPrint,
          printandonline: GRAPH_DATATYPE.ThematicEntityTrendPrintOnlie,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [

          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.ThematicEntityTrendCCM,
        value: REPORT_TYPES.ThematicEntityTrendCCM,
        reportCategory: REPORT_CATEGORIES.THEMATIC_ANALYSIS,
        label: "Thematic - Trend - Entity (CCM)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.ThematicEntityTrendOnline,
          print: GRAPH_DATATYPE.ThematicEntityTrendPrint,
          printandonline: GRAPH_DATATYPE.ThematicEntityTrendPrintOnlie,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [

          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.ThematicEntityTrendMAV,
        value: REPORT_TYPES.ThematicEntityTrendMAV,
        reportCategory: REPORT_CATEGORIES.THEMATIC_ANALYSIS,
        label: "Thematic - Trend - Entity (MAV)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.ThematicEntityTrendOnline,
          print: GRAPH_DATATYPE.ThematicEntityTrendPrint,
          printandonline: GRAPH_DATATYPE.ThematicEntityTrendPrintOnlie,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [

          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.ThematicEntityTrendReach,
        value: REPORT_TYPES.ThematicEntityTrendReach,
        reportCategory: REPORT_CATEGORIES.THEMATIC_ANALYSIS,
        label: "Thematic - Trend - Entity (Reach)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.ThematicEntityTrendOnline,
          print: GRAPH_DATATYPE.ThematicEntityTrendPrint,
          printandonline: GRAPH_DATATYPE.ThematicEntityTrendPrintOnlie,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [

          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.ThematicEntityTrendWordCount,
        value: REPORT_TYPES.ThematicEntityTrendWordCount,
        reportCategory: REPORT_CATEGORIES.THEMATIC_ANALYSIS,
        label: "Thematic - Trend - Entity (Word Count)",
        enablePrint: false,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.ThematicEntityTrendOnline,
          printandonline: GRAPH_DATATYPE.ThematicEntityTrendPrintOnlie,
        },
        verticalList: [V_ONLINE],
        groupByField: "entity_name",
        excludeGraphType: [

          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      //Thematic - Entity - Tonality
      {
        id: REPORT_TYPES.ThematicEntityTonalityIndex,
        value: REPORT_TYPES.ThematicEntityTonalityIndex,
        reportCategory: REPORT_CATEGORIES.THEMATIC_ANALYSIS,
        label: "Thematic - Tonality - Entity (Index)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.ThematicEntityTonalityOnline,
          print: GRAPH_DATATYPE.ThematicEntityTonalityPrint,
          printandonline: GRAPH_DATATYPE.ThematicEntityTonalityPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.ThematicEntityTonalityNOA,
        value: REPORT_TYPES.ThematicEntityTonalityNOA,
        reportCategory: REPORT_CATEGORIES.THEMATIC_ANALYSIS,
        label: "Thematic - Tonality - Entity (No. Of Article)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.ThematicEntityTonalityOnline,
          print: GRAPH_DATATYPE.ThematicEntityTonalityPrint,
          printandonline: GRAPH_DATATYPE.ThematicEntityTonalityPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.ThematicEntityTonalityCCM,
        value: REPORT_TYPES.ThematicEntityTonalityCCM,
        reportCategory: REPORT_CATEGORIES.THEMATIC_ANALYSIS,
        label: "Thematic - Tonality - Entity (CCM)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.ThematicEntityTonalityOnline,
          print: GRAPH_DATATYPE.ThematicEntityTonalityPrint,
          printandonline: GRAPH_DATATYPE.ThematicEntityTonalityPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.ThematicEntityTonalityMAV,
        value: REPORT_TYPES.ThematicEntityTonalityMAV,
        reportCategory: REPORT_CATEGORIES.THEMATIC_ANALYSIS,
        label: "Thematic - Tonality - Entity (MAV)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.ThematicEntityTonalityOnline,
          print: GRAPH_DATATYPE.ThematicEntityTonalityPrint,
          printandonline: GRAPH_DATATYPE.ThematicEntityTonalityPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.ThematicEntityTonalityReach,
        value: REPORT_TYPES.ThematicEntityTonalityReach,
        reportCategory: REPORT_CATEGORIES.THEMATIC_ANALYSIS,
        label: "Thematic - Tonality - Entity (Reach)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.ThematicEntityTonalityOnline,
          print: GRAPH_DATATYPE.ThematicEntityTonalityPrint,
          printandonline: GRAPH_DATATYPE.ThematicEntityTonalityPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.ThematicEntityTonalityWordCount,
        value: REPORT_TYPES.ThematicEntityTonalityWordCount,
        reportCategory: REPORT_CATEGORIES.THEMATIC_ANALYSIS,
        label: "Thematic - Tonality - Entity (Word Count)",
        enablePrint: false,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.ThematicEntityTonalityOnline,
          printandonline: GRAPH_DATATYPE.ThematicEntityTonalityPrintOnline,
        },
        verticalList: [V_ONLINE],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      //Thematic - Journalist - SOV
      {
        id: REPORT_TYPES.ThematicJournalistSOVIndex,
        value: REPORT_TYPES.ThematicJournalistSOVIndex,
        reportCategory: REPORT_CATEGORIES.THEMATIC_ANALYSIS,
        label: "Thematic - SOV - Journalist (Index)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.ThematicJournalistSOVOnline,
          print: GRAPH_DATATYPE.ThematicJournalistSOVPrint,
          printandonline: GRAPH_DATATYPE.ThematicJournalistSOVPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.ThematicJournalistSOVNOA,
        value: REPORT_TYPES.ThematicJournalistSOVNOA,
        reportCategory: REPORT_CATEGORIES.THEMATIC_ANALYSIS,
        label: "Thematic - SOV - Journalist (No. Of Article)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.ThematicJournalistSOVOnline,
          print: GRAPH_DATATYPE.ThematicJournalistSOVPrint,
          printandonline: GRAPH_DATATYPE.ThematicJournalistSOVPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.ThematicJournalistSOVCCM,
        value: REPORT_TYPES.ThematicJournalistSOVCCM,
        reportCategory: REPORT_CATEGORIES.THEMATIC_ANALYSIS,
        label: "Thematic - SOV - Journalist (CCM)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.ThematicJournalistSOVOnline,
          print: GRAPH_DATATYPE.ThematicJournalistSOVPrint,
          printandonline: GRAPH_DATATYPE.ThematicJournalistSOVPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.ThematicJournalistSOVMAV,
        value: REPORT_TYPES.ThematicJournalistSOVMAV,
        reportCategory: REPORT_CATEGORIES.THEMATIC_ANALYSIS,
        label: "Thematic - SOV - Journalist (MAV)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.ThematicJournalistSOVOnline,
          print: GRAPH_DATATYPE.ThematicJournalistSOVPrint,
          printandonline: GRAPH_DATATYPE.ThematicJournalistSOVPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.ThematicJournalistSOVReach,
        value: REPORT_TYPES.ThematicJournalistSOVReach,
        reportCategory: REPORT_CATEGORIES.THEMATIC_ANALYSIS,
        label: "Thematic - SOV - Journalist (Reach)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.ThematicJournalistSOVOnline,
          print: GRAPH_DATATYPE.ThematicJournalistSOVPrint,
          printandonline: GRAPH_DATATYPE.ThematicJournalistSOVPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.ThematicJournalistSOVWordCount,
        value: REPORT_TYPES.ThematicJournalistSOVWordCount,
        reportCategory: REPORT_CATEGORIES.THEMATIC_ANALYSIS,
        label: "Thematic - SOV - Journalist (Word Count)",
        enablePrint: false,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.ThematicJournalistSOVOnline,
          printandonline: GRAPH_DATATYPE.ThematicJournalistSOVPrintOnline,
        },
        verticalList: [V_ONLINE],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      //Thematic - Journalist - Trend
      {
        id: REPORT_TYPES.ThematicJournalistTrendIndex,
        value: REPORT_TYPES.ThematicJournalistTrendIndex,
        reportCategory: REPORT_CATEGORIES.THEMATIC_ANALYSIS,
        label: "Thematic - Trend - Journalist (Index)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.ThematicJournalistTrendOnline,
          print: GRAPH_DATATYPE.ThematicJournalistTrendPrint,
          printandonline: GRAPH_DATATYPE.ThematicJournalistTrendPrintOnlline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [

          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.ThematicJournalistTrendNOA,
        value: REPORT_TYPES.ThematicJournalistTrendNOA,
        reportCategory: REPORT_CATEGORIES.THEMATIC_ANALYSIS,
        label: "Thematic - Trend - Journalist (No. Of Article)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.ThematicJournalistTrendOnline,
          print: GRAPH_DATATYPE.ThematicJournalistTrendPrint,
          printandonline: GRAPH_DATATYPE.ThematicJournalistTrendPrintOnlline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [

          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.ThematicJournalistTrendCCM,
        value: REPORT_TYPES.ThematicJournalistTrendCCM,
        reportCategory: REPORT_CATEGORIES.THEMATIC_ANALYSIS,
        label: "Thematic - Trend - Journalist (CCM)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.ThematicJournalistTrendOnline,
          print: GRAPH_DATATYPE.ThematicJournalistTrendPrint,
          printandonline: GRAPH_DATATYPE.ThematicJournalistTrendPrintOnlline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [

          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.ThematicJournalistTrendMAV,
        value: REPORT_TYPES.ThematicJournalistTrendMAV,
        reportCategory: REPORT_CATEGORIES.THEMATIC_ANALYSIS,
        label: "Thematic - Trend - Journalist (MAV)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.ThematicJournalistTrendOnline,
          print: GRAPH_DATATYPE.ThematicJournalistTrendPrint,
          printandonline: GRAPH_DATATYPE.ThematicJournalistTrendPrintOnlline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [

          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.ThematicJournalistTrendReach,
        value: REPORT_TYPES.ThematicJournalistTrendReach,
        reportCategory: REPORT_CATEGORIES.THEMATIC_ANALYSIS,
        label: "Thematic - Trend - Journalist (Reach)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.ThematicJournalistTrendOnline,
          print: GRAPH_DATATYPE.ThematicJournalistTrendPrint,
          printandonline: GRAPH_DATATYPE.ThematicJournalistTrendPrintOnlline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [

          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.ThematicJournalistTrendWordCount,
        value: REPORT_TYPES.ThematicJournalistTrendWordCount,
        reportCategory: REPORT_CATEGORIES.THEMATIC_ANALYSIS,
        label: "Thematic - Trend - Journalist (Word Count)",
        enablePrint: false,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.ThematicJournalistTrendOnline,
          printandonline: GRAPH_DATATYPE.ThematicJournalistTrendPrintOnlline,
        },
        verticalList: [V_ONLINE],
        groupByField: "entity_name",
        excludeGraphType: [

          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      //Thematic - Journalist- Tonality
      {
        id: REPORT_TYPES.ThematicJournalistTonalityIndex,
        value: REPORT_TYPES.ThematicJournalistTonalityIndex,
        reportCategory: REPORT_CATEGORIES.THEMATIC_ANALYSIS,
        label: "Thematic - Tonality - Journalist (Index)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.ThematicJournalistTonalityOnline,
          print: GRAPH_DATATYPE.ThematicJournalistTonalityPrint,
          printandonline: GRAPH_DATATYPE.ThematicJournalistTonalityPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.ThematicJournalistTonalityNOA,
        value: REPORT_TYPES.ThematicJournalistTonalityNOA,
        reportCategory: REPORT_CATEGORIES.THEMATIC_ANALYSIS,
        label: "Thematic - Tonality - Journalist (No. Of Article)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.ThematicJournalistTonalityOnline,
          print: GRAPH_DATATYPE.ThematicJournalistTonalityPrint,
          printandonline: GRAPH_DATATYPE.ThematicJournalistTonalityPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.ThematicJournalistTonalityCCM,
        value: REPORT_TYPES.ThematicJournalistTonalityCCM,
        reportCategory: REPORT_CATEGORIES.THEMATIC_ANALYSIS,
        label: "Thematic - Tonality - Journalist (CCM)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.ThematicJournalistTonalityOnline,
          print: GRAPH_DATATYPE.ThematicJournalistTonalityPrint,
          printandonline: GRAPH_DATATYPE.ThematicJournalistTonalityPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.ThematicJournalistTonalityMAV,
        value: REPORT_TYPES.ThematicJournalistTonalityMAV,
        reportCategory: REPORT_CATEGORIES.THEMATIC_ANALYSIS,
        label: "Thematic - Tonality - Journalist (MAV)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.ThematicJournalistTonalityOnline,
          print: GRAPH_DATATYPE.ThematicJournalistTonalityPrint,
          printandonline: GRAPH_DATATYPE.ThematicJournalistTonalityPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.ThematicJournalistTonalityReach,
        value: REPORT_TYPES.ThematicJournalistTonalityReach,
        reportCategory: REPORT_CATEGORIES.THEMATIC_ANALYSIS,
        label: "Thematic - Tonality - Journalist (Reach)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.ThematicJournalistTonalityOnline,
          print: GRAPH_DATATYPE.ThematicJournalistTonalityPrint,
          printandonline: GRAPH_DATATYPE.ThematicJournalistTonalityPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.ThematicJournalistTonalityWordCount,
        value: REPORT_TYPES.ThematicJournalistTonalityWordCount,
        reportCategory: REPORT_CATEGORIES.THEMATIC_ANALYSIS,
        label: "Thematic - Tonality - Journalist (Word Count)",
        enablePrint: false,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.ThematicJournalistTonalityOnline,
          printandonline: GRAPH_DATATYPE.ThematicJournalistTonalityPrintOnline,
        },
        verticalList: [V_ONLINE],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      //Thematic - Keyword - SOV
      {
        id: REPORT_TYPES.ThematicKeywordSOVIndex,
        value: REPORT_TYPES.ThematicKeywordSOVIndex,
        reportCategory: REPORT_CATEGORIES.THEMATIC_ANALYSIS,
        label: "Thematic - SOV - Keyword (Index)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.ThematicKeywordSOVOnline,
          print: GRAPH_DATATYPE.ThematicKeywordSOVPrint,
          printandonline: GRAPH_DATATYPE.ThematicKeywordSOVPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.ThematicKeywordSOVNOA,
        value: REPORT_TYPES.ThematicKeywordSOVNOA,
        reportCategory: REPORT_CATEGORIES.THEMATIC_ANALYSIS,
        label: "Thematic - SOV - Keyword (No. Of Article)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.ThematicKeywordSOVOnline,
          print: GRAPH_DATATYPE.ThematicKeywordSOVPrint,
          printandonline: GRAPH_DATATYPE.ThematicKeywordSOVPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.ThematicKeywordSOVCCM,
        value: REPORT_TYPES.ThematicKeywordSOVCCM,
        reportCategory: REPORT_CATEGORIES.THEMATIC_ANALYSIS,
        label: "Thematic - SOV - Keyword (CCM)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.ThematicKeywordSOVOnline,
          print: GRAPH_DATATYPE.ThematicKeywordSOVPrint,
          printandonline: GRAPH_DATATYPE.ThematicKeywordSOVPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.ThematicKeywordSOVMAV,
        value: REPORT_TYPES.ThematicKeywordSOVMAV,
        reportCategory: REPORT_CATEGORIES.THEMATIC_ANALYSIS,
        label: "Thematic - SOV - Keyword (MAV)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.ThematicKeywordSOVOnline,
          print: GRAPH_DATATYPE.ThematicKeywordSOVPrint,
          printandonline: GRAPH_DATATYPE.ThematicKeywordSOVPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.ThematicKeywordSOVReach,
        value: REPORT_TYPES.ThematicKeywordSOVReach,
        reportCategory: REPORT_CATEGORIES.THEMATIC_ANALYSIS,
        label: "Thematic - SOV - Keyword (Reach)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.ThematicKeywordSOVOnline,
          print: GRAPH_DATATYPE.ThematicKeywordSOVPrint,
          printandonline: GRAPH_DATATYPE.ThematicKeywordSOVPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.ThematicKeywordSOVWordCount,
        value: REPORT_TYPES.ThematicKeywordSOVWordCount,
        reportCategory: REPORT_CATEGORIES.THEMATIC_ANALYSIS,
        label: "Thematic - SOV - Keyword (Word Count)",
        enablePrint: false,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.ThematicKeywordSOVOnline,
          printandonline: GRAPH_DATATYPE.ThematicKeywordSOVPrintOnline,
        },
        verticalList: [V_ONLINE],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      //Thematic - Keyword - Trend
      {
        id: REPORT_TYPES.ThematicKeywordTrendIndex,
        value: REPORT_TYPES.ThematicKeywordTrendIndex,
        reportCategory: REPORT_CATEGORIES.THEMATIC_ANALYSIS,
        label: "Thematic - Trend - Keyword (Index)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.ThematicKeywordTrendOnline,
          print: GRAPH_DATATYPE.ThematicKeywordTrendPrint,
          printandonline: GRAPH_DATATYPE.ThematicKeywordTrendPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [

          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.ThematicKeywordTrendNOA,
        value: REPORT_TYPES.ThematicKeywordTrendNOA,
        reportCategory: REPORT_CATEGORIES.THEMATIC_ANALYSIS,
        label: "Thematic - Trend - Keyword (No. Of Article)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.ThematicKeywordTrendOnline,
          print: GRAPH_DATATYPE.ThematicKeywordTrendPrint,
          printandonline: GRAPH_DATATYPE.ThematicKeywordTrendPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [

          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.ThematicKeywordTrendCCM,
        value: REPORT_TYPES.ThematicKeywordTrendCCM,
        reportCategory: REPORT_CATEGORIES.THEMATIC_ANALYSIS,
        label: "Thematic - Trend - Keyword (CCM)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.ThematicKeywordTrendOnline,
          print: GRAPH_DATATYPE.ThematicKeywordTrendPrint,
          printandonline: GRAPH_DATATYPE.ThematicKeywordTrendPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [

          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.ThematicKeywordTrendMAV,
        value: REPORT_TYPES.ThematicKeywordTrendMAV,
        reportCategory: REPORT_CATEGORIES.THEMATIC_ANALYSIS,
        label: "Thematic - Trend - Keyword (MAV)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.ThematicKeywordTrendOnline,
          print: GRAPH_DATATYPE.ThematicKeywordTrendPrint,
          printandonline: GRAPH_DATATYPE.ThematicKeywordTrendPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [

          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.ThematicKeywordTrendReach,
        value: REPORT_TYPES.ThematicKeywordTrendReach,
        reportCategory: REPORT_CATEGORIES.THEMATIC_ANALYSIS,
        label: "Thematic - Trend - Keyword (Reach)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.ThematicKeywordTrendOnline,
          print: GRAPH_DATATYPE.ThematicKeywordTrendPrint,
          printandonline: GRAPH_DATATYPE.ThematicKeywordTrendPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [

          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.ThematicKeywordTrendWordCount,
        value: REPORT_TYPES.ThematicKeywordTrendWordCount,
        reportCategory: REPORT_CATEGORIES.THEMATIC_ANALYSIS,
        label: "Thematic - Trend - Keyword (Word Count)",
        enablePrint: false,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.ThematicKeywordTrendOnline,
          printandonline: GRAPH_DATATYPE.ThematicKeywordTrendPrintOnline,
        },
        verticalList: [V_ONLINE],
        groupByField: "entity_name",
        excludeGraphType: [

          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      //Thematic - Keyword- Tonality
      {
        id: REPORT_TYPES.ThematicKeywordTonalityIndex,
        value: REPORT_TYPES.ThematicKeywordTonalityIndex,
        reportCategory: REPORT_CATEGORIES.THEMATIC_ANALYSIS,
        label: "Thematic - Tonality - Keyword (Index)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.ThematicKeywordTonalityOnline,
          print: GRAPH_DATATYPE.ThematicKeywordTonalityPrint,
          printandonline: GRAPH_DATATYPE.ThematicKeywordTonalityPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.ThematicKeywordTonalityNOA,
        value: REPORT_TYPES.ThematicKeywordTonalityNOA,
        reportCategory: REPORT_CATEGORIES.THEMATIC_ANALYSIS,
        label: "Thematic - Tonality - Keyword (No. Of Article)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.ThematicKeywordTonalityOnline,
          print: GRAPH_DATATYPE.ThematicKeywordTonalityPrint,
          printandonline: GRAPH_DATATYPE.ThematicKeywordTonalityPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.ThematicKeywordTonalityCCM,
        value: REPORT_TYPES.ThematicKeywordTonalityCCM,
        reportCategory: REPORT_CATEGORIES.THEMATIC_ANALYSIS,
        label: "Thematic - Tonality - Keyword (CCM)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.ThematicKeywordTonalityOnline,
          print: GRAPH_DATATYPE.ThematicKeywordTonalityPrint,
          printandonline: GRAPH_DATATYPE.ThematicKeywordTonalityPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.ThematicKeywordTonalityMAV,
        value: REPORT_TYPES.ThematicKeywordTonalityMAV,
        reportCategory: REPORT_CATEGORIES.THEMATIC_ANALYSIS,
        label: "Thematic - Tonality - Keyword (MAV)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.ThematicKeywordTonalityOnline,
          print: GRAPH_DATATYPE.ThematicKeywordTonalityPrint,
          printandonline: GRAPH_DATATYPE.ThematicKeywordTonalityPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.ThematicKeywordTonalityReach,
        value: REPORT_TYPES.ThematicKeywordTonalityReach,
        reportCategory: REPORT_CATEGORIES.THEMATIC_ANALYSIS,
        label: "Thematic - Tonality - Keyword (Reach)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.ThematicKeywordTonalityOnline,
          print: GRAPH_DATATYPE.ThematicKeywordTonalityPrint,
          printandonline: GRAPH_DATATYPE.ThematicKeywordTonalityPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.ThematicKeywordTonalityWordCount,
        value: REPORT_TYPES.ThematicKeywordTonalityWordCount,
        reportCategory: REPORT_CATEGORIES.THEMATIC_ANALYSIS,
        label: "Thematic - Tonality - Keyword (Word Count)",
        enablePrint: false,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.ThematicKeywordTonalityOnline,
          printandonline: GRAPH_DATATYPE.ThematicKeywordTonalityPrintOnline,
        },
        verticalList: [V_ONLINE],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      //Thematic - City - SOV
      //Todo: Remove Word  Count Reports for CITY LEVEL
      {
        id: REPORT_TYPES.ThematicCitySOVIndex,
        value: REPORT_TYPES.ThematicCitySOVIndex,
        reportCategory: REPORT_CATEGORIES.THEMATIC_ANALYSIS,
        label: "Thematic - SOV - City (Index)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          print: GRAPH_DATATYPE.ThematicCitySOVPrint,
        },
        verticalList: [V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.ThematicCitySOVNOA,
        value: REPORT_TYPES.ThematicCitySOVNOA,
        reportCategory: REPORT_CATEGORIES.THEMATIC_ANALYSIS,
        label: "Thematic - SOV - City (No. Of Article)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          print: GRAPH_DATATYPE.ThematicCitySOVPrint,
        },
        verticalList: [V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.ThematicCitySOVCCM,
        value: REPORT_TYPES.ThematicCitySOVCCM,
        reportCategory: REPORT_CATEGORIES.THEMATIC_ANALYSIS,
        label: "Thematic - SOV - City (CCM)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          print: GRAPH_DATATYPE.ThematicCitySOVPrint,
        },
        verticalList: [V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.ThematicCitySOVMAV,
        value: REPORT_TYPES.ThematicCitySOVMAV,
        reportCategory: REPORT_CATEGORIES.THEMATIC_ANALYSIS,
        label: "Thematic - SOV - City (MAV)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          print: GRAPH_DATATYPE.ThematicCitySOVPrint,
        },
        verticalList: [V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.ThematicCitySOVReach,
        value: REPORT_TYPES.ThematicCitySOVReach,
        reportCategory: REPORT_CATEGORIES.THEMATIC_ANALYSIS,
        label: "Thematic - SOV - City (Reach)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          print: GRAPH_DATATYPE.ThematicCitySOVPrint,
        },
        verticalList: [V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.ThematicCitySOVWordCount,
        value: REPORT_TYPES.ThematicCitySOVWordCount,
        reportCategory: REPORT_CATEGORIES.THEMATIC_ANALYSIS,
        label: "Thematic - SOV - City (Word Count)",
        enablePrint: false,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.ThematicCitySOVOnline,
        },
        verticalList: [V_ONLINE],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      //Thematic - City - Trend
      {
        id: REPORT_TYPES.ThematicCityTrendIndex,
        value: REPORT_TYPES.ThematicCityTrendIndex,
        reportCategory: REPORT_CATEGORIES.THEMATIC_ANALYSIS,
        label: "Thematic - Trend - City (Index)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          print: GRAPH_DATATYPE.ThematicCityTrendPrint,
        },
        verticalList: [V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [

          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.ThematicCityTrendNOA,
        value: REPORT_TYPES.ThematicCityTrendNOA,
        reportCategory: REPORT_CATEGORIES.THEMATIC_ANALYSIS,
        label: "Thematic - Trend - City (No. Of Article)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          print: GRAPH_DATATYPE.ThematicCityTrendPrint,
        },
        verticalList: [V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [

          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.ThematicCityTrendCCM,
        value: REPORT_TYPES.ThematicCityTrendCCM,
        reportCategory: REPORT_CATEGORIES.THEMATIC_ANALYSIS,
        label: "Thematic - Trend - City (CCM)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          print: GRAPH_DATATYPE.ThematicCityTrendPrint,
        },
        verticalList: [V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [

          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.ThematicCityTrendMAV,
        value: REPORT_TYPES.ThematicCityTrendMAV,
        reportCategory: REPORT_CATEGORIES.THEMATIC_ANALYSIS,
        label: "Thematic - Trend - City (MAV)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          print: GRAPH_DATATYPE.ThematicCityTrendPrint,
        },
        verticalList: [V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [

          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.ThematicCityTrendReach,
        value: REPORT_TYPES.ThematicCityTrendReach,
        reportCategory: REPORT_CATEGORIES.THEMATIC_ANALYSIS,
        label: "Thematic - Trend - City (Reach)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          print: GRAPH_DATATYPE.ThematicCityTrendPrint,
        },
        verticalList: [V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [

          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.ThematicCityTrendWordCount,
        value: REPORT_TYPES.ThematicCityTrendWordCount,
        reportCategory: REPORT_CATEGORIES.THEMATIC_ANALYSIS,
        label: "Thematic - Trend - City (Word Count)",
        enablePrint: false,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.ThematicCityTrendOnline,
        },
        verticalList: [V_ONLINE],
        groupByField: "entity_name",
        excludeGraphType: [

          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      //Thematic - City- Tonality
      {
        id: REPORT_TYPES.ThematicCityTonalityIndex,
        value: REPORT_TYPES.ThematicCityTonalityIndex,
        reportCategory: REPORT_CATEGORIES.THEMATIC_ANALYSIS,
        label: "Thematic - Tonality - City (Index)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          print: GRAPH_DATATYPE.ThematicCityTonalityPrint,
        },
        verticalList: [V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.ThematicCityTonalityNOA,
        value: REPORT_TYPES.ThematicCityTonalityNOA,
        reportCategory: REPORT_CATEGORIES.THEMATIC_ANALYSIS,
        label: "Thematic - Tonality - City (No. Of Article)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          print: GRAPH_DATATYPE.ThematicCityTonalityPrint,
        },
        verticalList: [V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.ThematicCityTonalityCCM,
        value: REPORT_TYPES.ThematicCityTonalityCCM,
        reportCategory: REPORT_CATEGORIES.THEMATIC_ANALYSIS,
        label: "Thematic - Tonality - City (CCM)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          print: GRAPH_DATATYPE.ThematicCityTonalityPrint,
        },
        verticalList: [V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.ThematicCityTonalityMAV,
        value: REPORT_TYPES.ThematicCityTonalityMAV,
        reportCategory: REPORT_CATEGORIES.THEMATIC_ANALYSIS,
        label: "Thematic - Tonality - City (MAV)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          print: GRAPH_DATATYPE.ThematicCityTonalityPrint,
        },
        verticalList: [V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.ThematicCityTonalityReach,
        value: REPORT_TYPES.ThematicCityTonalityReach,
        reportCategory: REPORT_CATEGORIES.THEMATIC_ANALYSIS,
        label: "Thematic - Tonality - City (Reach)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          print: GRAPH_DATATYPE.ThematicCityTonalityPrint,
        },
        verticalList: [V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.ThematicCityTonalityWordCount,
        value: REPORT_TYPES.ThematicCityTonalityWordCount,
        reportCategory: REPORT_CATEGORIES.THEMATIC_ANALYSIS,
        label: "Thematic - Tonality - City (Word Count)",
        enablePrint: false,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.ThematicCityTonalityOnline,
        },
        verticalList: [V_ONLINE],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      //Thematic - Publication - SOV
      {
        id: REPORT_TYPES.ThematicPublicationSOVIndex,
        value: REPORT_TYPES.ThematicPublicationSOVIndex,
        reportCategory: REPORT_CATEGORIES.THEMATIC_ANALYSIS,
        label: "Thematic - SOV - Publication (Index)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.ThematicPublicationSOVOnline,
          print: GRAPH_DATATYPE.ThematicPublicationSOVPrint,
        },
        verticalList: [V_ONLINE, V_PRINT_AND_ONLINE],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.ThematicPublicationSOVNOA,
        value: REPORT_TYPES.ThematicPublicationSOVNOA,
        reportCategory: REPORT_CATEGORIES.THEMATIC_ANALYSIS,
        label: "Thematic - SOV - Publication (No. Of Article)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.ThematicPublicationSOVOnline,
          print: GRAPH_DATATYPE.ThematicPublicationSOVPrint,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.ThematicPublicationSOVCCM,
        value: REPORT_TYPES.ThematicPublicationSOVCCM,
        reportCategory: REPORT_CATEGORIES.THEMATIC_ANALYSIS,
        label: "Thematic - SOV - Publication (CCM)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.ThematicPublicationSOVOnline,
          print: GRAPH_DATATYPE.ThematicPublicationSOVPrint,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.ThematicPublicationSOVMAV,
        value: REPORT_TYPES.ThematicPublicationSOVMAV,
        reportCategory: REPORT_CATEGORIES.THEMATIC_ANALYSIS,
        label: "Thematic - SOV - Publication (MAV)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.ThematicPublicationSOVOnline,
          print: GRAPH_DATATYPE.ThematicPublicationSOVPrint,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.ThematicPublicationSOVReach,
        value: REPORT_TYPES.ThematicPublicationSOVReach,
        reportCategory: REPORT_CATEGORIES.THEMATIC_ANALYSIS,
        label: "Thematic - SOV - Publication (Reach)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.ThematicPublicationSOVOnline,
          print: GRAPH_DATATYPE.ThematicPublicationSOVPrint,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.ThematicPublicationSOVWordCount,
        value: REPORT_TYPES.ThematicPublicationSOVWordCount,
        reportCategory: REPORT_CATEGORIES.THEMATIC_ANALYSIS,
        label: "Thematic - SOV - Publication (Word Count)",
        enablePrint: false,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.ThematicPublicationSOVOnline,
        },
        verticalList: [V_ONLINE],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      //Thematic - Publication - Trend
      {
        id: REPORT_TYPES.ThematicPublicationTrendIndex,
        value: REPORT_TYPES.ThematicPublicationTrendIndex,
        reportCategory: REPORT_CATEGORIES.THEMATIC_ANALYSIS,
        label: "Thematic - Trend - Publication (Index)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.ThematicPublicationTrendOnline,
          print: GRAPH_DATATYPE.ThematicPublicationTrendPrint,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [

          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.ThematicPublicationTrendNOA,
        value: REPORT_TYPES.ThematicPublicationTrendNOA,
        reportCategory: REPORT_CATEGORIES.THEMATIC_ANALYSIS,
        label: "Thematic - Trend - Publication (No. Of Article)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.ThematicPublicationTrendOnline,
          print: GRAPH_DATATYPE.ThematicPublicationTrendPrint,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [

          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.ThematicPublicationTrendCCM,
        value: REPORT_TYPES.ThematicPublicationTrendCCM,
        reportCategory: REPORT_CATEGORIES.THEMATIC_ANALYSIS,
        label: "Thematic - Trend - Publication (CCM)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.ThematicPublicationTrendOnline,
          print: GRAPH_DATATYPE.ThematicPublicationTrendPrint,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [

          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.ThematicPublicationTrendMAV,
        value: REPORT_TYPES.ThematicPublicationTrendMAV,
        reportCategory: REPORT_CATEGORIES.THEMATIC_ANALYSIS,
        label: "Thematic - Trend - Publication (MAV)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.ThematicPublicationTrendOnline,
          print: GRAPH_DATATYPE.ThematicPublicationTrendPrint,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [

          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.ThematicPublicationTrendReach,
        value: REPORT_TYPES.ThematicPublicationTrendReach,
        reportCategory: REPORT_CATEGORIES.THEMATIC_ANALYSIS,
        label: "Thematic - Trend - Publication (Reach)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.ThematicPublicationTrendOnline,
          print: GRAPH_DATATYPE.ThematicPublicationTrendPrint,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [

          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.ThematicPublicationTrendWordCount,
        value: REPORT_TYPES.ThematicPublicationTrendWordCount,
        reportCategory: REPORT_CATEGORIES.THEMATIC_ANALYSIS,
        label: "Thematic - Trend - Publication (Word Count)",
        enablePrint: false,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.ThematicPublicationTrendOnline,
        },
        verticalList: [V_ONLINE],
        groupByField: "entity_name",
        excludeGraphType: [

          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      //Thematic - Publication- Tonality
      {
        id: REPORT_TYPES.ThematicPublicationTonalityIndex,
        value: REPORT_TYPES.ThematicPublicationTonalityIndex,
        reportCategory: REPORT_CATEGORIES.THEMATIC_ANALYSIS,
        label: "Thematic - Tonality - Publication (Index)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.ThematicPublicationTonalityOnline,
          print: GRAPH_DATATYPE.ThematicPublicationTonalityPrint,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.ThematicPublicationTonalityNOA,
        value: REPORT_TYPES.ThematicPublicationTonalityNOA,
        reportCategory: REPORT_CATEGORIES.THEMATIC_ANALYSIS,
        label: "Thematic - Tonality - Publication (No. Of Article)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.ThematicPublicationTonalityOnline,
          print: GRAPH_DATATYPE.ThematicPublicationTonalityPrint,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.ThematicPublicationTonalityCCM,
        value: REPORT_TYPES.ThematicPublicationTonalityCCM,
        reportCategory: REPORT_CATEGORIES.THEMATIC_ANALYSIS,
        label: "Thematic - Tonality - Publication (CCM)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.ThematicPublicationTonalityOnline,
          print: GRAPH_DATATYPE.ThematicPublicationTonalityPrint,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.ThematicPublicationTonalityMAV,
        value: REPORT_TYPES.ThematicPublicationTonalityMAV,
        reportCategory: REPORT_CATEGORIES.THEMATIC_ANALYSIS,
        label: "Thematic - Tonality - Publication (MAV)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.ThematicPublicationTonalityOnline,
          print: GRAPH_DATATYPE.ThematicPublicationTonalityPrint,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.ThematicPublicationTonalityReach,
        value: REPORT_TYPES.ThematicPublicationTonalityReach,
        reportCategory: REPORT_CATEGORIES.THEMATIC_ANALYSIS,
        label: "Thematic - Tonality - Publication (Reach)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.ThematicPublicationTonalityOnline,
          print: GRAPH_DATATYPE.ThematicPublicationTonalityPrint,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.ThematicPublicationTonalityWordCount,
        value: REPORT_TYPES.ThematicPublicationTonalityWordCount,
        reportCategory: REPORT_CATEGORIES.THEMATIC_ANALYSIS,
        label: "Thematic - Tonality - Publication (Word Count)",
        enablePrint: false,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.ThematicPublicationTonalityOnline,
        },
        verticalList: [V_ONLINE],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },

      //block Thematic -New Entity - SOV 
      {
        id: REPORT_TYPES.ThematicNewEntitySOVIndex,
        value: REPORT_TYPES.ThematicNewEntitySOVIndex,
        reportCategory: REPORT_CATEGORIES.THEMATIC_ANALYSIS,
        label: "Theme as-per Entity (Index)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.ThematicNewEntitySOVOnline,
          print: GRAPH_DATATYPE.ThematicNewEntitySOVPrint,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.ThematicNewEntitySOVNOA,
        value: REPORT_TYPES.ThematicNewEntitySOVNOA,
        reportCategory: REPORT_CATEGORIES.THEMATIC_ANALYSIS,
        label: "Theme as-per Entity (No. Of Article)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.ThematicNewEntitySOVOnline,
          print: GRAPH_DATATYPE.ThematicNewEntitySOVPrint,
          printandonline: GRAPH_DATATYPE.ThematicNewEntitySOVPrint,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.ThematicNewEntitySOVCCM,
        value: REPORT_TYPES.ThematicNewEntitySOVCCM,
        reportCategory: REPORT_CATEGORIES.THEMATIC_ANALYSIS,
        label: "Theme as-per Entity (CCM)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.ThematicNewEntitySOVOnline,
          print: GRAPH_DATATYPE.ThematicNewEntitySOVPrint,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.ThematicNewEntitySOVMAV,
        value: REPORT_TYPES.ThematicNewEntitySOVMAV,
        reportCategory: REPORT_CATEGORIES.THEMATIC_ANALYSIS,
        label: "Theme as-per Entity (MAV)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.ThematicNewEntitySOVOnline,
          print: GRAPH_DATATYPE.ThematicNewEntitySOVPrint,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.ThematicNewEntitySOVReach,
        value: REPORT_TYPES.ThematicNewEntitySOVReach,
        reportCategory: REPORT_CATEGORIES.THEMATIC_ANALYSIS,
        label: "Theme as-per Entity (Reach)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.ThematicNewEntitySOVOnline,
          print: GRAPH_DATATYPE.ThematicNewEntitySOVPrint,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.ThematicNewEntitySOVWordCount,
        value: REPORT_TYPES.ThematicNewEntitySOVWordCount,
        reportCategory: REPORT_CATEGORIES.THEMATIC_ANALYSIS,
        label: "Theme as-per Entity (Word Count)",
        enablePrint: false,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.ThematicNewEntitySOVOnline,
        },
        verticalList: [V_ONLINE],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      // block THEMATIC ends
      //block Geolocation - All Editons Entity - SOV 
      {
        id: REPORT_TYPES.GeolocationNewEntitySOVIndex,
        value: REPORT_TYPES.GeolocationNewEntitySOVIndex,
        reportCategory: REPORT_CATEGORIES.GEOLOCATION,
        label: "Edition as-per Entity (Index)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.GeolocationNewEntitySOVOnline,
          print: GRAPH_DATATYPE.GeolocationNewEntitySOVPrint,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.GeolocationNewEntitySOVNOA,
        value: REPORT_TYPES.GeolocationNewEntitySOVNOA,
        reportCategory: REPORT_CATEGORIES.GEOLOCATION,
        label: "Edition as-per Entity (No. Of Article)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.GeolocationNewEntitySOVOnline,
          print: GRAPH_DATATYPE.GeolocationNewEntitySOVPrint,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.GeolocationNewEntitySOVCCM,
        value: REPORT_TYPES.GeolocationNewEntitySOVCCM,
        reportCategory: REPORT_CATEGORIES.GEOLOCATION,
        label: "Edition as-per Entity (CCM)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.GeolocationNewEntitySOVOnline,
          print: GRAPH_DATATYPE.GeolocationNewEntitySOVPrint,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.GeolocationNewEntitySOVMAV,
        value: REPORT_TYPES.GeolocationNewEntitySOVMAV,
        reportCategory: REPORT_CATEGORIES.GEOLOCATION,
        label: "Edition as-per Entity (MAV)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.GeolocationNewEntitySOVOnline,
          print: GRAPH_DATATYPE.GeolocationNewEntitySOVPrint,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.GeolocationNewEntitySOVReach,
        value: REPORT_TYPES.GeolocationNewEntitySOVReach,
        reportCategory: REPORT_CATEGORIES.GEOLOCATION,
        label: "Edition as-per Entity (Reach)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.GeolocationNewEntitySOVOnline,
          print: GRAPH_DATATYPE.GeolocationNewEntitySOVPrint,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.GeolocationNewEntitySOVWordCount,
        value: REPORT_TYPES.GeolocationNewEntitySOVWordCount,
        reportCategory: REPORT_CATEGORIES.GEOLOCATION,
        label: "Edition as-per Entity (Word Count)",
        enablePrint: false,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.GeolocationNewEntitySOVOnline,
        },
        verticalList: [V_ONLINE],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      // Geo Entity - starts
      {
        id: REPORT_TYPES.GeolocationEntitySOVIndex,
        value: REPORT_TYPES.GeolocationEntitySOVIndex,
        reportCategory: REPORT_CATEGORIES.GEOLOCATION,
        label: "Geolocation - SOV - Entity (Index)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.GeolocationEntitySOVOnline,
          print: GRAPH_DATATYPE.GeolocationEntitySOVPrint,
          printandonline: GRAPH_DATATYPE.GeolocationEntitySOVPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.GeolocationEntitySOVNOA,
        value: REPORT_TYPES.GeolocationEntitySOVNOA,
        reportCategory: REPORT_CATEGORIES.GEOLOCATION,
        label: "Geolocation - SOV - Entity (No. Of Article)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.GeolocationEntitySOVOnline,
          print: GRAPH_DATATYPE.GeolocationEntitySOVPrint,
          printandonline: GRAPH_DATATYPE.GeolocationEntitySOVPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.GeolocationEntitySOVCCM,
        value: REPORT_TYPES.GeolocationEntitySOVCCM,
        reportCategory: REPORT_CATEGORIES.GEOLOCATION,
        label: "Geolocation - SOV - Entity (CCM)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.GeolocationEntitySOVOnline,
          print: GRAPH_DATATYPE.GeolocationEntitySOVPrint,
          printandonline: GRAPH_DATATYPE.GeolocationEntitySOVPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.GeolocationEntitySOVMAV,
        value: REPORT_TYPES.GeolocationEntitySOVMAV,
        reportCategory: REPORT_CATEGORIES.GEOLOCATION,
        label: "Geolocation - SOV - Entity (MAV)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.GeolocationEntitySOVOnline,
          print: GRAPH_DATATYPE.GeolocationEntitySOVPrint,
          printandonline: GRAPH_DATATYPE.GeolocationEntitySOVPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.GeolocationEntitySOVReach,
        value: REPORT_TYPES.GeolocationEntitySOVReach,
        reportCategory: REPORT_CATEGORIES.GEOLOCATION,
        label: "Geolocation - SOV - Entity (Reach)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.GeolocationEntitySOVOnline,
          print: GRAPH_DATATYPE.GeolocationEntitySOVPrint,
          printandonline: GRAPH_DATATYPE.GeolocationEntitySOVPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.GeolocationEntitySOVWordCount,
        value: REPORT_TYPES.GeolocationEntitySOVWordCount,
        reportCategory: REPORT_CATEGORIES.GEOLOCATION,
        label: "Geolocation - SOV - Entity (Word Count)",
        enablePrint: false,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.GeolocationEntitySOVOnline,
          printandonline: GRAPH_DATATYPE.GeolocationEntitySOVPrintOnline,
        },
        verticalList: [V_ONLINE],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      //Geolocation - Entity - Trend
      {
        id: REPORT_TYPES.GeolocationEntityTrendIndex,
        value: REPORT_TYPES.GeolocationEntityTrendIndex,
        reportCategory: REPORT_CATEGORIES.GEOLOCATION,
        label: "Geolocation - Trend - Entity (Index)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.GeolocationEntityTrendOnline,
          print: GRAPH_DATATYPE.GeolocationEntityTrendPrint,
          printandonline: GRAPH_DATATYPE.GeolocationEntityTrendPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [

          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.GeolocationEntityTrendNOA,
        value: REPORT_TYPES.GeolocationEntityTrendNOA,
        reportCategory: REPORT_CATEGORIES.GEOLOCATION,
        label: "Geolocation - Trend - Entity (No. Of Article)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.GeolocationEntityTrendOnline,
          print: GRAPH_DATATYPE.GeolocationEntityTrendPrint,
          printandonline: GRAPH_DATATYPE.GeolocationEntityTrendPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [

          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.GeolocationEntityTrendCCM,
        value: REPORT_TYPES.GeolocationEntityTrendCCM,
        reportCategory: REPORT_CATEGORIES.GEOLOCATION,
        label: "Geolocation - Trend - Entity (CCM)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.GeolocationEntityTrendOnline,
          print: GRAPH_DATATYPE.GeolocationEntityTrendPrint,
          printandonline: GRAPH_DATATYPE.GeolocationEntityTrendPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [

          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.GeolocationEntityTrendMAV,
        value: REPORT_TYPES.GeolocationEntityTrendMAV,
        reportCategory: REPORT_CATEGORIES.GEOLOCATION,
        label: "Geolocation - Trend - Entity (MAV)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.GeolocationEntityTrendOnline,
          print: GRAPH_DATATYPE.GeolocationEntityTrendPrint,
          printandonline: GRAPH_DATATYPE.GeolocationEntityTrendPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [

          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.GeolocationEntityTrendReach,
        value: REPORT_TYPES.GeolocationEntityTrendReach,
        reportCategory: REPORT_CATEGORIES.GEOLOCATION,
        label: "Geolocation - Trend - Entity (Reach)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.GeolocationEntityTrendOnline,
          print: GRAPH_DATATYPE.GeolocationEntityTrendPrint,
          printandonline: GRAPH_DATATYPE.GeolocationEntityTrendPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [

          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.GeolocationEntityTrendWordCount,
        value: REPORT_TYPES.GeolocationEntityTrendWordCount,
        reportCategory: REPORT_CATEGORIES.GEOLOCATION,
        label: "Geolocation - Trend - Entity (Word Count)",
        enablePrint: false,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.GeolocationEntityTrendOnline,
          printandonline: GRAPH_DATATYPE.GeolocationEntityTrendPrintOnline,
        },
        verticalList: [V_ONLINE],
        groupByField: "entity_name",
        excludeGraphType: [

          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      //Geolocation - Entity - Tonality
      {
        id: REPORT_TYPES.GeolocationEntityTonalityIndex,
        value: REPORT_TYPES.GeolocationEntityTonalityIndex,
        reportCategory: REPORT_CATEGORIES.GEOLOCATION,
        label: "Geolocation - Tonality - Entity (Index)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.GeolocationEntityTonalityOnline,
          print: GRAPH_DATATYPE.GeolocationEntityTonalityPrint,
          printandonline: GRAPH_DATATYPE.GeolocationEntityTonalityPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.GeolocationEntityTonalityNOA,
        value: REPORT_TYPES.GeolocationEntityTonalityNOA,
        reportCategory: REPORT_CATEGORIES.GEOLOCATION,
        label: "Geolocation - Tonality - Entity (No. Of Article)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.GeolocationEntityTonalityOnline,
          print: GRAPH_DATATYPE.GeolocationEntityTonalityPrint,
          printandonline: GRAPH_DATATYPE.GeolocationEntityTonalityPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.GeolocationEntityTonalityCCM,
        value: REPORT_TYPES.GeolocationEntityTonalityCCM,
        reportCategory: REPORT_CATEGORIES.GEOLOCATION,
        label: "Geolocation - Tonality - Entity (CCM)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.GeolocationEntityTonalityOnline,
          print: GRAPH_DATATYPE.GeolocationEntityTonalityPrint,
          printandonline: GRAPH_DATATYPE.GeolocationEntityTonalityPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.GeolocationEntityTonalityMAV,
        value: REPORT_TYPES.GeolocationEntityTonalityMAV,
        reportCategory: REPORT_CATEGORIES.GEOLOCATION,
        label: "Geolocation - Tonality - Entity (MAV)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.GeolocationEntityTonalityOnline,
          print: GRAPH_DATATYPE.GeolocationEntityTonalityPrint,
          printandonline: GRAPH_DATATYPE.GeolocationEntityTonalityPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.GeolocationEntityTonalityReach,
        value: REPORT_TYPES.GeolocationEntityTonalityReach,
        reportCategory: REPORT_CATEGORIES.GEOLOCATION,
        label: "Geolocation - Tonality - Entity (Reach)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.GeolocationEntityTonalityOnline,
          print: GRAPH_DATATYPE.GeolocationEntityTonalityPrint,
          printandonline: GRAPH_DATATYPE.GeolocationEntityTonalityPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.GeolocationEntityTonalityWordCount,
        value: REPORT_TYPES.GeolocationEntityTonalityWordCount,
        reportCategory: REPORT_CATEGORIES.GEOLOCATION,
        label: "Geolocation - Tonality - Entity (Word Count)",
        enablePrint: false,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.GeolocationEntityTonalityOnline,
          printandonline: GRAPH_DATATYPE.GeolocationEntityTonalityPrintOnline,
        },
        verticalList: [V_ONLINE],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      //Geolocation - Publication - SOV
      {
        id: REPORT_TYPES.GeolocationPublicationSOVIndex,
        value: REPORT_TYPES.GeolocationPublicationSOVIndex,
        reportCategory: REPORT_CATEGORIES.GEOLOCATION,
        label: "Geolocation - SOV - Publication (Index)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.GeolocationPublicationSOVOnline,
          print: GRAPH_DATATYPE.GeolocationPublicationSOVPrint,
          printandonline: GRAPH_DATATYPE.GeolocationPublicationSOVPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.GeolocationPublicationSOVNOA,
        value: REPORT_TYPES.GeolocationPublicationSOVNOA,
        reportCategory: REPORT_CATEGORIES.GEOLOCATION,
        label: "Geolocation - SOV - Publication (No. Of Article)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.GeolocationPublicationSOVOnline,
          print: GRAPH_DATATYPE.GeolocationPublicationSOVPrint,
          printandonline: GRAPH_DATATYPE.GeolocationPublicationSOVPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.GeolocationPublicationSOVCCM,
        value: REPORT_TYPES.GeolocationPublicationSOVCCM,
        reportCategory: REPORT_CATEGORIES.GEOLOCATION,
        label: "Geolocation - SOV - Publication (CCM)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.GeolocationPublicationSOVOnline,
          print: GRAPH_DATATYPE.GeolocationPublicationSOVPrint,
          printandonline: GRAPH_DATATYPE.GeolocationPublicationSOVPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.GeolocationPublicationSOVMAV,
        value: REPORT_TYPES.GeolocationPublicationSOVMAV,
        reportCategory: REPORT_CATEGORIES.GEOLOCATION,
        label: "Geolocation - SOV - Publication (MAV)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.GeolocationPublicationSOVOnline,
          print: GRAPH_DATATYPE.GeolocationPublicationSOVPrint,
          printandonline: GRAPH_DATATYPE.GeolocationPublicationSOVPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.GeolocationPublicationSOVReach,
        value: REPORT_TYPES.GeolocationPublicationSOVReach,
        reportCategory: REPORT_CATEGORIES.GEOLOCATION,
        label: "Geolocation - SOV - Publication (Reach)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.GeolocationPublicationSOVOnline,
          print: GRAPH_DATATYPE.GeolocationPublicationSOVPrint,
          printandonline: GRAPH_DATATYPE.GeolocationPublicationSOVPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.GeolocationPublicationSOVWordCount,
        value: REPORT_TYPES.GeolocationPublicationSOVWordCount,
        reportCategory: REPORT_CATEGORIES.GEOLOCATION,
        label: "Geolocation - SOV - Publication (Word Count)",
        enablePrint: false,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.GeolocationPublicationSOVOnline,
          printandonline: GRAPH_DATATYPE.GeolocationPublicationSOVPrintOnline,
        },
        verticalList: [V_ONLINE],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      //Geolocation - Publication - Trend
      {
        id: REPORT_TYPES.GeolocationPublicationTrendIndex,
        value: REPORT_TYPES.GeolocationPublicationTrendIndex,
        reportCategory: REPORT_CATEGORIES.GEOLOCATION,
        label: "Geolocation - Trend - Publication (Index)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.GeolocationPublicationTrendOnline,
          print: GRAPH_DATATYPE.GeolocationPublicationTrendPrint,
          printandonline: GRAPH_DATATYPE.GeolocationPublicationTrendPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [

          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.GeolocationPublicationTrendNOA,
        value: REPORT_TYPES.GeolocationPublicationTrendNOA,
        reportCategory: REPORT_CATEGORIES.GEOLOCATION,
        label: "Geolocation - Trend - Publication (No. Of Article)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.GeolocationPublicationTrendOnline,
          print: GRAPH_DATATYPE.GeolocationPublicationTrendPrint,
          printandonline: GRAPH_DATATYPE.GeolocationPublicationTrendPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [

          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.GeolocationPublicationTrendCCM,
        value: REPORT_TYPES.GeolocationPublicationTrendCCM,
        reportCategory: REPORT_CATEGORIES.GEOLOCATION,
        label: "Geolocation - Trend - Publication (CCM)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.GeolocationPublicationTrendOnline,
          print: GRAPH_DATATYPE.GeolocationPublicationTrendPrint,
          printandonline: GRAPH_DATATYPE.GeolocationPublicationTrendPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [

          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.GeolocationPublicationTrendMAV,
        value: REPORT_TYPES.GeolocationPublicationTrendMAV,
        reportCategory: REPORT_CATEGORIES.GEOLOCATION,
        label: "Geolocation - Trend - Publication (MAV)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.GeolocationPublicationTrendOnline,
          print: GRAPH_DATATYPE.GeolocationPublicationTrendPrint,
          printandonline: GRAPH_DATATYPE.GeolocationPublicationTrendPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [

          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.GeolocationPublicationTrendReach,
        value: REPORT_TYPES.GeolocationPublicationTrendReach,
        reportCategory: REPORT_CATEGORIES.GEOLOCATION,
        label: "Geolocation - Trend - Publication (Reach)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.GeolocationPublicationTrendOnline,
          print: GRAPH_DATATYPE.GeolocationPublicationTrendPrint,
          printandonline: GRAPH_DATATYPE.GeolocationPublicationTrendPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [

          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.GeolocationPublicationTrendWordCount,
        value: REPORT_TYPES.GeolocationPublicationTrendWordCount,
        reportCategory: REPORT_CATEGORIES.GEOLOCATION,
        label: "Geolocation - Trend - Publication (Word Count)",
        enablePrint: false,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.GeolocationPublicationTrendOnline,
          printandonline: GRAPH_DATATYPE.GeolocationPublicationTrendPrintOnline,
        },
        verticalList: [V_ONLINE],
        groupByField: "entity_name",
        excludeGraphType: [

          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      //Geolocation - Publication- Tonality
      {
        id: REPORT_TYPES.GeolocationPublicationTonalityIndex,
        value: REPORT_TYPES.GeolocationPublicationTonalityIndex,
        reportCategory: REPORT_CATEGORIES.GEOLOCATION,
        label: "Geolocation - Tonality - Publication (Index)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.GeolocationPublicationTonalityOnline,
          print: GRAPH_DATATYPE.GeolocationPublicationTonalityPrint,
          printandonline: GRAPH_DATATYPE.GeolocationPublicationTonalityPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.GeolocationPublicationTonalityNOA,
        value: REPORT_TYPES.GeolocationPublicationTonalityNOA,
        reportCategory: REPORT_CATEGORIES.GEOLOCATION,
        label: "Geolocation - Tonality - Publication (No. Of Article)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.GeolocationPublicationTonalityOnline,
          print: GRAPH_DATATYPE.GeolocationPublicationTonalityPrint,
          printandonline: GRAPH_DATATYPE.GeolocationPublicationTonalityPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.GeolocationPublicationTonalityCCM,
        value: REPORT_TYPES.GeolocationPublicationTonalityCCM,
        reportCategory: REPORT_CATEGORIES.GEOLOCATION,
        label: "Geolocation - Tonality - Publication (CCM)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.GeolocationPublicationTonalityOnline,
          print: GRAPH_DATATYPE.GeolocationPublicationTonalityPrint,
          printandonline: GRAPH_DATATYPE.GeolocationPublicationTonalityPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.GeolocationPublicationTonalityMAV,
        value: REPORT_TYPES.GeolocationPublicationTonalityMAV,
        reportCategory: REPORT_CATEGORIES.GEOLOCATION,
        label: "Geolocation - Tonality - Publication (MAV)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.GeolocationPublicationTonalityOnline,
          print: GRAPH_DATATYPE.GeolocationPublicationTonalityPrint,
          printandonline: GRAPH_DATATYPE.GeolocationPublicationTonalityPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.GeolocationPublicationTonalityReach,
        value: REPORT_TYPES.GeolocationPublicationTonalityReach,
        reportCategory: REPORT_CATEGORIES.GEOLOCATION,
        label: "Geolocation - Tonality - Publication (Reach)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.GeolocationPublicationTonalityOnline,
          print: GRAPH_DATATYPE.GeolocationPublicationTonalityPrint,
          printandonline: GRAPH_DATATYPE.GeolocationPublicationTonalityPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.GeolocationPublicationTonalityWordCount,
        value: REPORT_TYPES.GeolocationPublicationTonalityWordCount,
        reportCategory: REPORT_CATEGORIES.GEOLOCATION,
        label: "Geolocation - Tonality - Publication (Word Count)",
        enablePrint: false,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.GeolocationPublicationTonalityOnline,
          printandonline: GRAPH_DATATYPE.GeolocationPublicationTonalityPrintOnline,
        },
        verticalList: [V_ONLINE],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      //Geolocation - Keyword - SOV
      {
        id: REPORT_TYPES.GeolocationKeywordSOVIndex,
        value: REPORT_TYPES.GeolocationKeywordSOVIndex,
        reportCategory: REPORT_CATEGORIES.GEOLOCATION,
        label: "Geolocation - SOV - Keyword (Index)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.GeolocationKeywordSOVOnline,
          print: GRAPH_DATATYPE.GeolocationKeywordSOVPrint,
          printandonline: GRAPH_DATATYPE.GeolocationKeywordSOVPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.GeolocationKeywordSOVNOA,
        value: REPORT_TYPES.GeolocationKeywordSOVNOA,
        reportCategory: REPORT_CATEGORIES.GEOLOCATION,
        label: "Geolocation - SOV - Keyword (No. Of Article)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.GeolocationKeywordSOVOnline,
          print: GRAPH_DATATYPE.GeolocationKeywordSOVPrint,
          printandonline: GRAPH_DATATYPE.GeolocationKeywordSOVPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.GeolocationKeywordSOVCCM,
        value: REPORT_TYPES.GeolocationKeywordSOVCCM,
        reportCategory: REPORT_CATEGORIES.GEOLOCATION,
        label: "Geolocation - SOV - Keyword (CCM)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.GeolocationKeywordSOVOnline,
          print: GRAPH_DATATYPE.GeolocationKeywordSOVPrint,
          printandonline: GRAPH_DATATYPE.GeolocationKeywordSOVPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.GeolocationKeywordSOVMAV,
        value: REPORT_TYPES.GeolocationKeywordSOVMAV,
        reportCategory: REPORT_CATEGORIES.GEOLOCATION,
        label: "Geolocation - SOV - Keyword (MAV)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.GeolocationKeywordSOVOnline,
          print: GRAPH_DATATYPE.GeolocationKeywordSOVPrint,
          printandonline: GRAPH_DATATYPE.GeolocationKeywordSOVPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.GeolocationKeywordSOVReach,
        value: REPORT_TYPES.GeolocationKeywordSOVReach,
        reportCategory: REPORT_CATEGORIES.GEOLOCATION,
        label: "Geolocation - SOV - Keyword (Reach)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.GeolocationKeywordSOVOnline,
          print: GRAPH_DATATYPE.GeolocationKeywordSOVPrint,
          printandonline: GRAPH_DATATYPE.GeolocationKeywordSOVPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.GeolocationKeywordSOVWordCount,
        value: REPORT_TYPES.GeolocationKeywordSOVWordCount,
        reportCategory: REPORT_CATEGORIES.GEOLOCATION,
        label: "Geolocation - SOV - Keyword (Word Count)",
        enablePrint: false,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.GeolocationKeywordSOVOnline,
          printandonline: GRAPH_DATATYPE.GeolocationKeywordSOVPrintOnline,
        },
        verticalList: [V_ONLINE],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      //Geolocation - Keyword - Trend
      {
        id: REPORT_TYPES.GeolocationKeywordTrendIndex,
        value: REPORT_TYPES.GeolocationKeywordTrendIndex,
        reportCategory: REPORT_CATEGORIES.GEOLOCATION,
        label: "Geolocation - Trend - Keyword (Index)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.GeolocationKeywordTrendOnline,
          print: GRAPH_DATATYPE.GeolocationKeywordTrendPrint,
          printandonline: GRAPH_DATATYPE.GeolocationKeywordTrendPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [

          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.GeolocationKeywordTrendNOA,
        value: REPORT_TYPES.GeolocationKeywordTrendNOA,
        reportCategory: REPORT_CATEGORIES.GEOLOCATION,
        label: "Geolocation - Trend - Keyword (No. Of Article)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.GeolocationKeywordTrendOnline,
          print: GRAPH_DATATYPE.GeolocationKeywordTrendPrint,
          printandonline: GRAPH_DATATYPE.GeolocationKeywordTrendPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [

          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.GeolocationKeywordTrendCCM,
        value: REPORT_TYPES.GeolocationKeywordTrendCCM,
        reportCategory: REPORT_CATEGORIES.GEOLOCATION,
        label: "Geolocation - Trend - Keyword (CCM)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.GeolocationKeywordTrendOnline,
          print: GRAPH_DATATYPE.GeolocationKeywordTrendPrint,
          printandonline: GRAPH_DATATYPE.GeolocationKeywordTrendPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [

          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.GeolocationKeywordTrendMAV,
        value: REPORT_TYPES.GeolocationKeywordTrendMAV,
        reportCategory: REPORT_CATEGORIES.GEOLOCATION,
        label: "Geolocation - Trend - Keyword (MAV)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.GeolocationKeywordTrendOnline,
          print: GRAPH_DATATYPE.GeolocationKeywordTrendPrint,
          printandonline: GRAPH_DATATYPE.GeolocationKeywordTrendPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [

          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.GeolocationKeywordTrendReach,
        value: REPORT_TYPES.GeolocationKeywordTrendReach,
        reportCategory: REPORT_CATEGORIES.GEOLOCATION,
        label: "Geolocation - Trend - Keyword (Reach)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.GeolocationKeywordTrendOnline,
          print: GRAPH_DATATYPE.GeolocationKeywordTrendPrint,
          printandonline: GRAPH_DATATYPE.GeolocationKeywordTrendPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [

          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.GeolocationKeywordTrendWordCount,
        value: REPORT_TYPES.GeolocationKeywordTrendWordCount,
        reportCategory: REPORT_CATEGORIES.GEOLOCATION,
        label: "Geolocation - Trend - Keyword (Word Count)",
        enablePrint: false,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.GeolocationKeywordTrendOnline,
          printandonline: GRAPH_DATATYPE.GeolocationKeywordTrendPrintOnline,
        },
        verticalList: [V_ONLINE],
        groupByField: "entity_name",
        excludeGraphType: [

          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      //Geolocation - Keyword- Tonality
      {
        id: REPORT_TYPES.GeolocationKeywordTonalityIndex,
        value: REPORT_TYPES.GeolocationKeywordTonalityIndex,
        reportCategory: REPORT_CATEGORIES.GEOLOCATION,
        label: "Geolocation - Tonality - Keyword (Index)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.GeolocationKeywordTonalityOnline,
          print: GRAPH_DATATYPE.GeolocationKeywordTonalityPrint,
          printandonline: GRAPH_DATATYPE.GeolocationKeywordTonalityPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.GeolocationKeywordTonalityNOA,
        value: REPORT_TYPES.GeolocationKeywordTonalityNOA,
        reportCategory: REPORT_CATEGORIES.GEOLOCATION,
        label: "Geolocation - Tonality - Keyword (No. Of Article)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.GeolocationKeywordTonalityOnline,
          print: GRAPH_DATATYPE.GeolocationKeywordTonalityPrint,
          printandonline: GRAPH_DATATYPE.GeolocationKeywordTonalityPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.GeolocationKeywordTonalityCCM,
        value: REPORT_TYPES.GeolocationKeywordTonalityCCM,
        reportCategory: REPORT_CATEGORIES.GEOLOCATION,
        label: "Geolocation - Tonality - Keyword (CCM)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.GeolocationKeywordTonalityOnline,
          print: GRAPH_DATATYPE.GeolocationKeywordTonalityPrint,
          printandonline: GRAPH_DATATYPE.GeolocationKeywordTonalityPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.GeolocationKeywordTonalityMAV,
        value: REPORT_TYPES.GeolocationKeywordTonalityMAV,
        reportCategory: REPORT_CATEGORIES.GEOLOCATION,
        label: "Geolocation - Tonality - Keyword (MAV)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.GeolocationKeywordTonalityOnline,
          print: GRAPH_DATATYPE.GeolocationKeywordTonalityPrint,
          printandonline: GRAPH_DATATYPE.GeolocationKeywordTonalityPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.GeolocationKeywordTonalityReach,
        value: REPORT_TYPES.GeolocationKeywordTonalityReach,
        reportCategory: REPORT_CATEGORIES.GEOLOCATION,
        label: "Geolocation - Tonality - Keyword (Reach)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.GeolocationKeywordTonalityOnline,
          print: GRAPH_DATATYPE.GeolocationKeywordTonalityPrint,
          printandonline: GRAPH_DATATYPE.GeolocationKeywordTonalityPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.GeolocationKeywordTonalityWordCount,
        value: REPORT_TYPES.GeolocationKeywordTonalityWordCount,
        reportCategory: REPORT_CATEGORIES.GEOLOCATION,
        label: "Geolocation - Tonality - Keyword (Word Count)",
        enablePrint: false,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.GeolocationKeywordTonalityOnline,
          printandonline: GRAPH_DATATYPE.GeolocationKeywordTonalityPrintOnline,
        },
        verticalList: [V_ONLINE],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      //block Publication - Entity - SOV 
      {
        id: REPORT_TYPES.PublicationEntitySOVIndex,
        value: REPORT_TYPES.PublicationEntitySOVIndex,
        reportCategory: REPORT_CATEGORIES.PUBLICATION,
        label: "Publication - SOV - Entity (Index)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.PublicationEntitySOVOnline,
          print: GRAPH_DATATYPE.PublicationEntitySOVPrint,
          printandonline: GRAPH_DATATYPE.PublicationEntitySOVPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.PublicationEntitySOVNOA,
        value: REPORT_TYPES.PublicationEntitySOVNOA,
        reportCategory: REPORT_CATEGORIES.PUBLICATION,
        label: "Publication - SOV - Entity (No. Of Article)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.PublicationEntitySOVOnline,
          print: GRAPH_DATATYPE.PublicationEntitySOVPrint,
          printandonline: GRAPH_DATATYPE.PublicationEntitySOVPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.PublicationEntitySOVCCM,
        value: REPORT_TYPES.PublicationEntitySOVCCM,
        reportCategory: REPORT_CATEGORIES.PUBLICATION,
        label: "Publication - SOV - Entity (CCM)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.PublicationEntitySOVOnline,
          print: GRAPH_DATATYPE.PublicationEntitySOVPrint,
          printandonline: GRAPH_DATATYPE.PublicationEntitySOVPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.PublicationEntitySOVMAV,
        value: REPORT_TYPES.PublicationEntitySOVMAV,
        reportCategory: REPORT_CATEGORIES.PUBLICATION,
        label: "Publication - SOV - Entity (MAV)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.PublicationEntitySOVOnline,
          print: GRAPH_DATATYPE.PublicationEntitySOVPrint,
          printandonline: GRAPH_DATATYPE.PublicationEntitySOVPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.PublicationEntitySOVReach,
        value: REPORT_TYPES.PublicationEntitySOVReach,
        reportCategory: REPORT_CATEGORIES.PUBLICATION,
        label: "Publication - SOV - Entity (Reach)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.PublicationEntitySOVOnline,
          print: GRAPH_DATATYPE.PublicationEntitySOVPrint,
          printandonline: GRAPH_DATATYPE.PublicationEntitySOVPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.PublicationEntitySOVWordCount,
        value: REPORT_TYPES.PublicationEntitySOVWordCount,
        reportCategory: REPORT_CATEGORIES.PUBLICATION,
        label: "Publication - SOV - Entity (Word Count)",
        enablePrint: false,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.PublicationEntitySOVOnline,
          printandonline: GRAPH_DATATYPE.PublicationEntitySOVPrintOnline,
        },
        verticalList: [V_ONLINE],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      //Publication - Entity - Trend
      {
        id: REPORT_TYPES.PublicationEntityTrendIndex,
        value: REPORT_TYPES.PublicationEntityTrendIndex,
        reportCategory: REPORT_CATEGORIES.PUBLICATION,
        label: "Publication - Trend - Entity (Index)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.PublicationEntityTrendOnline,
          print: GRAPH_DATATYPE.PublicationEntityTrendPrint,
          printandonline: GRAPH_DATATYPE.PublicationEntityTrendPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [

          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.PublicationEntityTrendNOA,
        value: REPORT_TYPES.PublicationEntityTrendNOA,
        reportCategory: REPORT_CATEGORIES.PUBLICATION,
        label: "Publication - Trend - Entity (No. Of Article)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.PublicationEntityTrendOnline,
          print: GRAPH_DATATYPE.PublicationEntityTrendPrint,
          printandonline: GRAPH_DATATYPE.PublicationEntityTrendPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [

          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.PublicationEntityTrendCCM,
        value: REPORT_TYPES.PublicationEntityTrendCCM,
        reportCategory: REPORT_CATEGORIES.PUBLICATION,
        label: "Publication - Trend - Entity (CCM)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.PublicationEntityTrendOnline,
          print: GRAPH_DATATYPE.PublicationEntityTrendPrint,
          printandonline: GRAPH_DATATYPE.PublicationEntityTrendPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [

          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.PublicationEntityTrendMAV,
        value: REPORT_TYPES.PublicationEntityTrendMAV,
        reportCategory: REPORT_CATEGORIES.PUBLICATION,
        label: "Publication - Trend - Entity (MAV)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.PublicationEntityTrendOnline,
          print: GRAPH_DATATYPE.PublicationEntityTrendPrint,
          printandonline: GRAPH_DATATYPE.PublicationEntityTrendPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [

          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.PublicationEntityTrendReach,
        value: REPORT_TYPES.PublicationEntityTrendReach,
        reportCategory: REPORT_CATEGORIES.PUBLICATION,
        label: "Publication - Trend - Entity (Reach)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.PublicationEntityTrendOnline,
          print: GRAPH_DATATYPE.PublicationEntityTrendPrint,
          printandonline: GRAPH_DATATYPE.PublicationEntityTrendPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [

          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.PublicationEntityTrendWordCount,
        value: REPORT_TYPES.PublicationEntityTrendWordCount,
        reportCategory: REPORT_CATEGORIES.PUBLICATION,
        label: "Publication - Trend - Entity (Word Count)",
        enablePrint: false,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.PublicationEntityTrendOnline,
          printandonline: GRAPH_DATATYPE.PublicationEntityTrendPrintOnline,
        },
        verticalList: [V_ONLINE],
        groupByField: "entity_name",
        excludeGraphType: [

          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      //Publication - Entity - Tonality
      {
        id: REPORT_TYPES.PublicationEntityTonalityIndex,
        value: REPORT_TYPES.PublicationEntityTonalityIndex,
        reportCategory: REPORT_CATEGORIES.PUBLICATION,
        label: "Publication - Tonality - Entity (Index)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.PublicationEntityTonalityOnline,
          print: GRAPH_DATATYPE.PublicationEntityTonalityPrint,
          printandonline: GRAPH_DATATYPE.PublicationEntityTonalityPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.PublicationEntityTonalityNOA,
        value: REPORT_TYPES.PublicationEntityTonalityNOA,
        reportCategory: REPORT_CATEGORIES.PUBLICATION,
        label: "Publication - Tonality - Entity (No. Of Article)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.PublicationEntityTonalityOnline,
          print: GRAPH_DATATYPE.PublicationEntityTonalityPrint,
          printandonline: GRAPH_DATATYPE.PublicationEntityTonalityPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.PublicationEntityTonalityCCM,
        value: REPORT_TYPES.PublicationEntityTonalityCCM,
        reportCategory: REPORT_CATEGORIES.PUBLICATION,
        label: "Publication - Tonality - Entity (CCM)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.PublicationEntityTonalityOnline,
          print: GRAPH_DATATYPE.PublicationEntityTonalityPrint,
          printandonline: GRAPH_DATATYPE.PublicationEntityTonalityPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.PublicationEntityTonalityMAV,
        value: REPORT_TYPES.PublicationEntityTonalityMAV,
        reportCategory: REPORT_CATEGORIES.PUBLICATION,
        label: "Publication - Tonality - Entity (MAV)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.PublicationEntityTonalityOnline,
          print: GRAPH_DATATYPE.PublicationEntityTonalityPrint,
          printandonline: GRAPH_DATATYPE.PublicationEntityTonalityPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.PublicationEntityTonalityReach,
        value: REPORT_TYPES.PublicationEntityTonalityReach,
        reportCategory: REPORT_CATEGORIES.PUBLICATION,
        label: "Publication - Tonality - Entity (Reach)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.PublicationEntityTonalityOnline,
          print: GRAPH_DATATYPE.PublicationEntityTonalityPrint,
          printandonline: GRAPH_DATATYPE.PublicationEntityTonalityPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.PublicationEntityTonalityWordCount,
        value: REPORT_TYPES.PublicationEntityTonalityWordCount,
        reportCategory: REPORT_CATEGORIES.PUBLICATION,
        label: "Publication - Tonality - Entity (Word Count)",
        enablePrint: false,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.PublicationEntityTonalityOnline,
          printandonline: GRAPH_DATATYPE.PublicationEntityTonalityPrintOnline,
        },
        verticalList: [V_ONLINE],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      //Publication - Journalist - SOV
      {
        id: REPORT_TYPES.PublicationJournalistSOVIndex,
        value: REPORT_TYPES.PublicationJournalistSOVIndex,
        reportCategory: REPORT_CATEGORIES.PUBLICATION,
        label: "Publication - SOV - Journalist (Index)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.PublicationJournalistSOVOnline,
          print: GRAPH_DATATYPE.PublicationJournalistSOVPrint,
          printandonline: GRAPH_DATATYPE.PublicationJournalistSOVPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.PublicationJournalistSOVNOA,
        value: REPORT_TYPES.PublicationJournalistSOVNOA,
        reportCategory: REPORT_CATEGORIES.PUBLICATION,
        label: "Publication - SOV - Journalist (No. Of Article)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.PublicationJournalistSOVOnline,
          print: GRAPH_DATATYPE.PublicationJournalistSOVPrint,
          printandonline: GRAPH_DATATYPE.PublicationJournalistSOVPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.PublicationJournalistSOVCCM,
        value: REPORT_TYPES.PublicationJournalistSOVCCM,
        reportCategory: REPORT_CATEGORIES.PUBLICATION,
        label: "Publication - SOV - Journalist (CCM)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.PublicationJournalistSOVOnline,
          print: GRAPH_DATATYPE.PublicationJournalistSOVPrint,
          printandonline: GRAPH_DATATYPE.PublicationJournalistSOVPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.PublicationJournalistSOVMAV,
        value: REPORT_TYPES.PublicationJournalistSOVMAV,
        reportCategory: REPORT_CATEGORIES.PUBLICATION,
        label: "Publication - SOV - Journalist (MAV)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.PublicationJournalistSOVOnline,
          print: GRAPH_DATATYPE.PublicationJournalistSOVPrint,
          printandonline: GRAPH_DATATYPE.PublicationJournalistSOVPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.PublicationJournalistSOVReach,
        value: REPORT_TYPES.PublicationJournalistSOVReach,
        reportCategory: REPORT_CATEGORIES.PUBLICATION,
        label: "Publication - SOV - Journalist (Reach)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.PublicationJournalistSOVOnline,
          print: GRAPH_DATATYPE.PublicationJournalistSOVPrint,
          printandonline: GRAPH_DATATYPE.PublicationJournalistSOVPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.PublicationJournalistSOVWordCount,
        value: REPORT_TYPES.PublicationJournalistSOVWordCount,
        reportCategory: REPORT_CATEGORIES.PUBLICATION,
        label: "Publication - SOV - Journalist (Word Count)",
        enablePrint: false,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.PublicationJournalistSOVOnline,
          printandonline: GRAPH_DATATYPE.PublicationJournalistSOVPrintOnline,
        },
        verticalList: [V_ONLINE],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      //Publication - Journalist - Trend
      {
        id: REPORT_TYPES.PublicationJournalistTrendIndex,
        value: REPORT_TYPES.PublicationJournalistTrendIndex,
        reportCategory: REPORT_CATEGORIES.PUBLICATION,
        label: "Publication - Trend - Journalist (Index)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.PublicationJournalistTrendOnline,
          print: GRAPH_DATATYPE.PublicationJournalistTrendPrint,
          printandonline: GRAPH_DATATYPE.PublicationJournalistTrendPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [

          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.PublicationJournalistTrendNOA,
        value: REPORT_TYPES.PublicationJournalistTrendNOA,
        reportCategory: REPORT_CATEGORIES.PUBLICATION,
        label: "Publication - Trend - Journalist (No. Of Article)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.PublicationJournalistTrendOnline,
          print: GRAPH_DATATYPE.PublicationJournalistTrendPrint,
          printandonline: GRAPH_DATATYPE.PublicationJournalistTrendPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [

          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.PublicationJournalistTrendCCM,
        value: REPORT_TYPES.PublicationJournalistTrendCCM,
        reportCategory: REPORT_CATEGORIES.PUBLICATION,
        label: "Publication - Trend - Journalist (CCM)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.PublicationJournalistTrendOnline,
          print: GRAPH_DATATYPE.PublicationJournalistTrendPrint,
          printandonline: GRAPH_DATATYPE.PublicationJournalistTrendPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [

          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.PublicationJournalistTrendMAV,
        value: REPORT_TYPES.PublicationJournalistTrendMAV,
        reportCategory: REPORT_CATEGORIES.PUBLICATION,
        label: "Publication - Trend - Journalist (MAV)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.PublicationJournalistTrendOnline,
          print: GRAPH_DATATYPE.PublicationJournalistTrendPrint,
          printandonline: GRAPH_DATATYPE.PublicationJournalistTrendPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [

          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.PublicationJournalistTrendReach,
        value: REPORT_TYPES.PublicationJournalistTrendReach,
        reportCategory: REPORT_CATEGORIES.PUBLICATION,
        label: "Publication - Trend - Journalist (Reach)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.PublicationJournalistTrendOnline,
          print: GRAPH_DATATYPE.PublicationJournalistTrendPrint,
          printandonline: GRAPH_DATATYPE.PublicationJournalistTrendPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [

          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.PublicationJournalistTrendWordCount,
        value: REPORT_TYPES.PublicationJournalistTrendWordCount,
        reportCategory: REPORT_CATEGORIES.PUBLICATION,
        label: "Publication - Trend - Journalist (Word Count)",
        enablePrint: false,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.PublicationJournalistTrendOnline,
          printandonline: GRAPH_DATATYPE.PublicationJournalistTrendPrintOnline,
        },
        verticalList: [V_ONLINE],
        groupByField: "entity_name",
        excludeGraphType: [

          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      //Publication - Journalist- Tonality
      {
        id: REPORT_TYPES.PublicationJournalistTonalityIndex,
        value: REPORT_TYPES.PublicationJournalistTonalityIndex,
        reportCategory: REPORT_CATEGORIES.PUBLICATION,
        label: "Publication - Tonality - Journalist (Index)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.PublicationJournalistTonalityOnline,
          print: GRAPH_DATATYPE.PublicationJournalistTonalityPrint,
          printandonline: GRAPH_DATATYPE.PublicationJournalistTonalityPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.PublicationJournalistTonalityNOA,
        value: REPORT_TYPES.PublicationJournalistTonalityNOA,
        reportCategory: REPORT_CATEGORIES.PUBLICATION,
        label: "Publication - Tonality - Journalist (No. Of Article)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.PublicationJournalistTonalityOnline,
          print: GRAPH_DATATYPE.PublicationJournalistTonalityPrint,
          printandonline: GRAPH_DATATYPE.PublicationJournalistTonalityPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.PublicationJournalistTonalityCCM,
        value: REPORT_TYPES.PublicationJournalistTonalityCCM,
        reportCategory: REPORT_CATEGORIES.PUBLICATION,
        label: "Publication - Tonality - Journalist (CCM)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.PublicationJournalistTonalityOnline,
          print: GRAPH_DATATYPE.PublicationJournalistTonalityPrint,
          printandonline: GRAPH_DATATYPE.PublicationJournalistTonalityPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.PublicationJournalistTonalityMAV,
        value: REPORT_TYPES.PublicationJournalistTonalityMAV,
        reportCategory: REPORT_CATEGORIES.PUBLICATION,
        label: "Publication - Tonality - Journalist (MAV)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.PublicationJournalistTonalityOnline,
          print: GRAPH_DATATYPE.PublicationJournalistTonalityPrint,
          printandonline: GRAPH_DATATYPE.PublicationJournalistTonalityPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.PublicationJournalistTonalityReach,
        value: REPORT_TYPES.PublicationJournalistTonalityReach,
        reportCategory: REPORT_CATEGORIES.PUBLICATION,
        label: "Publication - Tonality - Journalist (Reach)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.PublicationJournalistTonalityOnline,
          print: GRAPH_DATATYPE.PublicationJournalistTonalityPrint,
          printandonline: GRAPH_DATATYPE.PublicationJournalistTonalityPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.PublicationJournalistTonalityWordCount,
        value: REPORT_TYPES.PublicationJournalistTonalityWordCount,
        reportCategory: REPORT_CATEGORIES.PUBLICATION,
        label: "Publication - Tonality - Journalist (Word Count)",
        enablePrint: false,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.PublicationJournalistTonalityOnline,
          printandonline: GRAPH_DATATYPE.PublicationJournalistTonalityPrintOnline,
        },
        verticalList: [V_ONLINE],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      //Publication - Keyword - SOV
      {
        id: REPORT_TYPES.PublicationKeywordSOVIndex,
        value: REPORT_TYPES.PublicationKeywordSOVIndex,
        reportCategory: REPORT_CATEGORIES.PUBLICATION,
        label: "Publication - SOV - Keyword (Index)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.PublicationKeywordSOVOnline,
          print: GRAPH_DATATYPE.PublicationKeywordSOVPrint,
          printandonline: GRAPH_DATATYPE.PublicationKeywordSOVPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.PublicationKeywordSOVNOA,
        value: REPORT_TYPES.PublicationKeywordSOVNOA,
        reportCategory: REPORT_CATEGORIES.PUBLICATION,
        label: "Publication - SOV - Keyword (No. Of Article)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.PublicationKeywordSOVOnline,
          print: GRAPH_DATATYPE.PublicationKeywordSOVPrint,
          printandonline: GRAPH_DATATYPE.PublicationKeywordSOVPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.PublicationKeywordSOVCCM,
        value: REPORT_TYPES.PublicationKeywordSOVCCM,
        reportCategory: REPORT_CATEGORIES.PUBLICATION,
        label: "Publication - SOV - Keyword (CCM)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.PublicationKeywordSOVOnline,
          print: GRAPH_DATATYPE.PublicationKeywordSOVPrint,
          printandonline: GRAPH_DATATYPE.PublicationKeywordSOVPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.PublicationKeywordSOVMAV,
        value: REPORT_TYPES.PublicationKeywordSOVMAV,
        reportCategory: REPORT_CATEGORIES.PUBLICATION,
        label: "Publication - SOV - Keyword (MAV)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.PublicationKeywordSOVOnline,
          print: GRAPH_DATATYPE.PublicationKeywordSOVPrint,
          printandonline: GRAPH_DATATYPE.PublicationKeywordSOVPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.PublicationKeywordSOVReach,
        value: REPORT_TYPES.PublicationKeywordSOVReach,
        reportCategory: REPORT_CATEGORIES.PUBLICATION,
        label: "Publication - SOV - Keyword (Reach)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.PublicationKeywordSOVOnline,
          print: GRAPH_DATATYPE.PublicationKeywordSOVPrint,
          printandonline: GRAPH_DATATYPE.PublicationKeywordSOVPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.PublicationKeywordSOVWordCount,
        value: REPORT_TYPES.PublicationKeywordSOVWordCount,
        reportCategory: REPORT_CATEGORIES.PUBLICATION,
        label: "Publication - SOV - Keyword (Word Count)",
        enablePrint: false,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.PublicationKeywordSOVOnline,
          printandonline: GRAPH_DATATYPE.PublicationKeywordSOVPrintOnline,
        },
        verticalList: [V_ONLINE],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      //Publication - Keyword - Trend
      {
        id: REPORT_TYPES.PublicationKeywordTrendIndex,
        value: REPORT_TYPES.PublicationKeywordTrendIndex,
        reportCategory: REPORT_CATEGORIES.PUBLICATION,
        label: "Publication - Trend - Keyword (Index)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.PublicationKeywordTrendOnline,
          print: GRAPH_DATATYPE.PublicationKeywordTrendPrint,
          printandonline: GRAPH_DATATYPE.PublicationKeywordTrendPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [

          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.PublicationKeywordTrendNOA,
        value: REPORT_TYPES.PublicationKeywordTrendNOA,
        reportCategory: REPORT_CATEGORIES.PUBLICATION,
        label: "Publication - Trend - Keyword (No. Of Article)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.PublicationKeywordTrendOnline,
          print: GRAPH_DATATYPE.PublicationKeywordTrendPrint,
          printandonline: GRAPH_DATATYPE.PublicationKeywordTrendPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [

          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.PublicationKeywordTrendCCM,
        value: REPORT_TYPES.PublicationKeywordTrendCCM,
        reportCategory: REPORT_CATEGORIES.PUBLICATION,
        label: "Publication - Trend - Keyword (CCM)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.PublicationKeywordTrendOnline,
          print: GRAPH_DATATYPE.PublicationKeywordTrendPrint,
          printandonline: GRAPH_DATATYPE.PublicationKeywordTrendPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [

          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.PublicationKeywordTrendMAV,
        value: REPORT_TYPES.PublicationKeywordTrendMAV,
        reportCategory: REPORT_CATEGORIES.PUBLICATION,
        label: "Publication - Trend - Keyword (MAV)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.PublicationKeywordTrendOnline,
          print: GRAPH_DATATYPE.PublicationKeywordTrendPrint,
          printandonline: GRAPH_DATATYPE.PublicationKeywordTrendPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [

          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.PublicationKeywordTrendReach,
        value: REPORT_TYPES.PublicationKeywordTrendReach,
        reportCategory: REPORT_CATEGORIES.PUBLICATION,
        label: "Publication - Trend - Keyword (Reach)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.PublicationKeywordTrendOnline,
          print: GRAPH_DATATYPE.PublicationKeywordTrendPrint,
          printandonline: GRAPH_DATATYPE.PublicationKeywordTrendPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [

          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.PublicationKeywordTrendWordCount,
        value: REPORT_TYPES.PublicationKeywordTrendWordCount,
        reportCategory: REPORT_CATEGORIES.PUBLICATION,
        label: "Publication - Trend - Keyword (Word Count)",
        enablePrint: false,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.PublicationKeywordTrendOnline,
          printandonline: GRAPH_DATATYPE.PublicationKeywordTrendPrintOnline,
        },
        verticalList: [V_ONLINE],
        groupByField: "entity_name",
        excludeGraphType: [

          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      //Publication - Keyword- Tonality
      {
        id: REPORT_TYPES.PublicationKeywordTonalityIndex,
        value: REPORT_TYPES.PublicationKeywordTonalityIndex,
        reportCategory: REPORT_CATEGORIES.PUBLICATION,
        label: "Publication - Tonality - Keyword (Index)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.PublicationKeywordTonalityOnline,
          print: GRAPH_DATATYPE.PublicationKeywordTonalityPrint,
          printandonline: GRAPH_DATATYPE.PublicationKeywordTonalityPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.PublicationKeywordTonalityNOA,
        value: REPORT_TYPES.PublicationKeywordTonalityNOA,
        reportCategory: REPORT_CATEGORIES.PUBLICATION,
        label: "Publication - Tonality - Keyword (No. Of Article)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.PublicationKeywordTonalityOnline,
          print: GRAPH_DATATYPE.PublicationKeywordTonalityPrint,
          printandonline: GRAPH_DATATYPE.PublicationKeywordTonalityPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.PublicationKeywordTonalityCCM,
        value: REPORT_TYPES.PublicationKeywordTonalityCCM,
        reportCategory: REPORT_CATEGORIES.PUBLICATION,
        label: "Publication - Tonality - Keyword (CCM)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.PublicationKeywordTonalityOnline,
          print: GRAPH_DATATYPE.PublicationKeywordTonalityPrint,
          printandonline: GRAPH_DATATYPE.PublicationKeywordTonalityPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.PublicationKeywordTonalityMAV,
        value: REPORT_TYPES.PublicationKeywordTonalityMAV,
        reportCategory: REPORT_CATEGORIES.PUBLICATION,
        label: "Publication - Tonality - Keyword (MAV)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.PublicationKeywordTonalityOnline,
          print: GRAPH_DATATYPE.PublicationKeywordTonalityPrint,
          printandonline: GRAPH_DATATYPE.PublicationKeywordTonalityPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.PublicationKeywordTonalityReach,
        value: REPORT_TYPES.PublicationKeywordTonalityReach,
        reportCategory: REPORT_CATEGORIES.PUBLICATION,
        label: "Publication - Tonality - Keyword (Reach)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.PublicationKeywordTonalityOnline,
          print: GRAPH_DATATYPE.PublicationKeywordTonalityPrint,
          printandonline: GRAPH_DATATYPE.PublicationKeywordTonalityPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.PublicationKeywordTonalityWordCount,
        value: REPORT_TYPES.PublicationKeywordTonalityWordCount,
        reportCategory: REPORT_CATEGORIES.PUBLICATION,
        label: "Publication - Tonality - Keyword (Word Count)",
        enablePrint: false,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.PublicationKeywordTonalityOnline,
          printandonline: GRAPH_DATATYPE.PublicationKeywordTonalityPrintOnline,
        },
        verticalList: [V_ONLINE],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },

      //New Publication - NewEntity - SOV 
      {
        id: REPORT_TYPES.PublicationNewEntitySOVIndex,
        value: REPORT_TYPES.PublicationNewEntitySOVIndex,
        reportCategory: REPORT_CATEGORIES.PUBLICATION,
        label: "Publication Genre as-per  Entity (Index)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.PublicationNewEntitySOVOnline,
          print: GRAPH_DATATYPE.PublicationNewEntitySOVPrint,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.PublicationNewEntitySOVNOA,
        value: REPORT_TYPES.PublicationNewEntitySOVNOA,
        reportCategory: REPORT_CATEGORIES.PUBLICATION,
        label: "Publication Genre as-per  Entity (No. Of Article)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.PublicationNewEntitySOVOnline,
          print: GRAPH_DATATYPE.PublicationNewEntitySOVPrint,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.PublicationNewEntitySOVCCM,
        value: REPORT_TYPES.PublicationNewEntitySOVCCM,
        reportCategory: REPORT_CATEGORIES.PUBLICATION,
        label: "Publication Genre as-per  Entity (CCM)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.PublicationNewEntitySOVOnline,
          print: GRAPH_DATATYPE.PublicationNewEntitySOVPrint,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.PublicationNewEntitySOVMAV,
        value: REPORT_TYPES.PublicationNewEntitySOVMAV,
        reportCategory: REPORT_CATEGORIES.PUBLICATION,
        label: "Publication Genre as-per  Entity (MAV)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.PublicationNewEntitySOVOnline,
          print: GRAPH_DATATYPE.PublicationNewEntitySOVPrint,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.PublicationNewEntitySOVReach,
        value: REPORT_TYPES.PublicationNewEntitySOVReach,
        reportCategory: REPORT_CATEGORIES.PUBLICATION,
        label: "Publication Genre as-per  Entity (Reach)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.PublicationNewEntitySOVOnline,
          print: GRAPH_DATATYPE.PublicationNewEntitySOVPrint,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.PublicationNewEntitySOVWordCount,
        value: REPORT_TYPES.PublicationNewEntitySOVWordCount,
        reportCategory: REPORT_CATEGORIES.PUBLICATION,
        label: "Publication Genre as-per  Entity (Word Count)",
        enablePrint: false,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.PublicationNewEntitySOVOnline,
        },
        verticalList: [V_ONLINE],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      //prev qualitative graphs
      {
        id: REPORT_TYPES.SOVReportIndex,
        value: REPORT_TYPES.SOVReportIndex,
        reportCategory: "sov",
        label: "Share of Voice - Index​",
        enablePrint: true,
        enableOnline: true,
        enableSocial: true,
        graphDataType: {
          online: GRAPH_DATATYPE.SOVRankingNOAOnline,
          print: GRAPH_DATATYPE.SOVRankingNOAPrint,
          social: 1,
        },
        verticalList: [V_ONLINE, V_PRINT, V_SOCIAL, V_BLOG, V_FORUM],
        groupByField: "entity_name",
        excludeGraphType: [
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          BAR_STACKED_EQUAL_HEIGHT,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SOVReportArticle,
        value: REPORT_TYPES.SOVReportArticle,
        reportCategory: "sov",
        label: "Share of Voice - Articles",
        enablePrint: true,
        enableOnline: true,
        enableSocial: true,
        graphDataType: {
          online: GRAPH_DATATYPE.TrendAnalysisOnline,
          print: GRAPH_DATATYPE.TrendAnalysisOnline,
          social: 1,
        },
        verticalList: [V_ONLINE, V_PRINT, V_SOCIAL, V_BLOG, V_FORUM],
        groupByField: "entity_name",
        excludeGraphType: [
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          BAR_STACKED_EQUAL_HEIGHT,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "article_count",
      },
      {
        id: REPORT_TYPES.SNAPSHOT,
        value: REPORT_TYPES.SNAPSHOT,
        reportCategory: "SOVSnapshot",
        label: "Overall Snapshot​",
        enablePrint: false,
        enableOnline: false,
        enableSocial: true,
        graphDataType: {
          online: GRAPH_DATATYPE.Snapshot,
          print: GRAPH_DATATYPE.Snapshot,
          social: 1
        },
        excludeGraphType: [

        ],
        verticalList: [],
      },

      {
        id: REPORT_TYPES.SOVStory,
        value: REPORT_TYPES.SOVStory,
        reportCategory: "StoryPaticipate",
        label: "Prominence - No of article",
        enablePrint: true,
        enableOnline: true,
        enableSocial: true,
        graphDataType: {
          online: GRAPH_DATATYPE.StoryPaticipate,
          print: GRAPH_DATATYPE.StoryPaticipate,
          social: 3,
        },
        verticalList: [V_ONLINE, V_PRINT, V_SOCIAL, V_BLOG, V_FORUM],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          BAR_STACKED,

          AREA,
          LINE,
          WORD_CLOUD,
          GENDER,
          CHOROPLETH,
          DOUGHNUT,
          INFLUENCERS,
        ],
        entityKey: "entity_name",
        countKey: "article_count",
      },
      {
        id: REPORT_TYPES.STORYTABLE,
        value: REPORT_TYPES.STORYTABLE,
        reportCategory: "StoryTable",
        label: "Prominence – No. of Articles​",
        enablePrint: false,
        enableOnline: false,
        enableSocial: true,
        graphDataType: {
          online: GRAPH_DATATYPE.StoryTable,
          print: GRAPH_DATATYPE.StoryTable,
          social: 1
        },
        excludeGraphType: [

        ],
        verticalList: [],
      },
      //thematic qualitative     
      {
        id: REPORT_TYPES.ThematicReportThemeWiseArticle,
        value: REPORT_TYPES.ThematicReportThemeWiseArticle,
        reportCategory: "thematic",
        label: "Industry Theme Wise Analysis (Article)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.ThematicReportThemeWiseOnline,
          print: GRAPH_DATATYPE.ThematicReportThemeWisePrint,
          social: 3,
        },
        excludeGraphType: [
          BAR_HORIZONTAL,
          BAR_STACKED,

          AREA,
          LINE,
          TABLE,
          WORD_CLOUD,
          GENDER,
          CHOROPLETH,
          DOUGHNUT,
          INFLUENCERS,
          BAR_STACKED_EQUAL_HEIGHT,
        ],
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        entityKey: "entity_name",
        countKey: "articlecount",
      },
      {
        id: REPORT_TYPES.ThematicReportThemeWiseIndex,
        value: REPORT_TYPES.ThematicReportThemeWiseIndex,
        reportCategory: "thematic",
        label: "Industry Theme Wise Analysis (Index)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.ThematicReportThemeWiseOnline,
          print: GRAPH_DATATYPE.ThematicReportThemeWisePrint,
          social: 3,
        },
        excludeGraphType: [
          BAR_HORIZONTAL,
          BAR_STACKED,

          AREA,
          LINE,
          TABLE,
          WORD_CLOUD,
          GENDER,
          CHOROPLETH,
          DOUGHNUT,
          INFLUENCERS,
          BAR_STACKED_EQUAL_HEIGHT,
        ],
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        entityKey: "entity_name",
        countKey: "articlecount",
      },
      {
        id: REPORT_TYPES.ThematicReportWithTopicArticle,
        value: REPORT_TYPES.ThematicReportWithTopicArticle,
        reportCategory: "thematic",
        label: "With Topics (Article)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.ThematicReportWithTopicOnline,
          print: GRAPH_DATATYPE.ThematicReportWithTopicPrint,
          social: 3,
        },
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          BAR_STACKED,

          AREA,
          LINE,
          WORD_CLOUD,
          GENDER,
          CHOROPLETH,
          DOUGHNUT,
          INFLUENCERS,
          BAR_STACKED_EQUAL_HEIGHT,
        ],
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        entityKey: "entity_name",
        countKey: "articlecount",
      },
      {
        id: REPORT_TYPES.ThematicReportWithTopicIndex,
        value: REPORT_TYPES.ThematicReportWithTopicIndex,
        reportCategory: "thematic",
        label: "With Topics (Index)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.ThematicReportWithTopicOnline,
          print: GRAPH_DATATYPE.ThematicReportWithTopicPrint,
          social: 3,
        },
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          BAR_STACKED,

          AREA,
          LINE,
          WORD_CLOUD,
          GENDER,
          CHOROPLETH,
          DOUGHNUT,
          INFLUENCERS,
          BAR_STACKED_EQUAL_HEIGHT,
        ],
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        entityKey: "entity_name",
        countKey: "articlecount",
      },
      {
        id: REPORT_TYPES.ThematicReportThemeWiseSpreadArticle,
        value: REPORT_TYPES.ThematicReportThemeWiseSpreadArticle,
        reportCategory: "thematic",
        label: "Theme Wise Spread (Article)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.ThematicReportThemeWiseSpreadOnline,
          print: GRAPH_DATATYPE.ThematicReportThemeWiseSpreadPrint,
          social: 3,
        },
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          BAR_STACKED,
          AREA,
          LINE,
          WORD_CLOUD,
          GENDER,
          CHOROPLETH,
          DOUGHNUT,
          INFLUENCERS,
        ],
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        entityKey: "entity_name",
        countKey: "articlecount",
      },
      {
        id: REPORT_TYPES.ThematicReportThemeWiseSpreadIndex,
        value: REPORT_TYPES.ThematicReportThemeWiseSpreadIndex,
        reportCategory: "thematic",
        label: "Theme Wise Spread (Index)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.ThematicReportThemeWiseSpreadOnline,
          print: GRAPH_DATATYPE.ThematicReportThemeWiseSpreadPrint,
          social: 3,
        },
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          BAR_STACKED,
          AREA,
          LINE,
          WORD_CLOUD,
          GENDER,
          CHOROPLETH,
          DOUGHNUT,
          INFLUENCERS,
        ],
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        entityKey: "entity_name",
        countKey: "articlecount",
      },
      {
        id: REPORT_TYPES.ThematicReportEntityWiseSpreadArticle,
        value: REPORT_TYPES.ThematicReportEntityWiseSpreadArticle,
        reportCategory: "thematic",
        label: "Enity Wise Spread (Article)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.ThematicReportEntityWiseSpreadOnline,
          print: GRAPH_DATATYPE.ThematicReportEntityWiseSpreadPrint,
          social: 3,
        },
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          BAR_STACKED,
          AREA,
          LINE,
          WORD_CLOUD,
          GENDER,
          CHOROPLETH,
          DOUGHNUT,
          INFLUENCERS,
        ],
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        entityKey: "entity_name",
        countKey: "articlecount",
      },
      {
        id: REPORT_TYPES.ThematicReportEntityWiseSpreadIndex,
        value: REPORT_TYPES.ThematicReportEntityWiseSpreadIndex,
        reportCategory: "thematic",
        label: "Enity Wise Spread (Index)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.ThematicReportEntityWiseSpreadOnline,
          print: GRAPH_DATATYPE.ThematicReportEntityWiseSpreadPrint,
          social: 3,
        },
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          BAR_STACKED,
          AREA,
          LINE,
          WORD_CLOUD,
          GENDER,
          CHOROPLETH,
          DOUGHNUT,
          INFLUENCERS,
        ],
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        entityKey: "entity_name",
        countKey: "articlecount",
      },
      {
        id: REPORT_TYPES.ThematicReportThemeWiseSpreadRanking,
        value: REPORT_TYPES.ThematicReportThemeWiseSpreadRanking,
        reportCategory: "thematic",
        label: "Theme Wise Spread (Rank)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.ThematicReportThemeWiseSpreadOnline,
          print: GRAPH_DATATYPE.ThematicReportThemeWiseSpreadPrint,
          social: 3,
        },
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          BAR_STACKED,

          AREA,
          LINE,
          WORD_CLOUD,
          GENDER,
          CHOROPLETH,
          DOUGHNUT,
          INFLUENCERS,
          BAR_STACKED_EQUAL_HEIGHT,
        ],
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        entityKey: "entity_name",
        countKey: "articlecount",
      },

      //Geo Qualitative
      {
        id: REPORT_TYPES.GeolocationZonalSpreadArticle,
        value: REPORT_TYPES.GeolocationZonalSpreadArticle,
        reportCategory: "geolocation",
        label: "Zonal Spread (Article)",
        enablePrint: true,
        enableOnline: false,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.GeolocationZonalSpread,
          print: GRAPH_DATATYPE.GeolocationZonalSpread,
          social: 3,
        },
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          BAR_STACKED,
          AREA,
          LINE,
          TABLE,
          WORD_CLOUD,
          GENDER,
          CHOROPLETH,
          DOUGHNUT,
          INFLUENCERS,
          BAR_STACKED_EQUAL_HEIGHT,
        ],
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        entityKey: "entity_name",
        countKey: "articlecount",
      },
      {
        id: REPORT_TYPES.GeolocationZonalSpreadIndex,
        value: REPORT_TYPES.GeolocationZonalSpreadIndex,
        reportCategory: "geolocation",
        label: "Zonal Spread - Industry (Index)",
        enablePrint: true,
        enableOnline: false,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.GeolocationZonalSpreadIndex,
          print: GRAPH_DATATYPE.GeolocationZonalSpreadIndex,
          social: 3,
        },
        excludeGraphType: [
          BAR_HORIZONTAL,

          BAR_STACKED,
          AREA,
          LINE,
          TABLE,
          WORD_CLOUD,
          GENDER,
          CHOROPLETH,
          DOUGHNUT,
          INFLUENCERS,
          BAR_STACKED_EQUAL_HEIGHT,
        ],
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        entityKey: "entity_name",
        countKey: "articlecount",
      },
      {
        id: REPORT_TYPES.GeolocationZonalSpreadIndexEntityWise,
        value: REPORT_TYPES.GeolocationZonalSpreadIndexEntityWise,
        reportCategory: "geolocation",
        label: "Zonal Spread - Entity Wise (Index)",
        enablePrint: true,
        enableOnline: false,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.GeolocationZonalSpreadIndexEntityWise,
          print: GRAPH_DATATYPE.GeolocationZonalSpreadIndexEntityWise,
          social: 3,
        },
        excludeGraphType: [
          BAR_HORIZONTAL,

          BAR_STACKED,
          AREA,
          LINE,
          TABLE,
          WORD_CLOUD,
          GENDER,
          CHOROPLETH,
          DOUGHNUT,
          INFLUENCERS,
          BAR_STACKED_EQUAL_HEIGHT,
        ],
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        entityKey: "entity_name",
        countKey: "articlecount",
      },
      {
        id: REPORT_TYPES.GeolocationZoneWiseArticle,
        value: REPORT_TYPES.GeolocationZoneWiseArticle,
        reportCategory: "geolocation",
        label: "Zone Wise (Article)",
        enablePrint: true,
        enableOnline: false,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.GeolocationZoneWiseArticle,
          print: GRAPH_DATATYPE.GeolocationZoneWiseArticle,
          social: 3,
        },
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          BAR_STACKED,
          AREA,
          LINE,
          TABLE,
          WORD_CLOUD,
          GENDER,
          CHOROPLETH,
          DOUGHNUT,
          INFLUENCERS,
          BAR_STACKED_EQUAL_HEIGHT,
        ],
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        entityKey: "entity_name",
        countKey: "articlecount",
      },
      {
        id: REPORT_TYPES.GeolocationZoneWiseTopPublication,
        value: REPORT_TYPES.GeolocationZoneWiseTopPublication,
        reportCategory: "geolocation",
        label: "Zone Wise Top Publication",
        enablePrint: true,
        enableOnline: false,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.GeolocationZoneWiseTopPublication,
          print: GRAPH_DATATYPE.GeolocationZoneWiseTopPublication,
          social: 3,
        },
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          BAR_STACKED,

          AREA,
          LINE,
          WORD_CLOUD,
          GENDER,
          CHOROPLETH,
          DOUGHNUT,
          INFLUENCERS,
        ],
        entityKey: "entity_name",
        countKey: "article_count",
      },
      {
        id: REPORT_TYPES.GeolocationZoneWiseSOVIndex,
        value: REPORT_TYPES.GeolocationZoneWiseSOVIndex,
        reportCategory: "geolocation",
        label: "Zone Wise SOV (Index)",
        enablePrint: true,
        enableOnline: false,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.GeolocationZoneWiseSOVIndex,
          print: GRAPH_DATATYPE.GeolocationZoneWiseSOVIndex,
          social: 3,
        },
        excludeGraphType: [
          TABLE,
          PIE,
          BAR_HORIZONTAL,
          BAR_STACKED,
          AREA,
          LINE,
          WORD_CLOUD,
          GENDER,
          CHOROPLETH,
          DOUGHNUT,
          INFLUENCERS,
          BAR_STACKED_EQUAL_HEIGHT,
        ],
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        entityKey: "entity_name",
        countKey: "articlecount",
      },
      {
        id: REPORT_TYPES.GeolocationMarketSpread,
        value: REPORT_TYPES.GeolocationMarketSpread,
        reportCategory: "geolocation",
        label: "Market Spread",
        enablePrint: true,
        enableOnline: false,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.GeolocationMarketSpread,
          print: GRAPH_DATATYPE.GeolocationMarketSpread,
          social: 3,
        },
        excludeGraphType: [

          PIE,
          BAR_HORIZONTAL,
          BAR_STACKED,
          AREA,
          LINE,
          WORD_CLOUD,
          GENDER,
          CHOROPLETH,
          DOUGHNUT,
          INFLUENCERS,
          BAR_STACKED_EQUAL_HEIGHT,
        ],
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        entityKey: "entity_name",
        countKey: "articlecount",
      },
      {
        id: REPORT_TYPES.GeolocationCityWiseArticle,
        value: REPORT_TYPES.GeolocationCityWiseArticle,
        reportCategory: "geolocation",
        label: "City Wise (Article)",
        enablePrint: true,
        enableOnline: false,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.GeolocationCityWiseArticle,
          print: GRAPH_DATATYPE.GeolocationCityWiseArticle,
          social: 3,
        },
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          BAR_STACKED,
          AREA,
          LINE,
          TABLE,
          WORD_CLOUD,
          GENDER,
          CHOROPLETH,
          DOUGHNUT,
          INFLUENCERS,
          BAR_STACKED_EQUAL_HEIGHT,
        ],
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        entityKey: "entity_name",
        countKey: "articlecount",
      },
      {
        id: REPORT_TYPES.GeolocationCityWiseTopPublication,
        value: REPORT_TYPES.GeolocationCityWiseTopPublication,
        reportCategory: "geolocation",
        label: "City Wise Top Publication",
        enablePrint: true,
        enableOnline: false,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.GeolocationCityWiseTopPublication,
          print: GRAPH_DATATYPE.GeolocationCityWiseTopPublication,
          social: 3,
        },
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          BAR_STACKED,
          AREA,
          LINE,
          TABLE,
          WORD_CLOUD,
          GENDER,
          CHOROPLETH,
          DOUGHNUT,
          INFLUENCERS,
          BAR_STACKED_EQUAL_HEIGHT,
        ],
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        entityKey: "entity_name",
        countKey: "articlecount",
      },
      {
        id: REPORT_TYPES.GeolocationCityWiseSOVIndex,
        value: REPORT_TYPES.GeolocationCityWiseSOVIndex,
        reportCategory: "geolocation",
        label: "City Wise SOV (Index)",
        enablePrint: true,
        enableOnline: false,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.GeolocationCityWiseSOVIndex,
          print: GRAPH_DATATYPE.GeolocationCityWiseSOVIndex,
          social: 3,
        },
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          BAR_STACKED,
          AREA,
          LINE,
          TABLE,
          WORD_CLOUD,
          GENDER,
          CHOROPLETH,
          DOUGHNUT,
          INFLUENCERS,
          BAR_STACKED_EQUAL_HEIGHT,
        ],
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        entityKey: "entity_name",
        countKey: "articlecount",
      },
      //Qualitative geolocation ends

      //Journalist Qualitative
      {
        id: REPORT_TYPES.JournalistReportIndex,
        value: REPORT_TYPES.JournalistReportIndex,
        reportCategory: "journalist",
        label: "Journalist By Index",
        enablePrint: true,
        enableOnline: true,
        enableSocial: true,
        graphDataType: {
          online: GRAPH_DATATYPE.JournalistReportIndexOnline,
          print: GRAPH_DATATYPE.JournalistReportIndexPrint,
          social: 1,
        },
        verticalList: [V_ONLINE, V_PRINT, V_SOCIAL, V_BLOG, V_FORUM],
        groupByField: "entity_name",
        excludeGraphType: [
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          BAR_STACKED_EQUAL_HEIGHT,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "indexPerc",
      },
      {
        id: REPORT_TYPES.JournalistReportArticle,
        value: REPORT_TYPES.JournalistReportArticle,
        reportCategory: "journalist",
        label: "Journalist By Articles",
        enablePrint: true,
        enableOnline: true,
        enableSocial: true,
        graphDataType: {
          online: GRAPH_DATATYPE.JournalistReportArticleOnline,
          print: GRAPH_DATATYPE.JournalistReportArticlePrint,
          social: 1,
        },
        verticalList: [V_ONLINE, V_PRINT, V_SOCIAL, V_BLOG, V_FORUM],
        groupByField: "entity_name",
        excludeGraphType: [
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          BAR_STACKED_EQUAL_HEIGHT,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "article_count",
      },
      {
        id: REPORT_TYPES.JournalistSentiment,
        value: REPORT_TYPES.JournalistSentiment,
        reportCategory: "JournalistSentiment",
        label: "Top 20 Journalist Sentiment - No of article",
        enablePrint: true,
        enableOnline: true,
        enableSocial: true,
        graphDataType: {
          online: GRAPH_DATATYPE.JournalistSentiment,
          print: GRAPH_DATATYPE.JournalistSentiment,
          social: 3,
        },
        verticalList: [V_ONLINE, V_PRINT, V_SOCIAL, V_BLOG, V_FORUM],
        groupByField: "entity_name",
        excludeGraphType: [
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        entityKey: "entity_name",
        countKey: "articlecount",
      },
      //Qualitative Journalist end

      //Qualitative Sentiment start

      {
        id: REPORT_TYPES.SentimentReportIndex,
        value: REPORT_TYPES.SentimentReportIndex,
        reportCategory: "sentiment",
        label: "Competition - Sentiment Analysis – Index​",
        enablePrint: true,
        enableOnline: true,
        enableSocial: true,
        graphDataType: {
          online: GRAPH_DATATYPE.SentimentReportIndexOnline,
          print: GRAPH_DATATYPE.SentimentReportIndexPrint,
          social: 1,
        },
        verticalList: [V_ONLINE, V_PRINT, V_SOCIAL, V_BLOG, V_FORUM],
        groupByField: "entity_name",
        excludeGraphType: [
          BAR_HORIZONTAL,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
          PIE
        ],
        entityKey: "entity_name",
        countKey: "total",
      },
      {
        id: REPORT_TYPES.SentimentReportArticle,
        value: REPORT_TYPES.SentimentReportArticle,
        reportCategory: "sentiment",
        label: "Competition - Sentiment Analysis – Article",
        enablePrint: true,
        enableOnline: true,
        enableSocial: true,
        graphDataType: {
          online: GRAPH_DATATYPE.SentimentReportArticleOnline,
          print: GRAPH_DATATYPE.SentimentReportArticlePrint,
          social: 1,
        },
        verticalList: [V_ONLINE, V_PRINT, V_SOCIAL, V_BLOG, V_FORUM],
        groupByField: "entity_name",
        excludeGraphType: [
          BAR_HORIZONTAL,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
          PIE
        ],
        entityKey: "entity_name",
        countKey: "articlecnt",
      },
      {
        id: REPORT_TYPES.SentimentGenreIndex,
        value: REPORT_TYPES.SentimentGenreIndex,
        reportCategory: "sentiment",
        label: "Genre Wise - Sentiment Analysis – Index​",
        enablePrint: true,
        enableOnline: true,
        enableSocial: true,
        graphDataType: {
          online: GRAPH_DATATYPE.SentimentGenreIndexOnline,
          print: GRAPH_DATATYPE.SentimentGenreIndexPrint,
          social: 1,
        },
        verticalList: [V_ONLINE, V_PRINT, V_SOCIAL, V_BLOG, V_FORUM],
        groupByField: "entity_name",
        excludeGraphType: [
          BAR_HORIZONTAL,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
          PIE
        ],
        entityKey: "entity_name",
        countKey: "total",
      },
      {
        id: REPORT_TYPES.SentimentGenreArticle,
        value: REPORT_TYPES.SentimentGenreArticle,
        reportCategory: "sentiment",
        label: "Genre Wise - Sentiment Analysis – Article",
        enablePrint: true,
        enableOnline: true,
        enableSocial: true,
        graphDataType: {
          online: GRAPH_DATATYPE.SentimentGenreArticleOnline,
          print: GRAPH_DATATYPE.SentimentGenreArticlePrint,
          social: 1,
        },
        verticalList: [V_ONLINE, V_PRINT, V_SOCIAL, V_BLOG, V_FORUM],
        groupByField: "entity_name",
        excludeGraphType: [
          BAR_HORIZONTAL,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
          PIE
        ],
        entityKey: "entity_name",
        countKey: "articlecnt",
      },
      {
        id: REPORT_TYPES.SENTIMENTTABLEINDEX,
        value: REPORT_TYPES.SENTIMENTTABLEINDEX,
        reportCategory: "sentimentTable",
        label: "Competition - Sentiment Analysis – Index​",
        enablePrint: false,
        enableOnline: false,
        enableSocial: true,
        graphDataType: {
          online: GRAPH_DATATYPE.SentimentTableIndex,
          print: GRAPH_DATATYPE.SentimentTableIndex,
          social: 1
        },
        excludeGraphType: [

        ],
        verticalList: [],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SENTIMENTTABLEARTICLE,
        value: REPORT_TYPES.SENTIMENTTABLEARTICLE,
        reportCategory: "sentimentTable",
        label: "Competition - Sentiment Analysis – Article",
        enablePrint: false,
        enableOnline: false,
        enableSocial: true,
        graphDataType: {
          online: GRAPH_DATATYPE.SentimentTableArticle,
          print: GRAPH_DATATYPE.SentimentTableArticle,
          social: 1
        },
        excludeGraphType: [

        ],
        verticalList: [],
        entityKey: "entity_name",
        countKey: "totarticleperctage",
      },
      //sentiment ends

      //keyword qualitative starts
      {
        id: REPORT_TYPES.KeywordReportIndex,
        value: REPORT_TYPES.KeywordReportIndex,
        reportCategory: "keyword",
        label: "Keyword (Index)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.KeywordReportIndexOnline,
          print: GRAPH_DATATYPE.KeywordReportIndexPrint,
          social: 3,
        },
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          BAR_STACKED,
          AREA,
          TABLE,
          WORD_CLOUD,
          GENDER,
          CHOROPLETH,
          DOUGHNUT,
          INFLUENCERS,
          BAR_STACKED_EQUAL_HEIGHT,
        ],
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        entityKey: "entity_name",
        countKey: "articlecount",
      },
      {
        id: REPORT_TYPES.KeywordReportArticle,
        value: REPORT_TYPES.KeywordReportArticle,
        reportCategory: "keyword",
        label: "Keyword (Article)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.KeywordReportIndexOnline,
          print: GRAPH_DATATYPE.KeywordReportIndexPrint,
          social: 3,
        },
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          BAR_STACKED,
          AREA,
          TABLE,
          WORD_CLOUD,
          GENDER,
          CHOROPLETH,
          DOUGHNUT,
          INFLUENCERS,
          BAR_STACKED_EQUAL_HEIGHT,
        ],
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        entityKey: "entity_name",
        countKey: "articlecount",
      },
      {
        id: REPORT_TYPES.KeywordReportTrendIndex,
        value: REPORT_TYPES.KeywordReportTrendIndex,
        reportCategory: "keyword",
        label: "Keyword Trend (Index)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.KeywordReportTrendOnline,
          print: GRAPH_DATATYPE.KeywordReportTrendPrint,
          social: 3,
        },
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          BAR_STACKED,
          AREA,
          TABLE,
          WORD_CLOUD,
          GENDER,
          CHOROPLETH,
          DOUGHNUT,
          INFLUENCERS,
          BAR_STACKED_EQUAL_HEIGHT,
        ],
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        entityKey: "entity_name",
        countKey: "articlecount",
      },
      {
        id: REPORT_TYPES.KeywordReportTrendArticle,
        value: REPORT_TYPES.KeywordReportTrendArticle,
        reportCategory: "keyword",
        label: "Keyword Trend (Article)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.KeywordReportTrendOnline,
          print: GRAPH_DATATYPE.KeywordReportTrendPrint,
          social: 3,
        },
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          BAR_STACKED,
          AREA,
          TABLE,
          WORD_CLOUD,
          GENDER,
          CHOROPLETH,
          DOUGHNUT,
          INFLUENCERS,
          BAR_STACKED_EQUAL_HEIGHT,
        ],
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        entityKey: "entity_name",
        countKey: "articlecount",
      },
      {
        id: REPORT_TYPES.KeywordReportSentimentIndex,
        value: REPORT_TYPES.KeywordReportSentimentIndex,
        reportCategory: "keyword",
        label: "Keyword Sentiment (Index)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.KeywordReportSentimentOnline,
          print: GRAPH_DATATYPE.KeywordReportSentimentPrint,
          social: 3,
        },
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          BAR_STACKED,
          AREA,
          TABLE,
          WORD_CLOUD,
          GENDER,
          CHOROPLETH,
          DOUGHNUT,
          INFLUENCERS,
          BAR_STACKED_EQUAL_HEIGHT,
        ],
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        entityKey: "entity_name",
        countKey: "articlecount",
      },
      {
        id: REPORT_TYPES.KeywordReportSentimentArticle,
        value: REPORT_TYPES.KeywordReportSentimentArticle,
        reportCategory: "keyword",
        label: "Keyword Sentiment (Article)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.KeywordReportSentimentOnline,
          print: GRAPH_DATATYPE.KeywordReportSentimentPrint,
          social: 3,
        },
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          BAR_STACKED,
          AREA,
          TABLE,
          WORD_CLOUD,
          GENDER,
          CHOROPLETH,
          DOUGHNUT,
          INFLUENCERS,
          BAR_STACKED_EQUAL_HEIGHT,
        ],
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        entityKey: "entity_name",
        countKey: "articlecount",
      },

      //keyword qualitative ends



      // qualatative spokesperson
      {
        id: REPORT_TYPES.SPOKESPERSONARTICLE,
        value: REPORT_TYPES.SPOKESPERSONARTICLE,
        reportCategory: "spokesperson",
        label: "Top 10 Spokespersons– Tata Motors & Competitors​",
        enablePrint: false,
        enableOnline: false,
        enableSocial: true,
        graphDataType: {
          online: GRAPH_DATATYPE.SpokesPersonReportArticle,
          print: GRAPH_DATATYPE.SpokesPersonReportArticle,
          social: 1
        },
        excludeGraphType: [
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        verticalList: [],
        entityKey: "entity_name",
        countKey: "article_count",
      },
      {
        id: REPORT_TYPES.SPOKESPERSONINDEX,
        value: REPORT_TYPES.SPOKESPERSONINDEX,
        reportCategory: "spokesperson",
        label: "Top 10 Spokespersons– Tata Motors & Competitors",
        enablePrint: false,
        enableOnline: false,
        enableSocial: true,
        graphDataType: {
          online: GRAPH_DATATYPE.SpokesPersonReportIndex,
          print: GRAPH_DATATYPE.SpokesPersonReportIndex,
          social: 1
        },
        excludeGraphType: [
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        verticalList: [],
        entityKey: "entity_name",
        countKey: "index",
      },


      // sentiment inline starts

      //sentiment - Entity - Trend
      {
        id: REPORT_TYPES.SentimentEntityTrendIndex,
        value: REPORT_TYPES.SentimentEntityTrendIndex,
        reportCategory: REPORT_CATEGORIES.SENTIMENT,
        label: "Sentiment By Trend - Entity (Index)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SentimentEntityTrendOnline,
          print: GRAPH_DATATYPE.SentimentEntityTrendPrint,
          printandonline: GRAPH_DATATYPE.SentimentEntityTrendPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,
          BAR_STACKED_EQUAL_HEIGHT,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SentimentEntityTrendNOA,
        value: REPORT_TYPES.SentimentEntityTrendNOA,
        reportCategory: REPORT_CATEGORIES.SENTIMENT,
        label: "Sentiment By Trend - Entity (No. Of Article)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SentimentEntityTrendOnline,
          print: GRAPH_DATATYPE.SentimentEntityTrendPrint,
          printandonline: GRAPH_DATATYPE.SentimentEntityTrendPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,
          BAR_STACKED_EQUAL_HEIGHT,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SentimentEntityTrendCCM,
        value: REPORT_TYPES.SentimentEntityTrendCCM,
        reportCategory: REPORT_CATEGORIES.SENTIMENT,
        label: "Sentiment By Trend - Entity (CCM)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SentimentEntityTrendOnline,
          print: GRAPH_DATATYPE.SentimentEntityTrendPrint,
          printandonline: GRAPH_DATATYPE.SentimentEntityTrendPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,
          BAR_STACKED_EQUAL_HEIGHT,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SentimentEntityTrendMAV,
        value: REPORT_TYPES.SentimentEntityTrendMAV,
        reportCategory: REPORT_CATEGORIES.SENTIMENT,
        label: "Sentiment By Trend - Entity (MAV)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SentimentEntityTrendOnline,
          print: GRAPH_DATATYPE.SentimentEntityTrendPrint,
          printandonline: GRAPH_DATATYPE.SentimentEntityTrendPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,
          BAR_STACKED_EQUAL_HEIGHT,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SentimentEntityTrendReach,
        value: REPORT_TYPES.SentimentEntityTrendReach,
        reportCategory: REPORT_CATEGORIES.SENTIMENT,
        label: "Sentiment By Trend - Entity (Reach)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SentimentEntityTrendOnline,
          print: GRAPH_DATATYPE.SentimentEntityTrendPrint,
          printandonline: GRAPH_DATATYPE.SentimentEntityTrendPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,
          BAR_STACKED_EQUAL_HEIGHT,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SentimentEntityTrendWordCount,
        value: REPORT_TYPES.SentimentEntityTrendWordCount,
        reportCategory: REPORT_CATEGORIES.SENTIMENT,
        label: "Sentiment By Trend - Entity (Word Count)",
        enablePrint: false,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SentimentEntityTrendOnline,
          printandonline: GRAPH_DATATYPE.SentimentEntityTrendPrintOnline,
        },
        verticalList: [V_ONLINE],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,
          BAR_STACKED_EQUAL_HEIGHT,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },


      //sentiment all sentiment for entity

      {
        id: REPORT_TYPES.SentimentNewEntitySOVIndex,
        value: REPORT_TYPES.SentimentNewEntitySOVIndex,
        reportCategory: REPORT_CATEGORIES.SENTIMENT,
        label: "Sentiment as-per Entity (Index)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SentimentNewEntitySOVOnline,
          print: GRAPH_DATATYPE.SentimentNewEntitySOVPrint,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SentimentNewEntitySOVNOA,
        value: REPORT_TYPES.SentimentNewEntitySOVNOA,
        reportCategory: REPORT_CATEGORIES.SENTIMENT,
        label: "Sentiment as-per Entity (No. Of Article)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SentimentNewEntitySOVOnline,
          print: GRAPH_DATATYPE.SentimentNewEntitySOVPrint,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SentimentNewEntitySOVCCM,
        value: REPORT_TYPES.SentimentNewEntitySOVCCM,
        reportCategory: REPORT_CATEGORIES.SENTIMENT,
        label: "Sentiment as-per Entity (CCM)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SentimentNewEntitySOVOnline,
          print: GRAPH_DATATYPE.SentimentNewEntitySOVPrint,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SentimentNewEntitySOVMAV,
        value: REPORT_TYPES.SentimentNewEntitySOVMAV,
        reportCategory: REPORT_CATEGORIES.SENTIMENT,
        label: "Sentiment as-per Entity (MAV)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SentimentNewEntitySOVOnline,
          print: GRAPH_DATATYPE.SentimentNewEntitySOVPrint,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SentimentNewEntitySOVReach,
        value: REPORT_TYPES.SentimentNewEntitySOVReach,
        reportCategory: REPORT_CATEGORIES.SENTIMENT,
        label: "Sentiment as-per Entity (Reach)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SentimentNewEntitySOVOnline,
          print: GRAPH_DATATYPE.SentimentNewEntitySOVPrint,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SentimentNewEntitySOVWordCount,
        value: REPORT_TYPES.SentimentNewEntitySOVWordCount,
        reportCategory: REPORT_CATEGORIES.SENTIMENT,
        label: "Sentiment as-per Entity (Word Count)",
        enablePrint: false,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SentimentNewEntitySOVOnline,
        },
        verticalList: [V_ONLINE],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },

      // sentiment - Enitity - SOV



      {
        id: REPORT_TYPES.SentimentEntitySOVIndex,
        value: REPORT_TYPES.SentimentEntitySOVIndex,
        reportCategory: REPORT_CATEGORIES.SENTIMENT,
        label: "Sentiment By SOV - Entity (Index)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SentimentEntitySOVOnline,
          print: GRAPH_DATATYPE.SentimentEntitySOVPrint,
          printandonline: GRAPH_DATATYPE.SentimentEntitySOVPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          BAR_STACKED_EQUAL_HEIGHT,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SentimentEntitySOVNOA,
        value: REPORT_TYPES.SentimentEntitySOVNOA,
        reportCategory: REPORT_CATEGORIES.SENTIMENT,
        label: "Sentiment By SOV - Entity (No. Of Article)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SentimentEntitySOVOnline,
          print: GRAPH_DATATYPE.SentimentEntitySOVPrint,
          printandonline: GRAPH_DATATYPE.SentimentEntitySOVPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          BAR_STACKED_EQUAL_HEIGHT,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SentimentEntitySOVCCM,
        value: REPORT_TYPES.SentimentEntitySOVCCM,
        reportCategory: REPORT_CATEGORIES.SENTIMENT,
        label: "Sentiment By SOV - Entity (CCM)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SentimentEntitySOVOnline,
          print: GRAPH_DATATYPE.SentimentEntitySOVPrint,
          printandonline: GRAPH_DATATYPE.SentimentEntitySOVPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          BAR_STACKED_EQUAL_HEIGHT,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SentimentEntitySOVMAV,
        value: REPORT_TYPES.SentimentEntitySOVMAV,
        reportCategory: REPORT_CATEGORIES.SENTIMENT,
        label: "Sentiment By SOV - Entity (MAV)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SentimentEntitySOVOnline,
          print: GRAPH_DATATYPE.SentimentEntitySOVPrint,
          printandonline: GRAPH_DATATYPE.SentimentEntitySOVPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          BAR_STACKED_EQUAL_HEIGHT,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SentimentEntitySOVReach,
        value: REPORT_TYPES.SentimentEntitySOVReach,
        reportCategory: REPORT_CATEGORIES.SENTIMENT,
        label: "Sentiment By SOV - Entity (Reach)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SentimentEntitySOVOnline,
          print: GRAPH_DATATYPE.SentimentEntitySOVPrint,
          printandonline: GRAPH_DATATYPE.SentimentEntitySOVPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          BAR_STACKED_EQUAL_HEIGHT,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SentimentEntitySOVWordCount,
        value: REPORT_TYPES.SentimentEntitySOVWordCount,
        reportCategory: REPORT_CATEGORIES.SENTIMENT,
        label: "Sentiment By SOV - Entity (Word Count)",
        enablePrint: false,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SentimentEntitySOVOnline,
          printandonline: GRAPH_DATATYPE.SentimentEntitySOVPrintOnline,
        },
        verticalList: [V_ONLINE],
        groupByField: "entity_name",
        excludeGraphType: [
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          BAR_STACKED_EQUAL_HEIGHT,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },





      //sentiment - Journalist - Trend
      {
        id: REPORT_TYPES.SentimentJournalistTrendIndex,
        value: REPORT_TYPES.SentimentJournalistTrendIndex,
        reportCategory: REPORT_CATEGORIES.SENTIMENT,
        label: "Sentiment By Trend - Journalist (Index)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SentimentJournalistTrendOnline,
          print: GRAPH_DATATYPE.SentimentJournalistTrendPrint,
          printandonline: GRAPH_DATATYPE.SentimentJournalistTrendPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,
          BAR_STACKED_EQUAL_HEIGHT,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SentimentJournalistTrendNOA,
        value: REPORT_TYPES.SentimentJournalistTrendNOA,
        reportCategory: REPORT_CATEGORIES.SENTIMENT,
        label: "Sentiment By Trend - Journalist (No. Of Article)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SentimentJournalistTrendOnline,
          print: GRAPH_DATATYPE.SentimentJournalistTrendPrint,
          printandonline: GRAPH_DATATYPE.SentimentJournalistTrendPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,
          BAR_STACKED_EQUAL_HEIGHT,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SentimentJournalistTrendCCM,
        value: REPORT_TYPES.SentimentJournalistTrendCCM,
        reportCategory: REPORT_CATEGORIES.SENTIMENT,
        label: "Sentiment By Trend - Journalist (CCM)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SentimentJournalistTrendOnline,
          print: GRAPH_DATATYPE.SentimentJournalistTrendPrint,
          printandonline: GRAPH_DATATYPE.SentimentJournalistTrendPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,
          BAR_STACKED_EQUAL_HEIGHT,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SentimentJournalistTrendMAV,
        value: REPORT_TYPES.SentimentJournalistTrendMAV,
        reportCategory: REPORT_CATEGORIES.SENTIMENT,
        label: "Sentiment By Trend - Journalist (MAV)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SentimentJournalistTrendOnline,
          print: GRAPH_DATATYPE.SentimentJournalistTrendPrint,
          printandonline: GRAPH_DATATYPE.SentimentJournalistTrendPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,
          BAR_STACKED_EQUAL_HEIGHT,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SentimentJournalistTrendReach,
        value: REPORT_TYPES.SentimentJournalistTrendReach,
        reportCategory: REPORT_CATEGORIES.SENTIMENT,
        label: "Sentiment By Trend - Journalist (Reach)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SentimentJournalistTrendOnline,
          print: GRAPH_DATATYPE.SentimentJournalistTrendPrint,
          printandonline: GRAPH_DATATYPE.SentimentJournalistTrendPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,
          BAR_STACKED_EQUAL_HEIGHT,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SentimentJournalistTrendWordCount,
        value: REPORT_TYPES.SentimentJournalistTrendWordCount,
        reportCategory: REPORT_CATEGORIES.SENTIMENT,
        label: "Sentiment By Trend - Journalist (Word Count)",
        enablePrint: false,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SentimentJournalistTrendOnline,
          printandonline: GRAPH_DATATYPE.SentimentJournalistTrendPrintOnline,
        },
        verticalList: [V_ONLINE],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,
          BAR_STACKED_EQUAL_HEIGHT,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },

      //SENTIMENT - Publication - SOV
      {
        id: REPORT_TYPES.SentimentPublicationSOVIndex,
        value: REPORT_TYPES.SentimentPublicationSOVIndex,
        reportCategory: REPORT_CATEGORIES.SENTIMENT,
        label: "Sentiment By SOV - Publication (Index)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SentimentPublicationSOVOnline,
          print: GRAPH_DATATYPE.SentimentPublicationSOVPrint,
          printandonline: GRAPH_DATATYPE.SentimentPublicationSOVPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT_AND_ONLINE],
        groupByField: "entity_name",
        excludeGraphType: [

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SentimentPublicationSOVNOA,
        value: REPORT_TYPES.SentimentPublicationSOVNOA,
        reportCategory: REPORT_CATEGORIES.SENTIMENT,
        label: "Sentiment By SOV - Publication (No. Of Article)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SentimentPublicationSOVOnline,
          print: GRAPH_DATATYPE.SentimentPublicationSOVPrint,
          printandonline: GRAPH_DATATYPE.SentimentPublicationSOVPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SentimentPublicationSOVCCM,
        value: REPORT_TYPES.SentimentPublicationSOVCCM,
        reportCategory: REPORT_CATEGORIES.SENTIMENT,
        label: "Sentiment By SOV - Publication (CCM)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SentimentPublicationSOVOnline,
          print: GRAPH_DATATYPE.SentimentPublicationSOVPrint,
          printandonline: GRAPH_DATATYPE.SentimentPublicationSOVPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SentimentPublicationSOVMAV,
        value: REPORT_TYPES.SentimentPublicationSOVMAV,
        reportCategory: REPORT_CATEGORIES.SENTIMENT,
        label: "Sentiment By SOV - Publication (MAV)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SentimentPublicationSOVOnline,
          print: GRAPH_DATATYPE.SentimentPublicationSOVPrint,
          printandonline: GRAPH_DATATYPE.SentimentPublicationSOVPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SentimentPublicationSOVReach,
        value: REPORT_TYPES.SentimentPublicationSOVReach,
        reportCategory: REPORT_CATEGORIES.SENTIMENT,
        label: "Sentiment By SOV - Publication (Reach)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SentimentPublicationSOVOnline,
          print: GRAPH_DATATYPE.SentimentPublicationSOVPrint,
          printandonline: GRAPH_DATATYPE.SentimentPublicationSOVPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SentimentPublicationSOVWordCount,
        value: REPORT_TYPES.SentimentPublicationSOVWordCount,
        reportCategory: REPORT_CATEGORIES.SENTIMENT,
        label: "Sentiment By SOV - Publication (Word Count)",
        enablePrint: false,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SentimentPublicationSOVOnline,
          printandonline: GRAPH_DATATYPE.SentimentPublicationSOVPrintOnline,
        },
        verticalList: [V_ONLINE],
        groupByField: "entity_name",
        excludeGraphType: [

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      //SENTIMENT - Publication - Trend
      {
        id: REPORT_TYPES.SentimentPublicationTrendIndex,
        value: REPORT_TYPES.SentimentPublicationTrendIndex,
        reportCategory: REPORT_CATEGORIES.SENTIMENT,
        label: "Sentiment By Trend - Publication (Index)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SentimentPublicationTrendOnline,
          print: GRAPH_DATATYPE.SentimentPublicationTrendPrint,
          printandonline: GRAPH_DATATYPE.SentimentPublicationTrendPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,
          BAR_STACKED_EQUAL_HEIGHT,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SentimentPublicationTrendNOA,
        value: REPORT_TYPES.SentimentPublicationTrendNOA,
        reportCategory: REPORT_CATEGORIES.SENTIMENT,
        label: "Sentiment By Trend - Publication (No. Of Article)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SentimentPublicationTrendOnline,
          print: GRAPH_DATATYPE.SentimentPublicationTrendPrint,
          printandonline: GRAPH_DATATYPE.SentimentPublicationTrendPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,
          BAR_STACKED_EQUAL_HEIGHT,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SentimentPublicationTrendCCM,
        value: REPORT_TYPES.SentimentPublicationTrendCCM,
        reportCategory: REPORT_CATEGORIES.SENTIMENT,
        label: "Sentiment By Trend - Publication (CCM)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SentimentPublicationTrendOnline,
          print: GRAPH_DATATYPE.SentimentPublicationTrendPrint,
          printandonline: GRAPH_DATATYPE.SentimentPublicationTrendPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,
          BAR_STACKED_EQUAL_HEIGHT,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SentimentPublicationTrendMAV,
        value: REPORT_TYPES.SentimentPublicationTrendMAV,
        reportCategory: REPORT_CATEGORIES.SENTIMENT,
        label: "Sentiment By Trend - Publication (MAV)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SentimentPublicationTrendOnline,
          print: GRAPH_DATATYPE.SentimentPublicationTrendPrint,
          printandonline: GRAPH_DATATYPE.SentimentPublicationTrendPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,
          BAR_STACKED_EQUAL_HEIGHT,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SentimentPublicationTrendReach,
        value: REPORT_TYPES.SentimentPublicationTrendReach,
        reportCategory: REPORT_CATEGORIES.SENTIMENT,
        label: "Sentiment By Trend - Publication (Reach)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SentimentPublicationTrendOnline,
          print: GRAPH_DATATYPE.SentimentPublicationTrendPrint,
          printandonline: GRAPH_DATATYPE.SentimentPublicationTrendPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,
          BAR_STACKED_EQUAL_HEIGHT,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SentimentPublicationTrendWordCount,
        value: REPORT_TYPES.SentimentPublicationTrendWordCount,
        reportCategory: REPORT_CATEGORIES.SENTIMENT,
        label: "Sentiment By Trend - Publication (Word Count)",
        enablePrint: false,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SentimentPublicationTrendOnline,
          printandonline: GRAPH_DATATYPE.SentimentPublicationTrendPrintOnline,
        },
        verticalList: [V_ONLINE],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,
          BAR_STACKED_EQUAL_HEIGHT,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },



      // sentiment - Journalist - SOV

      {
        id: REPORT_TYPES.SentimentJournalistSOVIndex,
        value: REPORT_TYPES.SentimentJournalistSOVIndex,
        reportCategory: REPORT_CATEGORIES.SENTIMENT,
        label: "Sentiment By SOV - Journalist (Index)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SentimentJournalistSOVOnline,
          print: GRAPH_DATATYPE.SentimentJournalistSOVPrint,
          printandonline: GRAPH_DATATYPE.SentimentJournalistSOVPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SentimentJournalistSOVNOA,
        value: REPORT_TYPES.SentimentJournalistSOVNOA,
        reportCategory: REPORT_CATEGORIES.SENTIMENT,
        label: "Sentiment By SOV - Journalist (No. Of Article)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SentimentJournalistSOVOnline,
          print: GRAPH_DATATYPE.SentimentJournalistSOVPrint,
          printandonline: GRAPH_DATATYPE.SentimentJournalistSOVPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SentimentJournalistSOVCCM,
        value: REPORT_TYPES.SentimentJournalistSOVCCM,
        reportCategory: REPORT_CATEGORIES.SENTIMENT,
        label: "Sentiment By SOV - Journalist (CCM)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SentimentJournalistSOVOnline,
          print: GRAPH_DATATYPE.SentimentJournalistSOVPrint,
          printandonline: GRAPH_DATATYPE.SentimentJournalistSOVPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SentimentJournalistSOVMAV,
        value: REPORT_TYPES.SentimentJournalistSOVMAV,
        reportCategory: REPORT_CATEGORIES.SENTIMENT,
        label: "Sentiment By SOV - Journalist (MAV)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SentimentJournalistSOVOnline,
          print: GRAPH_DATATYPE.SentimentJournalistSOVPrint,
          printandonline: GRAPH_DATATYPE.SentimentJournalistSOVPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SentimentJournalistSOVReach,
        value: REPORT_TYPES.SentimentJournalistSOVReach,
        reportCategory: REPORT_CATEGORIES.SENTIMENT,
        label: "Sentiment By SOV - Journalist (Reach)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SentimentJournalistSOVOnline,
          print: GRAPH_DATATYPE.SentimentJournalistSOVPrint,
          printandonline: GRAPH_DATATYPE.SentimentJournalistSOVPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SentimentJournalistSOVWordCount,
        value: REPORT_TYPES.SentimentJournalistSOVWordCount,
        reportCategory: REPORT_CATEGORIES.SENTIMENT,
        label: "Sentiment By SOV - Journalist (Word Count)",
        enablePrint: false,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SentimentJournalistSOVOnline,
          printandonline: GRAPH_DATATYPE.SentimentJournalistSOVPrintOnline,
        },
        verticalList: [V_ONLINE],
        groupByField: "entity_name",
        excludeGraphType: [

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },


      //SENTIMENT - City - SOV
      {
        id: REPORT_TYPES.SentimentCitySOVIndex,
        value: REPORT_TYPES.SentimentCitySOVIndex,
        reportCategory: REPORT_CATEGORIES.SENTIMENT,
        label: "Sentiment By SOV - City (Index)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          print: GRAPH_DATATYPE.SentimentCitySOVPrint,
          printandonline: GRAPH_DATATYPE.SentimentCitySOVPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT_AND_ONLINE],
        groupByField: "entity_name",
        excludeGraphType: [

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SentimentCitySOVNOA,
        value: REPORT_TYPES.SentimentCitySOVNOA,
        reportCategory: REPORT_CATEGORIES.SENTIMENT,
        label: "Sentiment By SOV - City (No. Of Article)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          print: GRAPH_DATATYPE.SentimentCitySOVPrint,
          printandonline: GRAPH_DATATYPE.SentimentCitySOVPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SentimentCitySOVCCM,
        value: REPORT_TYPES.SentimentCitySOVCCM,
        reportCategory: REPORT_CATEGORIES.SENTIMENT,
        label: "Sentiment By SOV - City (CCM)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          print: GRAPH_DATATYPE.SentimentCitySOVPrint,
          printandonline: GRAPH_DATATYPE.SentimentCitySOVPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SentimentCitySOVMAV,
        value: REPORT_TYPES.SentimentCitySOVMAV,
        reportCategory: REPORT_CATEGORIES.SENTIMENT,
        label: "Sentiment By SOV - City (MAV)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          print: GRAPH_DATATYPE.SentimentCitySOVPrint,
          printandonline: GRAPH_DATATYPE.SentimentCitySOVPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SentimentCitySOVReach,
        value: REPORT_TYPES.SentimentCitySOVReach,
        reportCategory: REPORT_CATEGORIES.SENTIMENT,
        label: "Sentiment By SOV - City (Reach)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          print: GRAPH_DATATYPE.SentimentCitySOVPrint,
          printandonline: GRAPH_DATATYPE.SentimentCitySOVPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },

      //SENTIMENT - City - Trend
      {
        id: REPORT_TYPES.SentimentCityTrendIndex,
        value: REPORT_TYPES.SentimentCityTrendIndex,
        reportCategory: REPORT_CATEGORIES.SENTIMENT,
        label: "Sentiment By Trend - City (Index)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          print: GRAPH_DATATYPE.SentimentCityTrendPrint,
          printandonline: GRAPH_DATATYPE.SentimentCityTrendPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,
          BAR_STACKED_EQUAL_HEIGHT,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SentimentCityTrendNOA,
        value: REPORT_TYPES.SentimentCityTrendNOA,
        reportCategory: REPORT_CATEGORIES.SENTIMENT,
        label: "Sentiment By Trend - City (No. Of Article)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          print: GRAPH_DATATYPE.SentimentCityTrendPrint,
          printandonline: GRAPH_DATATYPE.SentimentCityTrendPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,
          BAR_STACKED_EQUAL_HEIGHT,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SentimentCityTrendCCM,
        value: REPORT_TYPES.SentimentCityTrendCCM,
        reportCategory: REPORT_CATEGORIES.SENTIMENT,
        label: "Sentiment By Trend - City (CCM)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          print: GRAPH_DATATYPE.SentimentCityTrendPrint,
          printandonline: GRAPH_DATATYPE.SentimentCityTrendPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,
          BAR_STACKED_EQUAL_HEIGHT,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SentimentCityTrendMAV,
        value: REPORT_TYPES.SentimentCityTrendMAV,
        reportCategory: REPORT_CATEGORIES.SENTIMENT,
        label: "Sentiment By Trend - City (MAV)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          print: GRAPH_DATATYPE.SentimentCityTrendPrint,
          printandonline: GRAPH_DATATYPE.SentimentCityTrendPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,
          BAR_STACKED_EQUAL_HEIGHT,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SentimentCityTrendReach,
        value: REPORT_TYPES.SentimentCityTrendReach,
        reportCategory: REPORT_CATEGORIES.SENTIMENT,
        label: "Sentiment By Trend - City (Reach)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          print: GRAPH_DATATYPE.SentimentCityTrendPrint,
          printandonline: GRAPH_DATATYPE.SentimentCityTrendPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,
          BAR_STACKED_EQUAL_HEIGHT,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },

      //SENTIMENT - Keyword - SOV
      {
        id: REPORT_TYPES.SentimentKeywordSOVIndex,
        value: REPORT_TYPES.SentimentKeywordSOVIndex,
        reportCategory: REPORT_CATEGORIES.SENTIMENT,
        label: "Sentiment By SOV - Keyword (Index)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SentimentKeywordSOVOnline,
          print: GRAPH_DATATYPE.SentimentKeywordSOVPrint,
          printandonline: GRAPH_DATATYPE.SentimentKeywordSOVPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT_AND_ONLINE],
        groupByField: "entity_name",
        excludeGraphType: [

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SentimentKeywordSOVNOA,
        value: REPORT_TYPES.SentimentKeywordSOVNOA,
        reportCategory: REPORT_CATEGORIES.SENTIMENT,
        label: "Sentiment By SOV - Keyword (No. Of Article)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SentimentKeywordSOVOnline,
          print: GRAPH_DATATYPE.SentimentKeywordSOVPrint,
          printandonline: GRAPH_DATATYPE.SentimentKeywordSOVPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SentimentKeywordSOVCCM,
        value: REPORT_TYPES.SentimentKeywordSOVCCM,
        reportCategory: REPORT_CATEGORIES.SENTIMENT,
        label: "Sentiment By SOV - Keyword (CCM)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SentimentKeywordSOVOnline,
          print: GRAPH_DATATYPE.SentimentKeywordSOVPrint,
          printandonline: GRAPH_DATATYPE.SentimentKeywordSOVPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SentimentKeywordSOVMAV,
        value: REPORT_TYPES.SentimentKeywordSOVMAV,
        reportCategory: REPORT_CATEGORIES.SENTIMENT,
        label: "Sentiment By SOV - Keyword (MAV)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SentimentKeywordSOVOnline,
          print: GRAPH_DATATYPE.SentimentKeywordSOVPrint,
          printandonline: GRAPH_DATATYPE.SentimentKeywordSOVPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SentimentKeywordSOVReach,
        value: REPORT_TYPES.SentimentKeywordSOVReach,
        reportCategory: REPORT_CATEGORIES.SENTIMENT,
        label: "Sentiment By SOV - Keyword (Reach)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SentimentKeywordSOVOnline,
          print: GRAPH_DATATYPE.SentimentKeywordSOVPrint,
          printandonline: GRAPH_DATATYPE.SentimentKeywordSOVPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SentimentKeywordSOVWordCount,
        value: REPORT_TYPES.SentimentKeywordSOVWordCount,
        reportCategory: REPORT_CATEGORIES.SENTIMENT,
        label: "Sentiment By SOV - Keyword (Word Count)",
        enablePrint: false,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SentimentKeywordSOVOnline,
          printandonline: GRAPH_DATATYPE.SentimentKeywordSOVPrintOnline,
        },
        verticalList: [V_ONLINE],
        groupByField: "entity_name",
        excludeGraphType: [

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      //SENTIMENT - Keyword - Trend
      {
        id: REPORT_TYPES.SentimentKeywordTrendIndex,
        value: REPORT_TYPES.SentimentKeywordTrendIndex,
        reportCategory: REPORT_CATEGORIES.SENTIMENT,
        label: "Sentiment By Trend - Keyword (Index)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SentimentKeywordTrendOnline,
          print: GRAPH_DATATYPE.SentimentKeywordTrendPrint,
          printandonline: GRAPH_DATATYPE.SentimentKeywordTrendPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,
          BAR_STACKED_EQUAL_HEIGHT,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SentimentKeywordTrendNOA,
        value: REPORT_TYPES.SentimentKeywordTrendNOA,
        reportCategory: REPORT_CATEGORIES.SENTIMENT,
        label: "Sentiment By Trend - Keyword (No. Of Article)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SentimentKeywordTrendOnline,
          print: GRAPH_DATATYPE.SentimentKeywordTrendPrint,
          printandonline: GRAPH_DATATYPE.SentimentKeywordTrendPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,
          BAR_STACKED_EQUAL_HEIGHT,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SentimentKeywordTrendCCM,
        value: REPORT_TYPES.SentimentKeywordTrendCCM,
        reportCategory: REPORT_CATEGORIES.SENTIMENT,
        label: "Sentiment By Trend - Keyword (CCM)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SentimentKeywordTrendOnline,
          print: GRAPH_DATATYPE.SentimentKeywordTrendPrint,
          printandonline: GRAPH_DATATYPE.SentimentKeywordTrendPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,
          BAR_STACKED_EQUAL_HEIGHT,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SentimentKeywordTrendMAV,
        value: REPORT_TYPES.SentimentKeywordTrendMAV,
        reportCategory: REPORT_CATEGORIES.SENTIMENT,
        label: "Sentiment By Trend - Keyword (MAV)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SentimentKeywordTrendOnline,
          print: GRAPH_DATATYPE.SentimentKeywordTrendPrint,
          printandonline: GRAPH_DATATYPE.SentimentKeywordTrendPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,
          BAR_STACKED_EQUAL_HEIGHT,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SentimentKeywordTrendReach,
        value: REPORT_TYPES.SentimentKeywordTrendReach,
        reportCategory: REPORT_CATEGORIES.SENTIMENT,
        label: "Sentiment By Trend - Keyword (Reach)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SentimentKeywordTrendOnline,
          print: GRAPH_DATATYPE.SentimentKeywordTrendPrint,
          printandonline: GRAPH_DATATYPE.SentimentKeywordTrendPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,
          BAR_STACKED_EQUAL_HEIGHT,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SentimentKeywordTrendWordCount,
        value: REPORT_TYPES.SentimentKeywordTrendWordCount,
        reportCategory: REPORT_CATEGORIES.SENTIMENT,
        label: "Sentiment By Trend - Keyword (Word Count)",
        enablePrint: false,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SentimentKeywordTrendOnline,
          printandonline: GRAPH_DATATYPE.SentimentKeywordTrendPrintOnline,
        },
        verticalList: [V_ONLINE],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,
          BAR_STACKED_EQUAL_HEIGHT,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },


      // sentiment inline filter Ends


      //SOV - Publication - Ranking
      {
        id: REPORT_TYPES.SOVPublicationRankingIndex,
        value: REPORT_TYPES.SOVPublicationRankingIndex,
        reportCategory: REPORT_CATEGORIES.SOV,
        label: "Share Of Voice By Ranking - Publication (Index)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SOVPublicationRankingOnline,
          print: GRAPH_DATATYPE.SOVPublicationRankingPrint,
          printandonline: GRAPH_DATATYPE.SOVPublicationRankingPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT_AND_ONLINE],
        groupByField: "entity_name",
        excludeGraphType: [

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SOVPublicationRankingNOA,
        value: REPORT_TYPES.SOVPublicationRankingNOA,
        reportCategory: REPORT_CATEGORIES.SOV,
        label: "Share Of Voice By Ranking - Publication (No. Of Article)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SOVPublicationRankingOnline,
          print: GRAPH_DATATYPE.SOVPublicationRankingPrint,
          printandonline: GRAPH_DATATYPE.SOVPublicationRankingPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SOVPublicationRankingCCM,
        value: REPORT_TYPES.SOVPublicationRankingCCM,
        reportCategory: REPORT_CATEGORIES.SOV,
        label: "Share Of Voice By Ranking - Publication (CCM)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SOVPublicationRankingOnline,
          print: GRAPH_DATATYPE.SOVPublicationRankingPrint,
          printandonline: GRAPH_DATATYPE.SOVPublicationRankingPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SOVPublicationRankingMAV,
        value: REPORT_TYPES.SOVPublicationRankingMAV,
        reportCategory: REPORT_CATEGORIES.SOV,
        label: "Share Of Voice By Ranking - Publication (MAV)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SOVPublicationRankingOnline,
          print: GRAPH_DATATYPE.SOVPublicationRankingPrint,
          printandonline: GRAPH_DATATYPE.SOVPublicationRankingPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SOVPublicationRankingReach,
        value: REPORT_TYPES.SOVPublicationRankingReach,
        reportCategory: REPORT_CATEGORIES.SOV,
        label: "Share Of Voice By Ranking - Publication (Reach)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SOVPublicationRankingOnline,
          print: GRAPH_DATATYPE.SOVPublicationRankingPrint,
          printandonline: GRAPH_DATATYPE.SOVPublicationRankingPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SOVPublicationRankingWordCount,
        value: REPORT_TYPES.SOVPublicationRankingWordCount,
        reportCategory: REPORT_CATEGORIES.SOV,
        label: "Share Of Voice By Ranking - Publication (Word Count)",
        enablePrint: false,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SOVPublicationRankingOnline,
          printandonline: GRAPH_DATATYPE.SOVPublicationRankingPrintOnline,
        },
        verticalList: [V_ONLINE],
        groupByField: "entity_name",
        excludeGraphType: [

          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      //SOV - Publication - Trend
      {
        id: REPORT_TYPES.SOVPublicationTrendIndex,
        value: REPORT_TYPES.SOVPublicationTrendIndex,
        reportCategory: REPORT_CATEGORIES.SOV,
        label: "Share Of Voice By Trend - Publication (Index)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SOVPublicationTrendOnline,
          print: GRAPH_DATATYPE.SOVPublicationTrendPrint,
          printandonline: GRAPH_DATATYPE.SOVPublicationTrendPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,
          BAR_STACKED_EQUAL_HEIGHT,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SOVPublicationTrendNOA,
        value: REPORT_TYPES.SOVPublicationTrendNOA,
        reportCategory: REPORT_CATEGORIES.SOV,
        label: "Share Of Voice By Trend - Publication (No. Of Article)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SOVPublicationTrendOnline,
          print: GRAPH_DATATYPE.SOVPublicationTrendPrint,
          printandonline: GRAPH_DATATYPE.SOVPublicationTrendPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,
          BAR_STACKED_EQUAL_HEIGHT,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SOVPublicationTrendCCM,
        value: REPORT_TYPES.SOVPublicationTrendCCM,
        reportCategory: REPORT_CATEGORIES.SOV,
        label: "Share Of Voice By Trend - Publication (CCM)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SOVPublicationTrendOnline,
          print: GRAPH_DATATYPE.SOVPublicationTrendPrint,
          printandonline: GRAPH_DATATYPE.SOVPublicationTrendPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,
          BAR_STACKED_EQUAL_HEIGHT,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SOVPublicationTrendMAV,
        value: REPORT_TYPES.SOVPublicationTrendMAV,
        reportCategory: REPORT_CATEGORIES.SOV,
        label: "Share Of Voice By Trend - Publication (MAV)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SOVPublicationTrendOnline,
          print: GRAPH_DATATYPE.SOVPublicationTrendPrint,
          printandonline: GRAPH_DATATYPE.SOVPublicationTrendPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,
          BAR_STACKED_EQUAL_HEIGHT,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SOVPublicationTrendReach,
        value: REPORT_TYPES.SOVPublicationTrendReach,
        reportCategory: REPORT_CATEGORIES.SOV,
        label: "Share Of Voice By Trend - Publication (Reach)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SOVPublicationTrendOnline,
          print: GRAPH_DATATYPE.SOVPublicationTrendPrint,
          printandonline: GRAPH_DATATYPE.SOVPublicationTrendPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,
          BAR_STACKED_EQUAL_HEIGHT,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SOVPublicationTrendWordCount,
        value: REPORT_TYPES.SOVPublicationTrendWordCount,
        reportCategory: REPORT_CATEGORIES.SOV,
        label: "Share Of Voice By Trend - Publication (Word Count)",
        enablePrint: false,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SOVPublicationTrendOnline,
          printandonline: GRAPH_DATATYPE.SOVPublicationTrendPrintOnline,
        },
        verticalList: [V_ONLINE],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,
          BAR_STACKED_EQUAL_HEIGHT,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },


      // Spokesperson inline starts

      //Spokesperson - Entity - Trend
      {
        id: REPORT_TYPES.SpokespersonEntityTrendIndex,
        value: REPORT_TYPES.SpokespersonEntityTrendIndex,
        reportCategory: REPORT_CATEGORIES.SPOKESPERSON,
        label: "Spokesperson By Trend - Entity (Index)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SpokespersonEntityTrendOnline,
          print: GRAPH_DATATYPE.SpokespersonEntityTrendPrint,
          printandonline: GRAPH_DATATYPE.SpokespersonEntityTrendPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SpokespersonEntityTrendNOA,
        value: REPORT_TYPES.SpokespersonEntityTrendNOA,
        reportCategory: REPORT_CATEGORIES.SPOKESPERSON,
        label: "Spokesperson By Trend - Entity (No. Of Article)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SpokespersonEntityTrendOnline,
          print: GRAPH_DATATYPE.SpokespersonEntityTrendPrint,
          printandonline: GRAPH_DATATYPE.SpokespersonEntityTrendPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SpokespersonEntityTrendCCM,
        value: REPORT_TYPES.SpokespersonEntityTrendCCM,
        reportCategory: REPORT_CATEGORIES.SPOKESPERSON,
        label: "Spokesperson By Trend - Entity (CCM)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SpokespersonEntityTrendOnline,
          print: GRAPH_DATATYPE.SpokespersonEntityTrendPrint,
          printandonline: GRAPH_DATATYPE.SpokespersonEntityTrendPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SpokespersonEntityTrendMAV,
        value: REPORT_TYPES.SpokespersonEntityTrendMAV,
        reportCategory: REPORT_CATEGORIES.SPOKESPERSON,
        label: "Spokesperson By Trend - Entity (MAV)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SpokespersonEntityTrendOnline,
          print: GRAPH_DATATYPE.SpokespersonEntityTrendPrint,
          printandonline: GRAPH_DATATYPE.SpokespersonEntityTrendPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SpokespersonEntityTrendReach,
        value: REPORT_TYPES.SpokespersonEntityTrendReach,
        reportCategory: REPORT_CATEGORIES.SPOKESPERSON,
        label: "Spokesperson By Trend - Entity (Reach)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SpokespersonEntityTrendOnline,
          print: GRAPH_DATATYPE.SpokespersonEntityTrendPrint,
          printandonline: GRAPH_DATATYPE.SpokespersonEntityTrendPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,
          BAR_STACKED_EQUAL_HEIGHT,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SpokespersonEntityTrendWordCount,
        value: REPORT_TYPES.SpokespersonEntityTrendWordCount,
        reportCategory: REPORT_CATEGORIES.SPOKESPERSON,
        label: "Spokesperson By Trend - Entity (Word Count)",
        enablePrint: false,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SpokespersonEntityTrendOnline,
          printandonline: GRAPH_DATATYPE.SpokespersonEntityTrendPrintOnline,
        },
        verticalList: [V_ONLINE],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },


      // Spokesperson - Enitity - SOV

      {
        id: REPORT_TYPES.SpokespersonEntitySOVIndex,
        value: REPORT_TYPES.SpokespersonEntitySOVIndex,
        reportCategory: REPORT_CATEGORIES.SPOKESPERSON,
        label: "Spokesperson By SOV - Entity (Index)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SpokespersonEntitySOVOnline,
          print: GRAPH_DATATYPE.SpokespersonEntitySOVPrint,
          printandonline: GRAPH_DATATYPE.SpokespersonEntitySOVPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
          PIE
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SpokespersonEntitySOVNOA,
        value: REPORT_TYPES.SpokespersonEntitySOVNOA,
        reportCategory: REPORT_CATEGORIES.SPOKESPERSON,
        label: "Spokesperson By SOV - Entity (No. Of Article)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SpokespersonEntitySOVOnline,
          print: GRAPH_DATATYPE.SpokespersonEntitySOVPrint,
          printandonline: GRAPH_DATATYPE.SpokespersonEntitySOVPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
          PIE
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SpokespersonEntitySOVCCM,
        value: REPORT_TYPES.SpokespersonEntitySOVCCM,
        reportCategory: REPORT_CATEGORIES.SPOKESPERSON,
        label: "Spokesperson By SOV - Entity (CCM)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SpokespersonEntitySOVOnline,
          print: GRAPH_DATATYPE.SpokespersonEntitySOVPrint,
          printandonline: GRAPH_DATATYPE.SpokespersonEntitySOVPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
          PIE
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SpokespersonEntitySOVMAV,
        value: REPORT_TYPES.SpokespersonEntitySOVMAV,
        reportCategory: REPORT_CATEGORIES.SPOKESPERSON,
        label: "Spokesperson By SOV - Entity (MAV)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SpokespersonEntitySOVOnline,
          print: GRAPH_DATATYPE.SpokespersonEntitySOVPrint,
          printandonline: GRAPH_DATATYPE.SpokespersonEntitySOVPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
          PIE
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SpokespersonEntitySOVReach,
        value: REPORT_TYPES.SpokespersonEntitySOVReach,
        reportCategory: REPORT_CATEGORIES.SPOKESPERSON,
        label: "Spokesperson By SOV - Entity (Reach)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SpokespersonEntitySOVOnline,
          print: GRAPH_DATATYPE.SpokespersonEntitySOVPrint,
          printandonline: GRAPH_DATATYPE.SpokespersonEntitySOVPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
          PIE
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SpokespersonEntitySOVWordCount,
        value: REPORT_TYPES.SpokespersonEntitySOVWordCount,
        reportCategory: REPORT_CATEGORIES.SPOKESPERSON,
        label: "Spokesperson By SOV - Entity (Word Count)",
        enablePrint: false,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SpokespersonEntitySOVOnline,
          printandonline: GRAPH_DATATYPE.SpokespersonEntitySOVPrintOnline,
        },
        verticalList: [V_ONLINE],
        groupByField: "entity_name",
        excludeGraphType: [
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
          PIE
        ],
        entityKey: "entity_name",
        countKey: "index",
      },





      //Spokesperson - Journalist - Trend
      {
        id: REPORT_TYPES.SpokespersonJournalistTrendIndex,
        value: REPORT_TYPES.SpokespersonJournalistTrendIndex,
        reportCategory: REPORT_CATEGORIES.SPOKESPERSON,
        label: "Spokesperson By Trend - Journalist (Index)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SpokespersonJournalistTrendOnline,
          print: GRAPH_DATATYPE.SpokespersonJournalistTrendPrint,
          printandonline: GRAPH_DATATYPE.SpokespersonJournalistTrendPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SpokespersonJournalistTrendNOA,
        value: REPORT_TYPES.SpokespersonJournalistTrendNOA,
        reportCategory: REPORT_CATEGORIES.SPOKESPERSON,
        label: "Spokesperson By Trend - Journalist (No. Of Article)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SpokespersonJournalistTrendOnline,
          print: GRAPH_DATATYPE.SpokespersonJournalistTrendPrint,
          printandonline: GRAPH_DATATYPE.SpokespersonJournalistTrendPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SpokespersonJournalistTrendCCM,
        value: REPORT_TYPES.SpokespersonJournalistTrendCCM,
        reportCategory: REPORT_CATEGORIES.SPOKESPERSON,
        label: "Spokesperson By Trend - Journalist (CCM)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SpokespersonJournalistTrendOnline,
          print: GRAPH_DATATYPE.SpokespersonJournalistTrendPrint,
          printandonline: GRAPH_DATATYPE.SpokespersonJournalistTrendPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SpokespersonJournalistTrendMAV,
        value: REPORT_TYPES.SpokespersonJournalistTrendMAV,
        reportCategory: REPORT_CATEGORIES.SPOKESPERSON,
        label: "Spokesperson By Trend - Journalist (MAV)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SpokespersonJournalistTrendOnline,
          print: GRAPH_DATATYPE.SpokespersonJournalistTrendPrint,
          printandonline: GRAPH_DATATYPE.SpokespersonJournalistTrendPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SpokespersonJournalistTrendReach,
        value: REPORT_TYPES.SpokespersonJournalistTrendReach,
        reportCategory: REPORT_CATEGORIES.SPOKESPERSON,
        label: "Spokesperson By Trend - Journalist (Reach)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SpokespersonJournalistTrendOnline,
          print: GRAPH_DATATYPE.SpokespersonJournalistTrendPrint,
          printandonline: GRAPH_DATATYPE.SpokespersonJournalistTrendPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SpokespersonJournalistTrendWordCount,
        value: REPORT_TYPES.SpokespersonJournalistTrendWordCount,
        reportCategory: REPORT_CATEGORIES.SPOKESPERSON,
        label: "Spokesperson By Trend - Journalist (Word Count)",
        enablePrint: false,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SpokespersonJournalistTrendOnline,
          printandonline: GRAPH_DATATYPE.SpokespersonJournalistTrendPrintOnline,
        },
        verticalList: [V_ONLINE],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },





      // Spokesperson - Journalist - SOV

      {
        id: REPORT_TYPES.SpokespersonJournalistSOVIndex,
        value: REPORT_TYPES.SpokespersonJournalistSOVIndex,
        reportCategory: REPORT_CATEGORIES.SPOKESPERSON,
        label: "Spokesperson By SOV - Journalist (Index)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SpokespersonJournalistSOVOnline,
          print: GRAPH_DATATYPE.SpokespersonJournalistSOVPrint,
          printandonline: GRAPH_DATATYPE.SpokespersonJournalistSOVPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
          PIE
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SpokespersonJournalistSOVNOA,
        value: REPORT_TYPES.SpokespersonJournalistSOVNOA,
        reportCategory: REPORT_CATEGORIES.SPOKESPERSON,
        label: "Spokesperson By SOV - Journalist (No. Of Article)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SpokespersonJournalistSOVOnline,
          print: GRAPH_DATATYPE.SpokespersonJournalistSOVPrint,
          printandonline: GRAPH_DATATYPE.SpokespersonJournalistSOVPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
          PIE
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SpokespersonJournalistSOVCCM,
        value: REPORT_TYPES.SpokespersonJournalistSOVCCM,
        reportCategory: REPORT_CATEGORIES.SPOKESPERSON,
        label: "Spokesperson By SOV - Journalist (CCM)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SpokespersonJournalistSOVOnline,
          print: GRAPH_DATATYPE.SpokespersonJournalistSOVPrint,
          printandonline: GRAPH_DATATYPE.SpokespersonJournalistSOVPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
          PIE
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SpokespersonJournalistSOVMAV,
        value: REPORT_TYPES.SpokespersonJournalistSOVMAV,
        reportCategory: REPORT_CATEGORIES.SPOKESPERSON,
        label: "Spokesperson By SOV - Journalist (MAV)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SpokespersonJournalistSOVOnline,
          print: GRAPH_DATATYPE.SpokespersonJournalistSOVPrint,
          printandonline: GRAPH_DATATYPE.SpokespersonJournalistSOVPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
          PIE
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SpokespersonJournalistSOVReach,
        value: REPORT_TYPES.SpokespersonJournalistSOVReach,
        reportCategory: REPORT_CATEGORIES.SPOKESPERSON,
        label: "Spokesperson By SOV - Journalist (Reach)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SpokespersonJournalistSOVOnline,
          print: GRAPH_DATATYPE.SpokespersonJournalistSOVPrint,
          printandonline: GRAPH_DATATYPE.SpokespersonJournalistSOVPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
          PIE
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SpokespersonJournalistSOVWordCount,
        value: REPORT_TYPES.SpokespersonJournalistSOVWordCount,
        reportCategory: REPORT_CATEGORIES.SPOKESPERSON,
        label: "Spokesperson By SOV - Journalist (Word Count)",
        enablePrint: false,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SpokespersonJournalistSOVOnline,
          printandonline: GRAPH_DATATYPE.SpokespersonJournalistSOVPrintOnline,
        },
        verticalList: [V_ONLINE],
        groupByField: "entity_name",
        excludeGraphType: [
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
          PIE
        ],
        entityKey: "entity_name",
        countKey: "index",
      },

      //SPOKESPERSON - Topic - SOV
      {
        id: REPORT_TYPES.SpokespersonTopicSOVIndex,
        value: REPORT_TYPES.SpokespersonTopicSOVIndex,
        reportCategory: REPORT_CATEGORIES.SPOKESPERSON,
        label: "Spokesperson By SOV - Topic (Index)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SpokespersonTopicSOVOnline,
          print: GRAPH_DATATYPE.SpokespersonTopicSOVPrint,
          printandonline: GRAPH_DATATYPE.SpokespersonTopicSOVPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT_AND_ONLINE],
        groupByField: "entity_name",
        excludeGraphType: [
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
          PIE
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SpokespersonTopicSOVNOA,
        value: REPORT_TYPES.SpokespersonTopicSOVNOA,
        reportCategory: REPORT_CATEGORIES.SPOKESPERSON,
        label: "Spokesperson By SOV - Topic (No. Of Article)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SpokespersonTopicSOVOnline,
          print: GRAPH_DATATYPE.SpokespersonTopicSOVPrint,
          printandonline: GRAPH_DATATYPE.SpokespersonTopicSOVPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
          PIE
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SpokespersonTopicSOVCCM,
        value: REPORT_TYPES.SpokespersonTopicSOVCCM,
        reportCategory: REPORT_CATEGORIES.SPOKESPERSON,
        label: "Spokesperson By SOV - Topic (CCM)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SpokespersonTopicSOVOnline,
          print: GRAPH_DATATYPE.SpokespersonTopicSOVPrint,
          printandonline: GRAPH_DATATYPE.SpokespersonTopicSOVPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
          PIE
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SpokespersonTopicSOVMAV,
        value: REPORT_TYPES.SpokespersonTopicSOVMAV,
        reportCategory: REPORT_CATEGORIES.SPOKESPERSON,
        label: "Spokesperson By SOV - Topic (MAV)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SpokespersonTopicSOVOnline,
          print: GRAPH_DATATYPE.SpokespersonTopicSOVPrint,
          printandonline: GRAPH_DATATYPE.SpokespersonTopicSOVPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
          PIE
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SpokespersonTopicSOVReach,
        value: REPORT_TYPES.SpokespersonTopicSOVReach,
        reportCategory: REPORT_CATEGORIES.SPOKESPERSON,
        label: "Spokesperson By SOV - Topic (Reach)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SpokespersonTopicSOVOnline,
          print: GRAPH_DATATYPE.SpokespersonTopicSOVPrint,
          printandonline: GRAPH_DATATYPE.SpokespersonTopicSOVPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
          PIE
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SpokespersonTopicSOVWordCount,
        value: REPORT_TYPES.SpokespersonTopicSOVWordCount,
        reportCategory: REPORT_CATEGORIES.SPOKESPERSON,
        label: "Spokesperson By SOV - Topic (Word Count)",
        enablePrint: false,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SpokespersonTopicSOVOnline,
          printandonline: GRAPH_DATATYPE.SpokespersonTopicSOVPrintOnline,
        },
        verticalList: [V_ONLINE],
        groupByField: "entity_name",
        excludeGraphType: [
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
          PIE
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      //SPOKESPERSON - Topic - Trend
      {
        id: REPORT_TYPES.SpokespersonTopicTrendIndex,
        value: REPORT_TYPES.SpokespersonTopicTrendIndex,
        reportCategory: REPORT_CATEGORIES.SPOKESPERSON,
        label: "Spokesperson By Trend - Topic (Index)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SpokespersonTopicTrendOnline,
          print: GRAPH_DATATYPE.SpokespersonTopicTrendPrint,
          printandonline: GRAPH_DATATYPE.SpokespersonTopicTrendPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SpokespersonTopicTrendNOA,
        value: REPORT_TYPES.SpokespersonTopicTrendNOA,
        reportCategory: REPORT_CATEGORIES.SPOKESPERSON,
        label: "Spokesperson By Trend - Topic (No. Of Article)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SpokespersonTopicTrendOnline,
          print: GRAPH_DATATYPE.SpokespersonTopicTrendPrint,
          printandonline: GRAPH_DATATYPE.SpokespersonTopicTrendPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SpokespersonTopicTrendCCM,
        value: REPORT_TYPES.SpokespersonTopicTrendCCM,
        reportCategory: REPORT_CATEGORIES.SPOKESPERSON,
        label: "Spokesperson By Trend - Topic (CCM)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SpokespersonTopicTrendOnline,
          print: GRAPH_DATATYPE.SpokespersonTopicTrendPrint,
          printandonline: GRAPH_DATATYPE.SpokespersonTopicTrendPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SpokespersonTopicTrendMAV,
        value: REPORT_TYPES.SpokespersonTopicTrendMAV,
        reportCategory: REPORT_CATEGORIES.SPOKESPERSON,
        label: "Spokesperson By Trend - Topic (MAV)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SpokespersonTopicTrendOnline,
          print: GRAPH_DATATYPE.SpokespersonTopicTrendPrint,
          printandonline: GRAPH_DATATYPE.SpokespersonTopicTrendPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SpokespersonTopicTrendReach,
        value: REPORT_TYPES.SpokespersonTopicTrendReach,
        reportCategory: REPORT_CATEGORIES.SPOKESPERSON,
        label: "Spokesperson By Trend - Topic (Reach)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SpokespersonTopicTrendOnline,
          print: GRAPH_DATATYPE.SpokespersonTopicTrendPrint,
          printandonline: GRAPH_DATATYPE.SpokespersonTopicTrendPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SpokespersonTopicTrendWordCount,
        value: REPORT_TYPES.SpokespersonTopicTrendWordCount,
        reportCategory: REPORT_CATEGORIES.SPOKESPERSON,
        label: "Spokesperson By Trend - Topic (Word Count)",
        enablePrint: false,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SpokespersonTopicTrendOnline,
          printandonline: GRAPH_DATATYPE.SpokespersonTopicTrendPrintOnline,
        },
        verticalList: [V_ONLINE],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },


      //SPOKESPERSON - Profile - SOV
      {
        id: REPORT_TYPES.SpokespersonProfileSOVIndex,
        value: REPORT_TYPES.SpokespersonProfileSOVIndex,
        reportCategory: REPORT_CATEGORIES.SPOKESPERSON,
        label: "Spokesperson By SOV - Profile (Index)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SpokespersonProfileSOVOnline,
          print: GRAPH_DATATYPE.SpokespersonProfileSOVPrint,
          printandonline: GRAPH_DATATYPE.SpokespersonProfileSOVPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT_AND_ONLINE],
        groupByField: "entity_name",
        excludeGraphType: [
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
          PIE
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SpokespersonProfileSOVNOA,
        value: REPORT_TYPES.SpokespersonProfileSOVNOA,
        reportCategory: REPORT_CATEGORIES.SPOKESPERSON,
        label: "Spokesperson By SOV - Profile (No. Of Article)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SpokespersonProfileSOVOnline,
          print: GRAPH_DATATYPE.SpokespersonProfileSOVPrint,
          printandonline: GRAPH_DATATYPE.SpokespersonProfileSOVPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
          PIE
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SpokespersonProfileSOVCCM,
        value: REPORT_TYPES.SpokespersonProfileSOVCCM,
        reportCategory: REPORT_CATEGORIES.SPOKESPERSON,
        label: "Spokesperson By SOV - Profile (CCM)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SpokespersonProfileSOVOnline,
          print: GRAPH_DATATYPE.SpokespersonProfileSOVPrint,
          printandonline: GRAPH_DATATYPE.SpokespersonProfileSOVPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
          PIE
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SpokespersonProfileSOVMAV,
        value: REPORT_TYPES.SpokespersonProfileSOVMAV,
        reportCategory: REPORT_CATEGORIES.SPOKESPERSON,
        label: "Spokesperson By SOV - Profile (MAV)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SpokespersonProfileSOVOnline,
          print: GRAPH_DATATYPE.SpokespersonProfileSOVPrint,
          printandonline: GRAPH_DATATYPE.SpokespersonProfileSOVPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
          PIE
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SpokespersonProfileSOVReach,
        value: REPORT_TYPES.SpokespersonProfileSOVReach,
        reportCategory: REPORT_CATEGORIES.SPOKESPERSON,
        label: "Spokesperson By SOV - Profile (Reach)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SpokespersonProfileSOVOnline,
          print: GRAPH_DATATYPE.SpokespersonProfileSOVPrint,
          printandonline: GRAPH_DATATYPE.SpokespersonProfileSOVPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
          PIE
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SpokespersonProfileSOVWordCount,
        value: REPORT_TYPES.SpokespersonProfileSOVWordCount,
        reportCategory: REPORT_CATEGORIES.SPOKESPERSON,
        label: "Spokesperson By SOV - Profile (Word Count)",
        enablePrint: false,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SpokespersonProfileSOVOnline,
          printandonline: GRAPH_DATATYPE.SpokespersonProfileSOVPrintOnline,
        },
        verticalList: [V_ONLINE],
        groupByField: "entity_name",
        excludeGraphType: [
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
          PIE
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      //SPOKESPERSON - Profile - Trend
      {
        id: REPORT_TYPES.SpokespersonProfileTrendIndex,
        value: REPORT_TYPES.SpokespersonProfileTrendIndex,
        reportCategory: REPORT_CATEGORIES.SPOKESPERSON,
        label: "Spokesperson By Trend - Profile (Index)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SpokespersonProfileTrendOnline,
          print: GRAPH_DATATYPE.SpokespersonProfileTrendPrint,
          printandonline: GRAPH_DATATYPE.SpokespersonProfileTrendPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SpokespersonProfileTrendNOA,
        value: REPORT_TYPES.SpokespersonProfileTrendNOA,
        reportCategory: REPORT_CATEGORIES.SPOKESPERSON,
        label: "Spokesperson By Trend - Profile (No. Of Article)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SpokespersonProfileTrendOnline,
          print: GRAPH_DATATYPE.SpokespersonProfileTrendPrint,
          printandonline: GRAPH_DATATYPE.SpokespersonProfileTrendPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SpokespersonProfileTrendCCM,
        value: REPORT_TYPES.SpokespersonProfileTrendCCM,
        reportCategory: REPORT_CATEGORIES.SPOKESPERSON,
        label: "Spokesperson By Trend - Profile (CCM)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SpokespersonProfileTrendOnline,
          print: GRAPH_DATATYPE.SpokespersonProfileTrendPrint,
          printandonline: GRAPH_DATATYPE.SpokespersonProfileTrendPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SpokespersonProfileTrendMAV,
        value: REPORT_TYPES.SpokespersonProfileTrendMAV,
        reportCategory: REPORT_CATEGORIES.SPOKESPERSON,
        label: "Spokesperson By Trend - Profile (MAV)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SpokespersonProfileTrendOnline,
          print: GRAPH_DATATYPE.SpokespersonProfileTrendPrint,
          printandonline: GRAPH_DATATYPE.SpokespersonProfileTrendPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SpokespersonProfileTrendReach,
        value: REPORT_TYPES.SpokespersonProfileTrendReach,
        reportCategory: REPORT_CATEGORIES.SPOKESPERSON,
        label: "Spokesperson By Trend - Profile (Reach)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SpokespersonProfileTrendOnline,
          print: GRAPH_DATATYPE.SpokespersonProfileTrendPrint,
          printandonline: GRAPH_DATATYPE.SpokespersonProfileTrendPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.SpokespersonProfileTrendWordCount,
        value: REPORT_TYPES.SpokespersonProfileTrendWordCount,
        reportCategory: REPORT_CATEGORIES.SPOKESPERSON,
        label: "Spokesperson By Trend - Profile (Word Count)",
        enablePrint: false,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.SpokespersonProfileTrendOnline,
          printandonline: GRAPH_DATATYPE.SpokespersonProfileTrendPrintOnline,
        },
        verticalList: [V_ONLINE],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH
        ],
        entityKey: "entity_name",
        countKey: "index",
      },


      // Spokesperson inline filter Ends



      // Journalist inline starts

      //Journalist - Entity - Trend
      {
        id: REPORT_TYPES.JournalistEntityTrendIndex,
        value: REPORT_TYPES.JournalistEntityTrendIndex,
        reportCategory: REPORT_CATEGORIES.JOURNALIST,
        label: "Journalist By Trend - Entity (Index)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.JournalistEntityTrendOnline,
          print: GRAPH_DATATYPE.JournalistEntityTrendPrint,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.JournalistEntityTrendNOA,
        value: REPORT_TYPES.JournalistEntityTrendNOA,
        reportCategory: REPORT_CATEGORIES.JOURNALIST,
        label: "Journalist By Trend - Entity (No. Of Article)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.JournalistEntityTrendOnline,
          print: GRAPH_DATATYPE.JournalistEntityTrendPrint,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.JournalistEntityTrendCCM,
        value: REPORT_TYPES.JournalistEntityTrendCCM,
        reportCategory: REPORT_CATEGORIES.JOURNALIST,
        label: "Journalist By Trend - Entity (CCM)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.JournalistEntityTrendOnline,
          print: GRAPH_DATATYPE.JournalistEntityTrendPrint,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.JournalistEntityTrendMAV,
        value: REPORT_TYPES.JournalistEntityTrendMAV,
        reportCategory: REPORT_CATEGORIES.JOURNALIST,
        label: "Journalist By Trend - Entity (MAV)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.JournalistEntityTrendOnline,
          print: GRAPH_DATATYPE.JournalistEntityTrendPrint,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.JournalistEntityTrendReach,
        value: REPORT_TYPES.JournalistEntityTrendReach,
        reportCategory: REPORT_CATEGORIES.JOURNALIST,
        label: "Journalist By Trend - Entity (Reach)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.JournalistEntityTrendOnline,
          print: GRAPH_DATATYPE.JournalistEntityTrendPrint,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,
          BAR_STACKED_EQUAL_HEIGHT,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.JournalistEntityTrendWordCount,
        value: REPORT_TYPES.JournalistEntityTrendWordCount,
        reportCategory: REPORT_CATEGORIES.JOURNALIST,
        label: "Journalist By Trend - Entity (Word Count)",
        enablePrint: false,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.JournalistEntityTrendOnline,
        },
        verticalList: [V_ONLINE],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },


      // Journalist - Enitity - SOV

      {
        id: REPORT_TYPES.JournalistEntitySOVIndex,
        value: REPORT_TYPES.JournalistEntitySOVIndex,
        reportCategory: REPORT_CATEGORIES.JOURNALIST,
        label: "Journalist By SOV - Entity (Index)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.JournalistEntitySOVOnline,
          print: GRAPH_DATATYPE.JournalistEntitySOVPrint,
          printandonline: GRAPH_DATATYPE.JournalistEntitySOVPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
          PIE
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.JournalistEntitySOVNOA,
        value: REPORT_TYPES.JournalistEntitySOVNOA,
        reportCategory: REPORT_CATEGORIES.JOURNALIST,
        label: "Journalist By SOV - Entity (No. Of Article)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.JournalistEntitySOVOnline,
          print: GRAPH_DATATYPE.JournalistEntitySOVPrint,
          printandonline: GRAPH_DATATYPE.JournalistEntitySOVPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
          PIE
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.JournalistEntitySOVCCM,
        value: REPORT_TYPES.JournalistEntitySOVCCM,
        reportCategory: REPORT_CATEGORIES.JOURNALIST,
        label: "Journalist By SOV - Entity (CCM)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.JournalistEntitySOVOnline,
          print: GRAPH_DATATYPE.JournalistEntitySOVPrint,
          printandonline: GRAPH_DATATYPE.JournalistEntitySOVPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
          PIE
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.JournalistEntitySOVMAV,
        value: REPORT_TYPES.JournalistEntitySOVMAV,
        reportCategory: REPORT_CATEGORIES.JOURNALIST,
        label: "Journalist By SOV - Entity (MAV)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.JournalistEntitySOVOnline,
          print: GRAPH_DATATYPE.JournalistEntitySOVPrint,
          printandonline: GRAPH_DATATYPE.JournalistEntitySOVPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
          PIE
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.JournalistEntitySOVReach,
        value: REPORT_TYPES.JournalistEntitySOVReach,
        reportCategory: REPORT_CATEGORIES.JOURNALIST,
        label: "Journalist By SOV - Entity (Reach)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.JournalistEntitySOVOnline,
          print: GRAPH_DATATYPE.JournalistEntitySOVPrint,
          printandonline: GRAPH_DATATYPE.JournalistEntitySOVPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
          PIE
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.JournalistEntitySOVWordCount,
        value: REPORT_TYPES.JournalistEntitySOVWordCount,
        reportCategory: REPORT_CATEGORIES.JOURNALIST,
        label: "Journalist By SOV - Entity (Word Count)",
        enablePrint: false,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.JournalistEntitySOVOnline,
          printandonline: GRAPH_DATATYPE.JournalistEntitySOVPrintOnline,
        },
        verticalList: [V_ONLINE],
        groupByField: "entity_name",
        excludeGraphType: [
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
          PIE
        ],
        entityKey: "entity_name",
        countKey: "index",
      },

      // Journalist - Enitity - Tonality

      {
        id: REPORT_TYPES.JournalistEntityTonalityIndex,
        value: REPORT_TYPES.JournalistEntityTonalityIndex,
        reportCategory: REPORT_CATEGORIES.JOURNALIST,
        label: "Journalist By Tonality - Entity (Index)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.JournalistEntityTonalityOnline,
          print: GRAPH_DATATYPE.JournalistEntityTonalityPrint,
          printandonline: GRAPH_DATATYPE.JournalistEntityTonalityPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
          PIE
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.JournalistEntityTonalityNOA,
        value: REPORT_TYPES.JournalistEntityTonalityNOA,
        reportCategory: REPORT_CATEGORIES.JOURNALIST,
        label: "Journalist By Tonality - Entity (No. Of Article)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.JournalistEntityTonalityOnline,
          print: GRAPH_DATATYPE.JournalistEntityTonalityPrint,
          printandonline: GRAPH_DATATYPE.JournalistEntityTonalityPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
          PIE
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.JournalistEntityTonalityCCM,
        value: REPORT_TYPES.JournalistEntityTonalityCCM,
        reportCategory: REPORT_CATEGORIES.JOURNALIST,
        label: "Journalist By Tonality - Entity (CCM)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.JournalistEntityTonalityOnline,
          print: GRAPH_DATATYPE.JournalistEntityTonalityPrint,
          printandonline: GRAPH_DATATYPE.JournalistEntityTonalityPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
          PIE
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.JournalistEntityTonalityMAV,
        value: REPORT_TYPES.JournalistEntityTonalityMAV,
        reportCategory: REPORT_CATEGORIES.JOURNALIST,
        label: "Journalist By Tonality - Entity (MAV)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.JournalistEntityTonalityOnline,
          print: GRAPH_DATATYPE.JournalistEntityTonalityPrint,
          printandonline: GRAPH_DATATYPE.JournalistEntityTonalityPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
          PIE
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.JournalistEntityTonalityReach,
        value: REPORT_TYPES.JournalistEntityTonalityReach,
        reportCategory: REPORT_CATEGORIES.JOURNALIST,
        label: "Journalist By Tonality - Entity (Reach)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.JournalistEntityTonalityOnline,
          print: GRAPH_DATATYPE.JournalistEntityTonalityPrint,
          printandonline: GRAPH_DATATYPE.JournalistEntityTonalityPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
          PIE
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.JournalistEntityTonalityWordCount,
        value: REPORT_TYPES.JournalistEntityTonalityWordCount,
        reportCategory: REPORT_CATEGORIES.JOURNALIST,
        label: "Journalist By Tonality - Entity (Word Count)",
        enablePrint: false,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.JournalistEntityTonalityOnline,
          printandonline: GRAPH_DATATYPE.JournalistEntityTonalityPrintOnline,
        },
        verticalList: [V_ONLINE],
        groupByField: "entity_name",
        excludeGraphType: [
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
          PIE
        ],
        entityKey: "entity_name",
        countKey: "index",
      },



      //Journalist - Keyword - Trend
      {
        id: REPORT_TYPES.JournalistKeywordTrendIndex,
        value: REPORT_TYPES.JournalistKeywordTrendIndex,
        reportCategory: REPORT_CATEGORIES.JOURNALIST,
        label: "Journalist By Trend - Keyword (Index)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.JournalistKeywordTrendOnline,
          print: GRAPH_DATATYPE.JournalistKeywordTrendPrint,
          printandonline: GRAPH_DATATYPE.JournalistKeywordTrendPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.JournalistKeywordTrendNOA,
        value: REPORT_TYPES.JournalistKeywordTrendNOA,
        reportCategory: REPORT_CATEGORIES.JOURNALIST,
        label: "Journalist By Trend - Keyword (No. Of Article)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.JournalistKeywordTrendOnline,
          print: GRAPH_DATATYPE.JournalistKeywordTrendPrint,
          printandonline: GRAPH_DATATYPE.JournalistKeywordTrendPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.JournalistKeywordTrendCCM,
        value: REPORT_TYPES.JournalistKeywordTrendCCM,
        reportCategory: REPORT_CATEGORIES.JOURNALIST,
        label: "Journalist By Trend - Keyword (CCM)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.JournalistKeywordTrendOnline,
          print: GRAPH_DATATYPE.JournalistKeywordTrendPrint,
          printandonline: GRAPH_DATATYPE.JournalistKeywordTrendPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.JournalistKeywordTrendMAV,
        value: REPORT_TYPES.JournalistKeywordTrendMAV,
        reportCategory: REPORT_CATEGORIES.JOURNALIST,
        label: "Journalist By Trend - Keyword (MAV)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.JournalistKeywordTrendOnline,
          print: GRAPH_DATATYPE.JournalistKeywordTrendPrint,
          printandonline: GRAPH_DATATYPE.JournalistKeywordTrendPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.JournalistKeywordTrendReach,
        value: REPORT_TYPES.JournalistKeywordTrendReach,
        reportCategory: REPORT_CATEGORIES.JOURNALIST,
        label: "Journalist By Trend - Keyword (Reach)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.JournalistKeywordTrendOnline,
          print: GRAPH_DATATYPE.JournalistKeywordTrendPrint,
          printandonline: GRAPH_DATATYPE.JournalistKeywordTrendPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,
          BAR_STACKED_EQUAL_HEIGHT,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.JournalistKeywordTrendWordCount,
        value: REPORT_TYPES.JournalistKeywordTrendWordCount,
        reportCategory: REPORT_CATEGORIES.JOURNALIST,
        label: "Journalist By Trend - Keyword (Word Count)",
        enablePrint: false,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.JournalistKeywordTrendOnline,
          printandonline: GRAPH_DATATYPE.JournalistKeywordTrendPrintOnline,
        },
        verticalList: [V_ONLINE],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },


      // Journalist - Enitity - SOV

      {
        id: REPORT_TYPES.JournalistKeywordSOVIndex,
        value: REPORT_TYPES.JournalistKeywordSOVIndex,
        reportCategory: REPORT_CATEGORIES.JOURNALIST,
        label: "Journalist By SOV - Keyword (Index)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.JournalistKeywordSOVOnline,
          print: GRAPH_DATATYPE.JournalistKeywordSOVPrint,
          printandonline: GRAPH_DATATYPE.JournalistKeywordSOVPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
          PIE
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.JournalistKeywordSOVNOA,
        value: REPORT_TYPES.JournalistKeywordSOVNOA,
        reportCategory: REPORT_CATEGORIES.JOURNALIST,
        label: "Journalist By SOV - Keyword (No. Of Article)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.JournalistKeywordSOVOnline,
          print: GRAPH_DATATYPE.JournalistKeywordSOVPrint,
          printandonline: GRAPH_DATATYPE.JournalistKeywordSOVPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
          PIE
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.JournalistKeywordSOVCCM,
        value: REPORT_TYPES.JournalistKeywordSOVCCM,
        reportCategory: REPORT_CATEGORIES.JOURNALIST,
        label: "Journalist By SOV - Keyword (CCM)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.JournalistKeywordSOVOnline,
          print: GRAPH_DATATYPE.JournalistKeywordSOVPrint,
          printandonline: GRAPH_DATATYPE.JournalistKeywordSOVPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
          PIE
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.JournalistKeywordSOVMAV,
        value: REPORT_TYPES.JournalistKeywordSOVMAV,
        reportCategory: REPORT_CATEGORIES.JOURNALIST,
        label: "Journalist By SOV - Keyword (MAV)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.JournalistKeywordSOVOnline,
          print: GRAPH_DATATYPE.JournalistKeywordSOVPrint,
          printandonline: GRAPH_DATATYPE.JournalistKeywordSOVPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
          PIE
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.JournalistKeywordSOVReach,
        value: REPORT_TYPES.JournalistKeywordSOVReach,
        reportCategory: REPORT_CATEGORIES.JOURNALIST,
        label: "Journalist By SOV - Keyword (Reach)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.JournalistKeywordSOVOnline,
          print: GRAPH_DATATYPE.JournalistKeywordSOVPrint,
          printandonline: GRAPH_DATATYPE.JournalistKeywordSOVPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
          PIE
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.JournalistKeywordSOVWordCount,
        value: REPORT_TYPES.JournalistKeywordSOVWordCount,
        reportCategory: REPORT_CATEGORIES.JOURNALIST,
        label: "Journalist By SOV - Keyword (Word Count)",
        enablePrint: false,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.JournalistKeywordSOVOnline,
          printandonline: GRAPH_DATATYPE.JournalistKeywordSOVPrintOnline,
        },
        verticalList: [V_ONLINE],
        groupByField: "entity_name",
        excludeGraphType: [
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
          PIE
        ],
        entityKey: "entity_name",
        countKey: "index",
      },

      // Journalist - Enitity - Tonality

      {
        id: REPORT_TYPES.JournalistKeywordTonalityIndex,
        value: REPORT_TYPES.JournalistKeywordTonalityIndex,
        reportCategory: REPORT_CATEGORIES.JOURNALIST,
        label: "Journalist By Tonality - Keyword (Index)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.JournalistKeywordTonalityOnline,
          print: GRAPH_DATATYPE.JournalistKeywordTonalityPrint,
          printandonline: GRAPH_DATATYPE.JournalistKeywordTonalityPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
          PIE
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.JournalistKeywordTonalityNOA,
        value: REPORT_TYPES.JournalistKeywordTonalityNOA,
        reportCategory: REPORT_CATEGORIES.JOURNALIST,
        label: "Journalist By Tonality - Keyword (No. Of Article)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.JournalistKeywordTonalityOnline,
          print: GRAPH_DATATYPE.JournalistKeywordTonalityPrint,
          printandonline: GRAPH_DATATYPE.JournalistKeywordTonalityPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
          PIE
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.JournalistKeywordTonalityCCM,
        value: REPORT_TYPES.JournalistKeywordTonalityCCM,
        reportCategory: REPORT_CATEGORIES.JOURNALIST,
        label: "Journalist By Tonality - Keyword (CCM)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.JournalistKeywordTonalityOnline,
          print: GRAPH_DATATYPE.JournalistKeywordTonalityPrint,
          printandonline: GRAPH_DATATYPE.JournalistKeywordTonalityPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
          PIE
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.JournalistKeywordTonalityMAV,
        value: REPORT_TYPES.JournalistKeywordTonalityMAV,
        reportCategory: REPORT_CATEGORIES.JOURNALIST,
        label: "Journalist By Tonality - Keyword (MAV)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.JournalistKeywordTonalityOnline,
          print: GRAPH_DATATYPE.JournalistKeywordTonalityPrint,
          printandonline: GRAPH_DATATYPE.JournalistKeywordTonalityPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
          PIE
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.JournalistKeywordTonalityReach,
        value: REPORT_TYPES.JournalistKeywordTonalityReach,
        reportCategory: REPORT_CATEGORIES.JOURNALIST,
        label: "Journalist By Tonality - Keyword (Reach)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.JournalistKeywordTonalityOnline,
          print: GRAPH_DATATYPE.JournalistKeywordTonalityPrint,
          printandonline: GRAPH_DATATYPE.JournalistKeywordTonalityPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
          PIE
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.JournalistKeywordTonalityWordCount,
        value: REPORT_TYPES.JournalistKeywordTonalityWordCount,
        reportCategory: REPORT_CATEGORIES.JOURNALIST,
        label: "Journalist By Tonality - Keyword (Word Count)",
        enablePrint: false,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.JournalistKeywordTonalityOnline,
          printandonline: GRAPH_DATATYPE.JournalistKeywordTonalityPrintOnline,
        },
        verticalList: [V_ONLINE],
        groupByField: "entity_name",
        excludeGraphType: [
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
          PIE
        ],
        entityKey: "entity_name",
        countKey: "index",
      },


      // Journalist inline ends


      // Keyword inline starts

      //Keyword - Entity - Trend
      {
        id: REPORT_TYPES.KeywordEntityTrendIndex,
        value: REPORT_TYPES.KeywordEntityTrendIndex,
        reportCategory: REPORT_CATEGORIES.KEYWORD_CLOUD,
        label: "Keyword By Trend - Entity (Index)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.KeywordEntityTrendOnline,
          print: GRAPH_DATATYPE.KeywordEntityTrendPrint,
          printandonline: GRAPH_DATATYPE.KeywordEntityTrendPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.KeywordEntityTrendNOA,
        value: REPORT_TYPES.KeywordEntityTrendNOA,
        reportCategory: REPORT_CATEGORIES.KEYWORD_CLOUD,
        label: "Keyword By Trend - Entity (No. Of Article)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.KeywordEntityTrendOnline,
          print: GRAPH_DATATYPE.KeywordEntityTrendPrint,
          printandonline: GRAPH_DATATYPE.KeywordEntityTrendPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.KeywordEntityTrendCCM,
        value: REPORT_TYPES.KeywordEntityTrendCCM,
        reportCategory: REPORT_CATEGORIES.KEYWORD_CLOUD,
        label: "Keyword By Trend - Entity (CCM)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.KeywordEntityTrendOnline,
          print: GRAPH_DATATYPE.KeywordEntityTrendPrint,
          printandonline: GRAPH_DATATYPE.KeywordEntityTrendPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.KeywordEntityTrendMAV,
        value: REPORT_TYPES.KeywordEntityTrendMAV,
        reportCategory: REPORT_CATEGORIES.KEYWORD_CLOUD,
        label: "Keyword By Trend - Entity (MAV)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.KeywordEntityTrendOnline,
          print: GRAPH_DATATYPE.KeywordEntityTrendPrint,
          printandonline: GRAPH_DATATYPE.KeywordEntityTrendPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.KeywordEntityTrendReach,
        value: REPORT_TYPES.KeywordEntityTrendReach,
        reportCategory: REPORT_CATEGORIES.KEYWORD_CLOUD,
        label: "Keyword By Trend - Entity (Reach)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.KeywordEntityTrendOnline,
          print: GRAPH_DATATYPE.KeywordEntityTrendPrint,
          printandonline: GRAPH_DATATYPE.KeywordEntityTrendPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,
          BAR_STACKED_EQUAL_HEIGHT,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.KeywordEntityTrendWordCount,
        value: REPORT_TYPES.KeywordEntityTrendWordCount,
        reportCategory: REPORT_CATEGORIES.KEYWORD_CLOUD,
        label: "Keyword By Trend - Entity (Word Count)",
        enablePrint: false,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.KeywordEntityTrendOnline,
          printandonline: GRAPH_DATATYPE.KeywordEntityTrendPrintOnline,
        },
        verticalList: [V_ONLINE],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },


      // Keyword - Enitity - SOV

      {
        id: REPORT_TYPES.KeywordEntitySOVIndex,
        value: REPORT_TYPES.KeywordEntitySOVIndex,
        reportCategory: REPORT_CATEGORIES.KEYWORD_CLOUD,
        label: "Keyword By SOV - Entity (Index)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.KeywordEntitySOVOnline,
          print: GRAPH_DATATYPE.KeywordEntitySOVPrint,
          printandonline: GRAPH_DATATYPE.KeywordEntitySOVPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
          PIE
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.KeywordEntitySOVNOA,
        value: REPORT_TYPES.KeywordEntitySOVNOA,
        reportCategory: REPORT_CATEGORIES.KEYWORD_CLOUD,
        label: "Keyword By SOV - Entity (No. Of Article)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.KeywordEntitySOVOnline,
          print: GRAPH_DATATYPE.KeywordEntitySOVPrint,
          printandonline: GRAPH_DATATYPE.KeywordEntitySOVPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
          PIE
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.KeywordEntitySOVCCM,
        value: REPORT_TYPES.KeywordEntitySOVCCM,
        reportCategory: REPORT_CATEGORIES.KEYWORD_CLOUD,
        label: "Keyword By SOV - Entity (CCM)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.KeywordEntitySOVOnline,
          print: GRAPH_DATATYPE.KeywordEntitySOVPrint,
          printandonline: GRAPH_DATATYPE.KeywordEntitySOVPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
          PIE
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.KeywordEntitySOVMAV,
        value: REPORT_TYPES.KeywordEntitySOVMAV,
        reportCategory: REPORT_CATEGORIES.KEYWORD_CLOUD,
        label: "Keyword By SOV - Entity (MAV)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.KeywordEntitySOVOnline,
          print: GRAPH_DATATYPE.KeywordEntitySOVPrint,
          printandonline: GRAPH_DATATYPE.KeywordEntitySOVPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
          PIE
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.KeywordEntitySOVReach,
        value: REPORT_TYPES.KeywordEntitySOVReach,
        reportCategory: REPORT_CATEGORIES.KEYWORD_CLOUD,
        label: "Keyword By SOV - Entity (Reach)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.KeywordEntitySOVOnline,
          print: GRAPH_DATATYPE.KeywordEntitySOVPrint,
          printandonline: GRAPH_DATATYPE.KeywordEntitySOVPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
          PIE
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.KeywordEntitySOVWordCount,
        value: REPORT_TYPES.KeywordEntitySOVWordCount,
        reportCategory: REPORT_CATEGORIES.KEYWORD_CLOUD,
        label: "Keyword By SOV - Entity (Word Count)",
        enablePrint: false,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.KeywordEntitySOVOnline,
          printandonline: GRAPH_DATATYPE.KeywordEntitySOVPrintOnline,
        },
        verticalList: [V_ONLINE],
        groupByField: "entity_name",
        excludeGraphType: [
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
          PIE
        ],
        entityKey: "entity_name",
        countKey: "index",
      },

      // Keyword - Enitity - Tonality

      {
        id: REPORT_TYPES.KeywordEntityTonalityIndex,
        value: REPORT_TYPES.KeywordEntityTonalityIndex,
        reportCategory: REPORT_CATEGORIES.KEYWORD_CLOUD,
        label: "Keyword By Tonality - Entity (Index)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.KeywordEntityTonalityOnline,
          print: GRAPH_DATATYPE.KeywordEntityTonalityPrint,
          printandonline: GRAPH_DATATYPE.KeywordEntityTonalityPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
          PIE
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.KeywordEntityTonalityNOA,
        value: REPORT_TYPES.KeywordEntityTonalityNOA,
        reportCategory: REPORT_CATEGORIES.KEYWORD_CLOUD,
        label: "Keyword By Tonality - Entity (No. Of Article)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.KeywordEntityTonalityOnline,
          print: GRAPH_DATATYPE.KeywordEntityTonalityPrint,
          printandonline: GRAPH_DATATYPE.KeywordEntityTonalityPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
          PIE
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.KeywordEntityTonalityCCM,
        value: REPORT_TYPES.KeywordEntityTonalityCCM,
        reportCategory: REPORT_CATEGORIES.KEYWORD_CLOUD,
        label: "Keyword By Tonality - Entity (CCM)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.KeywordEntityTonalityOnline,
          print: GRAPH_DATATYPE.KeywordEntityTonalityPrint,
          printandonline: GRAPH_DATATYPE.KeywordEntityTonalityPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
          PIE
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.KeywordEntityTonalityMAV,
        value: REPORT_TYPES.KeywordEntityTonalityMAV,
        reportCategory: REPORT_CATEGORIES.KEYWORD_CLOUD,
        label: "Keyword By Tonality - Entity (MAV)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.KeywordEntityTonalityOnline,
          print: GRAPH_DATATYPE.KeywordEntityTonalityPrint,
          printandonline: GRAPH_DATATYPE.KeywordEntityTonalityPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
          PIE
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.KeywordEntityTonalityReach,
        value: REPORT_TYPES.KeywordEntityTonalityReach,
        reportCategory: REPORT_CATEGORIES.KEYWORD_CLOUD,
        label: "Keyword By Tonality - Entity (Reach)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.KeywordEntityTonalityOnline,
          print: GRAPH_DATATYPE.KeywordEntityTonalityPrint,
          printandonline: GRAPH_DATATYPE.KeywordEntityTonalityPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
          PIE
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.KeywordEntityTonalityWordCount,
        value: REPORT_TYPES.KeywordEntityTonalityWordCount,
        reportCategory: REPORT_CATEGORIES.KEYWORD_CLOUD,
        label: "Keyword By Tonality - Entity (Word Count)",
        enablePrint: false,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.KeywordEntityTonalityOnline,
          printandonline: GRAPH_DATATYPE.KeywordEntityTonalityPrintOnline,
        },
        verticalList: [V_ONLINE],
        groupByField: "entity_name",
        excludeGraphType: [
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
          PIE
        ],
        entityKey: "entity_name",
        countKey: "index",
      },


      //Keyword - Publication - Trend
      {
        id: REPORT_TYPES.KeywordPublicationTrendIndex,
        value: REPORT_TYPES.KeywordPublicationTrendIndex,
        reportCategory: REPORT_CATEGORIES.KEYWORD_CLOUD,
        label: "Keyword By Trend - Publication (Index)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.KeywordPublicationTrendOnline,
          print: GRAPH_DATATYPE.KeywordPublicationTrendPrint,
          printandonline: GRAPH_DATATYPE.KeywordPublicationTrendPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.KeywordPublicationTrendNOA,
        value: REPORT_TYPES.KeywordPublicationTrendNOA,
        reportCategory: REPORT_CATEGORIES.KEYWORD_CLOUD,
        label: "Keyword By Trend - Publication (No. Of Article)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.KeywordPublicationTrendOnline,
          print: GRAPH_DATATYPE.KeywordPublicationTrendPrint,
          printandonline: GRAPH_DATATYPE.KeywordPublicationTrendPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.KeywordPublicationTrendCCM,
        value: REPORT_TYPES.KeywordPublicationTrendCCM,
        reportCategory: REPORT_CATEGORIES.KEYWORD_CLOUD,
        label: "Keyword By Trend - Publication (CCM)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.KeywordPublicationTrendOnline,
          print: GRAPH_DATATYPE.KeywordPublicationTrendPrint,
          printandonline: GRAPH_DATATYPE.KeywordPublicationTrendPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.KeywordPublicationTrendMAV,
        value: REPORT_TYPES.KeywordPublicationTrendMAV,
        reportCategory: REPORT_CATEGORIES.KEYWORD_CLOUD,
        label: "Keyword By Trend - Publication (MAV)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.KeywordPublicationTrendOnline,
          print: GRAPH_DATATYPE.KeywordPublicationTrendPrint,
          printandonline: GRAPH_DATATYPE.KeywordPublicationTrendPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.KeywordPublicationTrendReach,
        value: REPORT_TYPES.KeywordPublicationTrendReach,
        reportCategory: REPORT_CATEGORIES.KEYWORD_CLOUD,
        label: "Keyword By Trend - Publication (Reach)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.KeywordPublicationTrendOnline,
          print: GRAPH_DATATYPE.KeywordPublicationTrendPrint,
          printandonline: GRAPH_DATATYPE.KeywordPublicationTrendPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,
          BAR_STACKED_EQUAL_HEIGHT,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.KeywordPublicationTrendWordCount,
        value: REPORT_TYPES.KeywordPublicationTrendWordCount,
        reportCategory: REPORT_CATEGORIES.KEYWORD_CLOUD,
        label: "Keyword By Trend - Publication (Word Count)",
        enablePrint: false,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.KeywordPublicationTrendOnline,
          printandonline: GRAPH_DATATYPE.KeywordPublicationTrendPrintOnline,
        },
        verticalList: [V_ONLINE],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },


      // Keyword - Enitity - SOV

      {
        id: REPORT_TYPES.KeywordPublicationSOVIndex,
        value: REPORT_TYPES.KeywordPublicationSOVIndex,
        reportCategory: REPORT_CATEGORIES.KEYWORD_CLOUD,
        label: "Keyword By SOV - Publication (Index)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.KeywordPublicationSOVOnline,
          print: GRAPH_DATATYPE.KeywordPublicationSOVPrint,
          printandonline: GRAPH_DATATYPE.KeywordPublicationSOVPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
          PIE
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.KeywordPublicationSOVNOA,
        value: REPORT_TYPES.KeywordPublicationSOVNOA,
        reportCategory: REPORT_CATEGORIES.KEYWORD_CLOUD,
        label: "Keyword By SOV - Publication (No. Of Article)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.KeywordPublicationSOVOnline,
          print: GRAPH_DATATYPE.KeywordPublicationSOVPrint,
          printandonline: GRAPH_DATATYPE.KeywordPublicationSOVPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
          PIE
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.KeywordPublicationSOVCCM,
        value: REPORT_TYPES.KeywordPublicationSOVCCM,
        reportCategory: REPORT_CATEGORIES.KEYWORD_CLOUD,
        label: "Keyword By SOV - Publication (CCM)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.KeywordPublicationSOVOnline,
          print: GRAPH_DATATYPE.KeywordPublicationSOVPrint,
          printandonline: GRAPH_DATATYPE.KeywordPublicationSOVPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
          PIE
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.KeywordPublicationSOVMAV,
        value: REPORT_TYPES.KeywordPublicationSOVMAV,
        reportCategory: REPORT_CATEGORIES.KEYWORD_CLOUD,
        label: "Keyword By SOV - Publication (MAV)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.KeywordPublicationSOVOnline,
          print: GRAPH_DATATYPE.KeywordPublicationSOVPrint,
          printandonline: GRAPH_DATATYPE.KeywordPublicationSOVPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
          PIE
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.KeywordPublicationSOVReach,
        value: REPORT_TYPES.KeywordPublicationSOVReach,
        reportCategory: REPORT_CATEGORIES.KEYWORD_CLOUD,
        label: "Keyword By SOV - Publication (Reach)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.KeywordPublicationSOVOnline,
          print: GRAPH_DATATYPE.KeywordPublicationSOVPrint,
          printandonline: GRAPH_DATATYPE.KeywordPublicationSOVPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
          PIE
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.KeywordPublicationSOVWordCount,
        value: REPORT_TYPES.KeywordPublicationSOVWordCount,
        reportCategory: REPORT_CATEGORIES.KEYWORD_CLOUD,
        label: "Keyword By SOV - Publication (Word Count)",
        enablePrint: false,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.KeywordPublicationSOVOnline,
          printandonline: GRAPH_DATATYPE.KeywordPublicationSOVPrintOnline,
        },
        verticalList: [V_ONLINE],
        groupByField: "entity_name",
        excludeGraphType: [
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
          PIE
        ],
        entityKey: "entity_name",
        countKey: "index",
      },

      // Keyword - Enitity - Tonality

      {
        id: REPORT_TYPES.KeywordPublicationTonalityIndex,
        value: REPORT_TYPES.KeywordPublicationTonalityIndex,
        reportCategory: REPORT_CATEGORIES.KEYWORD_CLOUD,
        label: "Keyword By Tonality - Publication (Index)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.KeywordPublicationTonalityOnline,
          print: GRAPH_DATATYPE.KeywordPublicationTonalityPrint,
          printandonline: GRAPH_DATATYPE.KeywordPublicationTonalityPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
          PIE
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.KeywordPublicationTonalityNOA,
        value: REPORT_TYPES.KeywordPublicationTonalityNOA,
        reportCategory: REPORT_CATEGORIES.KEYWORD_CLOUD,
        label: "Keyword By Tonality - Publication (No. Of Article)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.KeywordPublicationTonalityOnline,
          print: GRAPH_DATATYPE.KeywordPublicationTonalityPrint,
          printandonline: GRAPH_DATATYPE.KeywordPublicationTonalityPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
          PIE
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.KeywordPublicationTonalityCCM,
        value: REPORT_TYPES.KeywordPublicationTonalityCCM,
        reportCategory: REPORT_CATEGORIES.KEYWORD_CLOUD,
        label: "Keyword By Tonality - Publication (CCM)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.KeywordPublicationTonalityOnline,
          print: GRAPH_DATATYPE.KeywordPublicationTonalityPrint,
          printandonline: GRAPH_DATATYPE.KeywordPublicationTonalityPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
          PIE
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.KeywordPublicationTonalityMAV,
        value: REPORT_TYPES.KeywordPublicationTonalityMAV,
        reportCategory: REPORT_CATEGORIES.KEYWORD_CLOUD,
        label: "Keyword By Tonality - Publication (MAV)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.KeywordPublicationTonalityOnline,
          print: GRAPH_DATATYPE.KeywordPublicationTonalityPrint,
          printandonline: GRAPH_DATATYPE.KeywordPublicationTonalityPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
          PIE
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.KeywordPublicationTonalityReach,
        value: REPORT_TYPES.KeywordPublicationTonalityReach,
        reportCategory: REPORT_CATEGORIES.KEYWORD_CLOUD,
        label: "Keyword By Tonality - Publication (Reach)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.KeywordPublicationTonalityOnline,
          print: GRAPH_DATATYPE.KeywordPublicationTonalityPrint,
          printandonline: GRAPH_DATATYPE.KeywordPublicationTonalityPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
          PIE
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.KeywordPublicationTonalityWordCount,
        value: REPORT_TYPES.KeywordPublicationTonalityWordCount,
        reportCategory: REPORT_CATEGORIES.KEYWORD_CLOUD,
        label: "Keyword By Tonality - Publication (Word Count)",
        enablePrint: false,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.KeywordPublicationTonalityOnline,
          printandonline: GRAPH_DATATYPE.KeywordPublicationTonalityPrintOnline,
        },
        verticalList: [V_ONLINE],
        groupByField: "entity_name",
        excludeGraphType: [
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
          PIE
        ],
        entityKey: "entity_name",
        countKey: "index",
      },


      //Keyword - Journalist - Trend
      {
        id: REPORT_TYPES.KeywordJournalistTrendIndex,
        value: REPORT_TYPES.KeywordJournalistTrendIndex,
        reportCategory: REPORT_CATEGORIES.KEYWORD_CLOUD,
        label: "Keyword By Trend - Journalist (Index)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.KeywordJournalistTrendOnline,
          print: GRAPH_DATATYPE.KeywordJournalistTrendPrint,
          printandonline: GRAPH_DATATYPE.KeywordJournalistTrendPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.KeywordJournalistTrendNOA,
        value: REPORT_TYPES.KeywordJournalistTrendNOA,
        reportCategory: REPORT_CATEGORIES.KEYWORD_CLOUD,
        label: "Keyword By Trend - Journalist (No. Of Article)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.KeywordJournalistTrendOnline,
          print: GRAPH_DATATYPE.KeywordJournalistTrendPrint,
          printandonline: GRAPH_DATATYPE.KeywordJournalistTrendPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.KeywordJournalistTrendCCM,
        value: REPORT_TYPES.KeywordJournalistTrendCCM,
        reportCategory: REPORT_CATEGORIES.KEYWORD_CLOUD,
        label: "Keyword By Trend - Journalist (CCM)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.KeywordJournalistTrendOnline,
          print: GRAPH_DATATYPE.KeywordJournalistTrendPrint,
          printandonline: GRAPH_DATATYPE.KeywordJournalistTrendPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.KeywordJournalistTrendMAV,
        value: REPORT_TYPES.KeywordJournalistTrendMAV,
        reportCategory: REPORT_CATEGORIES.KEYWORD_CLOUD,
        label: "Keyword By Trend - Journalist (MAV)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.KeywordJournalistTrendOnline,
          print: GRAPH_DATATYPE.KeywordJournalistTrendPrint,
          printandonline: GRAPH_DATATYPE.KeywordJournalistTrendPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.KeywordJournalistTrendReach,
        value: REPORT_TYPES.KeywordJournalistTrendReach,
        reportCategory: REPORT_CATEGORIES.KEYWORD_CLOUD,
        label: "Keyword By Trend - Journalist (Reach)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.KeywordJournalistTrendOnline,
          print: GRAPH_DATATYPE.KeywordJournalistTrendPrint,
          printandonline: GRAPH_DATATYPE.KeywordJournalistTrendPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,
          BAR_STACKED_EQUAL_HEIGHT,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.KeywordJournalistTrendWordCount,
        value: REPORT_TYPES.KeywordJournalistTrendWordCount,
        reportCategory: REPORT_CATEGORIES.KEYWORD_CLOUD,
        label: "Keyword By Trend - Journalist (Word Count)",
        enablePrint: false,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.KeywordJournalistTrendOnline,
          printandonline: GRAPH_DATATYPE.KeywordJournalistTrendPrintOnline,
        },
        verticalList: [V_ONLINE],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },


      // Keyword - Enitity - SOV

      {
        id: REPORT_TYPES.KeywordJournalistSOVIndex,
        value: REPORT_TYPES.KeywordJournalistSOVIndex,
        reportCategory: REPORT_CATEGORIES.KEYWORD_CLOUD,
        label: "Keyword By SOV - Journalist (Index)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.KeywordJournalistSOVOnline,
          print: GRAPH_DATATYPE.KeywordJournalistSOVPrint,
          printandonline: GRAPH_DATATYPE.KeywordJournalistSOVPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
          PIE
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.KeywordJournalistSOVNOA,
        value: REPORT_TYPES.KeywordJournalistSOVNOA,
        reportCategory: REPORT_CATEGORIES.KEYWORD_CLOUD,
        label: "Keyword By SOV - Journalist (No. Of Article)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.KeywordJournalistSOVOnline,
          print: GRAPH_DATATYPE.KeywordJournalistSOVPrint,
          printandonline: GRAPH_DATATYPE.KeywordJournalistSOVPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
          PIE
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.KeywordJournalistSOVCCM,
        value: REPORT_TYPES.KeywordJournalistSOVCCM,
        reportCategory: REPORT_CATEGORIES.KEYWORD_CLOUD,
        label: "Keyword By SOV - Journalist (CCM)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.KeywordJournalistSOVOnline,
          print: GRAPH_DATATYPE.KeywordJournalistSOVPrint,
          printandonline: GRAPH_DATATYPE.KeywordJournalistSOVPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
          PIE
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.KeywordJournalistSOVMAV,
        value: REPORT_TYPES.KeywordJournalistSOVMAV,
        reportCategory: REPORT_CATEGORIES.KEYWORD_CLOUD,
        label: "Keyword By SOV - Journalist (MAV)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.KeywordJournalistSOVOnline,
          print: GRAPH_DATATYPE.KeywordJournalistSOVPrint,
          printandonline: GRAPH_DATATYPE.KeywordJournalistSOVPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
          PIE
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.KeywordJournalistSOVReach,
        value: REPORT_TYPES.KeywordJournalistSOVReach,
        reportCategory: REPORT_CATEGORIES.KEYWORD_CLOUD,
        label: "Keyword By SOV - Journalist (Reach)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.KeywordJournalistSOVOnline,
          print: GRAPH_DATATYPE.KeywordJournalistSOVPrint,
          printandonline: GRAPH_DATATYPE.KeywordJournalistSOVPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
          PIE
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.KeywordJournalistSOVWordCount,
        value: REPORT_TYPES.KeywordJournalistSOVWordCount,
        reportCategory: REPORT_CATEGORIES.KEYWORD_CLOUD,
        label: "Keyword By SOV - Journalist (Word Count)",
        enablePrint: false,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.KeywordJournalistSOVOnline,
          printandonline: GRAPH_DATATYPE.KeywordJournalistSOVPrintOnline,
        },
        verticalList: [V_ONLINE],
        groupByField: "entity_name",
        excludeGraphType: [
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
          PIE
        ],
        entityKey: "entity_name",
        countKey: "index",
      },

      // Keyword - Enitity - Tonality

      {
        id: REPORT_TYPES.KeywordJournalistTonalityIndex,
        value: REPORT_TYPES.KeywordJournalistTonalityIndex,
        reportCategory: REPORT_CATEGORIES.KEYWORD_CLOUD,
        label: "Keyword By Tonality - Journalist (Index)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.KeywordJournalistTonalityOnline,
          print: GRAPH_DATATYPE.KeywordJournalistTonalityPrint,
          printandonline: GRAPH_DATATYPE.KeywordJournalistTonalityPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
          PIE
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.KeywordJournalistTonalityNOA,
        value: REPORT_TYPES.KeywordJournalistTonalityNOA,
        reportCategory: REPORT_CATEGORIES.KEYWORD_CLOUD,
        label: "Keyword By Tonality - Journalist (No. Of Article)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.KeywordJournalistTonalityOnline,
          print: GRAPH_DATATYPE.KeywordJournalistTonalityPrint,
          printandonline: GRAPH_DATATYPE.KeywordJournalistTonalityPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
          PIE
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.KeywordJournalistTonalityCCM,
        value: REPORT_TYPES.KeywordJournalistTonalityCCM,
        reportCategory: REPORT_CATEGORIES.KEYWORD_CLOUD,
        label: "Keyword By Tonality - Journalist (CCM)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.KeywordJournalistTonalityOnline,
          print: GRAPH_DATATYPE.KeywordJournalistTonalityPrint,
          printandonline: GRAPH_DATATYPE.KeywordJournalistTonalityPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
          PIE
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.KeywordJournalistTonalityMAV,
        value: REPORT_TYPES.KeywordJournalistTonalityMAV,
        reportCategory: REPORT_CATEGORIES.KEYWORD_CLOUD,
        label: "Keyword By Tonality - Journalist (MAV)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.KeywordJournalistTonalityOnline,
          print: GRAPH_DATATYPE.KeywordJournalistTonalityPrint,
          printandonline: GRAPH_DATATYPE.KeywordJournalistTonalityPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
          PIE
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.KeywordJournalistTonalityReach,
        value: REPORT_TYPES.KeywordJournalistTonalityReach,
        reportCategory: REPORT_CATEGORIES.KEYWORD_CLOUD,
        label: "Keyword By Tonality - Journalist (Reach)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.KeywordJournalistTonalityOnline,
          print: GRAPH_DATATYPE.KeywordJournalistTonalityPrint,
          printandonline: GRAPH_DATATYPE.KeywordJournalistTonalityPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
          PIE
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.KeywordJournalistTonalityWordCount,
        value: REPORT_TYPES.KeywordJournalistTonalityWordCount,
        reportCategory: REPORT_CATEGORIES.KEYWORD_CLOUD,
        label: "Keyword By Tonality - Journalist (Word Count)",
        enablePrint: false,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.KeywordJournalistTonalityOnline,
          printandonline: GRAPH_DATATYPE.KeywordJournalistTonalityPrintOnline,
        },
        verticalList: [V_ONLINE],
        groupByField: "entity_name",
        excludeGraphType: [
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
          PIE
        ],
        entityKey: "entity_name",
        countKey: "index",
      },



      //Keyword - Spokesperson - Trend
      {
        id: REPORT_TYPES.KeywordSpokespersonTrendIndex,
        value: REPORT_TYPES.KeywordSpokespersonTrendIndex,
        reportCategory: REPORT_CATEGORIES.KEYWORD_CLOUD,
        label: "Keyword By Trend - Spokesperson (Index)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.KeywordSpokespersonTrendOnline,
          print: GRAPH_DATATYPE.KeywordSpokespersonTrendPrint,
          printandonline: GRAPH_DATATYPE.KeywordSpokespersonTrendPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.KeywordSpokespersonTrendNOA,
        value: REPORT_TYPES.KeywordSpokespersonTrendNOA,
        reportCategory: REPORT_CATEGORIES.KEYWORD_CLOUD,
        label: "Keyword By Trend - Spokesperson (No. Of Article)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.KeywordSpokespersonTrendOnline,
          print: GRAPH_DATATYPE.KeywordSpokespersonTrendPrint,
          printandonline: GRAPH_DATATYPE.KeywordSpokespersonTrendPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.KeywordSpokespersonTrendCCM,
        value: REPORT_TYPES.KeywordSpokespersonTrendCCM,
        reportCategory: REPORT_CATEGORIES.KEYWORD_CLOUD,
        label: "Keyword By Trend - Spokesperson (CCM)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.KeywordSpokespersonTrendOnline,
          print: GRAPH_DATATYPE.KeywordSpokespersonTrendPrint,
          printandonline: GRAPH_DATATYPE.KeywordSpokespersonTrendPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.KeywordSpokespersonTrendMAV,
        value: REPORT_TYPES.KeywordSpokespersonTrendMAV,
        reportCategory: REPORT_CATEGORIES.KEYWORD_CLOUD,
        label: "Keyword By Trend - Spokesperson (MAV)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.KeywordSpokespersonTrendOnline,
          print: GRAPH_DATATYPE.KeywordSpokespersonTrendPrint,
          printandonline: GRAPH_DATATYPE.KeywordSpokespersonTrendPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.KeywordSpokespersonTrendReach,
        value: REPORT_TYPES.KeywordSpokespersonTrendReach,
        reportCategory: REPORT_CATEGORIES.KEYWORD_CLOUD,
        label: "Keyword By Trend - Spokesperson (Reach)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.KeywordSpokespersonTrendOnline,
          print: GRAPH_DATATYPE.KeywordSpokespersonTrendPrint,
          printandonline: GRAPH_DATATYPE.KeywordSpokespersonTrendPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,
          BAR_STACKED_EQUAL_HEIGHT,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.KeywordSpokespersonTrendWordCount,
        value: REPORT_TYPES.KeywordSpokespersonTrendWordCount,
        reportCategory: REPORT_CATEGORIES.KEYWORD_CLOUD,
        label: "Keyword By Trend - Spokesperson (Word Count)",
        enablePrint: false,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.KeywordSpokespersonTrendOnline,
          printandonline: GRAPH_DATATYPE.KeywordSpokespersonTrendPrintOnline,
        },
        verticalList: [V_ONLINE],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },


      // Keyword - Enitity - SOV

      {
        id: REPORT_TYPES.KeywordSpokespersonSOVIndex,
        value: REPORT_TYPES.KeywordSpokespersonSOVIndex,
        reportCategory: REPORT_CATEGORIES.KEYWORD_CLOUD,
        label: "Keyword By SOV - Spokesperson (Index)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.KeywordSpokespersonSOVOnline,
          print: GRAPH_DATATYPE.KeywordSpokespersonSOVPrint,
          printandonline: GRAPH_DATATYPE.KeywordSpokespersonSOVPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
          PIE
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.KeywordSpokespersonSOVNOA,
        value: REPORT_TYPES.KeywordSpokespersonSOVNOA,
        reportCategory: REPORT_CATEGORIES.KEYWORD_CLOUD,
        label: "Keyword By SOV - Spokesperson (No. Of Article)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.KeywordSpokespersonSOVOnline,
          print: GRAPH_DATATYPE.KeywordSpokespersonSOVPrint,
          printandonline: GRAPH_DATATYPE.KeywordSpokespersonSOVPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
          PIE
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.KeywordSpokespersonSOVCCM,
        value: REPORT_TYPES.KeywordSpokespersonSOVCCM,
        reportCategory: REPORT_CATEGORIES.KEYWORD_CLOUD,
        label: "Keyword By SOV - Spokesperson (CCM)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.KeywordSpokespersonSOVOnline,
          print: GRAPH_DATATYPE.KeywordSpokespersonSOVPrint,
          printandonline: GRAPH_DATATYPE.KeywordSpokespersonSOVPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
          PIE
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.KeywordSpokespersonSOVMAV,
        value: REPORT_TYPES.KeywordSpokespersonSOVMAV,
        reportCategory: REPORT_CATEGORIES.KEYWORD_CLOUD,
        label: "Keyword By SOV - Spokesperson (MAV)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.KeywordSpokespersonSOVOnline,
          print: GRAPH_DATATYPE.KeywordSpokespersonSOVPrint,
          printandonline: GRAPH_DATATYPE.KeywordSpokespersonSOVPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
          PIE
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.KeywordSpokespersonSOVReach,
        value: REPORT_TYPES.KeywordSpokespersonSOVReach,
        reportCategory: REPORT_CATEGORIES.KEYWORD_CLOUD,
        label: "Keyword By SOV - Spokesperson (Reach)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.KeywordSpokespersonSOVOnline,
          print: GRAPH_DATATYPE.KeywordSpokespersonSOVPrint,
          printandonline: GRAPH_DATATYPE.KeywordSpokespersonSOVPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
          PIE
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.KeywordSpokespersonSOVWordCount,
        value: REPORT_TYPES.KeywordSpokespersonSOVWordCount,
        reportCategory: REPORT_CATEGORIES.KEYWORD_CLOUD,
        label: "Keyword By SOV - Spokesperson (Word Count)",
        enablePrint: false,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.KeywordSpokespersonSOVOnline,
          printandonline: GRAPH_DATATYPE.KeywordSpokespersonSOVPrintOnline,
        },
        verticalList: [V_ONLINE],
        groupByField: "entity_name",
        excludeGraphType: [
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
          PIE
        ],
        entityKey: "entity_name",
        countKey: "index",
      },

      // Keyword - Enitity - Tonality

      {
        id: REPORT_TYPES.KeywordSpokespersonTonalityIndex,
        value: REPORT_TYPES.KeywordSpokespersonTonalityIndex,
        reportCategory: REPORT_CATEGORIES.KEYWORD_CLOUD,
        label: "Keyword By Tonality - Spokesperson (Index)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.KeywordSpokespersonTonalityOnline,
          print: GRAPH_DATATYPE.KeywordSpokespersonTonalityPrint,
          printandonline: GRAPH_DATATYPE.KeywordSpokespersonTonalityPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
          PIE
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.KeywordSpokespersonTonalityNOA,
        value: REPORT_TYPES.KeywordSpokespersonTonalityNOA,
        reportCategory: REPORT_CATEGORIES.KEYWORD_CLOUD,
        label: "Keyword By Tonality - Spokesperson (No. Of Article)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.KeywordSpokespersonTonalityOnline,
          print: GRAPH_DATATYPE.KeywordSpokespersonTonalityPrint,
          printandonline: GRAPH_DATATYPE.KeywordSpokespersonTonalityPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
          PIE
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.KeywordSpokespersonTonalityCCM,
        value: REPORT_TYPES.KeywordSpokespersonTonalityCCM,
        reportCategory: REPORT_CATEGORIES.KEYWORD_CLOUD,
        label: "Keyword By Tonality - Spokesperson (CCM)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.KeywordSpokespersonTonalityOnline,
          print: GRAPH_DATATYPE.KeywordSpokespersonTonalityPrint,
          printandonline: GRAPH_DATATYPE.KeywordSpokespersonTonalityPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
          PIE
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.KeywordSpokespersonTonalityMAV,
        value: REPORT_TYPES.KeywordSpokespersonTonalityMAV,
        reportCategory: REPORT_CATEGORIES.KEYWORD_CLOUD,
        label: "Keyword By Tonality - Spokesperson (MAV)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.KeywordSpokespersonTonalityOnline,
          print: GRAPH_DATATYPE.KeywordSpokespersonTonalityPrint,
          printandonline: GRAPH_DATATYPE.KeywordSpokespersonTonalityPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
          PIE
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.KeywordSpokespersonTonalityReach,
        value: REPORT_TYPES.KeywordSpokespersonTonalityReach,
        reportCategory: REPORT_CATEGORIES.KEYWORD_CLOUD,
        label: "Keyword By Tonality - Spokesperson (Reach)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.KeywordSpokespersonTonalityOnline,
          print: GRAPH_DATATYPE.KeywordSpokespersonTonalityPrint,
          printandonline: GRAPH_DATATYPE.KeywordSpokespersonTonalityPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
          PIE
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.KeywordSpokespersonTonalityWordCount,
        value: REPORT_TYPES.KeywordSpokespersonTonalityWordCount,
        reportCategory: REPORT_CATEGORIES.KEYWORD_CLOUD,
        label: "Keyword By Tonality - Spokesperson (Word Count)",
        enablePrint: false,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.KeywordSpokespersonTonalityOnline,
          printandonline: GRAPH_DATATYPE.KeywordSpokespersonTonalityPrintOnline,
        },
        verticalList: [V_ONLINE],
        groupByField: "entity_name",
        excludeGraphType: [
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
          PIE
        ],
        entityKey: "entity_name",
        countKey: "index",
      },


      //Keyword - City - Trend
      {
        id: REPORT_TYPES.KeywordCityTrendIndex,
        value: REPORT_TYPES.KeywordCityTrendIndex,
        reportCategory: REPORT_CATEGORIES.KEYWORD_CLOUD,
        label: "Keyword By Trend - City (Index)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.KeywordCityTrendOnline,
          print: GRAPH_DATATYPE.KeywordCityTrendPrint,
          printandonline: GRAPH_DATATYPE.KeywordCityTrendPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.KeywordCityTrendNOA,
        value: REPORT_TYPES.KeywordCityTrendNOA,
        reportCategory: REPORT_CATEGORIES.KEYWORD_CLOUD,
        label: "Keyword By Trend - City (No. Of Article)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.KeywordCityTrendOnline,
          print: GRAPH_DATATYPE.KeywordCityTrendPrint,
          printandonline: GRAPH_DATATYPE.KeywordCityTrendPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.KeywordCityTrendCCM,
        value: REPORT_TYPES.KeywordCityTrendCCM,
        reportCategory: REPORT_CATEGORIES.KEYWORD_CLOUD,
        label: "Keyword By Trend - City (CCM)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.KeywordCityTrendOnline,
          print: GRAPH_DATATYPE.KeywordCityTrendPrint,
          printandonline: GRAPH_DATATYPE.KeywordCityTrendPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.KeywordCityTrendMAV,
        value: REPORT_TYPES.KeywordCityTrendMAV,
        reportCategory: REPORT_CATEGORIES.KEYWORD_CLOUD,
        label: "Keyword By Trend - City (MAV)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.KeywordCityTrendOnline,
          print: GRAPH_DATATYPE.KeywordCityTrendPrint,
          printandonline: GRAPH_DATATYPE.KeywordCityTrendPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.KeywordCityTrendReach,
        value: REPORT_TYPES.KeywordCityTrendReach,
        reportCategory: REPORT_CATEGORIES.KEYWORD_CLOUD,
        label: "Keyword By Trend - City (Reach)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.KeywordCityTrendOnline,
          print: GRAPH_DATATYPE.KeywordCityTrendPrint,
          printandonline: GRAPH_DATATYPE.KeywordCityTrendPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,
          BAR_STACKED_EQUAL_HEIGHT,
          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.KeywordCityTrendWordCount,
        value: REPORT_TYPES.KeywordCityTrendWordCount,
        reportCategory: REPORT_CATEGORIES.KEYWORD_CLOUD,
        label: "Keyword By Trend - City (Word Count)",
        enablePrint: false,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.KeywordCityTrendOnline,
          printandonline: GRAPH_DATATYPE.KeywordCityTrendPrintOnline,
        },
        verticalList: [V_ONLINE],
        groupByField: "entity_name",
        excludeGraphType: [
          PIE,
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
        ],
        entityKey: "entity_name",
        countKey: "index",
      },


      // Keyword - Enitity - SOV

      {
        id: REPORT_TYPES.KeywordCitySOVIndex,
        value: REPORT_TYPES.KeywordCitySOVIndex,
        reportCategory: REPORT_CATEGORIES.KEYWORD_CLOUD,
        label: "Keyword By SOV - City (Index)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.KeywordCitySOVOnline,
          print: GRAPH_DATATYPE.KeywordCitySOVPrint,
          printandonline: GRAPH_DATATYPE.KeywordCitySOVPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
          PIE
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.KeywordCitySOVNOA,
        value: REPORT_TYPES.KeywordCitySOVNOA,
        reportCategory: REPORT_CATEGORIES.KEYWORD_CLOUD,
        label: "Keyword By SOV - City (No. Of Article)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.KeywordCitySOVOnline,
          print: GRAPH_DATATYPE.KeywordCitySOVPrint,
          printandonline: GRAPH_DATATYPE.KeywordCitySOVPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
          PIE
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.KeywordCitySOVCCM,
        value: REPORT_TYPES.KeywordCitySOVCCM,
        reportCategory: REPORT_CATEGORIES.KEYWORD_CLOUD,
        label: "Keyword By SOV - City (CCM)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.KeywordCitySOVOnline,
          print: GRAPH_DATATYPE.KeywordCitySOVPrint,
          printandonline: GRAPH_DATATYPE.KeywordCitySOVPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
          PIE
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.KeywordCitySOVMAV,
        value: REPORT_TYPES.KeywordCitySOVMAV,
        reportCategory: REPORT_CATEGORIES.KEYWORD_CLOUD,
        label: "Keyword By SOV - City (MAV)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.KeywordCitySOVOnline,
          print: GRAPH_DATATYPE.KeywordCitySOVPrint,
          printandonline: GRAPH_DATATYPE.KeywordCitySOVPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
          PIE
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.KeywordCitySOVReach,
        value: REPORT_TYPES.KeywordCitySOVReach,
        reportCategory: REPORT_CATEGORIES.KEYWORD_CLOUD,
        label: "Keyword By SOV - City (Reach)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.KeywordCitySOVOnline,
          print: GRAPH_DATATYPE.KeywordCitySOVPrint,
          printandonline: GRAPH_DATATYPE.KeywordCitySOVPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
          PIE
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.KeywordCitySOVWordCount,
        value: REPORT_TYPES.KeywordCitySOVWordCount,
        reportCategory: REPORT_CATEGORIES.KEYWORD_CLOUD,
        label: "Keyword By SOV - City (Word Count)",
        enablePrint: false,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.KeywordCitySOVOnline,
          printandonline: GRAPH_DATATYPE.KeywordCitySOVPrintOnline,
        },
        verticalList: [V_ONLINE],
        groupByField: "entity_name",
        excludeGraphType: [
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
          PIE
        ],
        entityKey: "entity_name",
        countKey: "index",
      },

      // Keyword - Enitity - Tonality

      {
        id: REPORT_TYPES.KeywordCityTonalityIndex,
        value: REPORT_TYPES.KeywordCityTonalityIndex,
        reportCategory: REPORT_CATEGORIES.KEYWORD_CLOUD,
        label: "Keyword By Tonality - City (Index)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.KeywordCityTonalityOnline,
          print: GRAPH_DATATYPE.KeywordCityTonalityPrint,
          printandonline: GRAPH_DATATYPE.KeywordCityTonalityPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
          PIE
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.KeywordCityTonalityNOA,
        value: REPORT_TYPES.KeywordCityTonalityNOA,
        reportCategory: REPORT_CATEGORIES.KEYWORD_CLOUD,
        label: "Keyword By Tonality - City (No. Of Article)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.KeywordCityTonalityOnline,
          print: GRAPH_DATATYPE.KeywordCityTonalityPrint,
          printandonline: GRAPH_DATATYPE.KeywordCityTonalityPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
          PIE
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.KeywordCityTonalityCCM,
        value: REPORT_TYPES.KeywordCityTonalityCCM,
        reportCategory: REPORT_CATEGORIES.KEYWORD_CLOUD,
        label: "Keyword By Tonality - City (CCM)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.KeywordCityTonalityOnline,
          print: GRAPH_DATATYPE.KeywordCityTonalityPrint,
          printandonline: GRAPH_DATATYPE.KeywordCityTonalityPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
          PIE
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.KeywordCityTonalityMAV,
        value: REPORT_TYPES.KeywordCityTonalityMAV,
        reportCategory: REPORT_CATEGORIES.KEYWORD_CLOUD,
        label: "Keyword By Tonality - City (MAV)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.KeywordCityTonalityOnline,
          print: GRAPH_DATATYPE.KeywordCityTonalityPrint,
          printandonline: GRAPH_DATATYPE.KeywordCityTonalityPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
          PIE
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.KeywordCityTonalityReach,
        value: REPORT_TYPES.KeywordCityTonalityReach,
        reportCategory: REPORT_CATEGORIES.KEYWORD_CLOUD,
        label: "Keyword By Tonality - City (Reach)",
        enablePrint: true,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.KeywordCityTonalityOnline,
          print: GRAPH_DATATYPE.KeywordCityTonalityPrint,
          printandonline: GRAPH_DATATYPE.KeywordCityTonalityPrintOnline,
        },
        verticalList: [V_ONLINE, V_PRINT],
        groupByField: "entity_name",
        excludeGraphType: [
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
          PIE
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      {
        id: REPORT_TYPES.KeywordCityTonalityWordCount,
        value: REPORT_TYPES.KeywordCityTonalityWordCount,
        reportCategory: REPORT_CATEGORIES.KEYWORD_CLOUD,
        label: "Keyword By Tonality - City (Word Count)",
        enablePrint: false,
        enableOnline: true,
        enableSocial: false,
        graphDataType: {
          online: GRAPH_DATATYPE.KeywordCityTonalityOnline,
          printandonline: GRAPH_DATATYPE.KeywordCityTonalityPrintOnline,
        },
        verticalList: [V_ONLINE],
        groupByField: "entity_name",
        excludeGraphType: [
          BAR_HORIZONTAL,
          TABLE,
          WORD_CLOUD,
          GENDER,
          LINE,
          AREA,
          BAR_STACKED,

          DOUGHNUT,
          CHOROPLETH,
          PIE
        ],
        entityKey: "entity_name",
        countKey: "index",
      },
      // {
      //   id: REPORT_TYPES.TonalityDataTV,
      //   value: REPORT_TYPES.TonalityDataTV,
      //   reportCategory: REPORT_CATEGORIES.SENTIMENT,
      //   label: "Sentiment Analysis -TV",
      //   enablePrint: false,
      //   enableOnline: false,
      //   enableSocial: false,
      //   enableTV: true,
      //   graphDataType: {
      //     tv :GRAPH_DATATYPE.TonalityDataTV
      //   },
      //   verticalList: [V_TV],
      //   groupByField: "entity_name",
      //   excludeGraphType: [
      //     BAR_HORIZONTAL,
      //     TABLE,
      //     WORD_CLOUD,
      //     GENDER,
      //     LINE,
      //     AREA,
      //     BAR_STACKED,

      //     DOUGHNUT,
      //     CHOROPLETH,
      //     PIE
      //   ],
      //   entityKey: "entity_name",
      //   countKey: "index",
      // },
      //tv report added
      // Keyword inline ends

    ],
  },
};

export const COOKIE = {
  AUTH_TOKEN: "auth_token",
  FB_SHORT_LIVE_TOKEN: "fb_short_live",
  CONCEPT_USER_ID: "c_id",
  CONCEPT_USER_EMAIL: "c_email",
  CONCEPT_USER_NAME: "c_name",
  IS_SOCIAL_DOWNLOADING: "s_download_progress",
  IS_PRINT_DOWNLOADING: "P_download_progress",
  IS_BLOG_DOWNLOADING: "b_download_progress",
  DOWNLOAD_SUCCESS: "success",
};

export const HTTP_METHOD_TYPES = {
  GET: "get",
  POST: "post",
  PUT: "put",
  DELETE: "delete",
};

export const APP_CONSTANTS = {
  API_CANCEL_ERROR_TEXT: "API Cancel",
  BEARER_TOKEN_KEY: "bearerToken",
};

export const MESSAGES = {
  SOMETHING_WENT_WRONG: "Something went wrong",
  UNAVAILABLE: "Selected resource not found or not available at the moment",
  BAD_REQUEST: "Bad request",
  FORBIDDEN: "Access Forbidden",
};

export const ERROR_MSG = {
  INVALID_EMAIL: "Invalid email address",
  TOPIC_NAME: "Topic name required",
};

export const VALIDATION = {
  VALID_EMAIL_REGEX: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z ]{2,4}$/i,
};

export const MEDIA_TYPES = {
  ALL: "0",
  ONLINE: "1",
  PRINT: "2",
  PRINT_MV: "ad",
  ONLINE_MV: "oad",
  SOCIAL_MV: "sad",
  SOCIAL: "3",
  BLOG: "4",
  BLOG_MV: "bafad",
};

export const GRANULARITY = {
  DAY: "day",
  WEEK: "week",
  MONTH: "month",
  QUARTER: "quarter",
  YEAR: "year",
};

export const SOCIAL_SOURCES = {
  FACEBOOK: 1,
  INSTAGRAM: 2,
  TWITTER: 3,
  YOUTUBE: 4,
  LINKEDIN: 10,
  // PINTEREST: 7,
};

export const SOCIAL_ICONS = [
  {value: 1,icon:<FacebookIcon />},
  {value: 2,icon:<InstagramIcon />},
  {value: 3,icon:<TwitterIcon />},
  {value: 4,icon:<YoutubePlayIcon />},
  {value: 10,icon:<LinkedInIcon />},
  // PINTEREST: 7,
];

export const REPORT_WISE_SOCIAL_ICONS = {
  [REPORT_TYPES.WorldMap]: [
    SOCIAL_SOURCES.FACEBOOK,
    SOCIAL_SOURCES.TWITTER,
    // SOCIAL_SOURCES.PINTEREST,
  ],
  [REPORT_TYPES.INFLUENCERS]: [SOCIAL_SOURCES.TWITTER],
  [REPORT_TYPES.KEYINFLUENCERS]: [SOCIAL_SOURCES.TWITTER],
  [REPORT_TYPES.Reach]: [
    SOCIAL_SOURCES.FACEBOOK,
    SOCIAL_SOURCES.INSTAGRAM,
    SOCIAL_SOURCES.TWITTER,
  ],
  [REPORT_TYPES.TopLanguages]: [
    SOCIAL_SOURCES.TWITTER,
    SOCIAL_SOURCES.YOUTUBE,
    // SOCIAL_SOURCES.PINTEREST,
  ],
};

export const SOCIAL_SOURCES_OPTIONS = [
  {
    label: "All",
    value: "",
    showInFilters: true,
    showInTypePost: false,
    showInShareRetweet: false,
    showInReplyComment: false,
    showInGeo: false,
  },
  {
    label: "Facebook",
    value: SOCIAL_SOURCES.FACEBOOK,
    showInFilters: true,
    showInTypePost: true,
    showInShareRetweet: true,
    showInReplyComment: true,
    showInAttachment: true,
    showInGeo: true,
  },
  {
    label: "Instagram",
    value: SOCIAL_SOURCES.INSTAGRAM,
    showInFilters: true,
    showInTypePost: true,
    showInShareRetweet: false,
    showInReplyComment: true,
    showInGeo: true,
  },
  // {
  //   label: "Pinterest",
  //   value: SOCIAL_SOURCES.PINTEREST,
  //   showInFilters: true,
  // },
  {
    label: "X",
    value: SOCIAL_SOURCES.TWITTER,
    showInFilters: true,
    showInTypePost: true,
    showInShareRetweet: true,
    showInReplyComment: true,
    showInGeo: true,
  },
  {
    label: "Youtube",
    value: SOCIAL_SOURCES.YOUTUBE,
    showInFilters: false,
    showInTypePost: false,
    showInShareRetweet: false,
    showInReplyComment: false,
    showInGeo: false,
    //https://webonise.atlassian.net/browse/CB-642
  },
  {
    label: "Blog",
    value: 5,
    showInTypePost: false
  },
  {
    label: "Forum",
    value: 6,
    showInTypePost: false
  },
  {
    label: "LinkedIn",
    value: SOCIAL_SOURCES.LINKEDIN,
    showInFilters: false,
    showInTypePost: false,
    showInShareRetweet: true,
    showInReplyComment: true,
    showInAttachment: true,
    showInMemberType: true,
    showInGeo: false,
  },
];

export const GRANULARITY_OPTIONS = [
  {
    label: "Daily",
    value: GRANULARITY.DAY,
  },
  {
    label: "Weekly",
    value: GRANULARITY.WEEK,
  },
  {
    label: "Monthly",
    value: GRANULARITY.MONTH,
  },
  {
    label: "Quarterly",
    value: GRANULARITY.QUARTER,
  },
  {
    label: "Yearly",
    value: GRANULARITY.YEAR,
  },
];

export const VERTICAL_OPTIONS = [
  {
    value: VERTICALS.V_PRINT,
    label: "Print",
  },
  {
    value: VERTICALS.V_ONLINE,
    label: "Online",
  },
  {
    value: VERTICALS.V_SOCIAL,
    label: "Social",
  },
  {
    value: VERTICALS.V_TV,
    label: "TV",
  },
  // {
  //   value: VERTICALS.V_BLOG,
  //   label: "Blogs",
  // },
  // {
  //   value: VERTICALS.V_FORUM,
  //   label: "Forum",
  // },
];
export const VERTICAL_OPTIONS_FOR_BLOGS_AND_FORUMS = [
  {
    value: VERTICALS.V_BLOG,
    label: "Blogs",
  },
  {
    value: VERTICALS.V_FORUM,
    label: "Forum",
  },
];
export const GRAPH_TYPE_OPTIONS = [
  {
    value: GRAPH_TYPES.PIE,
    label: "Pie",
  },
  {
    value: GRAPH_TYPES.BAR_VERTICAL,
    label: "Bar-Vertical",
  },
  {
    value: GRAPH_TYPES.BAR_HORIZONTAL,
    label: "Bar-Horizontal",
  },
  {
    value: GRAPH_TYPES.LINE,
    label: "Line",
  },
  {
    value: GRAPH_TYPES.AREA,
    label: "Area",
  },
  {
    value: GRAPH_TYPES.BAR_STACKED,
    label: "Bar-Stacked",
  },
  {
    value: GRAPH_TYPES.BAR_STACKED_EQUAL_HEIGHT,
    label: "Full-Stacked",
  },
  {
    value: GRAPH_TYPES.TABLE,
    label: "Table",
  },
  {
    value: GRAPH_TYPES.WORD_CLOUD,
    label: "Word Cloud",
  },
  {
    value: GRAPH_TYPES.GENDER,
    label: "Gender",
  },
  {
    value: GRAPH_TYPES.DOUGHNUT,
    label: "Doughnut",
  },
  {
    value: GRAPH_TYPES.CHOROPLETH,
    label: "World Map",
  },
];

export const DATE_FORMATS = {
  YYYYMMDD_dash: "yyyy-mm-dd",
  YYYYMMDD_slash: "yyyy/mm/dd",
  MMDDYYYY_slash: "mm/dd/yyyy",
  DDMMYYYY_dash: "DD-MM-YYYY",
  ddMMYYYY_dash: "dd-MM-yyyy",
  DT_DDMMYYYY_dash: "DD-MM-YYYY HH:mm",
  DTS_MMYYYYDD_dash: "MM/DD/YYYY HH:mm:ss",
  DTA_DDMMYYYY_dash: "dd-MM-yyyy hh:mm aa",
  DTA_DDMMYYYY_dash_momet: "DD-MM-YYYY hh:mm a",
};

export const MAX_FEEDS_LIMIT = 1000;

export const DASHBOARD_MESSAGES = {
  NAME_REQUIRED: "Please enter dashboard name",
  ERROR_OCCURED: "Error occurred. Please try again",
};

export const DOWNLOAD_FORMATS = [
  // May need for Future use.
  //{
  //   label: "Direct Download Word",
  //   format: "word_without_mav",
  //   type: "docx",
  // },

  {
    label: "Excel – Single Clip, Single Edition",
    format: "excel",
    type: "xls",
  },
  {
    label: "Excel - Single Clip,All Editions",
    // format: "excel",
    format: "single_excel_editions",
    type: "xls",
  },
  {
    label: "Excel - All clips, All Editions",
    format: "excel",
    type: "xls",
  },
  {
    label: "Excel - Publication Priority",
    format: "priority_excel",
    type: "xls",
  },
  {
    label: "WORD - All clips, All Editions",
    format: "word_without_mav",
    type: "docx",
  },
  {
    label: "WORD - Single Clip, Single Edition",
    format: "single-word-without-mav",
    type: "docx",
  },
  {
    label: "WORD - Single clip, All Editions",
    format: "single-word-without-mav",
    type: "docx",
  },
  {
    label: "WORD - Publication Priority",
    format: "priority_word",
    type: "docx",
  },
  {
    label: "PDF - All clips, All Editions",
    format: "download_pdf",
    type: "pdf",
  },
  {
    label: "PDF - All clips, All Editions(without index).",
    format: "download_pdf_no_index",
    type: "pdf",
  },
  {
    label: "PDF - All clips, All Editions (without metadata)",
    format: "download_pdf_nometa",
    type: "pdf",
  },
  {
    label: "PDF – Single Clip, Single Edition",
    format: "download_pdf",
    type: "pdf",
  },
  {
    label: "PDF – Single Clip, Single Edition (without metadata)",
    format: "download_pdf_nometa",
    type: "pdf",
  },
  {
    label: "PDF – Publication Priority",
    format: "priority_pdf",
    type: "pdf",
  },
];

export const DOWNLOAD_FORMATS_FOR_DETAILS_PAGE = [
  {
    label: "Direct Download Word",
    format: "word_without_mav",
    type: "docx",
  },
  {
    label: "Direct Download PDF",
    format: "download_pdf_no_index",
    type: "pdf",
  },
  {
    label: "Direct Download PDF With Index",
    format: "download_pdf",
    type: "pdf",
  },
  {
    label: "Direct Download PDF without metadata",
    format: "download_pdf_no_index_no_metadata",
    type: "pdf",
  },
];

export const languages = {
  ab: {
    name: "Abkhaz",
    nativeName: "аҧсуа",
  },
  aa: {
    name: "Afar",
    nativeName: "Afaraf",
  },
  af: {
    name: "Afrikaans",
    nativeName: "Afrikaans",
  },
  ak: {
    name: "Akan",
    nativeName: "Akan",
  },
  sq: {
    name: "Albanian",
    nativeName: "Shqip",
  },
  am: {
    name: "Amharic",
    nativeName: "አማርኛ",
  },
  ar: {
    name: "Arabic",
    nativeName: "العربية",
  },
  an: {
    name: "Aragonese",
    nativeName: "Aragonés",
  },
  hy: {
    name: "Armenian",
    nativeName: "Հայերեն",
  },
  as: {
    name: "Assamese",
    nativeName: "অসমীয়া",
  },
  av: {
    name: "Avaric",
    nativeName: "авар мацӀ, магӀарул мацӀ",
  },
  ae: {
    name: "Avestan",
    nativeName: "avesta",
  },
  ay: {
    name: "Aymara",
    nativeName: "aymar aru",
  },
  az: {
    name: "Azerbaijani",
    nativeName: "azərbaycan dili",
  },
  bm: {
    name: "Bambara",
    nativeName: "bamanankan",
  },
  ba: {
    name: "Bashkir",
    nativeName: "башҡорт теле",
  },
  eu: {
    name: "Basque",
    nativeName: "euskara, euskera",
  },
  be: {
    name: "Belarusian",
    nativeName: "Беларуская",
  },
  bn: {
    name: "Bengali",
    nativeName: "বাংলা",
  },
  bh: {
    name: "Bihari",
    nativeName: "भोजपुरी",
  },
  bi: {
    name: "Bislama",
    nativeName: "Bislama",
  },
  bs: {
    name: "Bosnian",
    nativeName: "bosanski jezik",
  },
  br: {
    name: "Breton",
    nativeName: "brezhoneg",
  },
  bg: {
    name: "Bulgarian",
    nativeName: "български език",
  },
  my: {
    name: "Burmese",
    nativeName: "ဗမာစာ",
  },
  ca: {
    name: "Catalan; Valencian",
    nativeName: "Català",
  },
  ch: {
    name: "Chamorro",
    nativeName: "Chamoru",
  },
  ce: {
    name: "Chechen",
    nativeName: "нохчийн мотт",
  },
  ny: {
    name: "Chichewa; Chewa; Nyanja",
    nativeName: "chiCheŵa, chinyanja",
  },
  zh: {
    name: "Chinese",
    nativeName: "中文 (Zhōngwén), 汉语, 漢語",
  },
  cv: {
    name: "Chuvash",
    nativeName: "чӑваш чӗлхи",
  },
  kw: {
    name: "Cornish",
    nativeName: "Kernewek",
  },
  co: {
    name: "Corsican",
    nativeName: "corsu, lingua corsa",
  },
  cr: {
    name: "Cree",
    nativeName: "ᓀᐦᐃᔭᐍᐏᐣ",
  },
  hr: {
    name: "Croatian",
    nativeName: "hrvatski",
  },
  cs: {
    name: "Czech",
    nativeName: "česky, čeština",
  },
  da: {
    name: "Danish",
    nativeName: "dansk",
  },
  dv: {
    name: "Divehi; Dhivehi; Maldivian;",
    nativeName: "ދިވެހި",
  },
  nl: {
    name: "Dutch",
    nativeName: "Nederlands, Vlaams",
  },
  en: {
    name: "English",
    nativeName: "English",
  },
  eo: {
    name: "Esperanto",
    nativeName: "Esperanto",
  },
  et: {
    name: "Estonian",
    nativeName: "eesti, eesti keel",
  },
  ee: {
    name: "Ewe",
    nativeName: "Eʋegbe",
  },
  fo: {
    name: "Faroese",
    nativeName: "føroyskt",
  },
  fj: {
    name: "Fijian",
    nativeName: "vosa Vakaviti",
  },
  fi: {
    name: "Finnish",
    nativeName: "suomi, suomen kieli",
  },
  fr: {
    name: "French",
    nativeName: "français, langue française",
  },
  ff: {
    name: "Fula; Fulah; Pulaar; Pular",
    nativeName: "Fulfulde, Pulaar, Pular",
  },
  gl: {
    name: "Galician",
    nativeName: "Galego",
  },
  ka: {
    name: "Georgian",
    nativeName: "ქართული",
  },
  de: {
    name: "German",
    nativeName: "Deutsch",
  },
  el: {
    name: "Greek, Modern",
    nativeName: "Ελληνικά",
  },
  gn: {
    name: "Guaraní",
    nativeName: "Avañeẽ",
  },
  gu: {
    name: "Gujarati",
    nativeName: "ગુજરાતી",
  },
  ht: {
    name: "Haitian; Haitian Creole",
    nativeName: "Kreyòl ayisyen",
  },
  ha: {
    name: "Hausa",
    nativeName: "Hausa, هَوُسَ",
  },
  he: {
    name: "Hebrew (modern)",
    nativeName: "עברית",
  },
  hz: {
    name: "Herero",
    nativeName: "Otjiherero",
  },
  hi: {
    name: "Hindi",
    nativeName: "हिन्दी, हिंदी",
  },
  ho: {
    name: "Hiri Motu",
    nativeName: "Hiri Motu",
  },
  hu: {
    name: "Hungarian",
    nativeName: "Magyar",
  },
  ia: {
    name: "Interlingua",
    nativeName: "Interlingua",
  },
  id: {
    name: "Indonesian",
    nativeName: "Bahasa Indonesia",
  },
  ie: {
    name: "Interlingue",
    nativeName: "Originally called Occidental; then Interlingue after WWII",
  },
  ga: {
    name: "Irish",
    nativeName: "Gaeilge",
  },
  ig: {
    name: "Igbo",
    nativeName: "Asụsụ Igbo",
  },
  ik: {
    name: "Inupiaq",
    nativeName: "Iñupiaq, Iñupiatun",
  },
  io: {
    name: "Ido",
    nativeName: "Ido",
  },
  is: {
    name: "Icelandic",
    nativeName: "Íslenska",
  },
  it: {
    name: "Italian",
    nativeName: "Italiano",
  },
  iu: {
    name: "Inuktitut",
    nativeName: "ᐃᓄᒃᑎᑐᑦ",
  },
  ja: {
    name: "Japanese",
    nativeName: "日本語 (にほんご／にっぽんご)",
  },
  jv: {
    name: "Javanese",
    nativeName: "basa Jawa",
  },
  kl: {
    name: "Kalaallisut, Greenlandic",
    nativeName: "kalaallisut, kalaallit oqaasii",
  },
  kn: {
    name: "Kannada",
    nativeName: "ಕನ್ನಡ",
  },
  kr: {
    name: "Kanuri",
    nativeName: "Kanuri",
  },
  ks: {
    name: "Kashmiri",
    nativeName: "कश्मीरी, كشميري‎",
  },
  kk: {
    name: "Kazakh",
    nativeName: "Қазақ тілі",
  },
  km: {
    name: "Khmer",
    nativeName: "ភាសាខ្មែរ",
  },
  ki: {
    name: "Kikuyu, Gikuyu",
    nativeName: "Gĩkũyũ",
  },
  rw: {
    name: "Kinyarwanda",
    nativeName: "Ikinyarwanda",
  },
  ky: {
    name: "Kirghiz, Kyrgyz",
    nativeName: "кыргыз тили",
  },
  kv: {
    name: "Komi",
    nativeName: "коми кыв",
  },
  kg: {
    name: "Kongo",
    nativeName: "KiKongo",
  },
  ko: {
    name: "Korean",
    nativeName: "한국어 (韓國語), 조선말 (朝鮮語)",
  },
  ku: {
    name: "Kurdish",
    nativeName: "Kurdî, كوردی‎",
  },
  kj: {
    name: "Kwanyama, Kuanyama",
    nativeName: "Kuanyama",
  },
  la: {
    name: "Latin",
    nativeName: "latine, lingua latina",
  },
  lb: {
    name: "Luxembourgish, Letzeburgesch",
    nativeName: "Lëtzebuergesch",
  },
  lg: {
    name: "Luganda",
    nativeName: "Luganda",
  },
  li: {
    name: "Limburgish, Limburgan, Limburger",
    nativeName: "Limburgs",
  },
  ln: {
    name: "Lingala",
    nativeName: "Lingála",
  },
  lo: {
    name: "Lao",
    nativeName: "ພາສາລາວ",
  },
  lt: {
    name: "Lithuanian",
    nativeName: "lietuvių kalba",
  },
  lu: {
    name: "Luba-Katanga",
    nativeName: "",
  },
  lv: {
    name: "Latvian",
    nativeName: "latviešu valoda",
  },
  gv: {
    name: "Manx",
    nativeName: "Gaelg, Gailck",
  },
  mk: {
    name: "Macedonian",
    nativeName: "македонски јазик",
  },
  mg: {
    name: "Malagasy",
    nativeName: "Malagasy fiteny",
  },
  ms: {
    name: "Malay",
    nativeName: "bahasa Melayu, بهاس ملايو‎",
  },
  ml: {
    name: "Malayalam",
    nativeName: "മലയാളം",
  },
  mt: {
    name: "Maltese",
    nativeName: "Malti",
  },
  mi: {
    name: "Māori",
    nativeName: "te reo Māori",
  },
  mr: {
    name: "Marathi (Marāṭhī)",
    nativeName: "मराठी",
  },
  mh: {
    name: "Marshallese",
    nativeName: "Kajin M̧ajeļ",
  },
  mn: {
    name: "Mongolian",
    nativeName: "монгол",
  },
  na: {
    name: "Nauru",
    nativeName: "Ekakairũ Naoero",
  },
  nv: {
    name: "Navajo, Navaho",
    nativeName: "Diné bizaad, Dinékʼehǰí",
  },
  nb: {
    name: "Norwegian Bokmål",
    nativeName: "Norsk bokmål",
  },
  nd: {
    name: "North Ndebele",
    nativeName: "isiNdebele",
  },
  ne: {
    name: "Nepali",
    nativeName: "नेपाली",
  },
  ng: {
    name: "Ndonga",
    nativeName: "Owambo",
  },
  nn: {
    name: "Norwegian Nynorsk",
    nativeName: "Norsk nynorsk",
  },
  no: {
    name: "Norwegian",
    nativeName: "Norsk",
  },
  ii: {
    name: "Nuosu",
    nativeName: "ꆈꌠ꒿ Nuosuhxop",
  },
  nr: {
    name: "South Ndebele",
    nativeName: "isiNdebele",
  },
  oc: {
    name: "Occitan",
    nativeName: "Occitan",
  },
  oj: {
    name: "Ojibwe, Ojibwa",
    nativeName: "ᐊᓂᔑᓈᐯᒧᐎᓐ",
  },
  cu: {
    name: "Old Church Slavonic, Church Slavic, Church Slavonic, Old Bulgarian, Old Slavonic",
    nativeName: "ѩзыкъ словѣньскъ",
  },
  om: {
    name: "Oromo",
    nativeName: "Afaan Oromoo",
  },
  or: {
    name: "Oriya",
    nativeName: "ଓଡ଼ିଆ",
  },
  os: {
    name: "Ossetian, Ossetic",
    nativeName: "ирон æвзаг",
  },
  pa: {
    name: "Panjabi, Punjabi",
    nativeName: "ਪੰਜਾਬੀ, پنجابی‎",
  },
  pi: {
    name: "Pāli",
    nativeName: "पाऴि",
  },
  fa: {
    name: "Persian",
    nativeName: "فارسی",
  },
  pl: {
    name: "Polish",
    nativeName: "polski",
  },
  ps: {
    name: "Pashto, Pushto",
    nativeName: "پښتو",
  },
  pt: {
    name: "Portuguese",
    nativeName: "Português",
  },
  qu: {
    name: "Quechua",
    nativeName: "Runa Simi, Kichwa",
  },
  rm: {
    name: "Romansh",
    nativeName: "rumantsch grischun",
  },
  rn: {
    name: "Kirundi",
    nativeName: "kiRundi",
  },
  ro: {
    name: "Romanian, Moldavian, Moldovan",
    nativeName: "română",
  },
  ru: {
    name: "Russian",
    nativeName: "русский язык",
  },
  sa: {
    name: "Sanskrit (Saṁskṛta)",
    nativeName: "संस्कृतम्",
  },
  sc: {
    name: "Sardinian",
    nativeName: "sardu",
  },
  sd: {
    name: "Sindhi",
    nativeName: "सिन्धी, سنڌي، سندھی‎",
  },
  se: {
    name: "Northern Sami",
    nativeName: "Davvisámegiella",
  },
  sm: {
    name: "Samoan",
    nativeName: "gagana faa Samoa",
  },
  sg: {
    name: "Sango",
    nativeName: "yângâ tî sängö",
  },
  sr: {
    name: "Serbian",
    nativeName: "српски језик",
  },
  gd: {
    name: "Scottish Gaelic; Gaelic",
    nativeName: "Gàidhlig",
  },
  sn: {
    name: "Shona",
    nativeName: "chiShona",
  },
  si: {
    name: "Sinhala, Sinhalese",
    nativeName: "සිංහල",
  },
  sk: {
    name: "Slovak",
    nativeName: "slovenčina",
  },
  sl: {
    name: "Slovene",
    nativeName: "slovenščina",
  },
  so: {
    name: "Somali",
    nativeName: "Soomaaliga, af Soomaali",
  },
  st: {
    name: "Southern Sotho",
    nativeName: "Sesotho",
  },
  es: {
    name: "Spanish; Castilian",
    nativeName: "español, castellano",
  },
  su: {
    name: "Sundanese",
    nativeName: "Basa Sunda",
  },
  sw: {
    name: "Swahili",
    nativeName: "Kiswahili",
  },
  ss: {
    name: "Swati",
    nativeName: "SiSwati",
  },
  sv: {
    name: "Swedish",
    nativeName: "svenska",
  },
  ta: {
    name: "Tamil",
    nativeName: "தமிழ்",
  },
  te: {
    name: "Telugu",
    nativeName: "తెలుగు",
  },
  tg: {
    name: "Tajik",
    nativeName: "тоҷикӣ, toğikī, تاجیکی‎",
  },
  th: {
    name: "Thai",
    nativeName: "ไทย",
  },
  ti: {
    name: "Tigrinya",
    nativeName: "ትግርኛ",
  },
  bo: {
    name: "Tibetan Standard, Tibetan, Central",
    nativeName: "བོད་ཡིག",
  },
  tk: {
    name: "Turkmen",
    nativeName: "Türkmen, Түркмен",
  },
  tl: {
    name: "Tagalog",
    nativeName: "Wikang Tagalog, ᜏᜒᜃᜅ᜔ ᜆᜄᜎᜓᜄ᜔",
  },
  tn: {
    name: "Tswana",
    nativeName: "Setswana",
  },
  to: {
    name: "Tonga (Tonga Islands)",
    nativeName: "faka Tonga",
  },
  tr: {
    name: "Turkish",
    nativeName: "Türkçe",
  },
  ts: {
    name: "Tsonga",
    nativeName: "Xitsonga",
  },
  tt: {
    name: "Tatar",
    nativeName: "татарча, tatarça, تاتارچا‎",
  },
  tw: {
    name: "Twi",
    nativeName: "Twi",
  },
  ty: {
    name: "Tahitian",
    nativeName: "Reo Tahiti",
  },
  ug: {
    name: "Uighur, Uyghur",
    nativeName: "Uyƣurqə, ئۇيغۇرچە‎",
  },
  uk: {
    name: "Ukrainian",
    nativeName: "українська",
  },
  ur: {
    name: "Urdu",
    nativeName: "اردو",
  },
  uz: {
    name: "Uzbek",
    nativeName: "zbek, Ўзбек, أۇزبېك‎",
  },
  ve: {
    name: "Venda",
    nativeName: "Tshivenḓa",
  },
  vi: {
    name: "Vietnamese",
    nativeName: "Tiếng Việt",
  },
  vo: {
    name: "Volapük",
    nativeName: "Volapük",
  },
  wa: {
    name: "Walloon",
    nativeName: "Walon",
  },
  cy: {
    name: "Welsh",
    nativeName: "Cymraeg",
  },
  wo: {
    name: "Wolof",
    nativeName: "Wollof",
  },
  fy: {
    name: "Western Frisian",
    nativeName: "Frysk",
  },
  xh: {
    name: "Xhosa",
    nativeName: "isiXhosa",
  },
  yi: {
    name: "Yiddish",
    nativeName: "ייִדיש",
  },
  yo: {
    name: "Yoruba",
    nativeName: "Yorùbá",
  },
  za: {
    name: "Zhuang, Chuang",
    nativeName: "Saɯ cueŋƅ, Saw cuengh",
  },
};

export const countries = [ 
  {"id": "India","name": "India", "code": "IN"}, {"id": "N/A","name": "N/A", "code": "NA"}, {"id": "Afghanistan","name": "Afghanistan", "code": "AF"},   {"id": "land Islands","name": "land Islands", "code": "AX"}, 
  {"id": "Albania", "name": "Albania", "code": "AL"},   {"id": "Algeria","name": "Algeria", "code": "DZ"},   {"id": "American Samoa","name": "American Samoa", "code": "AS"}, 
  {"id": "AndorrA","name": "AndorrA", "code": "AD"},   {"id": "Angola","name": "Angola", "code": "AO"},   {"id": "Anguilla","name": "Anguilla", "code": "AI"}, 
  {"id": "Antarctica","name": "Antarctica", "code": "AQ"},   {"id": "Antigua and Barbuda","name": "Antigua and Barbuda", "code": "AG"},   {"id": "Argentina","name": "Argentina", "code": "AR"}, 
  {"id": "Armenia","name": "Armenia", "code": "AM"},   {"id": "Aruba", "name": "Aruba","code": "AW"},   {"id": "Australia","name": "Australia", "code": "AU"}, 
  {"id": "Austria","name": "Austria", "code": "AT"},   {"id": "Azerbaijan","name": "Azerbaijan", "code": "AZ"},   {"id": "Bahamas","name": "Bahamas", "code": "BS"}, 
  {"id": "Bahrain","name": "Bahrain", "code": "BH"},   {"id": "Bangladesh","name": "Bangladesh", "code": "BD"},   {"id": "Barbados","name": "Barbados", "code": "BB"}, 
  {"id": "Belarus", "name": "Belarus","code": "BY"},   {"id": "Belgium", "name": "Belgium","code": "BE"},   {"id": "Belize", "name": "Belize", "code": "BZ"}, 
  {"id": "Benin","name": "Benin", "code": "BJ"},   {"id": "Bermuda", "name": "Bermuda","code": "BM"},   {"id": "Bhutan", "name": "Bhutan","code": "BT"}, 
  {"id": "Bolivia","name": "Bolivia", "code": "BO"},   {"id": "Bosnia and Herzegovina","name": "Bosnia and Herzegovina", "code": "BA"},   {"id": "Botswana","name": "Botswana", "code": "BW"}, 
  {"id": "Bouvet Island","name": "Bouvet Island", "code": "BV"},   {"id": "Brazil","name": "Brazil","code": "BR"},   {"id": "British Indian Ocean Territory","name": "British Indian Ocean Territory", "code": "IO"}, 
  {"id": "Brunei Darussalam","name": "Brunei Darussalam", "code": "BN"},   {"id": "Bulgaria","name": "Bulgaria", "code": "BG"},   {"id": "Burkina Faso","name": "Burkina Faso", "code": "BF"}, 
  {"id": "Burundi", "name": "Burundi","code": "BI"},   {"id": "Cambodia","name": "Cambodia", "code": "KH"},   {"id": "Cameroon","name": "Cameroon", "code": "CM"}, 
  {"id": "Canada", "name": "Canada","code": "CA"},   {"id": "Cape Verde","name": "Cape Verde", "code": "CV"},   {"id": "Cayman Islands","name": "Cayman Islands", "code": "KY"}, 
  {"id": "Central African Republic","name": "Central African Republic", "code": "CF"},   {"id": "Chad","name": "Chad", "code": "TD"},   {"id": "Chile","name": "Chile", "code": "CL"}, 
  {"id": "China","name": "China", "code": "CN"},   {"id": "Christmas Island","name": "Christmas Island", "code": "CX"},   {"id": "Cocos (Keeling) Islands","name": "Cocos (Keeling) Islands", "code": "CC"}, 
  {"id": "Colombia", "name": "Colombia", "code": "CO"},   {"id": "Comoros","name": "Comoros",  "code": "KM"},   {"id": "Congo", "name": "Congo","code": "CG"}, 
  {"id": "Congo, The Democratic Republic of the","name": "Congo, The Democratic Republic of the", "code": "CD"}, 
  {"id": "Cook Islands","name": "Cook Islands", "code": "CK"},   {"id": "Costa Rica","name": "Costa Rica", "code": "CR"},   {"id": "Cote D\"Ivoire","name": "Cote D\"Ivoire", "code": "CI"}, 
  {"id": "Croatia","name": "Croatia", "code": "HR"},   {"id": "Cuba", "name": "Cuba","code": "CU"},   {"id": "Cyprus","name": "Cyprus","code": "CY"}, 
  {"id": "Czech Republic", "name": "Czech Republic","code": "CZ"},   {"id": "Denmark", "name": "Denmark","code": "DK"},   {"id": "Djibouti", "name": "Djibouti","code": "DJ"}, 
  {"id": "Dominica","name": "Dominica", "code": "DM"},   {"id": "Dominican Republic", "name": "Dominican Republic","code": "DO"},   {"id": "Ecuador","name": "Ecuador", "code": "EC"}, 
  {"id": "Egypt","name": "Egypt", "code": "EG"},   {"id": "El Salvador","name": "El Salvador", "code": "SV"},   {"id": "Equatorial Guinea","name": "Equatorial Guinea", "code": "GQ"}, 
  {"id": "Eritrea","name": "Eritrea", "code": "ER"},   {"id": "Estonia","name": "Estonia", "code": "EE"},   {"id": "Ethiopia","name": "Ethiopia", "code": "ET"}, 
  {"id": "Falkland Islands (Malvinas)","name": "Falkland Islands (Malvinas)", "code": "FK"},   {"id": "Faroe Islands", "name": "Faroe Islands","code": "FO"}, 
  {"id": "Fiji", "name": "Fiji","code": "FJ"},   {"id": "Finland", "name": "Finland","code": "FI"},   {"id": "France","name": "France", "code": "FR"}, 
  {"id": "French Guiana","name": "French Guiana", "code": "GF"},   {"id": "French Polynesia","name": "French Polynesia", "code": "PF"},   {"id": "French Southern Territories", "name": "French Southern Territories","code": "TF"}, 
  {"id": "Gabon", "name": "Gabon", "code": "GA"},   {"id": "Gambia","name": "Gambia", "code": "GM"},   {"id": "Georgia","name": "Georgia", "code": "GE"}, 
  {"id": "Germany","name": "Germany", "code": "DE"},   {"id": "Ghana", "name": "Ghana","code": "GH"},   {"id": "Gibraltar","name": "Gibraltar", "code": "GI"}, 
  {"id": "Greece","name": "Greece", "code": "GR"},   {"id": "Greenland","name": "Greenland", "code": "GL"},   {"id": "Grenada","name": "Grenada", "code": "GD"}, 
  {"id": "Guadeloupe","name": "Guadeloupe", "code": "GP"},   {"id": "Guam","name": "Guam", "code": "GU"},   {"id": "Guatemala","name": "Guatemala", "code": "GT"}, 
  {"id": "Guernsey", "name": "Guernsey","code": "GG"},   {"id": "Guinea", "name": "Guinea","code": "GN"},   {"id": "Guinea-Bissau","name": "Guinea-Bissau", "code": "GW"}, 
  {"id": "Guyana", "name": "Guyana","code": "GY"},   {"id": "Haiti","name": "Haiti","code": "HT"},   {"id": "Heard Island and Mcdonald Islands","name": "Heard Island and Mcdonald Islands", "code": "HM"}, 
  {"id": "Holy See (Vatican City State)","name": "Holy See (Vatican City State)", "code": "VA"},   {"id": "Honduras", "name": "Honduras","code": "HN"}, 
  {"id": "Hong Kong","name": "Hong Kong", "code": "HK"},   {"id": "Hungary","name": "Hungary", "code": "HU"},   {"id": "Iceland", "name": "Iceland","code": "IS"},   
  {"id": "Indonesia","name": "Indonesia", "code": "ID"},   {"id": "Iran, Islamic Republic Of","name": "Iran, Islamic Republic Of", "code": "IR"}, 
  {"id": "Iraq", "name": "Iraq","code": "IQ"},   {"id": "Ireland","name": "Ireland", "code": "IE"},  {"id": "Isle of Man","name": "Isle of Man", "code": "IM"}, 
  {"id": "Israel", "name": "Israel","code": "IL"},   {"id": "Italy","name": "Italy", "code": "IT"},   {"id": "Jamaica","name": "Jamaica", "code": "JM"}, 
  {"id": "Japan","name": "Japan", "code": "JP"},   {"id": "Jersey", "name": "Jersey","code": "JE"},   {"id": "Jordan","name": "Jordan", "code": "JO"}, 
  {"id": "Kazakhstan", "name": "Kazakhstan","code": "KZ"},   {"id": "Kenya","name": "Kenya", "code": "KE"},   {"id": "Kiribati","name": "Kiribati", "code": "KI"}, 
  {"id": "Korea, Democratic People\"S Republic of", "name": "Korea, Democratic People\"S Republic of", "code": "KP"}, 
  {"id": "Korea, Republic of","name": "Korea, Republic of", "code": "KR"},   {"id": "Kuwait","name": "Kuwait", "code": "KW"},   {"id": "Kyrgyzstan", "name": "Kyrgyzstan","code": "KG"}, 
  {"id": "Lao People\"S Democratic Republic","name": "Lao People\"S Democratic Republic", "code": "LA"},   {"id": "Latvia","name": "Latvia", "code": "LV"}, 
  {"id": "Lebanon","name": "Lebanon", "code": "LB"},   {"id": "Lesotho", "name": "Lesotho","code": "LS"},   {"id": "Liberia","name": "Liberia", "code": "LR"}, 
  {"id": "Libyan Arab Jamahiriya", "name": "Libyan Arab Jamahiriya","code": "LY"},   {"id": "Liechtenstein","name": "Liechtenstein", "code": "LI"}, 
  {"id": "Lithuania","name": "Lithuania", "code": "LT"},   {"id": "Luxembourg","name": "Luxembourg",  "code": "LU"},   {"id": "Macao","name": "Macao", "code": "MO"}, 
  {"id": "Macedonia, The Former Yugoslav Republic of", "name": "Macedonia, The Former Yugoslav Republic of", "code": "MK"}, 
  {"id": "Madagascar","name": "Madagascar", "code": "MG"},   {"id": "Malawi","name": "Malawi", "code": "MW"},   {"id": "Malaysia", "name": "Malaysia", "code": "MY"}, 
  {"id": "Maldives", "name": "Maldives","code": "MV"},   {"id": "Mali", "name": "Mali", "code": "ML"},   {"id": "Malta","name": "Malta", "code": "MT"}, 
  {"id": "Marshall Islands","name": "Marshall Islands", "code": "MH"},   {"id": "Martinique","name": "Martinique", "code": "MQ"}, 
  {"id": "Mauritania", "name": "Mauritania","code": "MR"},   {"id": "Mauritius", "name": "Mauritius", "code": "MU"},   {"id": "Mayotte","name": "Mayotte", "code": "YT"}, 
  {"id": "Mexico","name": "Mexico", "code": "MX"},   {"id": "Micronesia, Federated States of", "name": "Micronesia, Federated States of", "code": "FM"}, 
  {"id": "Moldova, Republic of","name": "Moldova, Republic of", "code": "MD"},   {"id": "Monaco", "name": "Monaco","code": "MC"},   {"id": "Mongolia","name": "Mongolia", "code": "MN"}, 
  {"id": "Montenegro", "name": "Montenegro","code": "ME"},  {"id": "Montserrat","name": "Montserrat", "code": "MS"},  {"id": "Morocco","name": "Morocco", "code": "MA"}, 
  {"id": "Mozambique", "name": "Mozambique","code": "MZ"},   {"id": "Myanmar","name": "Myanmar", "code": "MM"},   {"id": "Namibia","name": "Namibia", "code": "NA"}, 
  {"id": "Nauru","name": "Nauru", "code": "NR"},   {"id": "Nepal","name": "Nepal", "code": "NP"},   {"id": "Netherlands","name": "Netherlands", "code": "NL"}, 
  {"id": "Netherlands Antilles","name": "Netherlands Antilles", "code": "AN"},   {"id": "New Caledonia","name": "New Caledonia", "code": "NC"}, 
  {"id": "New Zealand","name": "New Zealand", "code": "NZ"},   {"id": "Nicaragua", "name": "Nicaragua","code": "NI"},   {"id": "Niger","name": "Niger", "code": "NE"}, 
  {"id": "Nigeria","name": "Nigeria", "code": "NG"},   {"id": "Niue","name": "Niue", "code": "NU"},   {"id": "Norfolk Island","name": "Norfolk Island", "code": "NF"}, 
  {"id": "Northern Mariana Islands","name": "Northern Mariana Islands", "code": "MP"},   {"id": "Norway","name": "Norway", "code": "NO"}, 
  {"id": "Oman","name": "Oman", "code": "OM"},   {"id": "Pakistan","name": "Pakistan", "code": "PK"},   {"id": "Palau","name": "Palau", "code": "PW"}, 
  {"id": "Palestinian Territory,Occupied","name": "Palestinian Territory, Occupied", "code": "PS"},   {"id": "Panama","name": "Panama", "code": "PA"}, 
  {"id": "Papua New Guinea","name": "Papua New Guinea", "code": "PG"},   {"id": "Paraguay","name": "Paraguay", "code": "PY"},   {"id": "Peru", "name": "Peru","code": "PE"}, 
  {"id": "Philippines", "name": "Philippines","code": "PH"},   {"id": "Pitcairn", "name": "Pitcairn","code": "PN"},   {"id": "Poland","name": "Poland", "code": "PL"}, 
  {"id": "Portugal","name": "Portugal", "code": "PT"},   {"id": "Puerto Rico", "name": "Puerto Rico","code": "PR"},   {"id": "Qatar", "name": "Qatar","code": "QA"}, 
  {"id": "Reunion","name": "Reunion", "code": "RE"},   {"id": "Romania","name": "Romania", "code": "RO"},   {"id": "Russian Federation","name": "Russian Federation", "code": "RU"}, 
  {"id": "RWANDA","name": "RWANDA", "code": "RW"},   {"id": "Saint Helena","name": "Saint Helena", "code": "SH"},   {"id": "Saint Kitts and Nevis","name": "Saint Kitts and Nevis", "code": "KN"}, 
  {"id": "Saint Lucia","name": "Saint Lucia", "code": "LC"},   {"id": "Saint Pierre and Miquelon", "name": "Saint Pierre and Miquelon","code": "PM"}, 
  {"id": "Saint Vincent and the Grenadines", "name": "Saint Vincent and the Grenadines","code": "VC"},   {"id": "Samoa", "name": "Samoa", "code": "WS"}, 
  {"id": "San Marino","name": "San Marino", "code": "SM"},   {"id": "Sao Tome and Principe","name": "Sao Tome and Principe", "code": "ST"},   {"id": "Saudi Arabia","name": "Saudi Arabia", "code": "SA"}, 
  {"id": "Senegal","name": "Senegal", "code": "SN"},   {"id": "Serbia","name": "Serbia", "code": "RS"},   {"id": "Seychelles","name": "Seychelles", "code": "SC"}, 
  {"id": "Sierra Leone", "name": "Sierra Leone","code": "SL"},   {"id": "Singapore","name": "Singapore", "code": "SG"},   {"id": "Slovakia","name": "Slovakia", "code": "SK"}, 
  {"id": "Slovenia", "name": "Slovenia","code": "SI"},   {"id": "Solomon Islands","name": "Solomon Islands", "code": "SB"},   {"id": "Somalia","name": "Somalia", "code": "SO"}, 
  {"id": "South Africa","name": "South Africa", "code": "ZA"},   {"id": "South Georgia and the South Sandwich Islands","name": "South Georgia and the South Sandwich Islands", "code": "GS"}, 
  {"id": "Spain","name": "Spain", "code": "ES"},   {"id": "Sri Lanka","name": "Sri Lanka","code": "LK"},   {"id": "Sudan","name": "Sudan", "code": "SD"}, 
  {"id": "Suriname","name": "Suriname", "code": "SR"},   {"id": "Svalbard and Jan Mayen","name": "Svalbard and Jan Mayen", "code": "SJ"},   {"id": "Swaziland","name": "Swaziland", "code": "SZ"}, 
  {"id": "Sweden","name": "Sweden", "code": "SE"},   {"id": "Switzerland","name": "Switzerland", "code": "CH"},   {"id": "Syrian Arab Republic","name": "Syrian Arab Republic", "code": "SY"}, 
  {"id": "Taiwan, Province of China","name": "Taiwan, Province of China", "code": "TW"},   {"id": "Tajikistan","name": "Tajikistan", "code": "TJ"}, 
  {"id": "Tanzania, United Republic of","name": "Tanzania, United Republic of", "code": "TZ"}, 
  {"id": "Thailand","name": "Thailand", "code": "TH"},   {"id": "Timor-Leste", "name": "Timor-Leste","code": "TL"},   {"id": "Togo", "name": "Togo","code": "TG"},   {"id": "Tokelau", "name": "Tokelau","code": "TK"}, 
  {"id": "Tonga","name": "Tonga", "code": "TO"},   
  {"id": "Trinidad and Tobago", "name": "Trinidad and Tobago","code": "TT"},   
  {"id": "Tunisia","name": "Tunisia", "code": "TN"},   
  {"id": "Turkey","name": "Turkey", "code": "TR"}, 
  {"id": "Turkmenistan","name": "Turkmenistan"},  {"id": "Turkmenistan", "code": "TM"},   {"id": "Turks and Caicos Islands", "name": "Turks and Caicos Islands","code": "TC"},   {"id": "Tuvalu","name": "Tuvalu", "code": "TV"},   {"id": "Uganda","name": "Uganda", "code": "UG"}, 
  {"id": "Ukraine","name": "Ukraine", "code": "UA"},   {"id": "United Arab Emirates","name": "United Arab Emirates", "code": "AE"},   {"id": "United Kingdom","name": "United Kingdom", "code": "GB"}, 
  {"id": "United States","name": "United States", "code": "US"},   {"id": "United States Minor Outlying Islands","name": "United States Minor Outlying Islands", "code": "UM"}, 
  {"id": "Uruguay","name": "Uruguay", "code": "UY"},   {"id": "Uzbekistan","name": "Uzbekistan", "code": "UZ"},   {"id": "Vanuatu", "name": "Vanuatu","code": "VU"},   {"id": "Venezuela","name": "Venezuela", "code": "VE"}, 
  {"id": "Viet Nam","name": "Viet Nam", "code": "VN"},   {"id": "Virgin Islands, British","name": "Virgin Islands, British", "code": "VG"}, 
  {"id": "Virgin Islands, U.S.","name": "Virgin Islands, U.S.", "code": "VI"},   {"id": "Wallis and Futuna","name": "Wallis and Futuna", "code": "WF"}, 
  {"id": "Western Sahara", "name": "Western Sahara","code": "EH"},   {"id": "Yemen", "name": "Yemen","code": "YE"},   {"id": "Zambia", "name": "Zambia","code": "ZM"},   {"id": "Zimbabwe","name": "Zimbabwe", "code": "ZW"} 
  ]

// export const DOWNLOAD_FORMATS_FOR_TV = [
//   {
//     label: "Download Word",
//     format: "excel",
//     type: "xls",
//   }
// ]

export const TABS = ["Client", "Competitor", "Industry"];
export const TAB = ["Most Retweeted"];
export const INSIGHTTAB = ["Most Shared Post"];
export const INSTATAB = ["Most Liked Post"];

export const TABS_MAPPING = {
  all: "all",
  Client: "client",
  Competitor: "competitor",
  Industry: "industry",
};

export const REGIONAL_LANGUAGE = {
  en: 'English',
  hi: 'Hindi',
  bn: 'Bengali',
  mr: 'Marathi',
  gu: 'Gujarati',
  ta: 'Tamil',
  te: 'Telugu',
  kn: 'Kannada',
  ml: 'Malayalam',
  or: 'Oriya',
  pa: 'Panjabi; Punjabi',
}

export const LANGUAGE_CODES = {
  aa: "Afar",
  ab: "Abkhazian",
  ae: "Avestan",
  af: "Afrikaans",
  ak: "Akan",
  am: "Amharic",
  an: "Aragonese",
  ar: "Arabic",
  as: "Assamese",
  av: "Avaric",
  ay: "Aymara",
  az: "Azerbaijani",
  ba: "Bashkir",
  be: "Belarusian",
  bg: "Bulgarian",
  bh: "Bihari languages",
  bi: "Bislama",
  bm: "Bambara",
  bn: "Bengali",
  bo: "Tibetan",
  br: "Breton",
  bs: "Bosnian",
  ca: "Catalan; Valencian",
  ce: "Chechen",
  ch: "Chamorro",
  co: "Corsican",
  cr: "Cree",
  cs: "Czech",
  cu: "Church Slavic; Old Slavonic",
  cv: "Chuvash",
  cy: "Welsh",
  da: "Danish",
  de: "German",
  dv: "Divehi; Dhivehi; Maldivian",
  dz: "Dzongkha",
  ee: "Ewe",
  el: "Greek, Modern",
  en: "English",
  eo: "Esperanto",
  es: "Spanish; Castilian",
  et: "Estonian",
  eu: "Basque",
  fa: "Persian",
  ff: "Fulah",
  fi: "Finnish",
  fj: "Fijian",
  fo: "Faroese",
  fr: "French",
  fy: "Western Frisian",
  ga: "Irish",
  gd: "Gaelic; Scottish Gaelic",
  gl: "Galician",
  gn: "Guarani",
  gu: "Gujarati",
  gv: "Manx",
  ha: "Hausa",
  he: "Hebrew",
  hi: "Hindi",
  ho: "Hiri Motu",
  hr: "Croatian",
  ht: "Haitian; Haitian Creole",
  hu: "Hungarian",
  hy: "Armenian",
  hz: "Herero",
  ia: "Interlingua (International Auxiliary Language Association)",
  id: "Indonesian(id)",
  in: "Indonesian(in)",
  ie: "Interlingue; Occidental",
  ig: "Igbo",
  ii: "Sichuan Yi; Nuosu",
  ik: "Inupiaq",
  io: "Ido",
  is: "Icelandic",
  it: "Italian",
  iu: "Inuktitut",
  ja: "Japanese",
  jv: "Javanese",
  ka: "Georgian",
  kg: "Kongo",
  ki: "Kikuyu; Gikuyu",
  kj: "Kuanyama; Kwanyama",
  kk: "Kazakh",
  kl: "Kalaallisut; Greenlandic",
  km: "Central Khmer",
  kn: "Kannada",
  ko: "Korean",
  kr: "Kanuri",
  ks: "Kashmiri",
  ku: "Kurdish",
  kv: "Komi",
  kw: "Cornish",
  ky: "Kirghiz; Kyrgyz",
  la: "Latin",
  lb: "Luxembourgish; Letzeburgesch",
  lg: "Ganda",
  li: "Limburgan; Limburger; Limburgish",
  ln: "Lingala",
  lo: "Lao",
  lt: "Lithuanian",
  lu: "Luba-Katanga",
  lv: "Latvian",
  mg: "Malagasy",
  mh: "Marshallese",
  mi: "Maori",
  mk: "Macedonian",
  ml: "Malayalam",
  mn: "Mongolian",
  mr: "Marathi",
  ms: "Malay",
  mt: "Maltese",
  my: "Burmese",
  na: "Nauru",
  nb: "Bokm, Norwegian; Norwegian Bokm",
  nd: "Ndebele, North; North Ndebele",
  ne: "Nepali",
  ng: "Ndonga",
  nl: "Dutch; Flemish",
  nn: "Norwegian Nynorsk; Nynorsk, Norwegian",
  no: "Norwegian",
  nr: "Ndebele, South; South Ndebele",
  nv: "Navajo; Navaho",
  ny: "Chichewa; Chewa; Nyanja",
  oc: "Occitan",
  oj: "Ojibwa",
  om: "Oromo",
  or: "Oriya",
  os: "Ossetian; Ossetic",
  pa: "Panjabi; Punjabi",
  pi: "Pali",
  pl: "Polish",
  ps: "Pushto; Pashto",
  pt: "Portuguese",
  qu: "Quechua",
  rm: "Romansh",
  rn: "Rundi",
  ro: "Romanian; Moldavian; Moldovan",
  ru: "Russian",
  rw: "Kinyarwanda",
  sa: "Sanskrit",
  sc: "Sardinian",
  sd: "Sindhi",
  se: "Northern Sami",
  sg: "Sango",
  si: "Sinhala; Sinhalese",
  sk: "Slovak",
  sl: "Slovenian",
  sm: "Samoan",
  sn: "Shona",
  so: "Somali",
  sq: "Albanian",
  sr: "Serbian",
  ss: "Swati",
  st: "Sotho, Southern",
  su: "Sundanese",
  sv: "Swedish",
  sw: "Swahili",
  ta: "Tamil",
  te: "Telugu",
  tg: "Tajik",
  th: "Thai",
  ti: "Tigrinya",
  tk: "Turkmen",
  tl: "Tagalog",
  tn: "Tswana",
  to: "Tonga (Tonga Islands)",
  tr: "Turkish",
  ts: "Tsonga",
  tt: "Tatar",
  tw: "Twi",
  ty: "Tahitian",
  ug: "Uighur; Uyghur",
  uk: "Ukrainian",
  ur: "Urdu",
  uz: "Uzbek",
  ve: "Venda",
  vi: "Vietnamese",
  vo: "Volap",
  wa: "Walloon",
  wo: "Wolof",
  xh: "Xhosa",
  yi: "Yiddish",
  yo: "Yoruba",
  za: "Zhuang; Chuang",
  zh: "Chinese",
  zu: "Zulu",
  und: "Other",
  null: "Other",
  "zh-cn": "Chinese (PRC)",
  "zh-tw": "Chinese (Taiwan)",
};

export const SOCIAL_PERPAGE_LIMIT = 50;
export const SOCIAL_PAGE_PERPAGE_LIMIT = 500;
export const PRINT_PERPAGE_LIMIT = 500;
export const ONLINE_PERPAGE_LIMIT = 100;
export const NUMBER_FORMATS = {
  EN_IN: "en-IN",
  EN_US: "en-US",
};

export const CITY_LIST_BY_PRIORITY = [
  "New Delhi",
  "Mumbai",
  "Bangalore",
  "Chennai",
  "Kolkata",
  "Hyderabad",
  "Ahmedabad",
];
export const LANGUAGE_CODE = ["hi","ur","bn","mr","gu","pa","ta","te","kn","ml","en","kok","ne","ks","sa"]

export const TRACKING_ALLOWED_CLIENTS = ["11717"]

export const SUMMARY_ALLOWED_CLIENTS = [11717]
